export const SIDE_NAV = {
  overview: {
    uk: "Огляд",
    en: "Overview",
    hy: "Ակնարկ",
    ka: "მიმოხილვა",
  },
  photo_report: {
    uk: "Фото звіт",
    en: "Photo report",
    hy: "Լուսանկարի հաշվետվություն",
    ka: "ფოტო ანგარიში",
  },
  all_reports: {
    uk: "BI звіти",
    en: "BI reports",
    hy: "BI հաշվետվություններ",
    ka: "BI ანგარიშები",
  },
  merchandiser: {
    uk: "Мерчандайзери",
    en: "Merchandisers",
    hy: "Մերչենդայզերներ",
    ka: "მერჩენდაიზერები",
  },
  supervisors: {
    uk: "Супервайзери",
    en: "Supervisors",
    hy: "Սուպերվայզերներ",
    ka: "სუპერვაიზერები",
  },
  tasks: {
    uk: "Завдання",
    en: "Tasks",
    hy: "Առաջադրանքներ",
    ka: "დავალებები",
  },
  my_uploads: {
    uk: "Мої завантаження",
    en: "My Uploads",
    hy: "Իմ վերբեռնումները",
    ka: "ჩემი ატვირთვები",
  },
  answers: {
    uk: "Відповіді",
    en: "Answers",
    hy: "Պատասխաններ",
    ka: "პასუხები",
  },
  task_uploading: {
    uk: "Завантаження завдань",
    en: "Task uploading",
    hy: "Առաջադրանքների վերբեռնում",
    ka: "დავალებების ატვირთვა",
  },
  points: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  visit: {
    uk: "Візити",
    en: "Visits",
    hy: "Այցեր",
    ka: "ვიზიტები",
  },
  tracking: {
    uk: "Онлайн-моніторинг",
    en: "Online tracking",
    hy: "Առցանց մոնիտորինգ",
    ka: "ონლაინ მონიტორინგი",
  },
  documents: {
    uk: "Документи",
    en: "Documents",
    hy: "Փաստաթղթեր",
    ka: "დოკუმენტები",
  },
  logout: {
    uk: "Вихід",
    en: "Logout",
    hy: "Դուրս գալ",
    ka: "გამოსვლა",
  },
  pt_points: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  pt_networks: {
    uk: "Мережі",
    en: "Networks",
    hy: "Ցանցեր",
    ka: "ქსელები",
  },
  pt_categories: {
    uk: "Категорії",
    en: "Categories",
    hy: "Կատեգորիաներ",
    ka: "კატეგორიები",
  },
  pt_countries: {
    uk: "Країни",
    en: "Countries",
    hy: "Երկրներ",
    ka: "ქვეყნები",
  },
  pt_counties: {
    uk: "Регіони",
    en: "Counties",
    hy: "Մարզեր",
    ka: "რეგიონები",
  },
  pt_localities: {
    uk: "Населені пункти",
    en: "Localities",
    hy: "Բնակավայրեր",
    ka: "დასახლებები",
  },
  pt_point_groups: {
    uk: "Групи точок",
    en: "Point groups",
    hy: "Կետերի խմբեր",
    ka: "წერტილების ჯგუფები",
  },
  pt_surveys: {
    uk: "Опитування",
    en: "Surveys",
    hy: "Հարցումներ",
    ka: "გამოკითხვები",
  },
  orders: {
    uk: "Замовлення",
    en: "Orders",
    hy: "Պատվերներ",
    ka: "შეკვეთები",
  },
  returns: {
    uk: "Повернення",
    en: "Returns",
    hy: "Վերադարձներ",
    ka: "დაბრუნებები",
  },
  counterparties: {
    uk: "Контрагенти",
    en: "Counterparties",
    hy: "Կոնտրագենտներ",
    ka: "კონტრაგენტები",
  },
};
export const MANAGER_PROFILE = {
  my_profile: {
    uk: "Мій профайл",
    en: "My profile",
    hy: "Իմ պրոֆիլը",
    ka: "ჩემი პროფილი",
  },
  my_help: {
    uk: "Допомога",
    en: "Help",
    hy: "Օգնություն",
    ka: "დახმარება",
  },
  name: {
    uk: "Імя",
    en: "Name",
    hy: "Անուն",
    ka: "სახელი",
  },
  surname: {
    uk: "Прізвище",
    en: "Surname",
    hy: "Ազգանուն",
    ka: "გვარი",
  },
  position: {
    uk: "Посада",
    en: "Position",
    hy: "Պաշտոն",
    ka: "პოზიცია",
  },
  my_region: {
    uk: "Мій регіон",
    en: "My region",
    hy: "Իմ մարզը",
    ka: "ჩემი რეგიონი",
  },
  telegram: {
    uk: "Телеграм ID",
    en: "Telegram ID",
    hy: "Տելեգրամ ID",
    ka: "ტელეგრამ ID",
  },
  language: {
    uk: "Мова",
    en: "Language",
    hy: "Լեզու",
    ka: "ენა",
  },
  save: {
    uk: "Зберегти",
    en: "Save",
    hy: "Պահպանել",
    ka: "შენახვა",
  },
  save_success: {
    uk: "Дані успішно збережені",
    en: "Data saved successfully",
    hy: "Տվյալները հաջողությամբ պահպանվեցին",
    ka: "მონაცემები წარმატებით შენახულია",
  },
  save_success_reload: {
    uk: "Дані успішно збережені. Сторінка буде перезавантажена...",
    en: "Data saved successfully. The page will be reloaded...",
    hy: "Տվյալները հաջողությամբ պահպանվեցին։ Էջը կվերբեռնվի...",
    ka: "მონაცემები წარმატებით შენახულია. გვერდი გადაიტვირთება...",
  },
  exit: {
    uk: "Вихід",
    en: "Logout",
    hy: "Դուրս գալ",
    ka: "გამოსვლა",
  },
};
export const ENTITY_DROPDOWN_SETTINGS = {
  custom_filter: {
    uk: "Користувацький фільтр",
    en: "Customer filter",
    hy: "Հատուկ ֆիլտր",
    ka: "მორგებული ფილტრი",
  },
  merchandiser: {
    uk: "Мерчендайзер",
    en: "Merchandiser",
    hy: "Մերչենդայզեր",
    ka: "მერჩენდაიზერი",
  },
  merchandisers: {
    uk: "Мерчендайзери",
    en: "Merchandisers",
    hy: "Մերչենդայզերներ",
    ka: "მერჩენდაიზერები",
  },
  supervisor: {
    uk: "Супервайзер",
    en: "Supervisor",
    hy: "Սուպերվայզեր",
    ka: "სუპერვაიზერი",
  },
  clients: {
    uk: "Клієнти",
    en: "Clients",
    hy: "Հաճախորդներ",
    ka: "კლიენტები",
  },
  counterparty: {
    uk: "Контрагент",
    en: "Counterparty",
    hy: "Կոնտրագենտ",
    ka: "კონტრაგენტი",
  },
  comment: {
    uk: "Коментар",
    en: "Comment",
    hy: "Մեկնաբանություն",
    ka: "კომენტარი",
  },
  point: {
    uk: "Точка",
    en: "Point",
    hy: "Կետ",
    ka: "წერტილი",
  },
  points: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  group_point_select_placeholder: {
    uk: "Група точок",
    en: "Group of points",
    hy: "Կետերի խումբ",
    ka: "წერტილების ჯგუფი",
  },
  network: {
    uk: "Мережа",
    en: "Network",
    hy: "Ցանց",
    ka: "ქსელი",
  },
  networks: {
    uk: "Мережі",
    en: "Networks",
    hy: "Ցանցեր",
    ka: "ქსელები",
  },
  created_by: {
    uk: "Ким створено",
    en: "Created by",
    hy: "Ստեղծել է",
    ka: "შემქმნელი",
  },
  region: {
    uk: "Регіон",
    en: "Region",
    hy: "Մարզ",
    ka: "რეგიონი",
  },
  city: {
    uk: "Місто",
    en: "City",
    hy: "Քաղաք",
    ka: "ქალაქი",
  },
  country: {
    uk: "Оберіть країну",
    en: "Select country",
    hy: "Ընտրեք երկիրը",
    ka: "აირჩიეთ ქვეყანა",
  },
  countries: {
    uk: "Оберіть країну",
    en: "Select country",
    hy: "Ընտրեք երկիրը",
    ka: "აირჩიეთ ქვეყანა",
  },
  brand: {
    uk: "Бренд",
    en: "Brand",
    hy: "Բրենդ",
    ka: "ბრენდი",
  },
  brands: {
    uk: "Бренди",
    en: "Brands",
    hy: "Բրենդներ",
    ka: "ბრენდები",
  },
  product: {
    uk: "Продукт",
    en: "Product",
    hy: "Ապրանք",
    ka: "პროდუქტი",
  },
  products: {
    uk: "Продукти",
    en: "Products",
    hy: "Ապրանքներ",
    ka: "პროდუქტები",
  },
  category: {
    uk: "Категорія",
    en: "Category",
    hy: "Կատեգորիա",
    ka: "კატეგორია",
  },
  categories: {
    uk: "Категорії",
    en: "Categories",
    hy: "Կատեգորիաներ",
    ka: "კატეგორიები",
  },
  subcategories: {
    uk: "Підкатегорія",
    en: "Sub category",
    hy: "Ենթակատեգորիա",
    ka: "ქვეკატეგორია",
  },
  tag: {
    uk: "Тег",
    en: "Tag",
    hy: "Թեգ",
    ka: "ტეგი",
  },
  tags: {
    uk: "Теги",
    en: "Tags",
    hy: "Թեգեր",
    ka: "ტეგები",
  },
  component: {
    uk: "Компонент",
    en: "Component",
    hy: "Բաղադրիչ",
    ka: "კომპონენტი",
  },
  template: {
    uk: "Шаблон",
    en: "Template",
    hy: "Ձևանմուշ",
    ka: "შაბლონი",
  },
  task_status: {
    uk: "Статус: всі",
    en: "Status: all",
    hy: "Կարգավիճակ՝ բոլորը",
    ka: "სტატუსი: ყველა",
  },
  task_negative: {
    uk: "Негативна відповідь",
    en: "Negative answer",
    hy: "Բացասական պատասխան",
    ka: "უარყოფითი პასუხი",
  },
  task_deadline: {
    uk: "Дедлайн",
    en: "Deadline",
    hy: "Դեդլայն",
    ka: "დედლაინი",
  },
  additional_filters: {
    uk: "Додаткові фільтри",
    en: "Additional filters",
    hy: "Լրացուցիչ ֆիլտրեր",
    ka: "დამატებითი ფილტრები",
  },
  apply: {
    uk: "Застосувати",
    en: "Apply",
    hy: "Կիրառել",
    ka: "გამოყენება",
  },
  filter_reset: {
    uk: "Скинути фільтри",
    en: "Reset the filters",
    hy: "Զրոյացնել ֆիլտրերը",
    ka: "ფილტრების გადატვირთვა",
  },
  filter_save: {
    uk: "Зберегти фільтр",
    en: "Save the filter",
    hy: "Պահպանել ֆիլտրը",
    ka: "ფილტრის შენახვა",
  },
  filter_remove: {
    uk: "Видалити фільтр",
    en: "Remove the filter",
    hy: "Հեռացնել ֆիլտրը",
    ka: "ფილტრის წაშლა",
  },
  filter_name_placeholder: {
    uk: "Назва фільтру",
    en: "Filter name",
    hy: "Ֆիլտրի անվանում",
    ka: "ფილტრის სახელი",
  },
  date_range: {
    uk: "Виберіть період",
    en: "Select a certain period",
    hy: "Ընտրեք ժամանակահատված",
    ka: "აირჩიეთ პერიოდი",
  },
  date_today: {
    uk: "Сьогодні",
    en: "Today",
    hy: "Այսօր",
    ka: "დღეს",
  },
  date_yesterday: {
    uk: "Вчора",
    en: "Yesterday",
    hy: "Երեկ",
    ka: "გუშინ",
  },
  date_current_week: {
    uk: "Поточний тиждень",
    en: "Current week",
    hy: "Ընթացիկ շաբաթ",
    ka: "მიმდინარე კვირა",
  },
  date_last_week: {
    uk: "Попередній тиждень",
    en: "Last week",
    hy: "Անցած շաբաթ",
    ka: "გასული კვირა",
  },
  date_current_month: {
    uk: "Поточний місяць",
    en: "Current month",
    hy: "Ընթացիկ ամիս",
    ka: "მიმდინარე თვე",
  },
  date_last_month: {
    uk: "Попередній місяць",
    en: "Last month",
    hy: "Անցած ամիս",
    ka: "გასული თვე",
  },
  date_last_half_year: {
    uk: "Останні пів року",
    en: "Last half a year",
    hy: "Վերջին կես տարի",
    ka: "ბოლო ნახევარი წელი",
  },
  /* The rest of this block belongs to `src/component/PeriodPicker.js` — the shared range picker.
     Rolling windows, which the calendar-aligned ones above do not cover. */
  date_last_7_days: {
    uk: "Останні 7 днів",
    en: "Last 7 days",
    hy: "Վերջին 7 օրը",
    ka: "ბოლო 7 დღე",
  },
  date_last_14_days: {
    uk: "Останні 14 днів",
    en: "Last 14 days",
    hy: "Վերջին 14 օրը",
    ka: "ბოლო 14 დღე",
  },
  date_last_30_days: {
    uk: "Останні 30 днів",
    en: "Last 30 days",
    hy: "Վերջին 30 օրը",
    ka: "ბოლო 30 დღე",
  },
  date_from: {
    uk: "Від",
    en: "From",
    hy: "Սկսած",
    ka: "დან",
  },
  date_to: {
    uk: "До",
    en: "To",
    hy: "Մինչև",
    ka: "მდე",
  },
  date_pick_start: {
    uk: "Виберіть початкову дату",
    en: "Select start date",
    hy: "Ընտրեք սկզբի ամսաթիվը",
    ka: "აირჩიეთ დაწყების თარიღი",
  },
  date_pick_end: {
    uk: "Виберіть кінцеву дату",
    en: "Select end date",
    hy: "Ընտրեք ավարտի ամսաթիվը",
    ka: "აირჩიეთ დასრულების თარიღი",
  },
  /* Days, not months — `PeriodPicker`'s cap is in days now. Abbreviated so the number never has
     to agree with the noun (spec/04), matching `notif_merch_idle`. */
  date_max_range: {
    uk: "максимум {n} д",
    en: "max {n} d",
    hy: "առավելագույնը {n} օր",
    ka: "მაქსიმუმ {n} დღე",
  },
  /* The option list's own three states — `src/component/EntitySelect.js`. */
  option_loading: {
    uk: "Завантаження…",
    en: "Loading…",
    hy: "Բեռնվում է…",
    ka: "იტვირთება…",
  },
  option_no_matches: {
    uk: "Немає відповідників",
    en: "No matches",
    hy: "Համապատասխանություններ չկան",
    ka: "შესატყვისი არ არის",
  },
  option_scroll_more: {
    uk: "Прокрутіть, щоб побачити більше",
    en: "Scroll for more",
    hy: "Ոլորեք ավելին տեսնելու համար",
    ka: "გადაახვიეთ მეტისთვის",
  },
  photo_review_type_group: {
    uk: "Груповий вигляд",
    en: "Grouped",
    hy: "Խմբային տեսք",
    ka: "ჯგუფური ხედი",
  },
  photo_review_type_single: {
    uk: "Індивідуальний вигляд",
    en: "Single",
    hy: "Անհատական տեսք",
    ka: "ინდივიდუალური ხედი",
  },
  date_сurrent_month: {
    uk: "Поточний місяць",
    en: "Current month",
    hy: "Ընթացիկ ամիս",
    ka: "მიმდინარე თვე",
  },
};
export const TRANSLATION_DOWNLOADER = {
  export: {
    uk: "Експортувати",
    en: "Export",
    hy: "Արտահանել",
    ka: "ექსპორტი",
  },
  download: {
    uk: "Скачати",
    en: "Download",
    hy: "Ներբեռնել",
    ka: "ჩამოტვირთვა",
  },
  downloadAll: {
    uk: "Скачати всі",
    en: "Download all",
    hy: "Ներբեռնել բոլորը",
    ka: "ჩამოტვირთე ყველა",
  },
  downloading: {
    uk: "Завантаження",
    en: "Downloading",
    hy: "Ներբեռնվում է",
    ka: "ჩამოტვირთვა მიმდინარეობს",
  },
  confirmation_msg: {
    uk: "Ви впевненні що хочете видалити фільтр?",
    en: "Are you sure that you want to delete the filter?",
    hy: "Համոզված եք, որ ցանկանում եք ջնջել ֆիլտրը?",
    ka: "დარწმუნებული ხართ, რომ გსურთ წაშალოთ ფილტრი?",
  },
  remove_confirmation_msg: {
    uk: "Потрібно вибрати фільтр для видалення",
    en: "Need to select a filter to delete",
    hy: "Ջնջելու համար անհրաժեշտ է ընտրել ֆիլտր",
    ka: "წასაშლელად საჭიროა ფილტრის შერჩევა",
  },
  remove_success_msg: {
    uk: "Фільтр видалений",
    en: "The filter is deleted",
    hy: "Ֆիլտրը ջնջված է",
    ka: "ფილტრი წაშლილია",
  },
  valid_error_msg: {
    uk: "Ім'я фільтра не може бути пустим!",
    en: "The filter's name cannot be empty!",
    hy: "Ֆիլտրի անունը չի կարող դատարկ լինել!",
    ka: "ფილტრის სახელი არ შეიძლება იყოს ცარიელი!",
  },
  newtask_success_msg: {
    uk: "Завдання зберeжене",
    en: "The task is saved",
    hy: "Առաջադրանքը պահպանված է",
    ka: "დავალება შენახულია",
  },

  task_object_item_id_msg: {
    uk: "object_id або object_type не знайдені",
    en: "object_id or object_type not found",
    hy: "object_id կամ object_type չի գտնվել",
    ka: "object_id ან object_type ვერ მოიძებნა",
  },
  task_reject_msg: {
    uk: "Відхиленно",
    en: "Rejection",
    hy: "Մերժում",
    ka: "უარყოფა",
  },
  task_accept_msg: {
    uk: "Затвердженно",
    en: "Approval",
    hy: "Հաստատում",
    ka: "დამტკიცება",
  },
  back: {
    uk: "Назад",
    en: "Back",
    hy: "Հետ",
    ka: "უკან",
  },
  yes: {
    uk: "Так",
    en: "Yes",
    hy: "Այո",
    ka: "დიახ",
  },
  cancel: {
    uk: "Відмінити",
    en: "Cancel",
    hy: "Չեղարկել",
    ka: "გაუქმება",
  },
};
export const ROUTE_CALENDAR = {
  heading: {
    uk: "Маршрути",
    en: "Routes",
    hy: "Երթուղիներ",
    ka: "მარშრუტები",
  },
  /* Both ways of adding a stop are named: dragging does not work on a touch screen and cannot be
     started from the keyboard, so "drag a point" alone described a path half the users do not
     have. */
  legend: {
    uk: "Перетягніть точку на день або оберіть точку й натисніть «Додати сюди». Винятки успадковують тижневий план.",
    en: "Drag a point onto a day, or select a point and choose “Add here”. Overrides inherit the weekly plan.",
    hy: "Քաշեք կետը օրվա վրա կամ ընտրեք կետը և սեղմեք «Ավելացնել այստեղ»։ Բացառությունները ժառանգում են շաբաթական պլանը։",
    ka: "გადაათრიეთ წერტილი დღეზე ან აირჩიეთ წერტილი და დააჭირეთ „დამატება აქ“. გამონაკლისები მემკვიდრეობით იღებენ კვირის გეგმას.",
  },
  search_placeholder: {
    uk: "Пошук точок…",
    en: "Search points…",
    hy: "Փնտրել կետեր…",
    ka: "წერტილების ძებნა…",
  },
  no_points_found: {
    uk: "Точок не знайдено",
    en: "No points found",
    hy: "Կետեր չեն գտնվել",
    ka: "წერტილები ვერ მოიძებნა",
  },
  scope_title: {
    uk: "Додати точку до…",
    en: "Add point to…",
    hy: "Ավելացնել կետը…",
    ka: "წერტილის დამატება…",
  },
  scope_every: {
    uk: "Кожен {day}",
    en: "Every {day}",
    hy: "Ամեն {day}",
    ka: "ყოველ {day}",
  },
  scope_nth: {
    uk: "Лише {ord} {day} щомісяця",
    en: "Only the {ord} {day} of each month",
    hy: "Ամսվա {ord} {day}-ը",
    ka: "თვის {ord} {day}",
  },
  /* Encoded as the 1st+3rd or 2nd+4th Nth-weekday pair — see routeModel.biweeklyNths.
     uk goes through ukGrammar.ukBiweekly for case/gender agreement. */
  scope_biweekly: {
    uk: "Раз на два тижні ({ordA} і {ordB} {day})",
    en: "Every two weeks ({ordA} and {ordB} {day})",
    hy: "Երկու շաբաթը մեկ ({ordA} և {ordB} {day})",
    ka: "ორ კვირაში ერთხელ ({ordA} და {ordB} {day})",
  },
  scope_date: {
    uk: "Лише {date}",
    en: "Only on {date}",
    hy: "Միայն {date}",
    ka: "მხოლოდ {date}",
  },
  cancel: {
    uk: "Скасувати",
    en: "Cancel",
    hy: "Չեղարկել",
    ka: "გაუქმება",
  },
  badge_weekly: {
    uk: "Щотижня",
    en: "Weekly",
    hy: "Շաբաթական",
    ka: "ყოველკვირა",
  },
  badge_date: {
    uk: "Разово",
    en: "One-off",
    hy: "Մեկանգամյա",
    ka: "ერთჯერადი",
  },
  /* Fallback for an absence day whose record carries no reason text (PICSELL-1581 #14). */
  absent_day: {
    uk: "Відсутність",
    en: "Absence",
    hy: "Բացակայություն",
    ka: "არყოფნა",
  },
  ord_first: { uk: "1-й", en: "1st", hy: "1-ին", ka: "1-ლი" },
  ord_second: { uk: "2-й", en: "2nd", hy: "2-րդ", ka: "2-ე" },
  ord_third: { uk: "3-й", en: "3rd", hy: "3-րդ", ka: "3-ე" },
  ord_fourth: { uk: "4-й", en: "4th", hy: "4-րդ", ka: "4-ე" },
  ord_fifth: { uk: "5-й", en: "5th", hy: "5-րդ", ka: "5-ე" },

  /* Click-to-place: dragging is mouse-only (native HTML5 drag fires no events on a touch screen)
     and gave a keyboard user no way to add a stop at all, so selecting a point and then choosing a
     day is the same action by a second route. */
  select_point: {
    uk: "Обрати точку",
    en: "Select point",
    hy: "Ընտրել կետը",
    ka: "წერტილის არჩევა",
  },
  point_selected: {
    uk: "Обрано. Тепер виберіть день.",
    en: "Selected. Now choose a day.",
    hy: "Ընտրված է։ Այժմ ընտրեք օրը։",
    ka: "არჩეულია. ახლა აირჩიეთ დღე.",
  },
  add_here: {
    uk: "Додати сюди",
    en: "Add here",
    hy: "Ավելացնել այստեղ",
    ka: "დამატება აქ",
  },
  clear_selection: {
    uk: "Скасувати вибір",
    en: "Clear selection",
    hy: "Չեղարկել ընտրությունը",
    ka: "არჩევის გასუფთავება",
  },
  /* aria-labels. These were hardcoded English strings, which a screen reader reads out to a
     Ukrainian supervisor verbatim. */
  move_up: {
    uk: "Перемістити вище",
    en: "Move up",
    hy: "Տեղափոխել վեր",
    ka: "აწევა",
  },
  move_down: {
    uk: "Перемістити нижче",
    en: "Move down",
    hy: "Տեղափոխել վար",
    ka: "ჩამოწევა",
  },
  remove_stop: {
    uk: "Видалити точку",
    en: "Remove point",
    hy: "Հեռացնել կետը",
    ka: "წერტილის წაშლა",
  },
  remove_scope_title: {
    uk: "Прибрати точку з…",
    en: "Remove point from…",
    hy: "Հեռացնել կետը…",
    ka: "წერტილის ამოღება…",
  },
  move_stop: {
    uk: "Перенести на інший день",
    en: "Move to another day",
    hy: "Տեղափոխել այլ օր",
    ka: "სხვა დღეზე გადატანა",
  },
  move_scope_title: {
    uk: "Перенести точку на…",
    en: "Move point to…",
    hy: "Տեղափոխել կետը…",
    ka: "წერტილის გადატანა…",
  },
  prev_month: {
    uk: "Попередній місяць",
    en: "Previous month",
    hy: "Նախորդ ամիս",
    ka: "წინა თვე",
  },
  next_month: {
    uk: "Наступний місяць",
    en: "Next month",
    hy: "Հաջորդ ամիս",
    ka: "შემდეგი თვე",
  },
  /* The week view (PICSELL-1615 #8). The stepper's labels change with it: "Previous month" on a
     button that steps a week would be an a11y lie. */
  prev_week: { uk: "Попередній тиждень", en: "Previous week", hy: "Նախորդ շաբաթ", ka: "წინა კვირა" },
  next_week: { uk: "Наступний тиждень", en: "Next week", hy: "Հաջորդ շաբաթ", ka: "შემდეგი კვირა" },
  view_month: { uk: "Місяць", en: "Month", hy: "Ամիս", ka: "თვე" },
  view_week: { uk: "Тиждень", en: "Week", hy: "Շաբաթ", ka: "კვირა" },
  stops_label: {
    uk: "Точок",
    en: "Stops",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  unsaved_changes: {
    uk: "Є незбережені зміни",
    en: "Unsaved changes",
    hy: "Չպահված փոփոխություններ",
    ka: "შეუნახავი ცვლილებები",
  },
  save_failed: {
    uk: "Не вдалося зберегти маршрути",
    en: "Could not save routes",
    hy: "Չհաջողվեց պահել երթուղիները",
    ka: "მარშრუტების შენახვა ვერ მოხერხდა",
  },
};

// Localized labels for hardcoded option arrays in const.js (price-monitoring components,
// outforz statuses, …), keyed by the option VALUE. Missing keys fall back to the raw label.
export const OPTION_LABELS = {
  photo: { uk: "Фото", en: "Photo", hy: "Լուսանկար", ka: "ფოტო" },
  price: { uk: "Ціна", en: "Price", hy: "Գին", ka: "ფასი" },
  sale_price: { uk: "Акційна ціна", en: "Sale price", hy: "Զեղչված գին", ka: "ფასდაკლების ფასი" },
  comment: { uk: "Коментар", en: "Comment", hy: "Մեկնաբանություն", ka: "კომენტარი" },
  created: { uk: "Створено", en: "Created", hy: "Ստեղծված", ka: "შექმნილია" },
  ready_for_neural_network: { uk: "Готово для нейромережі", en: "Ready for neural network", hy: "Պատրաստ նեյրոցանցի", ka: "მზადაა ნეირონული ქსელისთვის" },
  in_neural_network: { uk: "У нейромережі", en: "In neural network", hy: "Նեյրոցանցում", ka: "ნეირონულ ქსელში" },
  got_an_error_in_neural_network: { uk: "Помилка в нейромережі", en: "Error in neural network", hy: "Սխալ նեյրոցանցում", ka: "შეცდომა ნეირონულ ქსელში" },
  open: { uk: "Відкрито", en: "Open", hy: "Բաց", ka: "ღიაა" },
  in_progress: { uk: "В роботі", en: "In progress", hy: "Ընթացքի մեջ", ka: "მიმდინარეობს" },
  review: { uk: "На перевірці", en: "Review", hy: "Վերանայում", ka: "განხილვა" },
  done: { uk: "Виконано", en: "Done", hy: "Կատարված", ka: "დასრულებული" },
  closed: { uk: "Закрито", en: "Closed", hy: "Փակված", ka: "დახურული" },
};

export const MERCHANDISER_MAIN_PAGE = {
  data_successfully_saved: {
    uk: "Дані успішно збережені",
    en: "Data successfully saved",
    hy: "Տվյալները հաջողությամբ պահպանվեցին",
    ka: "მონაცემები წარმატებით შენახულია",
  },
  view_btn: {
    uk: "Перегляд",
    en: "View",
    hy: "Դիտել",
    ka: "ნახვა",
  },
  edit_btn: {
    uk: "Редагувати",
    en: "Edit",
    hy: "Խմբագրել",
    ka: "რედაქტირება",
  },
  routes: {
    uk: "Maршрути",
    en: "Routes",
    hy: "Մարքուտներ",
    ka: "მარშრუტები",
  },
  route: {
    uk: "Маршрут",
    en: "Route",
    hy: "Երթուղի",
    ka: "მარშრუტი",
  },
  assignment: {
    uk: "Завдання",
    en: "Assignment",
    hy: "Առաջադրանք",
    ka: "დავალება",
  },
  visits: {
    uk: "Вiзити",
    en: "Visits",
    hy: "ԱՅՑԵՐ",
    ka: "ვიზიტები",
  },
  presence: {
    uk: "Відсутність",
    en: "Absence",
    hy: "ՆԵՐԿԱՅՈՒԹՅՈՒՆ",
    ka: "დასწრება",
  },
  network_title: {
    uk: "Мережа",
    en: "Network",
    hy: "Ցանց",
    ka: "ქსელი",
  },
  title_title: {
    uk: "Титул",
    en: "Title",
    hy: "Տիտղոս",
    ka: "სათაური",
  },
  start_title: {
    /* Was "Срт" — a truncated Ukrainian value whose Cyrillic С-р-т reads as the pseudo-Latin "CPT",
       which is exactly how it was reported (PICSELL-1574 #4). en/hy/ka were already correct. */
    uk: "Початок",
    en: "Start",
    hy: "Սկիզբ",
    ka: "დაწყება",
  },
  end_title: {
    uk: "Кінець",
    en: "End",
    hy: "Ավարտ",
    ka: "დასასრული",
  },
  number_of_tags_title: {
    uk: "Кількість тегів",
    en: "Number of tags",
    hy: "Թեգերի քանակ",
    ka: "ტეგების რაოდენობა",
  },
  completion_title: {
    uk: "Закінчення",
    en: "Completion",
    hy: "Ավարտում",
    ka: "დასრულება",
  },
  point_title: {
    uk: "Точка",
    en: "Point",
    hy: "Կետ",
    ka: "წერტილი",
  },
  points_title: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  day_title: {
    uk: "День",
    en: "Day",
    hy: "Օր",
    ka: "დღე",
  },
  save_btn: {
    uk: "Зберегти",
    en: "Save",
    hy: "Պահպանել",
    ka: "შენახვა",
  },
  movement: {
    uk: "Пересування",
    en: "Movement",
    hy: "Տեղաշարժ",
    ka: "მოძრაობა",
  },
  connected: {
    uk: "Приєднався",
    en: "Connected",
    hy: "Միացված",
    ka: "დაკავშირებული",
  },
  deactivated: {
    uk: "Деактивований",
    en: "Deactivated",
    hy: "Ապաակտիվացված",
    ka: "დეაქტივირებული",
  },
  till_newbie: {
    uk: "До новачків",
    en: "Till Newbie",
    hy: "Մինչև նորեկ",
    ka: "დამწყებამდე",
  },
  user_status: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  phone_number: {
    uk: "Телефон",
    en: "Phone",
    hy: "Հեռախոս",
    ka: "ტელეფონი",
  },
};
export const MERCHANDISER_LIST = {
  user_name: {
    uk: "Ім'я користувача",
    en: "User name",
    hy: "Օգտատիրոջ անունը",
    ka: "მომხმარებლის სახელი",
  },
  phone_number: {
    uk: "Телефон",
    en: "Phone",
    hy: "Հեռախոս",
    ka: "ტელეფონი",
  },
  movement: {
    uk: "Пересування",
    en: "Movement",
    hy: "Տեղաշարժ",
    ka: "მოძრაობა",
  },
  user_state: {
    uk: "Стан",
    en: "User State",
    hy: "Օգտատիրոջ կարգավիճակ",
    ka: "მომხმარებლის მდგომარეობა",
  },
  date_join: {
    uk: "Дата приєднання",
    en: "Date of joining",
    hy: "Միանալու ամսաթիվ",
    ka: "გაწევრიანების თარიღი",
  },
};
export const ABSENCE_USER = {
  query: {
    uk: "Запит",
    en: "Request",
    hy: "Հայտ",
    ka: "მოთხოვნა",
  },
  date_from: {
    uk: "Дата з",
    en: "Date from",
    hy: "Ամսաթիվը սկսած",
    ka: "თარიღი დან",
  },
  date_to: {
    uk: "Дата до",
    en: "Date to",
    hy: "Ամսաթիվը մինչև",
    ka: "თარიღი მდე",
  },
  reason: {
    uk: "Причина",
    en: "Reason",
    hy: "Պատճառ",
    ka: "მიზეზი",
  },
  add_btn: {
    uk: "Додати",
    en: "Add",
    hy: "Ավելացնել",
    ka: "დამატება",
  },
  absence_history: {
    uk: "Історія відсутностей",
    en: "Absence history",
    hy: "Բացակայության պատմություն",
    ka: "არყოფნის ისტორია",
  },
  absence_reason: {
    uk: "Будь ласка, введіть причину відсутності",
    en: "Please enter the reason of absence",
    hy: "Խնդրում ենք նշել բացակայության պատճառը",
    ka: "გთხოვთ მიუთითოთ არყოფნის მიზეზი",
  },
  absence_short_reason_title: {
    uk: "Варіанти швидких причин відсутності",
    en: "Quick absence reasons",
    hy: "Բացակայության արագ պատճառներ",
    ka: "არყოფნის სასწრაფო მიზეზები",
  },
  absence_short_reason: {
    uk: "Виберіть швидкий варіант причини відсутності",
    en: "You can choose a quick reason for absence",
    hy: "Դուք կարող եք ընտրել բացակայության արագ պատճառ",
    ka: "შეგიძლიათ აირჩიოთ არყოფნის სასწრაფო მიზეზი",
  },
};
export const WEEK = {
  monday: {
    uk: "Понеділок",
    en: "Monday",
    hy: "Երկուշաբթի",
    ka: "ორშაბათი",
  },
  tuesday: {
    uk: "Вівторок",
    en: "Tuesday",
    hy: "Երեքշաբթի",
    ka: "სამშაბათი",
  },
  wednesday: {
    uk: "Середа",
    en: "Wednesday",
    hy: "Չորեքշաբթի",
    ka: "ოთხშაბათი",
  },
  thursday: {
    uk: "Четвер",
    en: "Thursday",
    hy: "Հինգշաբթի",
    ka: "ხუთშაბათი",
  },
  friday: {
    uk: "Пятниця",
    en: "Friday",
    hy: "Ուրբաթ",
    ka: "პარასკევი",
  },
  saturday: {
    uk: "Субота",
    en: "Saturday",
    hy: "Շաբաթ",
    ka: "შაბათი",
  },
  sunday: {
    uk: "Неділя",
    en: "Sunday",
    hy: "Կիրակի",
    ka: "კვირა",
  },
};
export const TAKS_IMPORT = {
  import_tab: {
    uk: "Імпорт",
    en: "Import",
    hy: "Ներմուծում",
    ka: "იმპორტი",
  },
  import_advanced_tab: {
    uk: "Розширений імпорт",
    en: "Advanced Import",
    hy: "Ընդլայնված ներմուծում",
    ka: "დამატებითი იმპორტი",
  },
  import_matrix_tab: {
    uk: "Імпорт: асортимента матриця",
    en: "Import: Assortment Matrix",
    hy: "Ներմուծում. Տեսականու մատրիցա",
    ka: "იმპორტი: ასორტიმენტის მატრიცა",
  },
  import_downloads_tab: {
    uk: "Мої завантаження",
    en: "My Uploads",
    hy: "Իմ վերբեռնումները",
    ka: "ჩემი ატვირთვები",
  },
  type_loading: {
    uk: "Тип завантаження",
    en: "Loading Type",
    hy: "Բեռնման տեսակ",
    ka: "ჩატვირთვის ტიპი",
  },
  click_or_drag_file: {
    uk: "Клікніть або перетягніть файл",
    en: "Click or Drag a File",
    hy: "Սեղմեք կամ քաշեք ֆայլը",
    ka: "დააჭირეთ ან გადმოათრიეთ ფაილი",
  },
  download_btn: {
    uk: "Завантажити",
    en: "Download",
    hy: "Ներբեռնել",
    ka: "ჩამოტვირთვა",
  },
  add_record_btn: {
    uk: "Додати запис",
    en: "Add Record",
    hy: "Ավելացնել գրառում",
    ka: "ჩანაწერის დამატება",
  },
  save_btn: {
    uk: "Зберегти",
    en: "Save",
    hy: "Պահպանել",
    ka: "შენახვა",
  },
  back_btn: {
    uk: "Назад",
    en: "Back",
    hy: "Հետ",
    ka: "უკან",
  },
  status: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  name_title: {
    uk: "Назва",
    en: "Name",
    hy: "Անուն",
    ka: "სახელი",
  },
  line_title: {
    uk: "Рядок",
    en: "Line",
    hy: "Տող",
    ka: "ხაზი",
  },
  start_date_title: {
    uk: "Дата початку",
    en: "Start Date",
    hy: "Սկզբի ամսաթիվ",
    ka: "დაწყების თარიღი",
  },
  end_date_title: {
    uk: "Дата кінця",
    en: "End Date",
    hy: "Ավարտի ամսաթիվ",
    ka: "დასრულების თარიღი",
  },
  photo_title: {
    uk: "Фото",
    en: "Photo",
    hy: "Լուսանկար",
    ka: "ფოტო",
  },
  description_title: {
    uk: "Опис",
    en: "Description",
    hy: "Նկարագրություն",
    ka: "აღწერა",
  },
  added_points_text_label_suf: {
    uk: "Додано",
    en: "Added",
    hy: "Ավելացվել է",
    ka: "დამატებულია",
  },
  added_points_text_label_pref: {
    uk: "точка(точок)",
    en: "point(points)",
    hy: "կետ(եր)",
    ka: "წერტილი(ები)",
  },
  type_tasks_title: {
    uk: "Тип задач",
    en: "Type of tasks",
    hy: "Առաջադրանքների տեսակ",
    ka: "დავალებების ტიპი",
  },
  download_date_title: {
    uk: "Дата завантаження",
    en: "Download date",
    hy: "Ներբեռնման ամսաթիվ",
    ka: "ჩამოტვირთვის თარიღი",
  },
  loading_errors_title: {
    uk: "Помилки завантаження",
    en: "Loading errors",
    hy: "Բեռնման սխալներ",
    ka: "ჩატვირთვის შეცდომები",
  },
  need_title_task_msg: {
    uk: "Потрібно ввести титул завдання",
    en: "You need to enter the title of the task",
    hy: "Անհրաժեշտ է մուտքագրել առաջադրանքի վերնագիրը",
    ka: "საჭიროა შეიყვანოთ დავალების სათაური",
  },
  download_was_delete_msg: {
    uk: "Завантаження успішно видалено",
    en: "Download has been successfully deleted",
    hy: "Ներբեռնումը հաջողությամբ ջնջվել է",
    ka: "ჩამოტვირთვა წარმატებით წაიშალა",
  },
  need_choose_task_msg: {
    uk: "Потрібно вибрати шаблон",
    en: "You need to choose a template",
    hy: "Անհրաժեշտ է ընտրել ձևանմուշ",
    ka: "საჭიროა შაბლონის არჩევა",
  },
  need_choose_point_msg: {
    uk: "Потрібно вибрати точку",
    en: "Point is required field",
    hy: "Կետը պարտադիր դաշտ է",
    ka: "წერტილი სავალდებულო ველია",
  },
  /* Added with the `"network"` branch in `validateReviewTask` — before it, a network task always
     failed the `"single"` check with "Point is required". hy/ka need native review. */
  need_choose_network_msg: {
    uk: "Потрібно вибрати мережу",
    en: "Network is required field",
    hy: "Ցանցը պարտադիր դաշտ է",
    ka: "ქსელი სავალდებულო ველია",
  },
  need_choose_point_group_msg: {
    uk: "Потрібно вибрати групу точок",
    en: "Group of points is required field",
    hy: "Կետերի խումբը պարտադիր դաշտ է",
    ka: "წერტილების ჯგუფი სავალდებულო ველია",
  },
  create_success_group_task_msg: {
    uk: "Ваші завдання створюються та будуть готові за кілька хвилин.",
    en: "Creating your tasks. They will be ready in a couple of minutes.",
    hy: "Ձեր առաջադրանքները ստեղծվում են։ Դրանք պատրաստ կլինեն մի քանի րոպեում։",
    ka: "თქვენი დავალებები იქმნება. ისინი მზად იქნება რამდენიმე წუთში.",
  },
  need_choose_point_group_name_msg: {
    uk: "Потрібно ввести титул завантаження",
    en: "Group of points title is required field",
    hy: "Կետերի խմբի վերնագիրը պարտադիր դաշտ է",
    ka: "წერტილების ჯგუფის სათაური სავალდებულო ველია",
  },
  empty_field_msg: {
    uk: "Це поле не може бути пустим",
    en: "This field cannot be empty",
    hy: "Այս դաշտը չի կարող դատարկ լինել",
    ka: "ეს ველი არ შეიძლება იყოს ცარიელი",
  },
  download_name: {
    uk: "Назва завантаження",
    en: "Download name",
    hy: "Ներբեռնման անվանում",
    ka: "ჩამოტვირთვის სახელი",
  },
  select_download_type: {
    uk: "Оберіть типа завантаження",
    en: "Choose the download type",
    hy: "Ընտրեք ներբեռնման տեսակը",
    ka: "აირჩიეთ ჩამოტვირთვის ტიპი",
  },
  click_drag_img: {
    uk: "Клікніть або перетягніть зображення сюди",
    en: "Click or drag the image here",
    hy: "Սեղմեք կամ քաշեք նկարը այստեղ",
    ka: "დააჭირეთ ან გადმოათრიეთ სურათი აქ",
  },
  only_one_photo_allowed_for_type_point: {
    uk: "Для типу завантаження 'Точка' дозволене лише одне фото",
    en: "For upload type 'Point', only one photo is allowed",
    hy: "«Կետ» տեսակի վերբեռնման համար թույլատրվում է միայն մեկ լուսանկար",
    ka: "'წერტილი' ტიპის ატვირთვისთვის დაშვებულია მხოლოდ ერთი ფოტო",
  },
  complete_at_least_one_task_msg: {
    uk: "Заповніть хоча б одне завдання або виберіть файл для імпорту",
    en: "Complete at least one task or select a file to import",
    hy: "Լրացրեք առնվազն մեկ առաջադրանք կամ ընտրեք ֆայլ ներմուծման համար",
    ka: "შეავსეთ სულ მცირე ერთი დავალება ან აირჩიეთ ფაილი იმპორტისთვის",
  },
  network_label: {
    uk: "Мережа",
    en: "Network",
    hy: "Ցանց",
    ka: "ქსელი",
  },
  point_label: {
    uk: "Точка",
    en: "Point",
    hy: "Կետ",
    ka: "წერტილი",
  },
  remove_btn: {
    uk: "Видалити",
    en: "Remove",
    hy: "Հեռացնել",
    ka: "წაშლა",
  },
  addresses_label: {
    uk: "Адреса",
    en: "Addresses",
    hy: "Հասցեներ",
    ka: "მისამართები",
  },
  code_label: {
    uk: "Код",
    en: "Code",
    hy: "Կոդ",
    ka: "კოდი",
  },
  location_label: {
    uk: "Розташування",
    en: "Location",
    hy: "Գտնվելու վայր",
    ka: "მდებარეობა",
  },
  coordinates_label: {
    uk: "Координати",
    en: "Coordinates",
    hy: "Կոորդինատներ",
    ka: "კოორდინატები",
  },
  view_the_point: {
    uk: "Перегляд точки",
    en: "View the point",
    hy: "Դիտել կետը",
    ka: "წერტილის ნახვა",
  },
  grouping_btn_name: {
    uk: "Групування",
    en: "Grouping",
    hy: "Խմբավորում",
    ka: "დაჯგუფება",
  },
  new_group_btn_name: {
    uk: "Нова група",
    en: "New Group",
    hy: "Նոր խումբ",
    ka: "ახალი ჯგუფი",
  },
  grouping_popup_title: {
    uk: "Групування торгових точок",
    en: "Grouping of trade points",
    hy: "Առևտրի կետերի խմբավորում",
    ka: "სავაჭრო წერტილების დაჯგუფება",
  },
  new_group_popup_title: {
    uk: "Існуючі групи",
    en: "Existing groups",
    hy: "Առկա խմբեր",
    ka: "არსებული ჯგუფები",
  },
  new_group_popup_new_title: {
    uk: "Створення нової групи",
    en: "Creating a new group",
    hy: "Նոր խմբի ստեղծում",
    ka: "ახალი ჯგუფის შექმნა",
  },
  new_group_popup_edit_title: {
    uk: "Редагування групи",
    en: "Editing group",
    hy: "Խմբի խմբագրում",
    ka: "ჯგუფის რედაქტირება",
  },
  new_group_popup_field_name: {
    uk: "Назва групи",
    en: "Group Name",
    hy: "Խմբի անվանում",
    ka: "ჯგუფის სახელი",
  },
  new_group_popup_field_group_textarea_name: {
    uk: "Торгові точки",
    en: "Trade points",
    hy: "Առևտրի կետեր",
    ka: "სავაჭრო წერტილები",
  },
  group_popup_filter_name_label: {
    uk: "Фільтр точок",
    en: "Points filter",
    hy: "Կետերի ֆիլտր",
    ka: "წერტილების ფილტრი",
  },
  new_group_popup_field_group_available_users: {
    uk: "Доступно для",
    en: "Available for",
    hy: "Հասանելի է",
    ka: "ხელმისაწვდომია",
  },
  new_group_popup_field_name_placeholder: {
    uk: "Введіть назву групи. Мінімум 5 символів",
    en: "Enter the name of the group. Minimum 5 characters",
    hy: "Մուտքագրեք խմբի անվանումը։ Առնվազն 5 նշան",
    ka: "შეიყვანეთ ჯგუფის სახელი. მინიმუმ 5 სიმბოლო",
  },
  group_popup_filter_name_placeholder: {
    uk: "Фільтрування торгових точок (мін 3 символи)",
    en: "Filtering trade points (min 3 characters)",
    hy: "Առևտրի կետերի զտում (նվազագույնը 3 նշան)",
    ka: "სავაჭრო წერტილების ფილტრაცია (მინ. 3 სიმბოლო)",
  },
  new_group_popup_field_group_add_all_btn_text: {
    uk: "Додати всі точки",
    en: "Add all points",
    hy: "Ավելացնել բոլոր կետերը",
    ka: "ყველა წერტილის დამატება",
  },
  new_group_popup_field_group_placeholder: {
    uk: "Виберіть торгові точки зі списку",
    en: "Choose trade points from the list",
    hy: "Ընտրեք առևտրի կետերը ցանկից",
    ka: "აირჩიეთ სავაჭრო წერტილები სიიდან",
  },
  group_popup_filter_name_empty_placeholder: {
    uk: "Торгових точок що відповідають вашому фільтру не знайдено",
    en: "No trade points matching your filter were found.",
    hy: "Ձեր ֆիլտրին համապատասխանող առևտրի կետեր չեն գտնվել։",
    ka: "თქვენი ფილტრის შესატყვისი სავაჭრო წერტილები არ მოიძებნა.",
  },
  new_group_popup_field_users_placeholder: {
    uk: "Виберіть кому доступна група зі списку",
    en: "Choose who has access to the group from the list",
    hy: "Ընտրեք ցանկից, ում համար հասանելի է խումբը",
    ka: "აირჩიეთ სიიდან, ვისთვისაც ხელმისაწვდომია ჯგუფი",
  },
  new_group_popup_error_text: {
    uk: "Поле не може бути пустим",
    en: "The field cannot be empty",
    hy: "Դաշտը չի կարող դատարկ լինել",
    ka: "ველი არ შეიძლება იყოს ცარიელი",
  },
  new_group_popup_error_text_minimum: {
    uk: "Мінімум 5 символів",
    en: "Minimum 5 characters",
    hy: "Առնվազն 5 նշան",
    ka: "მინიმუმ 5 სიმბოლო",
  },
  new_group_popup_success_save_text: {
    uk: "Успішно збережено",
    en: "Successfully saved",
    hy: "Հաջողությամբ պահպանվել է",
    ka: "წარმატებით შეინახა",
  },
  new_group_popup_success_deleted_text: {
    uk: "Успішно видалено",
    en: "Successfully deleted",
    hy: "Հաջողությամբ ջնջվել է",
    ka: "წარმატებით წაიშალა",
  },
  new_group_popup_failed_deleted_text: {
    uk: "Помилка видалення, дивіться деталі в консолі",
    en: "Failed to delete, check the console",
    hy: "Ջնջումը ձախողվեց, ստուգեք console-ը",
    ka: "წაშლა ვერ მოხერხდა, გადაამოწმეთ კონსოლი",
  },
  new_group_popup_user_validate_error_text: {
    uk: "У вас немає дозволу для виконання цієї дії",
    en: "You do not have permission to perform this action.",
    hy: "Դուք չունեք այս գործողությունը կատարելու թույլտվություն։",
    ka: "თქვენ არ გაქვთ ამ მოქმედების შესრულების უფლება.",
  },
  new_group_popup_error_save_text: {
    uk: "Помилка створення нової группи",
    en: "Error creating a new group",
    hy: "Սխալ նոր խումբ ստեղծելիս",
    ka: "შეცდომა ახალი ჯგუფის შექმნისას",
  },
  new_group_popup_error_update_text: {
    uk: "Помилка оновлення группи",
    en: "Error updating group",
    hy: "Սխալ խումբը թարմացնելիս",
    ka: "შეცდომა ჯგუფის განახლებისას",
  },
  new_group_popup_delete_approve_text: {
    uk: "Ви впевнені, що хочете видалити?",
    en: "Are you sure you want to delete?",
    hy: "Համոզված եք, որ ուզում եք ջնջել?",
    ka: "დარწმუნებული ხართ, რომ გსურთ წაშლა?",
  },
  new_group_popup_btn_save_name: {
    uk: "Зберегти",
    en: "Save",
    hy: "Պահպանել",
    ka: "შენახვა",
  },
  no_group_found_msg: {
    uk: "Жодна група не знайдена",
    en: "No group found",
    hy: "Խումբ չի գտնվել",
    ka: "ჯგუფი არ მოიძებნა",
  },
  selected_point_row_has_error: {
    uk: "При виборі точки виникла помилка",
    en: "An error occurred while selecting the point",
    hy: "Կետը ընտրելիս սխալ տեղի ունեցավ",
    ka: "წერტილის არჩევისას მოხდა შეცდომა",
  },
  file_successfully_uploaded: {
    uk: "Файл успішно завантажений",
    en: "File Successfully Uploaded",
    hy: "Ֆայլը հաջողությամբ վերբեռնվեց",
    ka: "ფაილი წარმატებით აიტვირთა",
  },
  file_error_uploaded: {
    uk: "Виникла помилка при загрузці файла",
    en: "An error occurred while loading the file.",
    hy: "Ֆայլը բեռնելիս սխալ տեղի ունեցավ։",
    ka: "ფაილის ჩატვირთვისას მოხდა შეცდომა.",
  },
  import_group_dragdrop_label: {
    uk: "Клікніть або перетягніть файл сюди або виберіть торгові точки зі списку",
    en: "Click or drag the file here or select the trade points from the list",
    hy: "Սեղմեք կամ քաշեք ֆայլը այստեղ, կամ ընտրեք առևտրի կետերը ցանկից",
    ka: "დააჭირეთ ან გადმოათრიეთ ფაილი აქ, ან აირჩიეთ სავაჭრო წერტილები სიიდან",
  },
  import_group_dragdrop_approve_file_text: {
    uk: "Тільки .csv,.xlsx файл",
    en: "Only .csv,.xlsx file",
    hy: "Միայն .csv, .xlsx ֆայլ",
    ka: "მხოლოდ .csv, .xlsx ფაილი",
  },
  confirm_clear_all_points_before_change: {
    uk: "Ви додали всі поінти. Очистити список та продовжити? (ОК — очистити, Скасувати — залишити)",
    en: "You added all points. Clear the list and proceed? (OK — clear, Cancel — keep)",
    hy: "Դուք ավելացրել եք բոլոր կետերը։ Մաքրել ցանկը և շարունակել։ (OK — մաքրել, Չեղարկել — պահել)",
    ka: "თქვენ დაამატეთ ყველა წერტილი. გავასუფთაოთ სია და გავაგრძელოთ? (OK — გასუფთავება, გაუქმება — შენარჩუნება)",
  },
  confirm_reset_or_keep_points: {
    uk: "В списку є вибрані поінти. Додати нові до існуючих? (ОК — додати до існуючих, Скасувати — скинути)",
    en: "Points exist in the list. Add new ones to existing? (OK — add to existing, Cancel — reset)",
    hy: "Ցանկում կան ընտրված կետեր։ Ավելացնել նորերը գոյություն ունեցողներին։ (OK — ավելացնել առկաներին, Չեղարկել — զրոյացնել)",
    ka: "სიაში არსებობს არჩეული წერტილები. დავამატოთ ახლები არსებულებთან? (OK — დამატება არსებულთან, გაუქმება — გადაყენება)",
  },
  add_to_group_btn: {
    uk: "Додати до групи",
    en: "Add to group",
    hy: "Ավելացնել խմբին",
    ka: "ჯგუფში დამატება",
  },
  cancel_btn: {
    uk: "Відмінити",
    en: "Cancel",
    hy: "Չեղարկել",
    ka: "გაუქმება",
  },
  group_already_in: {
    uk: "Уже в групі:",
    en: "Already in the group:",
    hy: "Արդեն խմբում՝",
    ka: "უკვე ჯგუფშია:",
  },
  group_field_label: {
    uk: "Група",
    en: "Group",
    hy: "Խումբ",
    ka: "ჯგუფი",
  },
  group_has_points: {
    uk: "Точок у групі:",
    en: "Points in the group:",
    hy: "Կետեր խմբում՝",
    ka: "წერტილები ჯგუფში:",
  },
  group_import_btn: {
    uk: "Імпорт з файлу",
    en: "Import from file",
    hy: "Ներմուծել ֆայլից",
    ka: "იმპორტი ფაილიდან",
  },
  group_manage_link: {
    uk: "Керування групами",
    en: "Manage groups",
    hy: "Խմբերի կառավարում",
    ka: "ჯგუფების მართვა",
  },
  group_more_hidden: {
    uk: "Ще {n}",
    en: "{n} more",
    hy: "Եվս {n}",
    ka: "კიდევ {n}",
  },
  group_no_points: {
    uk: "Немає точок для додавання",
    en: "No points to add",
    hy: "Ավելացնելու կետեր չկան",
    ka: "დასამატებელი წერტილები არ არის",
  },
  group_points_added: {
    uk: "Точки додано до групи",
    en: "Points added to the group",
    hy: "Կետերն ավելացվել են խմբին",
    ka: "წერტილები დაემატა ჯგუფს",
  },
  group_points_to_add: {
    uk: "Точки для додавання",
    en: "Points to add",
    hy: "Ավելացվող կետեր",
    ka: "დასამატებელი წერტილები",
  },
  group_target_existing: {
    uk: "Існуюча група",
    en: "Existing group",
    hy: "Առկա խումբ",
    ka: "არსებული ჯგუფი",
  },
  group_target_new: {
    uk: "Нова група",
    en: "New group",
    hy: "Նոր խումբ",
    ka: "ახალი ჯგუფი",
  },
};
export const DOCUMENTS = {
  file_deleted: {
    uk: "Файл видалений",
    en: "File Deleted",
    hy: "Ֆայլը ջնջված է",
    ka: "ფაილი წაშლილია",
  },
  file_name_cannot_be_empty: {
    uk: "Ім'я файлу не може бути пустим",
    en: "File Name Cannot Be Empty",
    hy: "Ֆայլի անունը չի կարող դատարկ լինել",
    ka: "ფაილის სახელი არ შეიძლება იყოს ცარიელი",
  },
  need_to_add_file: {
    uk: "Потрібно додати файл",
    en: "Need to Add File",
    hy: "Անհրաժեշտ է ավելացնել ֆայլ",
    ka: "საჭიროა ფაილის დამატება",
  },
  file_successfully_uploaded: {
    uk: "Файл успішно завантажений",
    en: "File Successfully Uploaded",
    hy: "Ֆայլը հաջողությամբ վերբեռնվեց",
    ka: "ფაილი წარმატებით აიტვირთა",
  },
  add_file: {
    uk: "Додати файл",
    en: "Add File",
    hy: "Ավելացնել ֆայլ",
    ka: "ფაილის დამატება",
  },
  file_name: {
    uk: "Назва файлу",
    en: "File Name",
    hy: "Ֆայլի անուն",
    ka: "ფაილის სახელი",
  },
  click_or_drag_files_here: {
    uk: "Клікніть або перетягніть файли сюди",
    en: "Click or Drag Files Here",
    hy: "Սեղմեք կամ քաշեք ֆայլերը այստեղ",
    ka: "დააჭირეთ ან გადმოათრიეთ ფაილები აქ",
  },
  download_file_btn: {
    uk: "Завантажити файл",
    en: "Download File",
    hy: "Ներբեռնել ֆայլը",
    ka: "ფაილის ჩამოტვირთვა",
  },
  creation_time: {
    uk: "Час створення",
    en: "Creation Time",
    hy: "Ստեղծման ժամանակ",
    ka: "შექმნის დრო",
  },
  search: {
    uk: "Пошук",
    en: "Search",
    hy: "Որոնում",
    ka: "ძებნა",
  },
  confirm_delete: {
    uk: "Видалити «{name}»?",
    en: "Delete “{name}”?",
    hy: "Ջնջե՞լ «{name}»-ը:",
    ka: "წავშალო „{name}“?",
  },
  empty_desc: {
    uk: "Завантажте перший файл, щоб поділитися ним із командою",
    en: "Upload the first file to share it with your team",
    hy: "Վերբեռնեք առաջին ֆայլը՝ թիմի հետ կիսվելու համար",
    ka: "ატვირთეთ პირველი ფაილი, რომ გაუზიაროთ გუნდს",
  },
  empty_search_desc: {
    uk: "Змініть запит або очистіть пошук",
    en: "Change the query or clear the search",
    hy: "Փոխեք հարցումը կամ մաքրեք որոնումը",
    ka: "შეცვალეთ მოთხოვნა ან გაასუფთავეთ ძებნა",
  },
  empty_search_title: {
    uk: "Нічого не знайдено",
    en: "Nothing found",
    hy: "Ոչինչ չի գտնվել",
    ka: "ვერაფერი მოიძებნა",
  },
  empty_title: {
    uk: "Файлів ще немає",
    en: "No files yet",
    hy: "Ֆայլեր դեռ չկան",
    ka: "ფაილები ჯერ არ არის",
  },
  f_type: {
    uk: "Тип",
    en: "Type",
    hy: "Տիպ",
    ka: "ტიპი",
  },
  page_sub: {
    uk: "Файли, доступні вашій команді",
    en: "Files available to your team",
    hy: "Ձեր թիմին հասանելի ֆայլերը",
    ka: "თქვენი გუნდისთვის ხელმისაწვდომი ფაილები",
  },
  search_ph: {
    uk: "Назва файлу",
    en: "File name",
    hy: "Ֆայլի անուն",
    ka: "ფაილის სახელი",
  },
};
export const PHOTO_REVIEW = {
  merchendiser: {
    uk: "Мерчендайзер",
    en: "Merchendiser",
    hy: "Մերչենդայզեր",
    ka: "მერჩენდაიზერი",
  },
  responsible_supervisor: {
    uk: "Відповідальний супервайзер",
    en: "Responsible supervisor",
    hy: "Պատասխանատու վերակացու",
    ka: "პასუხისმგებელი სუპერვაიზერი",
  },
  start_visit: {
    uk: "Старт візиту",
    en: "The start of the visit",
    hy: "Այցի սկիզբը",
    ka: "ვიზიტის დაწყება",
  },
  end_visit: {
    uk: "Кінець візиту",
    en: "The end of the visit",
    hy: "Այցի ավարտը",
    ka: "ვიზიტის დასასრული",
  },
  comment: {
    uk: "Коментар",
    en: "Comment",
    hy: "Մեկնաբանություն",
    ka: "კომენტარი",
  },
  price: {
    uk: "Ціна",
    en: "Price",
    hy: "Գին",
    ka: "ფასი",
  },
  sales_price: {
    uk: "Ціна продажу",
    en: "Sales price",
    hy: "Վաճառքի գին",
    ka: "გაყიდვის ფასი",
  },
  price_monitoring: {
    uk: "Моніторинг цін",
    en: "Price monitoring",
    hy: "Գների մոնիտորինգ",
    ka: "ფასების მონიტორინგი",
  },
  approve_reject_label_block: {
    uk: "Статус затвердження/відхилення",
    en: "Approval/Rejection Status",
    hy: "Հաստատման/մերժման կարգավիճակ",
    ka: "დამტკიცების/უკუქცევის სტატუსი",
  },
  approv_btn: {
    uk: "Затвердити",
    en: "Approve",
    hy: "Հաստատել",
    ka: "დამტკიცება",
  },
  reject_btn: {
    uk: "Відхилити",
    en: "Reject",
    hy: "Մերժել",
    ka: "უკუქცევა",
  },
  approved_by: {
    uk: "Затверджено",
    en: "Approved by",
    hy: "Հաստատված է՝",
    ka: "დამტკიცებულია",
  },
  rejected_by: {
    uk: "Відхилено",
    en: "Rejected by",
    hy: "Մերժված է՝",
    ka: "უკუქცეულია",
  },
  app_reject_date: {
    uk: "Дата",
    en: "Date",
    hy: "Ամսաթիվ",
    ka: "თარიღი",
  },
  answer: {
    uk: "Відповідь",
    en: "Answer",
    hy: "Պատասխան",
    ka: "პასუხი",
  },
  linkedTasks: {
    uk: "Повязані задачі",
    en: "Linked tasks",
    hy: "Կապակցված առաջադրանքներ",
    ka: "დაკავშირებული დავალებები",
  },
  linkedVisit: {
    uk: "Візит",
    en: "Visit",
    hy: "Այց",
    ka: "ვიზიტი",
  },
  description: {
    uk: "Опис",
    en: "Description",
    hy: "Նկարագրություն",
    ka: "აღწერა",
  },
  yes: {
    uk: "Так",
    en: "Yes",
    hy: "Այո",
    ka: "დიახ",
  },
  no: {
    uk: "Ні",
    en: "No",
    hy: "Ոչ",
    ka: "არა",
  },
  created_by: {
    uk: "Ким створено",
    en: "Created by",
    hy: "Ստեղծված է՝",
    ka: "შექმნილია",
  },
  priority: {
    uk: "Пріорітет",
    en: "Priority",
    hy: "Առաջնահերթություն",
    ka: "პრიორიტეტი",
  },
  status: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  approved: {
    uk: "Затверджено",
    en: "Approved",
    hy: "Հաստատված",
    ka: "დამტკიცებული",
  },
  rejected: {
    uk: "Відхілено",
    en: "Rejected",
    hy: "Մերժված",
    ka: "უკუქცეული",
  },
};
/* ------------------------------------------------------------------
   PHOTO_REPORT — the redesigned /photo-review page (docs/design/photo-review.html).
   Only strings the page needs that no existing group already carries: the filter labels come
   from ENTITY_DROPDOWN_SETTINGS, the export/download verbs from TRANSLATION_DOWNLOADER, and
   the review-panel labels from PHOTO_REVIEW. Counts are kept away from nouns per
   docs/design/spec/04-content-i18n.md#counts.
   ⚠ hy / ka are best-effort and NEED NATIVE REVIEW before release.
   ------------------------------------------------------------------ */
export const PHOTO_REPORT = {
  load_failed: {
    uk: "Не вдалося завантажити фотозвіти",
    en: "Could not load the photo reports",
    hy: "Չհաջողվեց բեռնել լուսանկարների հաշվետվությունները",
    ka: "ფოტოანგარიშების ჩატვირთვა ვერ მოხერხდა",
  },
  status_all: {
    uk: "Усі",
    en: "All",
    hy: "Բոլորը",
    ka: "ყველა",
  },
  status_pending: {
    uk: "На перевірці",
    en: "On verification",
    hy: "Ստուգման փուլում",
    ka: "შემოწმებაზე",
  },
  status_approved: {
    uk: "Затверджено",
    en: "Approved",
    hy: "Հաստատված",
    ka: "დამტკიცებული",
  },
  status_rejected: {
    uk: "Не затверджено",
    en: "Not approved",
    hy: "Չհաստատված",
    ka: "არ არის დამტკიცებული",
  },
  records_count: {
    uk: "Кількість записів",
    en: "Records count",
    hy: "Գրառումների քանակը",
    ka: "ჩანაწერების რაოდენობა",
  },
  select_all: {
    uk: "Вибрати всі",
    en: "Select all",
    hy: "Ընտրել բոլորը",
    ka: "ყველას მონიშვნა",
  },
  clear_selection: {
    uk: "Очистити",
    en: "Clear",
    hy: "Մաքրել",
    ka: "გასუფთავება",
  },
  w_selected: {
    uk: "Вибрано: {n}",
    en: "{n} selected",
    hy: "Ընտրված է՝ {n}",
    ka: "მონიშნულია: {n}",
  },
  w_position: {
    uk: "{i} з {n}",
    en: "{i} of {n}",
    hy: "{i} / {n}",
    ka: "{i} / {n}",
  },
  photos_label: {
    uk: "Фото",
    en: "Photos",
    hy: "Լուսանկարներ",
    ka: "ფოტოები",
  },
  empty_title: {
    uk: "Немає фото за цими фільтрами",
    en: "No photos match these filters",
    hy: "Այս զտիչներով լուսանկարներ չկան",
    ka: "ამ ფილტრებით ფოტოები არ არის",
  },
  empty_desc: {
    uk: "Спробуйте розширити період або зняти частину фільтрів.",
    en: "Try widening the date range or clearing some filters.",
    hy: "Փորձեք ընդլայնել ժամանակահատվածը կամ հեռացնել որոշ զտիչներ։",
    ka: "სცადეთ პერიოდის გაფართოება ან ნაწილი ფილტრების მოხსნა.",
  },
  load_more: {
    uk: "Завантажити ще",
    en: "Load more",
    hy: "Բեռնել ևս",
    ka: "მეტის ჩატვირთვა",
  },
  review_title: {
    uk: "Перегляд фото",
    en: "Photo review",
    hy: "Լուսանկարի ստուգում",
    ka: "ფოტოს განხილვა",
  },
  no_photo: {
    uk: "Немає фото",
    en: "No photo",
    hy: "Լուսանկար չկա",
    ka: "ფოტო არ არის",
  },
  period: {
    uk: "Період",
    en: "Period",
    hy: "Ժամանակահատված",
    ka: "პერიოდი",
  },
  kbd_hint: {
    uk: "← → перехід · A затвердити · R відхилити · Esc закрити",
    en: "← → to move · A approve · R reject · Esc to close",
    hy: "← → տեղափոխում · A հաստատել · R մերժել · Esc փակել",
    ka: "← → გადაადგილება · A დამტკიცება · R უკუქცევა · Esc დახურვა",
  },
  filter_saved_msg: {
    uk: "Фільтр збережено",
    en: "The filter is saved",
    hy: "Զտիչը պահպանված է",
    ka: "ფილტრი შენახულია",
  },
  print_hint: {
    uk: "Друк поточної вибірки",
    en: "Print the current selection",
    hy: "Տպել ընթացիկ ընտրանքը",
    ka: "მიმდინარე მონაცემების ბეჭდვა",
  },
  a_prev: {
    uk: "Попередній звіт",
    en: "Previous report",
    hy: "Նախորդ հաշվետվությունը",
    ka: "წინა ანგარიში",
  },
  a_next: {
    uk: "Наступний звіт",
    en: "Next report",
    hy: "Հաջորդ հաշվետվությունը",
    ka: "შემდეგი ანგარიში",
  },
  a_close: {
    uk: "Закрити",
    en: "Close",
    hy: "Փակել",
    ka: "დახურვა",
  },
  a_select: {
    uk: "Вибрати",
    en: "Select",
    hy: "Ընտրել",
    ka: "მონიშვნა",
  },
  a_prev_photo: {
    uk: "Попереднє фото",
    en: "Previous photo",
    hy: "Նախորդ լուսանկարը",
    ka: "წინა ფოტო",
  },
  a_next_photo: {
    uk: "Наступне фото",
    en: "Next photo",
    hy: "Հաջորդ լուսանկարը",
    ka: "შემდეგი ფოტო",
  },
  a_photo_n: {
    uk: "Фото {n}",
    en: "Photo {n}",
    hy: "Լուսանկար {n}",
    ka: "ფოტო {n}",
  },
  a_remove_filter: {
    uk: "Зняти фільтр",
    en: "Remove filter",
    hy: "Հեռացնել զտիչը",
    ka: "ფილტრის მოხსნა",
  },
  annot_clear: {
    uk: "Очистити",
    en: "Clear",
    hy: "Մաքրել",
    ka: "გასუფთავება",
  },
  annot_colour: {
    uk: "Колір",
    en: "Colour",
    hy: "Գույն",
    ka: "ფერი",
  },
  annot_fit: {
    uk: "Вмістити",
    en: "Fit",
    hy: "Տեղավորել",
    ka: "მორგება",
  },
  annot_hint: {
    uk: "Прокручування — масштаб, подвійне клацання по «Вмістити» — скинути",
    en: "Scroll to zoom, Fit to reset the view",
    hy: "Ոլորումը՝ մասշտաբ, «Տեղավորել»՝ վերականգնել տեսքը",
    ka: "სქროლი — მასშტაბი, «მორგება» — ხედის დაბრუნება",
  },
  annot_text_hint: {
    uk: "Текст, Enter — додати",
    en: "Text, Enter to add",
    hy: "Տեքստ, Enter՝ ավելացնել",
    ka: "ტექსტი, Enter — დამატება",
  },
  annot_unavailable: {
    uk: "Не вдалося завантажити фото для розмітки. Доручення можна створити без неї.",
    en: "The photo could not be loaded for markup. The task can still be created without it.",
    hy: "Չհաջողվեց բեռնել լուսանկարը նշումների համար։ Հանձնարարությունը կարելի է ստեղծել առանց դրա։",
    ka: "ფოტოს ჩატვირთვა ვერ მოხერხდა მონიშვნისთვის. დავალების შექმნა მაინც შესაძლებელია.",
  },
  annot_undo: {
    uk: "Скасувати",
    en: "Undo",
    hy: "Հետարկել",
    ka: "დაბრუნება",
  },
  annot_weight: {
    uk: "Товщина",
    en: "Stroke weight",
    hy: "Հաստություն",
    ka: "სისქე",
  },
  search: {
    uk: "Пошук",
    en: "Search",
    hy: "Որոնում",
    ka: "ძებნა",
  },
  a_zoom_in: {
    uk: "Збільшити",
    en: "Zoom in",
    hy: "Մեծացնել",
    ka: "გადიდება",
  },
  a_zoom_out: {
    uk: "Зменшити",
    en: "Zoom out",
    hy: "Փոքրացնել",
    ka: "დაპატარავება",
  },
  a_zoom_reset: {
    uk: "Вихідний розмір",
    en: "Reset zoom",
    hy: "Վերականգնել չափը",
    ka: "ზომის დაბრუნება",
  },
  a_open_image: {
    uk: "Відкрити фото в новій вкладці",
    en: "Open photo in a new tab",
    hy: "Բացել լուսանկարը նոր ներդիրում",
    ka: "ფოტოს გახსნა ახალ ჩანართში",
  },
  a_copy_image_link: {
    uk: "Копіювати посилання на фото",
    en: "Copy photo link",
    hy: "Պատճենել լուսանկարի հղումը",
    ka: "ფოტოს ბმულის კოპირება",
  },
  link_copied: {
    uk: "Посилання скопійовано",
    en: "Link copied",
    hy: "Հղումը պատճենվեց",
    ka: "ბმული დაკოპირდა",
  },
  link_copy_failed: {
    uk: "Не вдалося скопіювати посилання",
    en: "Could not copy the link",
    hy: "Չհաջողվեց պատճենել հղումը",
    ka: "ბმულის კოპირება ვერ მოხერხდა",
  },
  annot_arrow: {
    uk: "Стрілка",
    en: "Arrow",
    hy: "Սլաք",
    ka: "ისარი",
  },
  annot_pan: {
    uk: "Пересунути",
    en: "Pan",
    hy: "Տեղափոխել",
    ka: "გადაადგილება",
  },
  annot_pen: {
    uk: "Олівець",
    en: "Pen",
    hy: "Մատիտ",
    ka: "კალამი",
  },
  annot_rect: {
    uk: "Прямокутник",
    en: "Box",
    hy: "Ուղղանկյուն",
    ka: "მართკუთხედი",
  },
  annot_text: {
    uk: "Текст",
    en: "Text",
    hy: "Տեքստ",
    ka: "ტექსტი",
  },
  annot_weight_l: {
    uk: "L",
    en: "L",
    hy: "L",
    ka: "L",
  },
  annot_weight_m: {
    uk: "M",
    en: "M",
    hy: "M",
    ka: "M",
  },
  annot_weight_s: {
    uk: "S",
    en: "S",
    hy: "S",
    ka: "S",
  },
  f_all: {
    uk: "Усі",
    en: "All",
    hy: "Բոլորը",
    ka: "ყველა",
  },
  f_date: {
    uk: "Дата",
    en: "Date",
    hy: "Ամսաթիվ",
    ka: "თარიღი",
  },
  priority_1: {
    uk: "Низький",
    en: "Low",
    hy: "Ցածր",
    ka: "დაბალი",
  },
  priority_2: {
    uk: "Звичайний",
    en: "Normal",
    hy: "Սովորական",
    ka: "ჩვეულებრივი",
  },
  priority_3: {
    uk: "Високий",
    en: "High",
    hy: "Բարձր",
    ka: "მაღალი",
  },
  reject_done: {
    uk: "Фото відхилено",
    en: "Photo rejected",
    hy: "Լուսանկարը մերժված է",
    ka: "ფოტო უარყოფილია",
  },
  reject_task_due: {
    uk: "Виконати до",
    en: "Due by",
    hy: "Կատարել մինչև",
    ka: "შესრულების ვადა",
  },
  reject_task_for: {
    uk: "Для точки",
    en: "For point",
    hy: "Կետի համար",
    ka: "წერტილისთვის",
  },
  reject_task_name: {
    uk: "Назва доручення",
    en: "Task name",
    hy: "Հանձնարարության անվանումը",
    ka: "დავალების სახელი",
  },
  reject_task_priority: {
    uk: "Пріоритет",
    en: "Priority",
    hy: "Առաջնահերթություն",
    ka: "პრიორიტეტი",
  },
  // The form the merchandiser will be asked to fill in — what the corrective task actually is.
  reject_task_template: {
    uk: "Шаблон",
    en: "Template",
    hy: "Կաղապար",
    ka: "შაბლონი",
  },
  reject_task_saved_verdict_failed: {
    uk: "Доручення створено, але відхилення не збережено. Спробуйте відхилити ще раз.",
    en: "The task was created, but the rejection was not saved. Try rejecting again.",
    hy: "Հանձնարարությունը ստեղծվեց, բայց մերժումը չպահպանվեց։ Փորձեք կրկին մերժել։",
    ka: "დავალება შეიქმნა, მაგრამ უარყოფა ვერ შეინახა. სცადეთ უარყოფა ხელახლა.",
  },
  reject_task_submit: {
    uk: "Відхилити та створити",
    en: "Reject and create",
    hy: "Մերժել և ստեղծել",
    ka: "უარყოფა და შექმნა",
  },
  reject_task_photo_pending: {
    uk: "Фото ще завантажується — зачекайте або відхиліть без задачі",
    en: "The photo is still loading — wait a moment, or reject without a task",
    hy: "Լուսանկարը դեռ բեռնվում է — սպասեք կամ մերժեք առանց առաջադրանքի",
    ka: "ფოტო ჯერ იტვირთება — დაელოდეთ ან უარყავით დავალების გარეშე",
  },
  reject_task_title: {
    uk: "Відхилити та створити доручення",
    en: "Reject and create a task",
    hy: "Մերժել և ստեղծել հանձնարարություն",
    ka: "უარყოფა და დავალების შექმნა",
  },
  reject_without_task: {
    uk: "Лише відхилити",
    en: "Reject only",
    hy: "Միայն մերժել",
    ka: "მხოლოდ უარყოფა",
  },
};
/* ------------------------------------------------------------------
   AUTH — sign-in and forgot-password screens.
   Generated from docs/design/login.html's dictionary so the shipped copy matches
   the approved design exactly. Strings that were already live in Login.js /
   ForgotPassword.js are unchanged.
   ⚠ hy / ka are best-effort and NEED NATIVE REVIEW before release.
   ------------------------------------------------------------------ */
export const AUTH = {
  headline: {
    uk: "Мерчандайзинг\nпід контролем",
    en: "Merchandising\nunder control",
    hy: "Մերչենդայզինգը\nվերահսկողության տակ",
    ka: "მერჩენდაიზინგი\nკონტროლის ქვეშ",
  },
  subhead: {
    uk: "Маршрути, візити та фотозвіти — усе в одному місці. Швидка перевірка, чіткі рішення.",
    en: "Routes, visits and photo reports — all in one place. Faster checks, clearer decisions.",
    hy: "Երթուղիներ, այցեր և լուսանկարային հաշվետվություններ՝ մեկ վայրում։ Արագ ստուգում, հստակ որոշումներ։",
    ka: "მარშრუტები, ვიზიტები და ფოტოანგარიშები — ერთ ადგილას. სწრაფი შემოწმება, ნათელი გადაწყვეტილებები.",
  },
  feat1: {
    uk: "Фотоперевірка — підтвердження або відхилення за секунди",
    en: "Photo review — approve or reject in seconds",
    hy: "Լուսանկարների ստուգում՝ հաստատեք կամ մերժեք վայրկյանների ընթացքում",
    ka: "ფოტოს შემოწმება — დაამტკიცეთ ან უარყავით წამებში",
  },
  feat2: {
    uk: "Планування маршрутів і відстеження візитів",
    en: "Route planning and live visit tracking",
    hy: "Երթուղիների պլանավորում և այցերի հետևում",
    ka: "მარშრუტების დაგეგმვა და ვიზიტების თვალყურის დევნება",
  },
  feat3: {
    uk: "Точки, мережі та опитування в одному місці",
    en: "Points, networks and surveys in one place",
    hy: "Կետեր, ցանցեր և հարցումներ մեկ վայրում",
    ka: "წერტილები, ქსელები და გამოკითხვები ერთ ადგილას",
  },
  signin_title: {
    uk: "Вхід",
    en: "Sign in",
    hy: "Մուտք",
    ka: "შესვლა",
  },
  signin_sub: {
    uk: "Увійдіть, щоб продовжити роботу в Picsell Dashboard",
    en: "Sign in to continue to Picsell Dashboard",
    hy: "Մուտք գործեք՝ Picsell Dashboard-ում աշխատանքը շարունակելու համար",
    ka: "შედით, რომ გააგრძელოთ მუშაობა Picsell Dashboard-ში",
  },
  phone_label: {
    uk: "Телефон",
    en: "Phone",
    hy: "Հեռախոս",
    ka: "ტელეფონი",
  },
  phone_ph: {
    uk: "+380 50 123 45 67",
    en: "+380 50 123 45 67",
    hy: "+380 50 123 45 67",
    ka: "+380 50 123 45 67",
  },
  password_label: {
    uk: "Пароль",
    en: "Password",
    hy: "Գաղտնաբառ",
    ka: "პაროლი",
  },
  password_ph: {
    uk: "••••••••",
    en: "••••••••",
    hy: "••••••••",
    ka: "••••••••",
  },
  forgot_link: {
    uk: "Забули пароль?",
    en: "Forgot password?",
    hy: "Մոռացե՞լ եք գաղտնաբառը",
    ka: "დაგავიწყდათ პაროლი?",
  },
  signin_btn: {
    uk: "Увійти",
    en: "Sign in",
    hy: "Մուտք",
    ka: "შესვლა",
  },
  role_note: {
    uk: "Доступ лише для користувачів з роллю «Супервайзер»",
    en: "Access is limited to users with the Supervisor role",
    hy: "Հասանելի է միայն «Վերակացու» դերով օգտատերերին",
    ka: "წვდომა მხოლოდ „სუპერვაიზერის“ როლის მომხმარებლებისთვის",
  },
  show_password: {
    uk: "Показати пароль",
    en: "Show password",
    hy: "Ցուցադրել գաղտնաբառը",
    ka: "პაროლის ჩვენება",
  },
  hide_password: {
    uk: "Сховати пароль",
    en: "Hide password",
    hy: "Թաքցնել գաղտնաբառը",
    ka: "პაროლის დამალვა",
  },
  forgot_title: {
    uk: "Забули пароль?",
    en: "Forgot password?",
    hy: "Մոռացե՞լ եք գաղտնաբառը",
    ka: "დაგავიწყდათ პაროლი?",
  },
  forgot_sub: {
    uk: "Введіть номер телефону, з яким ви входите в систему, і ми надішлемо інструкції для відновлення пароля в SMS.",
    en: "Enter the phone number you sign in with and we'll send password reset instructions by SMS.",
    hy: "Մուտքագրեք հեռախոսահամարը, որով մուտք եք գործում, և մենք SMS-ով կուղարկենք գաղտնաբառը վերականգնելու հրահանգները։",
    ka: "შეიყვანეთ ტელეფონის ნომერი, რომლითაც შედიხართ, და ჩვენ SMS-ით გამოგიგზავნით პაროლის აღდგენის ინსტრუქციას.",
  },
  send_btn: {
    uk: "Відправити",
    en: "Send",
    hy: "Ուղարկել",
    ka: "გაგზავნა",
  },
  back_link: {
    uk: "Повернутися до сторінки входу",
    en: "Back to sign in",
    hy: "Վերադառնալ մուտքի էջ",
    ka: "დაბრუნება შესვლის გვერდზე",
  },
  sent_title: {
    uk: "Перевірте телефон",
    en: "Check your phone",
    hy: "Ստուգեք ձեր հեռախոսը",
    ka: "შეამოწმეთ თქვენი ტელეფონი",
  },
  sent_sub: {
    uk: "Якщо акаунт для {phone} існує, інструкції з відновлення надіслано в SMS.",
    en: "If an account exists for {phone}, reset instructions are on their way by SMS.",
    hy: "Եթե {phone} համարով հաշիվ գոյություն ունի, վերականգնման հրահանգներն ուղարկվել են SMS-ով։",
    ka: "თუ {phone}-ისთვის ანგარიში არსებობს, აღდგენის ინსტრუქცია გამოგზავნილია SMS-ით.",
  },
  err_required: {
    uk: "Це поле обов'язкове",
    en: "This field is required",
    hy: "Այս դաշտը պարտադիր է",
    ka: "ეს ველი სავალდებულოა",
  },
  err_phone: {
    uk: "Введіть коректний номер телефону",
    en: "Enter a valid phone number",
    hy: "Մուտքագրեք վավեր հեռախոսահամար",
    ka: "შეიყვანეთ სწორი ტელეფონის ნომერი",
  },
  err_reset_unavailable: {
    uk: "Відновлення пароля ще недоступне. Зверніться до свого керівника.",
    en: "Password reset is not available yet. Please contact your manager.",
    hy: "Գաղտնաբառի վերականգնումը դեռ հասանելի չէ։ Դիմեք Ձեր ղեկավարին։",
    ka: "პაროლის აღდგენა ჯერ არ არის ხელმისაწვდომი. მიმართეთ თქვენს ხელმძღვანელს.",
  },
  language: {
    uk: "Мова",
    en: "Language",
    hy: "Լեզու",
    ka: "ენა",
  },
  /* Reuses the brand-panel wording: same fact, no second translation to drift. */
  err_role: {
    uk: "Доступ лише для користувачів з роллю «Супервайзер»",
    en: "Access is limited to users with the Supervisor role",
    hy: "Հասանելի է միայն «Վերակացու» դերով օգտատերերին",
    ka: "წვდომა მხოლოდ „სუპერვაიზერის“ როლის მომხმარებლებისთვის",
  },
  login: {
    uk: "Увійти",
    en: "Log in",
    hy: "Մուտք",
    ka: "შესვლა",
  },
};

/* ------------------------------------------------------------------
   PROFILE_PAGE — the /profile screen. Generated from docs/design/profile.html's dictionary.
   Keys already in MANAGER_PROFILE (name, surname, position, my_region, telegram, language,
   save, save_success…) are reused from there, not duplicated here.
   The design's email field and Change-password row are absent on purpose: User has no email
   field, and no change-password endpoint exists.
   ⚠ hy / ka are best-effort and NEED NATIVE REVIEW — role_supervisor especially, see below.
   ------------------------------------------------------------------ */
export const PROFILE_PAGE = {
  profile_sub: {
    uk: "Керуйте особистими даними, каналами звʼязку та налаштуваннями дашборду.",
    en: "Manage your personal details, contact channels and dashboard preferences.",
    hy: "Կառավարեք ձեր անձնական տվյալները, կապի ուղիները և դաշբորդի կարգավորումները։",
    ka: "მართეთ პირადი მონაცემები, კონტაქტის არხები და დეშბორდის პარამეტრები.",
  },
  sec_identity: {
    uk: "Особисті дані",
    en: "Identity",
    hy: "Անձնական տվյալներ",
    ka: "პირადი მონაცემები",
  },
  sec_identity_desc: {
    uk: "Як ваше імʼя відображається в дашборді та для мерчендайзерів.",
    en: "How your name appears across the dashboard and to your merchandisers.",
    hy: "Ինչպես է ձեր անունը երևում դաշբորդում և մերչենդայզերների համար։",
    ka: "როგორ ჩანს თქვენი სახელი დეშბორდში და მერჩენდაიზერებისთვის.",
  },
  sec_contact: {
    uk: "Контакти",
    en: "Contact",
    hy: "Կապ",
    ka: "კონტაქტი",
  },
  sec_contact_desc: {
    uk: "Куди система надсилає повідомлення про перевірки та сповіщення.",
    en: "Where the system reaches you about reviews and alerts.",
    hy: "Ուր համակարգը ուղարկում է ստուգումների և ծանուցումների մասին տեղեկություններ։",
    ka: "სად გიგზავნის სისტემა შემოწმებებისა და შეტყობინებების შესახებ ინფორმაციას.",
  },
  sec_work: {
    uk: "Робоча зона",
    en: "Work area",
    hy: "Աշխատանքային գոտի",
    ka: "სამუშაო ზონა",
  },
  sec_work_desc: {
    uk: "Територія та організація, до яких належить ваш акаунт.",
    en: "The territory and organisation your account belongs to.",
    hy: "Տարածքը և կազմակերպությունը, որին պատկանում է ձեր հաշիվը։",
    ka: "ტერიტორია და ორგანიზაცია, რომელსაც ეკუთვნის თქვენი ანგარიში.",
  },
  sec_prefs: {
    uk: "Налаштування",
    en: "Preferences",
    hy: "Կարգավորումներ",
    ka: "პარამეტრები",
  },
  sec_prefs_desc: {
    uk: "Мова інтерфейсу дашборду.",
    en: "Language used across the dashboard interface.",
    hy: "Դաշբորդի ինտերֆեյսի լեզուն։",
    ka: "დეშბორდის ინტერფეისის ენა.",
  },
  upload_photo: {
    uk: "Завантажити фото",
    en: "Upload photo",
    hy: "Վերբեռնել լուսանկար",
    ka: "ფოტოს ატვირთვა",
  },
  remove_photo: {
    uk: "Видалити",
    en: "Remove",
    hy: "Հեռացնել",
    ka: "წაშლა",
  },
  photo_hint: {
    uk: "JPG або PNG, не менше 200×200 px. Показується в хедері та у звітах про візити.",
    en: "JPG or PNG, at least 200×200 px. Shown in the header and on visit reports.",
    hy: "JPG կամ PNG, առնվազն 200×200 px։ Ցուցադրվում է վերնագրում և այցերի հաշվետվություններում։",
    ka: "JPG ან PNG, მინიმუმ 200×200 px. ჩანს ჰედერში და ვიზიტების ანგარიშებში.",
  },
  position_hint: {
    uk: "Довільний текст, напр. «Регіональний супервайзер-менеджер».",
    en: "Free text, e.g. “Regional supervisor manager”.",
    hy: "Ազատ տեքստ, օր. «Տարածաշրջանային սուպերվայզեր-մենեջեր»։",
    ka: "თავისუფალი ტექსტი, მაგ. „რეგიონული სუპერვაიზერ-მენეჯერი“.",
  },
  phone: {
    uk: "Телефон",
    en: "Phone",
    hy: "Հեռախոս",
    ka: "ტელეფონი",
  },
  phone_hint: {
    uk: "Це ваш ідентифікатор для входу — його не можна змінити тут, зверніться до адміністратора.",
    en: "This is your sign-in identifier and cannot be changed here — contact an administrator.",
    hy: "Սա ձեր մուտքի նույնացուցիչն է և այստեղ չի փոփոխվում — դիմեք ադմինիստրատորին։",
    ka: "ეს არის თქვენი შესვლის იდენტიფიკატორი და აქ ვერ იცვლება — მიმართეთ ადმინისტრატორს.",
  },
  telegram_hint: {
    uk: "Необовʼязково. Для миттєвих сповіщень від бота перевірки.",
    en: "Optional. Used for instant alerts from the review bot.",
    hy: "Ոչ պարտադիր։ Ստուգման բոտից ակնթարթային ծանուցումների համար։",
    ka: "არასავალდებულო. შემოწმების ბოტისგან მყისიერი შეტყობინებებისთვის.",
  },
  region_hint: {
    uk: "Обмежує, які точки та візити ви бачите.",
    en: "Limits which points and visits you can see.",
    hy: "Սահմանափակում է, թե որ կետերն ու այցերը կտեսնեք։",
    ka: "ზღუდავს, რომელ წერტილებსა და ვიზიტებს ხედავთ.",
  },
  role: {
    uk: "Роль",
    en: "Role",
    hy: "Դեր",
    ka: "როლი",
  },
  role_supervisor_manager: {
    uk: "Супервайзер-менеджер",
    en: "Supervisor manager",
    hy: "Սուպերվայզեր-մենեջեր",
    ka: "სუპერვაიზერ-მენეჯერი",
  },
  company: {
    uk: "Компанія",
    en: "Company",
    hy: "Ընկերություն",
    ka: "კომპანია",
  },
  readonly_hint: {
    uk: "Роль і компанію встановлює адміністратор.",
    en: "Role and company are set by an administrator.",
    hy: "Դերը և ընկերությունը սահմանում է ադմինիստրատորը։",
    ka: "როლს და კომპანიას ადმინისტრატორი განსაზღვრავს.",
  },
  language_reload_warn: {
    uk: "Після збереження зміна мови перезавантажить дашборд.",
    en: "Changing the language reloads the dashboard after saving.",
    hy: "Պահպանելուց հետո լեզվի փոփոխությունը վերաբեռնում է դաշբորդը։",
    ka: "შენახვის შემდეგ ენის შეცვლა გადატვირთავს დეშბორდს.",
  },
  account: {
    uk: "Акаунт",
    en: "Account",
    hy: "Հաշիվ",
    ka: "ანგარიში",
  },
  rail_note: {
    uk: "Зміни стосуються лише вашого акаунта. Дані мерчендайзерів редагуються на сторінці «Мерчендайзер».",
    en: "Changes apply to your account only. Merchandiser records are edited from the Merchandiser page.",
    hy: "Փոփոխությունները վերաբերում են միայն ձեր հաշվին։ Մերչենդայզերների տվյալները խմբագրվում են «Մերչենդայզեր» էջում։",
    ka: "ცვლილებები მხოლოდ თქვენს ანგარიშს ეხება. მერჩენდაიზერების მონაცემები იხედება „მერჩენდაიზერის“ გვერდზე.",
  },
  unsaved_changes: {
    uk: "Є незбережені зміни",
    en: "You have unsaved changes",
    hy: "Կան չպահպանված փոփոխություններ",
    ka: "გაქვთ შეუნახავი ცვლილებები",
  },
  discard: {
    uk: "Скасувати",
    en: "Discard",
    hy: "Չեղարկել",
    ka: "გაუქმება",
  },
  err_required: {
    uk: "Це поле обовʼязкове",
    en: "This field is required",
    hy: "Այս դաշտը պարտադիր է",
    ka: "ეს ველი სავალდებულოა",
  },
  err_telegram: {
    uk: "Використовуйте формат @username",
    en: "Use the @username format",
    hy: "Օգտագործեք @username ձևաչափը",
    ka: "გამოიყენეთ @username ფორმატი",
  },
  help_confirm: {
    uk: "Ми надішлемо службі підтримки ваше імʼя, телефон і компанію, щоб вони звʼязалися з вами.",
    en: "We will send support your name, phone number and company so they can get back to you.",
    hy: "Աջակցման ծառայությանը կուղարկենք ձեր անունը, հեռախոսահամարը և ընկերությունը, որպեսզի կապվեն ձեզ հետ։",
    ka: "მხარდაჭერას გავუგზავნით თქვენს სახელს, ტელეფონის ნომერს და კომპანიას, რომ დაგიკავშირდნენ.",
  },
  help_send: {
    uk: "Надіслати",
    en: "Send",
    hy: "Ուղարկել",
    ka: "გაგზავნა",
  },
  help_sent: {
    uk: "Запит надіслано. Підтримка звʼяжеться з вами.",
    en: "Request sent. Support will get back to you.",
    hy: "Հարցումն ուղարկվել է։ Աջակցումը կկապվի ձեզ հետ։",
    ka: "მოთხოვნა გაიგზავნა. მხარდაჭერა დაგიკავშირდებათ.",
  },
  help_failed: {
    uk: "Не вдалося надіслати запит. Спробуйте пізніше.",
    en: "Could not send the request. Please try again later.",
    hy: "Հարցումն ուղարկել չհաջողվեց։ Փորձեք ավելի ուշ։",
    ka: "მოთხოვნის გაგზავნა ვერ მოხერხდა. სცადეთ მოგვიანებით.",
  },
  /* Derived from role_supervisor_manager by dropping the "-manager" component. The Georgian
     nominative ending is an inflection rather than a truncation — review this one. */
  role_supervisor: {
    uk: "Супервайзер",
    en: "Supervisor",
    hy: "Սուպերվայզեր",
    ka: "სუპერვაიზერი",
  },
};

/* ------------------------------------------------------------------
   GLOBAL_SEARCH — the app bar's search box and results panel.
   Category headings deliberately reuse SIDE_NAV labels (pt_points, merchandiser, visit,
   pt_surveys, tasks) rather than duplicating five nouns that already exist there.
   ⚠ hy / ka are best-effort and NEED NATIVE REVIEW before release.
   ------------------------------------------------------------------ */
export const GLOBAL_SEARCH = {
  /* One category is still time-windowed server-side (`RECENT_DAYS` in
     picsell/search/api/web/v1/views.py) — `visit`, the largest table, where the window is a second
     bound on top of the trigram index. The rest are searched in full. So this renders in the header
     of the GROUPS that carry a window, not in the panel footer: one global note would claim to
     apply to all five. It is stated at all because a search that silently cannot find an older
     record reads as broken. Number kept off the noun — {n} is always days (spec/04). */
  window_days: {
    uk: "за останні {n} д",
    en: "last {n} d",
    hy: "վերջին {n} օր",
    ka: "ბოლო {n} დღე",
  },
  kb_navigate: {
    uk: "навігація",
    en: "to navigate",
    hy: "նավարկել",
    ka: "ნავიგაცია",
  },
  kb_open: {
    uk: "відкрити",
    en: "to open",
    hy: "բացել",
    ka: "გახსნა",
  },
  kb_close: {
    uk: "закрити",
    en: "to close",
    hy: "փակել",
    ka: "დახურვა",
  },
  recent_searches: {
    uk: "Останні запити",
    en: "Recent searches",
    hy: "Վերջին որոնումները",
    ka: "ბოლო ძებნები",
  },
  see_all: {
    uk: "Показати всі",
    en: "See all",
    hy: "Դիտել բոլորը",
    ka: "ყველას ნახვა",
  },
  search_placeholder: {
    uk: "Пошук мерчендайзерів, візитів, точок, опитувань…",
    en: "Search merchandisers, visits, points, surveys…",
    hy: "Որոնել մերչենդայզերներ, այցեր, կետեր, հարցումներ…",
    ka: "მოძებნეთ მერჩენდაიზერები, ვიზიტები, წერტილები, გამოკითხვები…",
  },
  /* {n} is MIN_QUERY in AppSearch.js, not a literal, because the floor is set by what the
     trigram index can serve and has already drifted from this string once. ⚠ uk agrees with the
     number: 2–4 takes "символи", 5+ would need "символів". */
  search_hint: {
    uk: "Введіть щонайменше {n} символи",
    en: "Type at least {n} characters",
    hy: "Մուտքագրեք առնվազն {n} նշան",
    ka: "შეიყვანეთ მინიმუმ {n} სიმბოლო",
  },
  search_no_results: {
    uk: "Нічого не знайдено за запитом",
    en: "Nothing found for",
    hy: "Ոչինչ չի գտնվել՝",
    ka: "ვერაფერი მოიძებნა:",
  },
  search_all: {
    uk: "Усі",
    en: "All",
    hy: "Բոլորը",
    ka: "ყველა",
  },
  search_label: {
    uk: "Пошук",
    en: "Search",
    hy: "Որոնում",
    ka: "ძებნა",
  },
  search_clear: {
    uk: "Очистити",
    en: "Clear",
    hy: "Մաքրել",
    ka: "გასუფთავება",
  },
};

/* ------------------------------------------------------------------
   NOTIFICATIONS — the app bar's bell. Signals are derived server-side (see StatsViewSet
   .notifications); there is no notifications table. Counts render as a badge rather than inline
   with a noun, so nothing here inflects against a number — {n} is always days.
   ⚠ hy / ka are best-effort and NEED NATIVE REVIEW.
   ------------------------------------------------------------------ */
export const NOTIFICATIONS = {
  notifications: {
    uk: "Повідомлення",
    en: "Notifications",
    hy: "Ծանուցումներ",
    ka: "შეტყობინებები",
  },
  mark_all_read: {
    uk: "Позначити всі як прочитані",
    en: "Mark all as read",
    hy: "Նշել բոլորը որպես կարդացված",
    ka: "ყველას წაკითხულად მონიშვნა",
  },
  view_all_notifications: {
    uk: "Усі повідомлення",
    en: "View all notifications",
    hy: "Բոլոր ծանուցումները",
    ka: "ყველა შეტყობინება",
  },
  notif_empty: {
    uk: "Нових повідомлень немає",
    en: "Nothing needs your attention",
    hy: "Ոչինչ չի պահանջում ձեր ուշադրությունը",
    ka: "ყურადღებას არაფერი საჭიროებს",
  },
  notif_visits_pending: {
    uk: "Візити на перевірці",
    en: "Visits awaiting verification",
    hy: "Այցեր, որոնք սպասում են ստուգման",
    ka: "ვიზიტები, რომლებიც შემოწმებას ელოდება",
  },
  notif_merch_idle: {
    uk: "Мерчендайзери без візитів понад {n} д",
    en: "Merchandisers with no visits in {n} d",
    hy: "Մերչենդայզերներ առանց այցերի {n} օրից ավելի",
    ka: "მერჩენდაიზერები ვიზიტების გარეშე {n} დღეზე მეტი",
  },
  notif_surveys_ending: {
    uk: "Опитування завершуються протягом {n} д",
    en: "Surveys closing within {n} d",
    hy: "Հարցումներ, որոնք ավարտվում են {n} օրվա ընթացքում",
    ka: "გამოკითხვები, რომლებიც {n} დღეში სრულდება",
  },
};

export const USER_LOGIN = {
  login_success_msg: {
    uk: "Ви успішно увійшли в систему",
    en: "You have successfully logged in to the system",
    hy: "Դուք հաջողությամբ մուտք գործեցիք համակարգ",
    ka: "თქვენ წარმატებით შეხვედით სისტემაში",
  },
  login_error_msg: {
    uk: "Користувач не існує або неправильні дані для входу.",
    en: "User does not exist or incorrect login data.",
    hy: "Օգտատերը գոյություն չունի կամ մուտքի տվյալները սխալ են։",
    ka: "მომხმარებელი არ არსებობს ან შესვლის მონაცემები არასწორია.",
  },
};
export const VISIT_PAGE = {
  page_title: {
    uk: "Візити",
    en: "Visits",
    hy: "Այցեր",
    ka: "ვიზიტები",
  },
  columns: {
    uk: "Стовпці",
    en: "Columns",
    hy: "Սյունակներ",
    ka: "სვეტები",
  },
  table_timespent: {
    uk: "Час",
    en: "Time",
    hy: "Ժամանակ",
    ka: "დრო",
  },
  author_way: {
    uk: "Автор/По маршруту",
    en: "Author/On the route",
    hy: "Հեղինակ/Երթուղով",
    ka: "ავტორი/მარშრუტზე",
  },
  merchandiser: {
    uk: "Мерчендайзер",
    en: "Merchandiser",
    hy: "Մերչենդայզեր",
    ka: "მერჩენდაიზერი",
  },
  supervisor: {
    uk: "Супервайзер",
    en: "Supervisor",
    hy: "Վերակացու",
    ka: "სუპერვაიზერი",
  },
  approved_by: {
    uk: "Затверджено",
    en: "Approved by",
    hy: "Հաստատված է՝",
    ka: "დამტკიცებულია",
  },
  point: {
    uk: "Точка",
    en: "Point",
    hy: "Կետ",
    ka: "წერტილი",
  },
  point_started_title: {
    uk: "Розпочато",
    en: "Started",
    hy: "Սկսված է",
    ka: "დაწყებულია",
  },
  point_agoby_title: {
    uk: "тому",
    en: "ago by",
    hy: "առաջ՝",
    ka: "წინ",
  },
  seconds: {
    uk: "секунд",
    en: "seconds",
    hy: "վայրկյան",
    ka: "წამი",
  },
  minutes: {
    uk: "хвилин",
    en: "minutes",
    hy: "րոպե",
    ka: "წუთი",
  },
  hours: {
    uk: "годин",
    en: "hours",
    hy: "ժամ",
    ka: "საათი",
  },
  days: {
    uk: "днів",
    en: "days",
    hy: "օր",
    ka: "დღე",
  },
  months: {
    uk: "місяців",
    en: "months",
    hy: "ամիս",
    ka: "თვე",
  },
  years: {
    uk: "років",
    en: "years",
    hy: "տարի",
    ka: "წელი",
  },
  status_label: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  progress_label: {
    uk: "Прогрес, %",
    en: "Progress, %",
    hy: "Առաջընթաց, %",
    ka: "პროგრესი, %",
  },
  approved_label_popup: {
    uk: "Затверджено",
    en: "Approved",
    hy: "Հաստատված",
    ka: "დამტკიცებული",
  },
  pending_label_popup: {
    uk: "На затверджені",
    en: "Pending",
    hy: "Սպասման մեջ",
    ka: "მოლოდინში",
  },
  rejected_label_popup: {
    uk: "Не виконані",
    en: "Not executed",
    hy: "Չկատարված",
    ka: "შეუსრულებელი",
  },
  /* The price-monitoring section's status segment; the other three are the *_single_visit_name
     keys below. */
  f_all: {
    uk: "Усі",
    en: "All",
    hy: "Բոլորը",
    ka: "ყველა",
  },
  approved_single_visit_name: {
    uk: "Затверджено",
    en: "Approved",
    hy: "Հաստատված",
    ka: "დამტკიცებული",
  },
  no_approved_single_visit_name: {
    uk: "Не затверджено",
    en: "Not approved",
    hy: "Չհաստատված",
    ka: "დაუმტკიცებელი",
  },
  on_verification_single_visit_name: {
    uk: "На перевірці",
    en: "On verification",
    hy: "Ստուգման փուլում",
    ka: "გადამოწმებაში",
  },
  /* A visit with no `end` — still open, so it takes no verdict yet. */
  visit_in_progress: {
    uk: "Триває",
    en: "In progress",
    hy: "Ընթացքում է",
    ka: "მიმდინარეობს",
  },
  visit_active_no_verdict: {
    uk: "Візит ще триває — його можна перевірити після завершення",
    en: "The visit is still in progress — it can be reviewed once it has ended",
    hy: "Այցը դեռ ընթացքում է, այն կարելի է ստուգել ավարտվելուց հետո",
    ka: "ვიზიტი ჯერ კიდევ მიმდინარეობს — მისი შემოწმება დასრულების შემდეგ შეიძლება",
  },
  /* `StatusTag`'s neutral fourth state — a task nobody has answered (PICSELL-1615 #6). */
  awaiting_answer_name: {
    uk: "Без відповіді",
    en: "Awaiting answer",
    hy: "Սպասում է պատասխանի",
    ka: "პასუხის მოლოდინში",
  },
  back_to_btn_label: {
    uk: "Повернутися до візитів",
    en: "Back to visits",
    hy: "Վերադառնալ այցերին",
    ka: "დაბრუნება ვიზიტებზე",
  },
  orders_tab_name: {
    uk: "Замовлення",
    en: "Orders",
    hy: "Պատվերներ",
    ka: "შეკვეთები",
  },
  returns_tab_name: {
    uk: "Повернення",
    en: "Returns",
    hy: "Վերադարձներ",
    ka: "დაბრუნებები",
  },
  payments_tab_name: {
    uk: "Платежі",
    en: "Payments",
    hy: "Վճարումներ",
    ka: "გადახდები",
  },
  zvit_tab_name: {
    uk: "Звіти",
    en: "Reports",
    hy: "Հաշվետվություններ",
    ka: "ანგარიშები",
  },
  task_tab_name: {
    uk: "Задачі",
    en: "Tasks",
    hy: "Առաջադրանքներ",
    ka: "დავალებები",
  },
  /* The record modal's way out to the task's own page (PICSELL-1581 #4). */
  open_task: {
    uk: "Відкрити завдання",
    en: "Open task",
    hy: "Բացել առաջադրանքը",
    ka: "დავალების გახსնա",
  },
  /* A section fetch that FAILED, as opposed to one that returned nothing — the two used to be
     indistinguishable ("nothing here" under a pending counter, PICSELL-1581 #21). */
  sec_load_failed: {
    uk: "Не вдалося завантажити розділ",
    en: "Failed to load this section",
    hy: "Չհաջողվեց բեռնել բաժինը",
    ka: "სექციის ჩატვირთვა ვერ მოხერხდა",
  },
  retry: {
    uk: "Спробувати знову",
    en: "Retry",
    hy: "Կրկնել",
    ka: "ხელახლა",
  },
  monitoring_tab_name: {
    uk: "Моніторинг",
    en: "Monitoring",
    hy: "Մոնիտորինգ",
    ka: "მონიტორინგი",
  },
  log_tab_name: {
    uk: "Журнал подій",
    en: "Event log",
    hy: "Իրադարձությունների մատյան",
    ka: "ივენთების ჟურნალი",
  },
  surveys_tab_name: {
    uk: "Опитування",
    en: "Surveys",
    hy: "Հարցումներ",
    ka: "გამოკითხვები",
  },
  surveys_summary_surveys_label: {
    uk: "Опитування",
    en: "Surveys",
    hy: "Հարցումներ",
    ka: "გამოკითხვები",
  },
  surveys_summary_answers_label: {
    uk: "Відповіді",
    en: "Answers",
    hy: "Պատասխաններ",
    ka: "პასუხები",
  },
  surveys_summary_photos_label: {
    uk: "Фото",
    en: "Photos",
    hy: "Լուսանկարներ",
    ka: "ფოტოები",
  },
  surveys_tab_products: {
    uk: "Товари",
    en: "Products",
    hy: "Ապրանքներ",
    ka: "პროდუქტები",
  },
  surveys_tab_brands: {
    uk: "Бренди",
    en: "Brands",
    hy: "Բրենդներ",
    ka: "ბრენდები",
  },
  surveys_tab_categories: {
    uk: "Категорії",
    en: "Categories",
    hy: "Կատեգորիաներ",
    ka: "კატეგორიები",
  },
  surveys_tab_other: {
    uk: "Інше",
    en: "Other",
    hy: "Այլ",
    ka: "სხვა",
  },
  surveys_answer_type_bool: {
    uk: "Так/Ні",
    en: "Bool",
    hy: "Այո/Ոչ",
    ka: "დიახ/არა",
  },
  surveys_answer_type_numeric: {
    uk: "Число",
    en: "Numeric",
    hy: "Թվային",
    ka: "რიცხვითი",
  },
  surveys_answer_type_dropdown: {
    uk: "Список",
    en: "Dropdown",
    hy: "Ցանկ",
    ka: "სია",
  },
  surveys_answer_type_text: {
    uk: "Текст",
    en: "Text",
    hy: "Տեքստ",
    ka: "ტექსტი",
  },
  surveys_answer_type_date: {
    uk: "Дата",
    en: "Date",
    hy: "Ամսաթիվ",
    ka: "თარიღი",
  },
  surveys_answer_type_photo: {
    uk: "Фото",
    en: "Photo",
    hy: "Լուսանկար",
    ka: "ფოტო",
  },
  surveys_answer_bool_yes: {
    uk: "Так",
    en: "Yes",
    hy: "Այո",
    ka: "დიახ",
  },
  surveys_answer_bool_no: {
    uk: "Ні",
    en: "No",
    hy: "Ոչ",
    ka: "არა",
  },
  surveys_photo_label: {
    uk: "фото",
    en: "photos",
    hy: "լուսանկար",
    ka: "ფოტო",
  },
  surveys_empty_products: {
    uk: "Немає питань по товарах",
    en: "No product questions",
    hy: "Ապրանքների վերաբերյալ հարցեր չկան",
    ka: "პროდუქტის კითხვები არ არის",
  },
  surveys_empty_brands: {
    uk: "Немає питань по брендах",
    en: "No brand questions",
    hy: "Բրենդների վերաբերյալ հարցեր չկան",
    ka: "ბრენდის კითხვები არ არის",
  },
  surveys_empty_categories: {
    uk: "Немає питань по категоріях",
    en: "No category questions",
    hy: "Կատեգորիաների վերաբերյալ հարցեր չկան",
    ka: "კატეგორიის კითხვები არ არის",
  },
  surveys_empty_other: {
    uk: "Немає інших питань",
    en: "No other questions",
    hy: "Այլ հարցեր չկան",
    ka: "სხვა კითხვები არ არის",
  },
  surveys_modal_close: {
    uk: "Закрити",
    en: "Close",
    hy: "Փակել",
    ka: "დახურვა",
  },
  surveys_search_placeholder: {
    uk: "Пошук опитування…",
    en: "Search survey…",
    hy: "Փնտրել հարցում…",
    ka: "გამოკითხვის ძებნა…",
  },
  surveys_reset_btn: {
    uk: "Скинути",
    en: "Reset",
    hy: "Զրոյացնել",
    ka: "გადაყენება",
  },
  surveys_entity_search_placeholder: {
    uk: "Пошук…",
    en: "Search…",
    hy: "Փնտրել…",
    ka: "ძებნა…",
  },
  surveys_no_results: {
    uk: "Нічого не знайдено за запитом",
    en: "No results found",
    hy: "Արդյունքներ չեն գտնվել",
    ka: "შედეგები არ მოიძებნა",
  },
  surveys_show_more: {
    uk: "Показати ще",
    en: "Show more",
    hy: "Ցույց տալ ավելին",
    ka: "მეტის ჩვენება",
  },
  task_has_empty_error: {
    uk: "Будь ласка, виберіть хоча б один ітем",
    en: "Please select at least one item",
    hy: "Խնդրում ենք ընտրել առնվազն մեկ միավոր",
    ka: "გთხოვთ, აირჩიოთ მინიმუმ ერთი ერთეული",
  },
  task_has_answer_error: {
    uk: "Задача немає відповіді",
    en: "The task has no answer",
    hy: "Առաջադրանքը պատասխան չունի",
    ka: "დავალებას პასუხი არ აქვს",
  },
  approv_task_product_btn: {
    uk: "Затвердити продукт",
    en: "Approve the product",
    hy: "Հաստատել ապրանքը",
    ka: "პროდუქტის დამტკიცება",
  },
  reject_task_product_btn: {
    uk: "Відхилити продукт",
    en: "Reject the product",
    hy: "Մերժել ապրանքը",
    ka: "პროდუქტის უკუქცევა",
  },
  approv_task_btn: {
    uk: "Затвердити задачу",
    en: "Approve the task",
    hy: "Հաստատել առաջադրանքը",
    ka: "დავალების დამტკიცება",
  },
  reject_task_btn: {
    uk: "Відхилити задачу",
    en: "Reject the task",
    hy: "Մերժել առաջադրանքը",
    ka: "დავალების უკუქცევა",
  },
  approv_btn: {
    uk: "Затвердити",
    en: "Approve",
    hy: "Հաստատել",
    ka: "დამტკიცება",
  },
  reject_btn: {
    uk: "Відхилити",
    en: "Reject",
    hy: "Մերժել",
    ka: "უკუქცევა",
  },
  task_tab_type_label: {
    uk: "Тип",
    en: "Type",
    hy: "Տեսակ",
    ka: "ტიპი",
  },
  task_tab_task_name_label: {
    uk: "Назва задачі",
    en: "Name of the task",
    hy: "Առաջադրանքի անվանում",
    ka: "დავალების სახელი",
  },
  task_tab_info_label: {
    uk: "Опис",
    en: "Description",
    hy: "Նկարագրություն",
    ka: "აღწერა",
  },
  task_tab_deadline_label: {
    uk: "Дедлайн",
    en: "Deadline",
    hy: "Վերջնաժամկետ",
    ka: "დედლაინი",
  },
  task_tab_createdby_label: {
    uk: "Ким створено",
    en: "Created by",
    hy: "Ստեղծված է՝",
    ka: "შექმნილია",
  },
  task_tab_count_photo_label: {
    uk: "Кількість фото",
    en: "Number of photos",
    hy: "Լուսանկարների քանակ",
    ka: "ფოტოების რაოდენობა",
  },
  task_tab_status_label: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  task_tab_answer_status_yes_label: {
    uk: "Так",
    en: "Yes",
    hy: "Այո",
    ka: "დიახ",
  },
  task_tab_answer_status_no_label: {
    uk: "Ні",
    en: "No",
    hy: "Ոչ",
    ka: "არა",
  },
  task_tab_answer_status_label: {
    uk: "Відповідь",
    en: "Answer",
    hy: "Պատասխան",
    ka: "პასუხი",
  },
  task_tab_answer_comment_label: {
    uk: "Коментар",
    en: "Comment ",
    hy: "Մեկնաբանություն",
    ka: "კომენტარი",
  },
  task_tab_answer_tags_label: {
    uk: "Теги",
    en: "Tags ",
    hy: "Թեգեր",
    ka: "თეგები",
  },
  approve_visit_msg: {
    uk: "Візит затверджено",
    en: "Visit approved",
    hy: "Այցը հաստատված է",
    ka: "ვიზიტი დამტკიცებულია",
  },
  already_approve_visit_msg: {
    uk: "Візит вже було затверджено",
    en: "Visit already approved",
    hy: "Այցն արդեն հաստատված է",
    ka: "ვიზიტი უკვე დამტკიცებულია",
  },
  reject_visit_msg: {
    uk: "Візит відхилено",
    en: "Visit rejected",
    hy: "Այցը մերժված է",
    ka: "ვიზიტი უკუქცეულია",
  },
  already_reject_visit_msg: {
    uk: "Візит вже було відхилено",
    en: "Visit already rejected",
    hy: "Այցն արդեն մերժված է",
    ka: "ვიზიტი უკვე უკუქცეულია",
  },
  monitoring_tab_pname_label: {
    uk: "Назва",
    en: "Name",
    hy: "Անվանում",
    ka: "სახელი",
  },
  monitoring_tab_pcode_label: {
    uk: "Код продукту",
    en: "Product code",
    hy: "Ապրանքի կոդ",
    ka: "პროდუქტის კოდი",
  },
  monitoring_tab_price_label: {
    uk: "Ціна",
    en: "Price",
    hy: "Գին",
    ka: "ფასი",
  },
  monitoring_tab_sale_price_label: {
    uk: "Ціна продажу",
    en: "Sale Price",
    hy: "Վաճառքի գին",
    ka: "გაყიდვის ფასი",
  },
  monitoring_tab_photo_label: {
    uk: "Фото",
    en: "Photo URL",
    hy: "Լուսանկարի հղում",
    ka: "ფოტოს URL",
  },
  monitoring_tab_comment_label: {
    uk: "Коментар",
    en: "Comment",
    hy: "Մեկնաբանություն",
    ka: "კომენტარი",
  },
  monitoring_tab_event_monitoring_label: {
    uk: "Моніторинг",
    en: "Monitoring",
    hy: "Մոնիտորինգ",
    ka: "მონიტორინგი",
  },
  monitoring_tab_event_photos_in_answers_label: {
    uk: "Фото у відповідях",
    en: "Photos in answers",
    hy: "Լուսանկարներ պատասխաններում",
    ka: "ფოტოები პასუხებში",
  },
  monitoring_tab_event_photos_in_reports_label: {
    uk: "Фото у звітах",
    en: "Photos in reports",
    hy: "Լուսանկարներ հաշվետվություններում",
    ka: "ფოტოები ანგარიშებში",
  },
  monitoring_tab_event_reports_done_label: {
    uk: "Звітів виконано",
    en: "Reports done",
    hy: "Կատարված հաշվետվություններ",
    ka: "შესრულებული ანგარიშები",
  },
  monitoring_tab_event_tasks_done_label: {
    uk: "Завдань виконано",
    en: "Tasks done",
    hy: "Կատարված առաջադրանքներ",
    ka: "შესრულებული დავალებები",
  },
  monitoring_tab_event_tasks_not_done_label: {
    uk: "Завдань не виконано",
    en: "Tasks not done",
    hy: "Չկատարված առաջադրանքներ",
    ka: "შეუსრულებელი დავალებები",
  },
  monitoring_tab_event_answers_not_supervised_label: {
    uk: "Відповідей не перевірено",
    en: "Answers not supervised",
    hy: "Չվերստուգված պատասխաններ",
    ka: "შეუმოწმებელი პასუხები",
  },
  monitoring_tab_event_answers_supervised_label: {
    uk: "Відповідей перевірено",
    en: "Answers supervised",
    hy: "Վերստուգված պատասխաններ",
    ka: "შემოწმებული პასუხები",
  },
  monitoring_tab_selected_label: {
    uk: "Обрано",
    en: "Selected",
    hy: "Ընտրված",
    ka: "შერჩეული",
  },
  orders_product_name: {
    uk: "Назва замовлення",
    en: "Order Name",
    hy: "Պատվերի անվանում",
    ka: "შეკვეთის სახელი",
  },
  orders_product_status_changed: {
    uk: "Статус змінено",
    en: "Status changed ",
    hy: "Կարգավիճակը փոխվել է",
    ka: "სტატუსი შეიცვალა",
  },
  orders_product_status_date: {
    uk: "Дата",
    en: "Date",
    hy: "Ամսաթիվ",
    ka: "თარიღი",
  },
  orders_product_status: {
    uk: "Статус",
    en: "Status ",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  orders_product_total: {
    uk: "Всього",
    en: "Total ",
    hy: "Ընդամենը",
    ka: "ჯამი",
  },
  orders_currency_total: {
    uk: "грн.",
    en: "grn.",
    hy: "գրն.",
    ka: "გრნ.",
  },
  orders_popup_order_id_title: {
    uk: "ID замовлення",
    en: "Order ID",
    hy: "Պատվերի ID",
    ka: "შეკვეთის ID",
  },
  orders_popup_details_title: {
    uk: "Деталі замовлення",
    en: "Order details",
    hy: "Պատվերի մանրամասներ",
    ka: "შეკვეთის დეტალები",
  },
  orders_popup_sales_rep_label: {
    uk: "Торговий представник",
    en: "Sales Rep",
    hy: "Վաճառքի ներկայացուցիչ",
    ka: "გაყიდვების წარმომადგენელი",
  },
  orders_popup_order_status_label: {
    uk: "Статус замовлення",
    en: "Order Status",
    hy: "Պատվերի կարգավիճակ",
    ka: "შეკვეთის სტატუსი",
  },
  /* Added for PICSELL-1574 #12–#15: the counterparty's address and the number of product lines,
     both shown on the orders and returns tables and in their detail panels. */
  orders_address_label: {
    uk: "Адреса",
    en: "Address",
    hy: "Հասցե",
    ka: "მისამართი",
  },
  orders_items_count_label: {
    uk: "Позицій",
    en: "Items",
    hy: "Դիրքեր",
    ka: "პოზიციები",
  },
  /* The gross sum of the product lines, shown BESIDE the document's own total because the two
     disagree in the payload — see the note at the order modal's item table. */
  orders_lines_total: {
    uk: "Сума позицій",
    en: "Line total",
    hy: "Տողերի գումարը",
    ka: "ხაზების ჯამი",
  },
  orders_popup_counterparty_label: {
    uk: "Контрагент",
    en: "Counterparty",
    hy: "Կոնտրագենտ",
    ka: "კონტრაგენტი",
  },
  orders_popup_order_type_label: {
    uk: "Тип замовлення",
    en: "Order Type",
    hy: "Պատվերի տեսակ",
    ka: "შეკვეთის ტიპი",
  },
  orders_popup_order_table_label: {
    uk: "Таблиця продуктів",
    en: "Products Table",
    hy: "Ապրանքների աղյուսակ",
    ka: "პროდუქტების ცხრილი",
  },
  orders_popup_order_table_line_no: { uk: "№", en: "No.", hy: "Հ/Հ", ka: "№" },
  orders_popup_order_table_name: {
    uk: "Назва",
    en: "Name",
    hy: "Անվանում",
    ka: "სახელი",
  },
  orders_popup_order_table_quantity: {
    uk: "Кількість",
    en: "Quantity",
    hy: "Քանակ",
    ka: "რაოდენობა",
  },
  orders_popup_order_table_amount: {
    uk: "Сума",
    en: "Amount",
    hy: "Գումար",
    ka: "თანხა",
  },
  orders_popup_created_time_label: {
    uk: "Дата та час створення",
    en: "Created Date & Time",
    hy: "Ստեղծման ամսաթիվ և ժամ",
    ka: "შექმნის თარიღი და დრო",
  },
  orders_popup_delivery_time_label: {
    uk: "Дата доставки",
    en: "Delivery Date",
    hy: "Առաքման ամսաթիվ",
    ka: "მიწოდების თარიღი",
  },
  orders_popup_tracked_geolocation_label: {
    uk: "Відстежена геолокація",
    en: "Tracked Geolocation",
    hy: "Հետագծված աշխարհագրական դիրք",
    ka: "თრექინგის გეოლოკაცია",
  },
  orders_popup_custom_fields_label: {
    uk: "Користувацькі поля",
    en: "Custom Fields",
    hy: "Հատուկ դաշտեր",
    ka: "დამატებითი ველები",
  },
  orders_popup_comment_label: {
    uk: "Коментар",
    en: "Comment",
    hy: "Մեկնաբանություն",
    ka: "კომენტარი",
  },
  orders_popup_visit_label: {
    uk: "Візит",
    en: "Visit",
    hy: "Այց",
    ka: "ვიზიტი",
  },
  orders_physical_return_label: {
    uk: "Дата фізичного повернення",
    en: "Physical Return Date",
    hy: "Ֆիզիկական վերադարձի ամսաթիվ",
    ka: "ფიზიკური დაბრუნების თარიღი",
  },
  orders_status_return_label: {
    uk: "Статус повернення",
    en: "Return Status",
    hy: "Վերադարձի կարգավիճակ",
    ka: "დაბრუნების სტატუსი",
  },
  orders_return_id_label: {
    uk: "ID повернення",
    en: "Return ID",
    hy: "Վերադարձի ID",
    ka: "დაბრუნების ID",
  },
  orders_return_crated_label: {
    uk: "Дата та час створення",
    en: "Created Date & Time",
    hy: "Ստեղծման ամսաթիվ և ժամ",
    ka: "შექმნის თარიღი და დრო",
  },
  orders_payment_id_label: {
    uk: "ID оплати",
    en: "Payment ID",
    hy: "Վճարման ID",
    ka: "გადახდის ID",
  },
  orders_payment_amount_label: {
    uk: "Сума",
    en: "Amount",
    hy: "Գումար",
    ka: "თანხა",
  },
  orders_payment_debt_label: {
    uk: "Борг",
    en: "Debt",
    hy: "Պարտք",
    ka: "დავალიანება",
  },
  orders_delivery_label: {
    uk: "Доставка",
    en: "Delivery",
    hy: "Առաքում",
    ka: "მიწოდება",
  },
  orders_item_price_label: {
    uk: "Ціна",
    en: "Price",
    hy: "Գին",
    ka: "ფასი",
  },
  orders_item_sum_label: {
    uk: "Сума",
    en: "Sum",
    hy: "Գումար",
    ka: "ჯამი",
  },
  /* The stored `Order.Statuses` / `Return.Statuses` keys. DRF emits the KEY, not the label, so
     the cell used to read `sent_for_delivering` — lowercase, snake_case, English everywhere. */
  order_status_new: {
    uk: "Новий",
    en: "New",
    hy: "Նոր",
    ka: "ახალი",
  },
  order_status_processing: {
    uk: "В обробці",
    en: "Processing",
    hy: "Մշակվում է",
    ka: "მუშავდება",
  },
  order_status_sent_for_delivering: {
    uk: "Відправлено на доставку",
    en: "Sent for delivering",
    hy: "Ուղարկված է առաքման",
    ka: "გაგზავნილია მიწოდებაზე",
  },
  order_status_sent_to_logistics: {
    uk: "Передано в логістику",
    en: "Sent to logistics",
    hy: "Փոխանցված է լոգիստիկային",
    ka: "გადაცემულია ლოგისტიკაში",
  },
  order_status_closed: {
    uk: "Закрито",
    en: "Closed",
    hy: "Փակված",
    ka: "დახურული",
  },
  order_status_canceled: {
    uk: "Скасовано",
    en: "Cancelled",
    hy: "Չեղարկված",
    ka: "გაუქმებული",
  },
  rows_per_page: {
    uk: "Рядків на сторінці",
    en: "Rows per page",
    hy: "Տողեր մեկ էջում",
    ka: "სტრიქონები გვერდზე",
  },
  range_of: {
    uk: "{from}–{to} з {n}",
    en: "{from}–{to} of {n}",
    hy: "{from}–{to} {n}-ից",
    ka: "{from}–{to} {n}-დან",
  },
  /* The photo report section pages next/prev: its endpoint reports no total (see `SectionSteps`).
     The number stays out of a phrase, so nothing has to agree with it (spec/04). */
  page_n: {
    uk: "Сторінка {n}",
    en: "Page {n}",
    hy: "Էջ {n}",
    ka: "გვერდი {n}",
  },
  page_prev: {
    uk: "Попередня",
    en: "Previous",
    hy: "Նախորդը",
    ka: "წინა",
  },
  page_next: {
    uk: "Наступна",
    en: "Next",
    hy: "Հաջորդը",
    ka: "შემდეგი",
  },
  w_selected: {
    uk: "{n} обрано",
    en: "{n} selected",
    hy: "{n} ընտրված",
    ka: "{n} არჩეულია",
  },
  clear_selection: {
    uk: "Очистити",
    en: "Clear",
    hy: "Մաքրել",
    ka: "გასუფთავება",
  },
  all_reviewed_hint: {
    uk: "У цьому візиті немає нічого, що чекає на рішення.",
    en: "Nothing in this visit is waiting for a decision.",
    hy: "Այս այցում որոշման սպասող ոչինչ չկա։",
    ka: "ამ ვიზიტში გადაწყვეტილების მომლოდინე არაფერია.",
  },
  approved_at: {
    uk: "Дата рішення",
    en: "Decided at",
    hy: "Որոշման ամսաթիվը",
    ka: "გადაწყვეტილების თარიღი",
  },
  comment: {
    uk: "Коментар",
    en: "Comment",
    hy: "Մեկնաբանություն",
    ka: "კომენტარი",
  },
  copy_link: {
    uk: "Скопіювати посилання",
    en: "Copy link",
    hy: "Պատճենել հղումը",
    ka: "ბმულის კოპირება",
  },
  decide_failed_msg: {
    uk: "Не вдалося зберегти візитів: {n}",
    en: "{n} visits could not be saved",
    hy: "Չհաջողվեց պահպանել այցեր՝ {n}",
    ka: "ვერ შეინახა ვიზიტები: {n}",
  },
  delta: {
    uk: "Різниця",
    en: "Difference",
    hy: "Տարբերություն",
    ka: "სხვაობა",
  },
  empty_desc: {
    uk: "Спробуйте розширити період або зняти частину фільтрів.",
    en: "Try widening the period or clearing some filters.",
    hy: "Փորձեք ընդլայնել ժամանակահատվածը կամ հեռացնել որոշ զտիչներ։",
    ka: "სცადეთ პერიოდის გაფართოება ან ნაწილი ფილტრების მოხსნა.",
  },
  empty_title: {
    uk: "Немає візитів за цими фільтрами",
    en: "No visits match these filters",
    hy: "Այս զտիչներով այցեր չկան",
    ka: "ამ ფილტრებით ვიზიტები ვერ მოიძებნა",
  },
  gps_points: {
    uk: "Точок треку",
    en: "Track points",
    hy: "Երթուղու կետեր",
    ka: "ტრეკის წერტილები",
  },
  h_short: {
    uk: "г",
    en: "h",
    hy: "ժ",
    ka: "სთ",
  },
  link_copied: {
    uk: "Посилання скопійовано",
    en: "Link copied",
    hy: "Հղումը պատճենված է",
    ka: "ბმული დაკოპირდა",
  },
  m_short: {
    uk: "хв",
    en: "m",
    hy: "ր",
    ka: "წთ",
  },
  n_pending: {
    uk: "На перевірці: {n}",
    en: "On verification: {n}",
    hy: "Ստուգման փուլում՝ {n}",
    ka: "გადამოწმებაში: {n}",
  },
  next_visit: {
    uk: "Наступний візит",
    en: "Next visit",
    hy: "Հաջորդ այցը",
    ka: "შემდეგი ვიზიტი",
  },
  no_answer: {
    uk: "Немає відповіді",
    en: "No answer",
    hy: "Պատասխան չկա",
    ka: "პასუხი არ არის",
  },
  no_coordinates: {
    uk: "Точка не має координат",
    en: "The point has no coordinates",
    hy: "Կետը չունի կոորդինատներ",
    ka: "წერტილს არ აქვს კოორდინატები",
  },
  nothing_here: {
    uk: "Тут порожньо",
    en: "Nothing here",
    hy: "Այստեղ դատարկ է",
    ka: "აქ ცარიელია",
  },
  open_visit: {
    uk: "Відкрити візит",
    en: "Open visit",
    hy: "Բացել այցը",
    ka: "ვიზიტის გახსნა",
  },
  page_sub: {
    uk: "Затвердження візитів і виконання звітів",
    en: "Visit approvals and report completion",
    hy: "Այցերի հաստատում և հաշվետվությունների կատարում",
    ka: "ვიზიტების დამტკიცება და ანგარიშების შესრულება",
  },
  position_of: {
    uk: "{i} з {n}",
    en: "{i} of {n}",
    hy: "{n}-ից {i}",
    ka: "{n}-დან {i}",
  },
  prev_visit: {
    uk: "Попередній візит",
    en: "Previous visit",
    hy: "Նախորդ այցը",
    ka: "წინა ვიზიტი",
  },
  reject_reason: {
    uk: "Причина відхилення",
    en: "Rejection reason",
    hy: "Մերժման պատճառը",
    ka: "უარყოფის მიზეზი",
  },
  reject_reason_ph: {
    uk: "Що потрібно виправити?",
    en: "What needs to be fixed?",
    hy: "Ի՞նչը պետք է շտկել։",
    ka: "რა უნდა გამოსწორდეს?",
  },
  row_actions: {
    uk: "Дії",
    en: "Row actions",
    hy: "Գործողություններ",
    ka: "მოქმედებები",
  },
  sections: {
    uk: "Розділи",
    en: "Sections",
    hy: "Բաժիններ",
    ka: "სექციები",
  },
  show_on_map: {
    uk: "Показати на карті",
    en: "Show on map",
    hy: "Ցույց տալ քարտեզին",
    ka: "რუკაზე ჩვენება",
  },
  view_details: {
    uk: "Деталі",
    en: "View details",
    hy: "Մանրամասներ",
    ka: "დეტალები",
  },
  visit_end: {
    uk: "Кінець візиту",
    en: "Visit end",
    hy: "Այցի ավարտը",
    ka: "ვიზიტის დასასრული",
  },
  all_reviewed: {
    uk: "Все перевірено",
    en: "All reviewed",
    hy: "Ամեն ինչ ստուգված է",
    ka: "ყველაფერი შემოწმებულია",
  },
  approve_visits_msg: {
    uk: "Затверджено візитів: {n}",
    en: "{n} visits approved",
    hy: "Հաստատված այցեր՝ {n}",
    ka: "დამტკიცებული ვიზიტები: {n}",
  },
  gps_track: {
    uk: "GPS-трек",
    en: "GPS track",
    hy: "GPS երթուղի",
    ka: "GPS ტრეკი",
  },
  needs_attention: {
    uk: "Потребує уваги",
    en: "Needs your attention",
    hy: "Պահանջում է ձեր ուշադրությունը",
    ka: "საჭიროებს თქვენს ყურადღებას",
  },
  off_route: {
    uk: "Поза маршрутом",
    en: "Off route",
    hy: "Երթուղուց դուրս",
    ka: "მარშრუტის გარეთ",
  },
  on_route: {
    uk: "За маршрутом",
    en: "On the route",
    hy: "Երթուղով",
    ka: "მარშრუტზე",
  },
  record_approved: {
    uk: "Запис затверджено",
    en: "Record approved",
    hy: "Գրառումը հաստատված է",
    ka: "ჩანაწერი დამტკიცებულია",
  },
  record_rejected: {
    uk: "Запис відхилено",
    en: "Record rejected",
    hy: "Գրառումը մերժված է",
    ka: "ჩანაწერი უარყოფილია",
  },
  /* Mock-GPS pings on the track (PICSELL-1581 #5) — shown only when the mobile app flags one. */
  gps_mock_warning: {
    uk: "Виявлено ознаки підробленого GPS: позначок — {n}. Перевірте візит.",
    en: "Possible fake GPS detected: {n} flagged points. Review this visit.",
    hy: "Հնարավոր կեղծ GPS՝ {n} նշված կետ։ Ստուգեք այցը։",
    ka: "შესაძლო ყალბი GPS: {n} მონიშნული წერტილი. გადაამოწმეთ ვიზიტი.",
  },
  gps_from_point: {
    uk: "Час і відстань до точки візиту",
    en: "Time and distance from the visit point",
    hy: "Ժամը և հեռավորությունը այցի կետից",
    ka: "დრო და დაშორება ვიზიტის წერტილიდან",
  },
  gps_mock_tag: {
    uk: "Підроблений GPS",
    en: "Fake GPS",
    hy: "Կեղծ GPS",
    ka: "ყალბი GPS",
  },
  gps_m: {
    uk: "м",
    en: "m",
    hy: "մ",
    ka: "მ",
  },
  gps_km: {
    uk: "км",
    en: "km",
    hy: "կմ",
    ka: "კმ",
  },
  /* The bulk bar's result — a number, never a noun that must agree with it (spec/04). */
  records_approved: {
    uk: "Затверджено: {n}",
    en: "Approved: {n}",
    hy: "Հաստատված է՝ {n}",
    ka: "დამტკიცებულია: {n}",
  },
  records_rejected: {
    uk: "Відхилено: {n}",
    en: "Rejected: {n}",
    hy: "Մերժված է՝ {n}",
    ka: "უარყოფილია: {n}",
  },
  reject_visits_msg: {
    uk: "Відхилено візитів: {n}",
    en: "{n} visits rejected",
    hy: "Մերժված այցեր՝ {n}",
    ka: "უარყოფილი ვიზიტები: {n}",
  },
};
export const POINTS_ADMIN = {
  // section + generic
  section_points: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  new_btn: {
    uk: "Додати",
    en: "New",
    hy: "Նոր",
    ka: "ახალი",
  },
  save_btn: {
    uk: "Зберегти",
    en: "Save",
    hy: "Պահպանել",
    ka: "შენახვა",
  },
  /* ⚠ `create_btn` was ASKED FOR and never existed. `ResourcePage` renders
     `{isNew ? t("create_btn") : t("save_btn")}` as the children of a `<Button icon={<SaveOutlined/>}>`,
     `translate()` returns null for an unknown key, and antd applies `ant-btn-icon-only` when a
     button has an icon and no children — so the save control on every /<resource>/new page was a
     bare disk glyph with no label (PICSELL-1574 #26, #30). `summary` and `discard_confirm` were
     missing the same way: an empty rail heading and a titleless confirm modal. */
  create_btn: {
    uk: "Створити",
    en: "Create",
    hy: "Ստեղծել",
    ka: "შექმნა",
  },
  summary: {
    uk: "Зведення",
    en: "Summary",
    hy: "Ամփոփում",
    ka: "შეჯამება",
  },
  discard_confirm: {
    uk: "Відхилити незбережені зміни?",
    en: "Discard unsaved changes?",
    hy: "Չեղարկե՞լ չպահպանված փոփոխությունները։",
    ka: "გავაუქმოთ შენახული ცვლილებები?",
  },
  delete_btn: {
    uk: "Видалити",
    en: "Delete",
    hy: "Ջնջել",
    ka: "წაშლა",
  },
  back_btn: {
    uk: "Назад",
    en: "Back",
    hy: "Հետ",
    ka: "უკან",
  },
  edit_btn: {
    uk: "Редагувати",
    en: "Edit",
    hy: "Խմբագրել",
    ka: "რედაქტირება",
  },
  view_btn: {
    uk: "Перегляд",
    en: "View",
    hy: "Դիտել",
    ka: "ნახვა",
  },
  search_ph: {
    uk: "Пошук",
    en: "Search",
    hy: "Որոնում",
    ka: "ძებნა",
  },
  confirm_delete: {
    uk: "Видалити цей запис?",
    en: "Delete this record?",
    hy: "Ջնջել այս գրառումը?",
    ka: "წავშალო ეს ჩანაწერი?",
  },
  saved: {
    uk: "Збережено",
    en: "Saved",
    hy: "Պահպանված է",
    ka: "შენახულია",
  },
  save_error: {
    uk: "Помилка збереження",
    en: "Error while saving",
    hy: "Պահպանման սխալ",
    ka: "შენახვის შეცდომა",
  },
  deleted: {
    uk: "Видалено",
    en: "Deleted",
    hy: "Ջնջված է",
    ka: "წაშლილია",
  },
  empty: {
    uk: "Немає даних",
    en: "No data",
    hy: "Տվյալներ չկան",
    ka: "მონაცემები არ არის",
  },
  // shared field labels
  f_name: {
    uk: "Назва",
    en: "Name",
    hy: "Անվանում",
    ka: "სახელი",
  },
  f_code: {
    uk: "Код",
    en: "Code",
    hy: "Կոդ",
    ka: "კოდი",
  },
  f_image: {
    uk: "Зображення",
    en: "Image",
    hy: "Նկար",
    ka: "სურათი",
  },
  f_logo: {
    uk: "Логотип",
    en: "Logo",
    hy: "Լոգո",
    ka: "ლოგო",
  },
  f_address: {
    uk: "Адреса",
    en: "Address",
    hy: "Հասցե",
    ka: "მისამართი",
  },
  f_network: {
    uk: "Мережа",
    en: "Network",
    hy: "Ցանց",
    ka: "ქსელი",
  },
  f_category: {
    uk: "Категорія",
    en: "Category",
    hy: "Կատեգորիա",
    ka: "კატეგორია",
  },
  f_country: {
    uk: "Країна",
    en: "Country",
    hy: "Երկիր",
    ka: "ქვეყანა",
  },
  f_county: {
    uk: "Регіон",
    en: "County",
    hy: "Մարզ",
    ka: "რეგიონი",
  },
  f_locality: {
    uk: "Населений пункт",
    en: "Locality",
    hy: "Բնակավայր",
    ka: "დასახლებული პუნქტი",
  },
  f_location: {
    uk: "Координати",
    en: "Coordinates",
    hy: "Կոորդինատներ",
    ka: "კოორდინატები",
  },
  f_lat: {
    uk: "Широта",
    en: "Latitude",
    hy: "Լայնություն",
    ka: "განედი",
  },
  f_lng: {
    uk: "Довгота",
    en: "Longitude",
    hy: "Երկայնություն",
    ka: "გრძედი",
  },
  f_minutes: {
    uk: "Рекомендовані хвилини",
    en: "Recommended minutes",
    hy: "Առաջարկվող րոպեներ",
    ka: "რეკომენდებული წუთები",
  },
  f_merchandiser: {
    uk: "Мерчендайзер",
    en: "Merchandiser",
    hy: "Մերչենդայզեր",
    ka: "მერჩენდაიზერი",
  },
  f_supervisors: {
    uk: "Супервайзери",
    en: "Supervisors",
    hy: "Սուպերվայզերներ",
    ka: "სუპერვაიზერები",
  },
  f_is_active: {
    uk: "Активна",
    en: "Active",
    hy: "Ակտիվ",
    ka: "აქტიური",
  },
  f_available_tasks: {
    uk: "Доступна для завдань",
    en: "Available for tasks",
    hy: "Հասանելի է առաջադրանքների համար",
    ka: "ხელმისაწვდომია დავალებებისთვის",
  },
  f_additional_info: {
    uk: "Додаткова інформація",
    en: "Additional info",
    hy: "Լրացուցիչ տեղեկություններ",
    ka: "დამატებითი ინფორმაცია",
  },
  filter_created_by_me: {
    uk: "Створені мною",
    en: "Created by me",
    hy: "Իմ ստեղծած",
    ka: "ჩემ მიერ შექმნილი",
  },
  kv_key: {
    uk: "Мітка",
    en: "Label",
    hy: "Պիտակ",
    ka: "იარლიყი",
  },
  kv_value: {
    uk: "Значення",
    en: "Value",
    hy: "Արժեք",
    ka: "მნიშვნელობა",
  },
  kv_add: {
    uk: "Додати поле",
    en: "Add field",
    hy: "Ավելացնել դաշտ",
    ka: "ველის დამატება",
  },
  f_price_monitoring: {
    uk: "Моніторинг цін",
    en: "Price monitoring",
    hy: "Գների մոնիտորինգ",
    ka: "ფასების მონიტორინგი",
  },
  f_pm_components: {
    uk: "Компоненти моніторингу",
    en: "Price monitoring components",
    hy: "Գների մոնիտորինգի բաղադրիչներ",
    ka: "ფასების მონიტორინგის კომპონენტები",
  },
  f_pm_required: {
    uk: "Обов'язкові компоненти",
    en: "Required components",
    hy: "Պարտադիր բաղադրիչներ",
    ka: "სავალდებული კომპონენტები",
  },
  f_send_outforz: {
    uk: "Надсилати в Outforz",
    en: "Send to Outforz",
    hy: "Ուղարկել Outforz",
    ka: "გაგზავნა Outforz-ში",
  },
  f_auto_approve: {
    uk: "Автозатвердження звітів",
    en: "Auto-approve reports",
    hy: "Հաշվետվությունների ավտոհաստատում",
    ka: "ანგარიშების ავტომატური დამტკიცება",
  },
  f_status_outforz: {
    uk: "Статус для Outforz",
    en: "Status to send to Outforz",
    hy: "Կարգավիճակ Outforz-ին ուղարկելու համար",
    ka: "სტატუსი Outforz-ში გასაგზავნად",
  },
  f_default_tags: {
    uk: "Теги за замовчуванням",
    en: "Default tags",
    hy: "Կանխադրված թեգեր",
    ka: "ნაგულისხმევი ტეგები",
  },
  f_created_by: {
    uk: "Створив",
    en: "Created by",
    hy: "Ստեղծող",
    ka: "შემქმნელი",
  },
  f_available_supervisors: {
    uk: "Доступно супервайзерам",
    en: "Available for supervisors",
    hy: "Հասանելի սուպերվայզերներին",
    ka: "ხელმისაწვდომია სუპერვაიზერებისთვის",
  },
  f_points: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  // per-entity title keys
  networks_title: {
    uk: "Мережі",
    en: "Networks",
    hy: "Ցանցեր",
    ka: "ქსელები",
  },
  countries_title: {
    uk: "Країни",
    en: "Countries",
    hy: "Երկրներ",
    ka: "ქვეყნები",
  },
  counties_title: {
    uk: "Регіони",
    en: "Counties",
    hy: "Մարզեր",
    ka: "რეგიონები",
  },
  localities_title: {
    uk: "Населені пункти",
    en: "Localities",
    hy: "Բնակավայրեր",
    ka: "დასახლებული პუნქტები",
  },
  categories_title: {
    uk: "Категорії точок",
    en: "Point categories",
    hy: "Կետերի կատեգորիաներ",
    ka: "წერტილების კატეგორიები",
  },
  points_title: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  point_groups_title: {
    uk: "Групи точок",
    en: "Point groups",
    hy: "Կետերի խմբեր",
    ka: "წერტილების ჯგუფები",
  },
  // status pill
  active: {
    uk: "Активна",
    en: "Active",
    hy: "Ակտիվ",
    ka: "აქტიური",
  },
  inactive: {
    uk: "Неактивна",
    en: "Inactive",
    hy: "Ոչ ակտիվ",
    ka: "არააქტიური",
  },
  f_status: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  activate_btn: {
    uk: "Активувати",
    en: "Activate",
    hy: "Ակտիվացնել",
    ka: "გააქტიურება",
  },
  deactivate_btn: {
    uk: "Деактивувати",
    en: "Deactivate",
    hy: "Դեակտիվացնել",
    ka: "დეაქტივაცია",
  },
  confirm_deactivate: {
    uk: "Деактивувати цей запис?",
    en: "Deactivate this record?",
    hy: "Դեակտիվացնել այս գրառումը?",
    ka: "დეაქტივირება ამ ჩანაწერისთვის?",
  },
  // form sections
  sec_basic: {
    uk: "Основне",
    en: "Basic info",
    hy: "Հիմնական տվյալներ",
    ka: "ძირითადი ინფორმაცია",
  },
  sec_location: {
    uk: "Розташування",
    en: "Location",
    hy: "Տեղադրություն",
    ka: "მდებარეობა",
  },
  sec_assignment: {
    uk: "Відповідальні",
    en: "Assignment",
    hy: "Հանձնարարություն",
    ka: "დანიშვნა",
  },
  sec_options: {
    uk: "Параметри",
    en: "Options",
    hy: "Ընտրանքներ",
    ka: "პარამეტრები",
  },
  // location picker
  search_address: {
    uk: "Пошук адреси",
    en: "Search address",
    hy: "Հասցեի որոնում",
    ka: "მისამართის ძებნა",
  },
  search_btn: {
    uk: "Знайти",
    en: "Search",
    hy: "Փնտրել",
    ka: "ძებნა",
  },
  searching: {
    uk: "Пошук…",
    en: "Searching…",
    hy: "Որոնում…",
    ka: "იძებნება…",
  },
  not_found: {
    uk: "Не знайдено",
    en: "Not found",
    hy: "Չի գտնվել",
    ka: "არ მოიძებნა",
  },
  remove_image: {
    uk: "Видалити",
    en: "Remove",
    hy: "Հեռացնել",
    ka: "წაშლა",
  },
  crop_confirm: {
    uk: "Обрізати",
    en: "Crop",
    hy: "Կտրել",
    ka: "მოჭრა",
  },
  crop_cancel: {
    uk: "Скасувати",
    en: "Cancel",
    hy: "Չեղարկել",
    ka: "გაუქმება",
  },
  // personnel management
  merchandisers_title: {
    uk: "Мерчендайзери",
    en: "Merchandisers",
    hy: "Մերչենդայզերներ",
    ka: "მერჩენდაიზერები",
  },
  supervisors_title: {
    uk: "Супервайзери",
    en: "Supervisors",
    hy: "Սուպերվայզերներ",
    ka: "სუპერვაიზერები",
  },
  f_phone: {
    uk: "Телефон",
    en: "Phone",
    hy: "Հեռախոս",
    ka: "ტელეფონი",
  },
  f_movement: {
    uk: "Пересування",
    en: "Movement",
    hy: "Տեղաշարժ",
    ka: "გადაადგილება",
  },
  f_first_name: {
    uk: "Ім'я",
    en: "First name",
    hy: "Անուն",
    ka: "სახელი",
  },
  f_last_name: {
    uk: "Прізвище",
    en: "Last name",
    hy: "Ազգանուն",
    ka: "გვარი",
  },
  // surveys
  surveys_title: {
    uk: "Опитування",
    en: "Surveys",
    hy: "Հարցումներ",
    ka: "გამოკითხვები",
  },
  sec_schedule: {
    uk: "Розклад",
    en: "Schedule",
    hy: "Ժամանակացույց",
    ka: "განრიგი",
  },
  sec_audience: {
    uk: "Аудиторія",
    en: "Audience",
    hy: "Լսարան",
    ka: "აუდიტორია",
  },
  sec_questions: {
    uk: "Питання",
    en: "Questions",
    hy: "Հարցեր",
    ka: "კითხვები",
  },
  sec_targeting: {
    uk: "Таргетинг",
    en: "Targeting",
    hy: "Թիրախավորում",
    ka: "თარგეთირება",
  },
  no_dropdown_options: {
    uk: "Варіанти ще не додані",
    en: "No options yet",
    hy: "Տարբերակներ դեռ չկան",
    ka: "ვარიანტები ჯერ არ არის",
  },
  f_title: {
    uk: "Назва",
    en: "Title",
    hy: "Վերնագիր",
    ka: "სათაური",
  },
  f_description: {
    uk: "Опис",
    en: "Description",
    hy: "Նկարագրություն",
    ka: "აღწერა",
  },
  f_active_from: {
    uk: "Активний з",
    en: "Active from",
    hy: "Ակտիվ է սկսած",
    ka: "აქტიურია დან",
  },
  f_active_to: {
    uk: "Активний до",
    en: "Active to",
    hy: "Ակտիվ է մինչև",
    ka: "აქტიურია მდე",
  },
  f_form_organization_mode: {
    uk: "Режим організації форми",
    en: "Form organization mode",
    hy: "Ձևի կազմակերպման ռեժիմ",
    ka: "ფორმის ორგანიზების რეჟიმი",
  },
  f_audience: {
    uk: "Аудиторія",
    en: "Audience",
    hy: "Լսարան",
    ka: "აუდიტორია",
  },
  f_questions: {
    uk: "Питання",
    en: "Questions",
    hy: "Հարցեր",
    ka: "კითხვები",
  },
  audience_target_type: {
    uk: "Тип аудиторії",
    en: "Target type",
    hy: "Թիրախի տեսակ",
    ka: "სამიზნის ტიპი",
  },
  target_points: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  target_point_groups: {
    uk: "Групи точок",
    en: "Point groups",
    hy: "Կետերի խմբեր",
    ka: "წერტილების ჯგუფები",
  },
  target_networks: {
    uk: "Мережі",
    en: "Networks",
    hy: "Ցանցեր",
    ka: "ქსელები",
  },
  mode_products: {
    uk: "Товари",
    en: "Products",
    hy: "Ապրանքներ",
    ka: "პროდუქტები",
  },
  mode_brands: {
    uk: "Бренди",
    en: "Brands",
    hy: "Բրենդներ",
    ka: "ბრენდები",
  },
  mode_categories: {
    uk: "Категорії",
    en: "Categories",
    hy: "Կատեգորիաներ",
    ka: "კატეგორიები",
  },
  mode_subcategories: {
    uk: "Підкатегорії",
    en: "Subcategories",
    hy: "Ենթակատեգորիաներ",
    ka: "ქვეკატეგორიები",
  },
  question_add_btn: {
    uk: "Додати питання",
    en: "Add question",
    hy: "Ավելացնել հարց",
    ka: "კითხვის დამატება",
  },
  question_remove_btn: {
    uk: "Видалити питання",
    en: "Remove question",
    hy: "Հեռացնել հարցը",
    ka: "კითხვის წაშლა",
  },
  f_question_text: {
    uk: "Текст питання",
    en: "Question text",
    hy: "Հարցի տեքստ",
    ka: "კითხვის ტექსტი",
  },
  f_answer_type: {
    uk: "Тип відповіді",
    en: "Answer type",
    hy: "Պատասխանի տեսակ",
    ka: "პასუხის ტიპი",
  },
  answer_numeric: {
    uk: "Числове",
    en: "Numeric",
    hy: "Թվային",
    ka: "რიცხვითი",
  },
  answer_text: {
    uk: "Текстове",
    en: "Text",
    hy: "Տեքստային",
    ka: "ტექსტური",
  },
  answer_photo: {
    uk: "Фото",
    en: "Photo",
    hy: "Լուսանկար",
    ka: "ფოტო",
  },
  answer_dropdown: {
    uk: "Список",
    en: "Dropdown",
    hy: "Ցանկ",
    ka: "ჩამოსაშლელი",
  },
  answer_date: {
    uk: "Дата",
    en: "Date",
    hy: "Ամսաթիվ",
    ka: "თარიღი",
  },
  answer_boolean: {
    uk: "Так/Ні",
    en: "Boolean",
    hy: "Այո/Ոչ",
    ka: "დიახ/არა",
  },
  f_required: {
    uk: "Обов'язкове",
    en: "Required",
    hy: "Պարտադիր",
    ka: "სავალდებულო",
  },
  f_priority: {
    uk: "Пріоритет",
    en: "Priority",
    hy: "Առաջնահերթություն",
    ka: "პრიორიტეტი",
  },
  f_order: {
    uk: "Порядок",
    en: "Order",
    hy: "Հերթականություն",
    ka: "რიგითობა",
  },
  priority_low: {
    uk: "Низький",
    en: "Low",
    hy: "Ցածր",
    ka: "დაბალი",
  },
  priority_medium: {
    uk: "Середній",
    en: "Medium",
    hy: "Միջին",
    ka: "საშუალო",
  },
  priority_high: {
    uk: "Високий",
    en: "High",
    hy: "Բարձր",
    ka: "მაღალი",
  },
  f_question_mode: {
    uk: "Режим питання",
    en: "Question mode",
    hy: "Հարցի ռեժիմ",
    ka: "კითხვის რეჟიმი",
  },
  f_products_source: {
    uk: "Джерело товарів",
    en: "Products source",
    hy: "Ապրանքների աղբյուր",
    ka: "პროდუქტების წყარო",
  },
  source_all: {
    uk: "Усі",
    en: "All",
    hy: "Բոլորը",
    ka: "ყველა",
  },
  source_assortment_matrix: {
    uk: "Асортиментна матриця",
    en: "Assortment matrix",
    hy: "Տեսականու մատրիցա",
    ka: "ასორტიმენტის მატრიცა",
  },
  f_all_products: {
    uk: "Усі товари",
    en: "All products",
    hy: "Բոլոր ապրանքները",
    ka: "ყველა პროდუქტი",
  },
  f_all_brands: {
    uk: "Усі бренди",
    en: "All brands",
    hy: "Բոլոր բրենդները",
    ka: "ყველა ბრენდი",
  },
  f_all_categories: {
    uk: "Усі категорії",
    en: "All categories",
    hy: "Բոլոր կատեգորիաները",
    ka: "ყველა კატეგორია",
  },
  f_all_subcategories: {
    uk: "Усі підкатегорії",
    en: "All subcategories",
    hy: "Բոլոր ենթակատեգորիաները",
    ka: "ყველა ქვეკატეგორია",
  },
  f_products: {
    uk: "Товари",
    en: "Products",
    hy: "Ապրանքներ",
    ka: "პროდუქტები",
  },
  f_brands: {
    uk: "Бренди",
    en: "Brands",
    hy: "Բրենդներ",
    ka: "ბრენდები",
  },
  f_categories: {
    uk: "Категорії",
    en: "Categories",
    hy: "Կատեգորիաներ",
    ka: "კატეგორიები",
  },
  f_subcategories: {
    uk: "Підкатегорії",
    en: "Subcategories",
    hy: "Ենթակատեգորիաներ",
    ka: "ქვეკატეგორიები",
  },
  f_dropdown_options: {
    uk: "Варіанти списку",
    en: "Dropdown options",
    hy: "Ցանկի տարբերակներ",
    ka: "ჩამოსაშლელი ვარიანტები",
  },
  option_add_btn: {
    uk: "Додати варіант",
    en: "Add option",
    hy: "Ավելացնել տարբերակ",
    ka: "ვარიანტის დამატება",
  },
  option_label_ph: {
    uk: "Назва",
    en: "Label",
    hy: "Պիտակ",
    ka: "ლეიბლი",
  },
  option_value_ph: {
    uk: "Значення",
    en: "Value",
    hy: "Արժեք",
    ka: "მნიშვნელობა",
  },
  no_questions: {
    uk: "Питання ще не додані",
    en: "No questions yet",
    hy: "Հարցեր դեռ չկան",
    ka: "კითხვები ჯერ არ არის",
  },
  address_min_chars: {
    uk: "Введіть щонайменше 3 символи",
    en: "Type at least 3 characters",
    hy: "Մուտքագրեք առնվազն 3 նիշ",
    ka: "აკრიფეთ მინიმუმ 3 სიმბოლო",
  },
  all_answers: {
    uk: "Усі відповіді",
    en: "All answers",
    hy: "Բոլոր պատասխանները",
    ka: "ყველა პასუხი",
  },
  archive_btn: {
    uk: "Архівувати",
    en: "Archive",
    hy: "Արխիվացնել",
    ka: "დაარქივება",
  },
  archived: {
    uk: "В архіві",
    en: "Archived",
    hy: "Արխիվացված",
    ka: "დაარქივებული",
  },
  bulk_failed_n: {
    uk: "Не вдалося обробити. Кількість: {n}",
    en: "Could not be processed. Count: {n}",
    hy: "Չհաջողվեց մշակել։ Քանակը՝ {n}",
    ka: "ვერ დამუშავდა. რაოდენობა: {n}",
  },
  coords_readonly: {
    uk: "Координати задаються пошуком адреси або кліком на карті",
    en: "Coordinates are set by the address search or a map click",
    hy: "Կոորդինատները սահմանվում են հասցեի որոնմամբ կամ քարտեզի վրա սեղմումով",
    ka: "კოორდინატები დგინდება მისამართის ძებნით ან რუკაზე დაჭერით",
  },
  crop_area: {
    uk: "Область обрізання",
    en: "Crop area",
    hy: "Կտրման տարածք",
    ka: "მოჭრის არე",
  },
  crop_hint: {
    uk: "Перетягніть, щоб перемістити, кути — щоб змінити розмір. Стрілки зсувають, + і − змінюють масштаб",
    en: "Drag to move, corners to resize. Arrow keys nudge, + and − zoom",
    hy: "Քաշեք տեղափոխելու համար, անկյունները՝ չափը փոխելու։ Սլաքները տեղաշարժում են, + և − փոխում են խոշորացումը",
    ka: "გადაათრიეთ გადასაადგილებლად, კუთხეები — ზომის შესაცვლელად. ისრები გადააადგილებს, + და − ცვლის მასშტაბს",
  },
  crop_preview: {
    uk: "Перегляд",
    en: "Preview",
    hy: "Նախադիտում",
    ka: "წინასწარი ხედი",
  },
  crop_size: {
    uk: "Масштаб",
    en: "Zoom",
    hy: "Խոշորացում",
    ka: "მასშტაბი",
  },
  crop_title: {
    uk: "Обрізати зображення",
    en: "Crop image",
    hy: "Կտրել պատկերը",
    ka: "სურათის მოჭრა",
  },
  data_quality: {
    uk: "Якість даних",
    en: "Data quality",
    hy: "Տվյալների որակ",
    ka: "მონაცემთა ხარისხი",
  },
  empty_filtered: {
    uk: "Немає записів за цими фільтрами",
    en: "No records match these filters",
    hy: "Այս զտիչներին համապատասխանող գրառումներ չկան",
    ka: "ამ ფილტრებს არ შეესაბამება ჩანაწერები",
  },

  /* The second line of each empty state: `empty` / `empty_filtered` say WHAT, these say what to do
     about it. Nothing here yet and nothing matching are different states (spec/03). */
  empty_desc: {
    uk: "Створіть перший запис, щоб почати.",
    en: "Create the first record to get started.",
    hy: "Ստեղծեք առաջին գրառումը՝ սկսելու համար։",
    ka: "დასაწყებად შექმენით პირველი ჩანაწერი.",
  },

  empty_filtered_desc: {
    uk: "Спробуйте розширити пошук або скинути фільтри.",
    en: "Try widening the search or clearing the filters.",
    hy: "Փորձեք ընդլայնել որոնումը կամ մաքրել զտիչները։",
    ka: "სცადეთ ძიების გაფართოება ან ფილტრების გასუფთავება.",
  },
  filters_reset: {
    uk: "Фільтри скинуто",
    en: "Filters reset",
    hy: "Զտիչները զրոյացված են",
    ka: "ფილტრები გასუფთავდა",
  },
  min_col: {
    uk: "Хвилини",
    en: "Minutes",
    hy: "Րոպեներ",
    ka: "წუთები",
  },
  min_short: {
    uk: "хв",
    en: "min",
    hy: "ր",
    ka: "წთ",
  },
  never_visited: {
    uk: "Ще не відвідано",
    en: "Never visited",
    hy: "Դեռ չայցելված",
    ka: "ჯერ არ მონახულებულა",
  },
  new_point: {
    uk: "Нова точка",
    en: "New point",
    hy: "Նոր կետ",
    ka: "ახალი წერტილი",
  },
  no_coords: {
    uk: "Без координат",
    en: "No coordinates",
    hy: "Առանց կոորդինատների",
    ka: "კოორდინატები არ არის",
  },
  no_coords_hint: {
    uk: "У цієї точки немає координат, тому візити до неї не можна підтвердити на місці.",
    en: "This point has no coordinates, so visits to it cannot be verified on site.",
    hy: "Այս կետը կոորդինատներ չունի, ուստի այցերը հնավայրում հնարավոր չէ հաստատել։",
    ka: "ამ წერტილს კოორდინატები არ აქვს, ამიტომ ვიზიტების ადგილზე დადასტურება შეუძლებელია.",
  },
  no_tasks: {
    uk: "Завдання вимкнено",
    en: "Tasks off",
    hy: "Առաջադրանքներն անջատված են",
    ka: "დავალებები გამორთულია",
  },
  open_editor: {
    uk: "Відкрити редактор",
    en: "Open editor",
    hy: "Բացել խմբագրիչը",
    ka: "რედაქტორის გახსნა",
  },
  option_remove: {
    uk: "Видалити варіант",
    en: "Remove option",
    hy: "Հեռացնել տարբերակը",
    ka: "ვარიანტის წაშლა",
  },
  pick_image: {
    uk: "Вибрати зображення",
    en: "Choose image",
    hy: "Ընտրել պատկեր",
    ka: "აირჩიეთ სურათი",
  },
  points_sub: {
    uk: "Торгові точки, призначення та якість даних",
    en: "Retail locations, assignment and data quality",
    hy: "Առևտրի կետեր, նշանակում և տվյալների որակ",
    ka: "სავაჭრო წერტილები, დანიშვნა და მონაცემთა ხარისხი",
  },

  /* One line per reference list saying what its records are FOR — the one thing a title like
     "Localities" cannot. Rendered in the page head by `ResourceList`. */
  networks_sub: {
    uk: "Торгові мережі, до яких належать точки",
    en: "Retail chains the points belong to",
    hy: "Առևտրային ցանցեր, որոնց պատկանում են կետերը",
    ka: "სავაჭრო ქსელები, რომლებსაც ეკუთვნის წერტილები",
  },

  countries_sub: {
    uk: "Країни, що використовуються в адресах і регіонах",
    en: "Countries used in addresses and regions",
    hy: "Երկրներ, որոնք օգտագործվում են հասցեներում և տարածաշրջաններում",
    ka: "ქვეყნები, რომლებიც გამოიყენება მისამართებსა და რეგიონებში",
  },

  counties_sub: {
    uk: "Регіони, за якими розподіляються точки, маршрути та покриття",
    en: "Regions that scope points, routes and coverage",
    hy: "Տարածաշրջաններ, որոնցով բաշխվում են կետերը, երթուղիներն ու ծածկույթը",
    ka: "რეგიონები, რომლითაც ნაწილდება წერტილები, მარშრუტები და დაფარვა",
  },

  localities_sub: {
    uk: "Міста та села, до яких прив'язані точки",
    en: "Cities and towns the points are addressed to",
    hy: "Քաղաքներ և բնակավայրեր, որոնց կապված են կետերը",
    ka: "ქალაქები და დასახლებები, რომლებსაც უკავშირდება წერტილები",
  },

  categories_sub: {
    uk: "Типи точок, моніторинг цін і налаштування інтеграції",
    en: "Point types, price monitoring and integration settings",
    hy: "Կետերի տեսակներ, գների մոնիտորինգ և ինտեգրման կարգավորումներ",
    ka: "წერტილების ტიპები, ფასების მონიტორინგი და ინტეგრაციის პარამეტრები",
  },

  point_groups_sub: {
    uk: "Іменовані набори точок для завдань і опитувань",
    en: "Named sets of points for tasks and surveys",
    hy: "Կետերի անվանված խմբեր՝ առաջադրանքների և հարցումների համար",
    ka: "წერტილების დასახელებული ჯგუფები დავალებებისა და გამოკითხვებისთვის",
  },

  surveys_sub: {
    uk: "Опитування, на які мерчандайзери відповідають під час візиту",
    en: "Questionnaires merchandisers answer during a visit",
    hy: "Հարցումներ, որոնց մերչենդայզերները պատասխանում են այցի ժամանակ",
    ka: "გამოკითხვები, რომლებსაც მერჩენდაიზერები პასუხობენ ვიზიტისას",
  },
  question_move_down: {
    uk: "Перемістити вниз",
    en: "Move down",
    hy: "Տեղափոխել վար",
    ka: "დაწევა",
  },
  question_move_up: {
    uk: "Перемістити вгору",
    en: "Move up",
    hy: "Տեղափոխել վեր",
    ka: "აწევა",
  },
  restore_btn: {
    uk: "Відновити",
    en: "Restore",
    hy: "Վերականգնել",
    ka: "აღდგენა",
  },
  search_point_ph: {
    uk: "Назва, код або адреса",
    en: "Name, code or address",
    hy: "Անուն, կոդ կամ հասցե",
    ka: "სახელი, კოდი ან მისამართი",
  },
  select_page_hint: {
    uk: "Вибір діє на завантажену сторінку",
    en: "Selection covers the loaded page",
    hy: "Ընտրությունը վերաբերում է բեռնված էջին",
    ka: "არჩევანი მოქმედებს ჩატვირთულ გვერდზე",
  },
  unassigned: {
    uk: "Не призначено",
    en: "Unassigned",
    hy: "Չնշանակված",
    ka: "დაუნიშნავი",
  },
  archived_n: {
    uk: "Архівовано. Кількість: {n}",
    en: "Archived. Count: {n}",
    hy: "Արխիվացվեց։ Քանակը՝ {n}",
    ka: "დაარქივდა. რაოდენობა: {n}",
  },
  confirm_archive: {
    uk: "Архівувати цей запис?",
    en: "Archive this record?",
    hy: "Արխիվացնե՞լ այս գրառումը",
    ka: "დავაარქივოთ ეს ჩანაწერი?",
  },
  confirm_archive_n: {
    uk: "Архівувати вибрані записи? Кількість: {n}",
    en: "Archive the selected records? Count: {n}",
    hy: "Արխիվացնե՞լ ընտրված գրառումները։ Քանակը՝ {n}",
    ka: "დავაარქივოთ არჩეული ჩანაწერები? რაოდენობა: {n}",
  },
  confirm_deactivate_n: {
    uk: "Деактивувати вибрані записи? Кількість: {n}",
    en: "Deactivate the selected records? Count: {n}",
    hy: "Դեակտիվացնե՞լ ընտրված գրառումները։ Քանակը՝ {n}",
    ka: "დავაქტიურდეს არჩეული ჩანაწერები? რაოდენობა: {n}",
  },
  created_at: {
    uk: "Створено",
    en: "Created",
    hy: "Ստեղծված",
    ka: "შექმნილია",
  },
  deactivated_n: {
    uk: "Деактивовано. Кількість: {n}",
    en: "Deactivated. Count: {n}",
    hy: "Դեակտիվացվեց։ Քանակը՝ {n}",
    ka: "დეაქტივირდა. რაოდენობა: {n}",
  },

  activated_n: {
    uk: "Активовано. Кількість: {n}",
    en: "Activated. Count: {n}",
    hy: "Ակտիվացվեց։ Քանակը՝ {n}",
    ka: "აქტივირდა. რაოდენობა: {n}",
  },
  draft: {
    uk: "Чернетка",
    en: "Draft",
    hy: "Սևագիր",
    ka: "მონახაზი",
  },
  unsaved: {
    uk: "Незбережені зміни",
    en: "Unsaved changes",
    hy: "Չպահպանված փոփոխություններ",
    ka: "შეუნახავი ცვლილებები",
  },
  /* The list's status segment. `active` / `inactive` / `archived` above are the same words. */
  seg_all: {
    uk: "Усі",
    en: "All",
    hy: "Բոլորը",
    ka: "ყველა",
  },
  last_visit: {
    uk: "Останній візит",
    en: "Last visit",
    hy: "Վերջին այցը",
    ka: "ბოლო ვიზიტი",
  },
  fix_first: {
    uk: "Виправте позначені поля перед збереженням",
    en: "Fix the highlighted fields before saving",
    hy: "Ուղղեք նշված դաշտերը նախքան պահպանելը",
    ka: "შენახვამდე გაასწორეთ მონიშნული ველები",
  },
  // {f} = the field's own label. The em-dash form is deliberate: uk/hy/ka would otherwise have to
  // agree with the label's gender, which a descriptor label cannot carry.
  q_required: {
    uk: "{f} — обов'язкове поле",
    en: "{f} is required",
    hy: "{f} — պարտադիր դաշտ է",
    ka: "{f} — სავალდებულო ველია",
  },
  w_no_merch: {
    uk: "Немає відповідального мерчандайзера",
    en: "No responsible merchandiser",
    hy: "Պատասխանատու մերչենդայզեր չկա",
    ka: "პასუხისმგებელი მერჩენდაიზერი არ არის",
  },
  import_btn: {
    uk: "Імпорт",
    en: "Import",
    hy: "Ներմուծել",
    ka: "იმპორტი",
  },
  label: {
    uk: "Основне",
    en: "Main",
    hy: "Հիմնական",
    ka: "მთავარი",
  },
  q_complete: {
    uk: "Усе заповнено",
    en: "Nothing missing",
    hy: "Ամեն ինչ լրացված է",
    ka: "ყველაფერი შევსებულია",
  },
  restored_n: {
    uk: "Відновлено. Кількість: {n}",
    en: "Restored. Count: {n}",
    hy: "Վերականգնվեց։ Քանակը՝ {n}",
    ka: "აღდგა. რაოდენობა: {n}",
  },
  sec_assignment_desc: {
    uk: "Хто відповідає за цю точку",
    en: "Who is responsible for this point",
    hy: "Ով է պատասխանատու այս կետի համար",
    ka: "ვინ არის პასუხისმგებელი ამ წერტილზე",
  },
  sec_basic_desc: {
    uk: "Назва, код і мережа точки",
    en: "The point's name, code and network",
    hy: "Կետի անվանումը, կոդը և ցանցը",
    ka: "წერტილის სახელი, კოდი და ქსელი",
  },
  sec_integration: {
    uk: "Інтеграція з Outforz",
    en: "Outforz integration",
    hy: "Outforz ինտեգրում",
    ka: "Outforz ინტეგრაცია",
  },
  sec_location_desc: {
    uk: "Адреса, населений пункт і координати на карті",
    en: "Address, locality and coordinates on the map",
    hy: "Հասցեն, բնակավայրը և կոորդինատները քարտեզի վրա",
    ka: "მისამართი, დასახლება და კოორდინატები რუკაზე",
  },
  sec_options_desc: {
    uk: "Рекомендований час візиту та доступність",
    en: "Recommended visit time and availability",
    hy: "Այցի առաջարկվող տևողությունը և հասանելիությունը",
    ka: "ვიზიტის სასურველი დრო და ხელმისაწვდომობა",
  },
  sec_price_monitoring: {
    uk: "Моніторинг цін",
    en: "Price monitoring",
    hy: "Գների մոնիտորինգ",
    ka: "ფასების მონიტორინგი",
  },
};

export const OVERVIEW = {
  title: {
    uk: "Огляд",
    en: "Overview",
    hy: "Ակնարկ",
    ka: "მიმოხილვა",
  },
  active_merchandisers: {
    uk: "Активні мерчендайзери",
    en: "Active merchandisers",
    hy: "Ակտիվ մերչենդայզերներ",
    ka: "აქტიური მერჩენდაიზერები",
  },
  active_supervisors: {
    uk: "Активні супервайзери",
    en: "Active supervisors",
    hy: "Ակտիվ սուպերվայզերներ",
    ka: "აქტიური სუპერვაიზერები",
  },
  visits: {
    uk: "Візити",
    en: "Visits",
    hy: "Այցեր",
    ka: "ვიზიტები",
  },
  reports: {
    uk: "Звіти",
    en: "Reports",
    hy: "Հաշվետվություններ",
    ka: "ანგარიშები",
  },
  answers: {
    uk: "Відповіді",
    en: "Answers",
    hy: "Պատասխաններ",
    ka: "პასუხები",
  },
  trend_title: {
    uk: "Динаміка за місяць",
    en: "Monthly activity",
    hy: "Ամսական ակտիվություն",
    ka: "თვიური აქტივობა",
  },
  top_merchandisers: {
    uk: "Топ мерчендайзери",
    en: "Top merchandisers",
    hy: "Լավագույն մերչենդայզերներ",
    ka: "ტოპ მერჩენდაიზერები",
  },
  by_merchandiser: {
    uk: "Статистика за мерчендайзерами",
    en: "Statistics by merchandiser",
    hy: "Վիճակագրություն ըստ մերչենդայզերի",
    ka: "სტატისტიკა მერჩენდაიზერების მიხედვით",
  },
  search_ph: {
    uk: "Пошук мерчендайзера…",
    en: "Search merchandiser…",
    hy: "Փնտրել մերչենդայզեր…",
    ka: "მერჩენდაიზერის ძებნა…",
  },
  col_merchandiser: {
    uk: "Мерчендайзер",
    en: "Merchandiser",
    hy: "Մերչենդայզեր",
    ka: "მერჩენდაიზერი",
  },
  col_visits: {
    uk: "Візити",
    en: "Visits",
    hy: "Այցեր",
    ka: "ვიზიტები",
  },
  col_reports: {
    uk: "Звіти",
    en: "Reports",
    hy: "Հաշվետվություններ",
    ka: "ანგარიშები",
  },
  col_answers: {
    uk: "Відповіді",
    en: "Answers",
    hy: "Պատասխաններ",
    ka: "პასუხები",
  },
  loading: {
    uk: "Завантаження…",
    en: "Loading…",
    hy: "Բեռնվում է…",
    ka: "იტვირთება…",
  },
  empty: {
    uk: "Немає даних",
    en: "No data",
    hy: "Տվյալներ չկան",
    ka: "მონაცემები არ არის",
  },
  error: {
    uk: "Не вдалося завантажити статистику.",
    en: "Failed to load statistics.",
    hy: "Չհաջողվեց բեռնել վիճակագրությունը:",
    ka: "სტატისტიკის ჩატვირთვა ვერ მოხერხდა.",
  },
  retry: {
    uk: "Повторити",
    en: "Retry",
    hy: "Կրկնել",
    ka: "ხელახლა",
  },

  // Page subtitle: the period being shown and what it is compared against.
  // {m} = the selected month, {p} = the one before it.
  period_sub: {
    uk: "{m} · проти {p}",
    en: "{m} · vs {p}",
    hy: "{m} · ընդդեմ {p}",
    ka: "{m} · შედარებით {p}",
  },

  // Accessible names for the icon-only month stepper — an arrow glyph has none.
  prev_month: {
    uk: "Попередній місяць",
    en: "Previous month",
    hy: "Նախորդ ամիս",
    ka: "წინა თვე",
  },
  next_month: {
    uk: "Наступний місяць",
    en: "Next month",
    hy: "Հաջորդ ամիս",
    ka: "შემდეგი თვე",
  },

  // ---- Trend chart -------------------------------------------------------
  // The fourth series counts SURVEY answers, which are a different system from
  // the task `answers` KPI above — they need distinct labels or the legend lies.
  survey_answers: {
    uk: "Відповіді опитувань",
    en: "Survey answers",
    hy: "Հարցումների պատասխաններ",
    ka: "გამოკითხვის პასუხები",
  },

  // ---- Survey band -------------------------------------------------------
  surveys: {
    uk: "Опитування",
    en: "Surveys",
    hy: "Հարցումներ",
    ka: "გამოკითხვები",
  },
  active_surveys: {
    uk: "Активні опитування",
    en: "Active surveys",
    hy: "Ակտիվ հարցումներ",
    ka: "აქტიური გამოკითხვები",
  },
  // {t} = total surveys, {e} = how many end within seven days.
  active_surveys_hint: {
    uk: "усього {t} · завершуються цього тижня: {e}",
    en: "{t} total · {e} ending this week",
    hy: "ընդամենը {t} · այս շաբաթ ավարտվում է {e}",
    ka: "სულ {t} · ამ კვირას სრულდება {e}",
  },
  // {a} = answered required question instances, {b} = assigned.
  answers_collected: {
    uk: "Зібрано відповідей",
    en: "Answers collected",
    hy: "Հավաքված պատասխաններ",
    ka: "შეგროვებული პასუხები",
  },
  // {p} carries its own sign, {m} is the previous month's name.
  vs_previous_month: {
    uk: "{p}% проти {m}",
    en: "{p}% vs {m}",
    hy: "{p}% ընդդեմ {m}",
    ka: "{p}% შედარებით {m}",
  },

  // ---- Visit status ------------------------------------------------------
  visit_status: {
    uk: "Статус візитів",
    en: "Visit status",
    hy: "Այցերի կարգավիճակ",
    ka: "ვიზიტის სტატუსი",
  },
  approved: {
    uk: "Затверджено",
    en: "Approved",
    hy: "Հաստատված",
    ka: "დამტკიცებული",
  },
  on_verification: {
    uk: "На перевірці",
    en: "On verification",
    hy: "Ստուգման փուլում",
    ka: "გადამოწმებაში",
  },
  not_approved: {
    uk: "Не затверджено",
    en: "Not approved",
    hy: "Չհաստատված",
    ka: "დაუმტკიცებელი",
  },
  total: {
    uk: "усього",
    en: "total",
    hy: "ընդամենը",
    ka: "სულ",
  },

  // ---- Photo review pipeline ---------------------------------------------
  photo_pipeline: {
    uk: "Перевірка фото",
    en: "Photo review pipeline",
    hy: "Լուսանկարների ստուգում",
    ka: "ფოტოს შემოწმება",
  },
  submitted: {
    uk: "Надіслано",
    en: "Submitted",
    hy: "Ուղարկված",
    ka: "გაგზავნილი",
  },
  reviewed: {
    uk: "Перевірено",
    en: "Reviewed",
    hy: "Ստուգված",
    ka: "შემოწმებული",
  },
  // {n} = rejected count, {p} = share of everything reviewed.
  rejected_hint: {
    uk: "відхилено: {n} ({p}% перевірених)",
    en: "{n} rejected ({p}% of reviewed)",
    hy: "մերժված՝ {n} ({p}% ստուգվածների)",
    ka: "უარყოფილი: {n} (შემოწმებულის {p}%)",
  },

  // ---- Answers by type ---------------------------------------------------
  answers_by_type: {
    uk: "Відповіді за типом",
    en: "Answers by type",
    hy: "Պատասխանները ըստ տիպի",
    ka: "პასუხები ტიპის მიხედვით",
  },
  t_photo: {
    uk: "Фото",
    en: "Photo",
    hy: "Լուսանկար",
    ka: "ფოტო",
  },
  t_dropdown: {
    uk: "Список",
    en: "Dropdown",
    hy: "Ցանկ",
    ka: "სია",
  },
  t_numeric: {
    uk: "Число",
    en: "Numeric",
    hy: "Թիվ",
    ka: "რიცხვი",
  },
  t_text: {
    uk: "Текст",
    en: "Text",
    hy: "Տեքստ",
    ka: "ტექსტი",
  },
  t_boolean: {
    uk: "Так/Ні",
    en: "Boolean",
    hy: "Այո/Ոչ",
    ka: "დიახ/არა",
  },
  t_date: {
    uk: "Дата",
    en: "Date",
    hy: "Ամսաթիվ",
    ka: "თარიღი",
  },

  // ---- Regions -----------------------------------------------------------
  visits_by_region: {
    uk: "Візити за регіонами",
    en: "Visits by region",
    hy: "Այցեր ըստ մարզերի",
    ka: "ვიზიტები რეგიონების მიხედვით",
  },
  top_regions: {
    uk: "топ 5 і решта",
    en: "top 5 and the rest",
    hy: "թոփ 5 և մնացածը",
    ka: "ტოპ 5 და დანარჩენი",
  },
  other_regions: {
    uk: "Інші регіони",
    en: "Other regions",
    hy: "Այլ մարզեր",
    ka: "სხვა რეგიონები",
  },

  // ---- Per-survey completion ---------------------------------------------
  survey_activity: {
    uk: "Активність опитувань",
    en: "Survey activity",
    hy: "Հարցումների ակտիվություն",
    ka: "გამოკითხვების აქტივობა",
  },
  active_this_month: {
    uk: "активні цього місяця",
    en: "active this month",
    hy: "ակտիվ այս ամիս",
    ka: "აქტიური ამ თვეში",
  },
  // {a} = answers recorded, {q} = questions in the survey. Label:value form
  // rather than "{a} answers", which would need the noun to agree with {a}.

  // ---- Heatmap -----------------------------------------------------------
  visit_intensity: {
    uk: "Інтенсивність візитів",
    en: "Visit intensity",
    hy: "Այցերի ինտենսիվություն",
    ka: "ვიზიტების ინტენსივობა",
  },
  per_day: {
    uk: "візитів на день",
    en: "visits per day",
    hy: "այց օրական",
    ka: "ვიზიტი დღეში",
  },
  fewer: {
    uk: "Менше",
    en: "Fewer",
    hy: "Քիչ",
    ka: "ნაკლები",
  },
  more: {
    uk: "Більше",
    en: "More",
    hy: "Շատ",
    ka: "მეტი",
  },

  // ---- Table -------------------------------------------------------------
  by_visits: {
    uk: "за візитами",
    en: "by visits",
    hy: "ըստ այցերի",
    ka: "ვიზიტებით",
  },
};

export const BI_REPORTS = {
  subtitle: { uk: "Бізнес-звіти", en: "Business reports", hy: "Բիզնես հաշվետվություններ", ka: "ბიზნეს ანგარიშები" },
  available: { uk: "Доступно", en: "Available", hy: "Հասանելի", ka: "ხელმისაწვდომი" },
  error: {
    uk: "Не вдалося завантажити звіти",
    en: "Failed to load reports",
    hy: "Չհաջողվեց բեռնել հաշվետվությունները",
    ka: "ანგარიშების ჩატვირთვა ვერ მოხერხდა",
  },
  retry: { uk: "Спробувати знову", en: "Retry", hy: "Կրկնել", ka: "ხელახლა" },
  empty: { uk: "Немає звітів", en: "No reports available", hy: "Հաշվետվություններ չկան", ka: "ანგარიშები არ არის" },
  open_new_tab: { uk: "Відкрити", en: "Open", hy: "Բաց", ka: "ღიაა" },
};

export const MERCH_LIST = {
  page_sub: {
    uk: "Команда в полі, доступність і навантаження",
    en: "Field team, availability and workload",
    hy: "Դաշտային թիմ, հասանելիություն և ծանրաբեռնվածություն",
    ka: "საველე გუნდი, ხელმისაწვდომობა და დატვირთვა",
  },
  search_ph: {
    uk: "Ім'я або телефон",
    en: "Name or phone",
    hy: "Անուն կամ հեռախոս",
    ka: "სახელი ან ტელეფონი",
  },
  seg_all: {
    uk: "Усі",
    en: "All",
    hy: "Բոլորը",
    ka: "ყველა",
  },
  seg_active: {
    uk: "Активні",
    en: "Active",
    hy: "Ակտիվ",
    ka: "აქტიური",
  },
  seg_inactive: {
    uk: "Неактивні",
    en: "Inactive",
    hy: "Ոչ ակտիվ",
    ka: "არააქტიური",
  },
  flag_absent: {
    uk: "Відсутні сьогодні",
    en: "Away today",
    hy: "Այսօր բացակայում են",
    ka: "დღეს არ არის",
  },
  flag_newbie: {
    uk: "Новачки",
    en: "Newbie",
    hy: "Նորեկներ",
    ka: "ახალბედები",
  },
  flag_no_points: {
    uk: "Без точок",
    en: "No points",
    hy: "Առանց կետերի",
    ka: "წერტილების გარეშე",
  },
  availability: {
    uk: "Доступність",
    en: "Availability",
    hy: "Հասանելիություն",
    ka: "ხელმისაწვდომობა",
  },
  available: {
    uk: "Доступний",
    en: "Available",
    hy: "Հասանելի",
    ka: "ხელმისაწვდომი",
  },
  away: {
    uk: "Відсутній",
    en: "Away",
    hy: "Բացակայում է",
    ka: "არ არის",
  },
  away_until: {
    uk: "Відсутній до",
    en: "Away until",
    hy: "Բացակայում է մինչև",
    ka: "არ არის მდე",
  },
  newbie: {
    uk: "Новачок",
    en: "Newbie",
    hy: "Նորեկ",
    ka: "ახალბედა",
  },
  tenure: {
    uk: "Стаж",
    en: "Tenure",
    hy: "Աշխատաժամկետ",
    ka: "სტაჟი",
  },
  joined: {
    uk: "Прийнято",
    en: "Joined",
    hy: "Ընդունվել է",
    ka: "მიღებულია",
  },
  never_visited: {
    uk: "Ще без візитів",
    en: "No visits yet",
    hy: "Դեռ այցեր չկան",
    ka: "ვიზიტები ჯერ არ არის",
  },
  last_visit: {
    uk: "Останній візит",
    en: "Last visit",
    hy: "Վերջին այցը",
    ka: "ბოლო ვიზიტი",
  },
  days_short: {
    uk: "дн.",
    en: "d",
    hy: "օր",
    ka: "დღ",
  },
  yr_short: {
    uk: "р.",
    en: "yr",
    hy: "տ",
    ka: "წ",
  },
  status_active: {
    uk: "Активний",
    en: "Active",
    hy: "Ակտիվ",
    ka: "აქტიური",
  },
  status_inactive: {
    uk: "Неактивний",
    en: "Inactive",
    hy: "Ոչ ակտիվ",
    ka: "არააქტიური",
  },
  mv_on_foot: {
    uk: "Пішки",
    en: "On foot",
    hy: "Ոտքով",
    ka: "ფეხით",
  },
  mv_motorcycle: {
    uk: "Мотоцикл",
    en: "Motorcycle",
    hy: "Մոտոցիկլ",
    ka: "მოტოციკლი",
  },
  mv_bike: {
    uk: "Велосипед або скутер",
    en: "Bike or scooter",
    hy: "Հեծանիվ կամ սկուտեր",
    ka: "ველოსიპედი ან სკუტერი",
  },
  mv_automobile: {
    uk: "Автомобіль",
    en: "Automobile",
    hy: "Ավտոմեքենա",
    ka: "ავტომობილი",
  },
  mv_public: {
    uk: "Громадський транспорт",
    en: "Public transport",
    hy: "Հասարակական տրանսպորտ",
    ka: "საზოგადოებრივი ტრანსპორტი",
  },
  new_merch: {
    uk: "Новий мерчандайзер",
    en: "New merchandiser",
    hy: "Նոր մերչենդայզեր",
    ka: "ახალი მერჩენდაიზერი",
  },
  open: {
    uk: "Відкрити повну сторінку",
    en: "Open full page",
    hy: "Բացել ամբողջ էջը",
    ka: "სრული გვერდის გახსნა",
  },
  add_absence: {
    uk: "Додати відсутність",
    en: "Add absence",
    hy: "Ավելացնել բացակայություն",
    ka: "არყოფნის დამატება",
  },
  activate: {
    uk: "Активувати",
    en: "Activate",
    hy: "Ակտիվացնել",
    ka: "გააქტიურება",
  },
  deactivate: {
    uk: "Деактивувати",
    en: "Deactivate",
    hy: "Դեակտիվացնել",
    ka: "დეაქტივაცია",
  },
  confirm_deactivate: {
    uk: "Деактивувати мерчандайзерів? Вибрано: {n}",
    en: "Deactivate the selected merchandisers? Selected: {n}",
    hy: "Դեակտիվացնել այս գրառումը {n}",
    ka: "დეაქტივირება ამ ჩანაწერისთვის {n}",
  },
  confirm_activate: {
    uk: "Активувати мерчандайзерів? Вибрано: {n}",
    en: "Activate the selected merchandisers? Selected: {n}",
    hy: "Ակտիվացնել. {n}",
    ka: "გააქტიურება. {n}",
  },
  deactivated_msg: {
    uk: "Деактивовано: {n}",
    en: "Deactivated: {n}",
    hy: "Ապաակտիվացված է: {n}",
    ka: "დეაქტივირებულია: {n}",
  },
  activated_msg: {
    uk: "Активовано: {n}",
    en: "Activated: {n}",
    hy: "Ակտիվացված է: {n}",
    ka: "აქტივირებულია: {n}",
  },
  change_failed_msg: {
    uk: "Не вдалося змінити: {n}",
    en: "Could not be changed: {n}",
    hy: "Չհաջողվեց փոխել՝ {n}",
    ka: "ვერ შეიცვალა: {n}",
  },
  empty_title: {
    uk: "Мерчандайзерів не знайдено",
    en: "No merchandisers found",
    hy: "Մերչենդայզերներ չեն գտնվել",
    ka: "მერჩენდაიზერები ვერ მოიძებნა",
  },
  empty_desc: {
    uk: "Змініть фільтри або пошуковий запит.",
    en: "Change the filters or the search term.",
    hy: "Փոխեք զտիչները կամ որոնման տեքստը։",
    ka: "შეცვალეთ ფილტრები ან ძებნის ტექსტი.",
  },
  absent: {
    uk: "Відсутній",
    en: "Absent",
    hy: "Բացակա",
    ka: "არ არის",
  },
  county: {
    uk: "Регіон",
    en: "Region",
    hy: "Մարզ",
    ka: "რეგიონი",
  },
  merch_sub: {
    uk: "Команда в полі, доступність і навантаження",
    en: "Field team, availability and workload",
    hy: "Դաշտային թիմ, հասանելիություն և ծանրաբեռնվածություն",
    ka: "საველე გუნდი, ხელმისაწვდომობა და დატვირთვა",
  },
  page: {
    uk: "Мерчендайзери",
    en: "Merchandisers",
    hy: "Մերչենդայզերներ",
    ka: "მერჩენდაიზერები",
  },
  search_merch_ph: {
    uk: "Ім'я або телефон",
    en: "Name or phone",
    hy: "Անուն կամ հեռախոս",
    ka: "სახელი ან ტელეფონი",
  },
};

export const MERCH_DETAIL = {
  save_btn: {
    uk: "Зберегти",
    en: "Save",
    hy: "Պահպանել",
    ka: "შენახვა",
  },
  cancel_btn: {
    uk: "Відмінити",
    en: "Cancel",
    hy: "Չեղարկել",
    ka: "გაუქმება",
  },
  edit_btn: {
    uk: "Редагувати",
    en: "Edit",
    hy: "Խմբագրել",
    ka: "რედაქტირება",
  },
  view_btn: {
    uk: "Перегляд",
    en: "View",
    hy: "Դիտել",
    ka: "ნახვა",
  },
  activate_btn: {
    uk: "Активувати",
    en: "Activate",
    hy: "Ակտիվացնել",
    ka: "გააქტიურება",
  },
  deactivate_btn: {
    uk: "Деактивувати",
    en: "Deactivate",
    hy: "Դեակտիվացնել",
    ka: "დეაქტივაცია",
  },
  confirm_deactivate: {
    uk: "Деактивувати цей запис?",
    en: "Deactivate this record?",
    hy: "Դեակտիվացնել այս գրառումը?",
    ka: "დეაქტივირება ამ ჩანაწერისთვის?",
  },
  activated_msg: {
    uk: "Активовано",
    en: "Activated",
    hy: "Ակտիվացված է",
    ka: "აქტივირებულია",
  },
  deactivated_msg: {
    uk: "Деактивовано",
    en: "Deactivated",
    hy: "Ապաակտիվացված է",
    ka: "დეაქტივირებულია",
  },
  st_inactive: {
    uk: "Неактивна",
    en: "Inactive",
    hy: "Ոչ ակտիվ",
    ka: "არააქტიური",
  },
  unsaved: {
    uk: "Незбережені зміни",
    en: "Unsaved changes",
    hy: "Չպահպանված փոփոխություններ",
    ka: "შენახული არ არის",
  },
  all_saved: {
    uk: "Усі зміни збережено",
    en: "All changes saved",
    hy: "Բոլոր փոփոխությունները պահպանված են",
    ka: "ყველა ცვლილება შენახულია",
  },
  sec_basic: {
    uk: "Основне",
    en: "Basic info",
    hy: "Հիմնական տվյալներ",
    ka: "ძირითადი ინფორმაცია",
  },
  f_name: {
    uk: "Назва",
    en: "Name",
    hy: "Անվանում",
    ka: "სახელი",
  },
  first_name: {
    uk: "Ім'я",
    en: "First name",
    hy: "Անուն",
    ka: "სახელი",
  },
  last_name: {
    uk: "Прізвище",
    en: "Last name",
    hy: "Ազգանուն",
    ka: "გვარი",
  },
  f_phone: {
    uk: "Телефон",
    en: "Phone",
    hy: "Հեռախոս",
    ka: "ტელეფონი",
  },
  f_movement: {
    uk: "Пересування",
    en: "Movement",
    hy: "Տեղաշարժ",
    ka: "გადაადგილება",
  },
  supervisor: {
    uk: "Супервайзер",
    en: "Supervisor",
    hy: "Վերակացու",
    ka: "სუპერვაიზერი",
  },
  f_county: {
    uk: "Регіон",
    en: "County",
    hy: "Մարզ",
    ka: "რეგიონი",
  },
  password: {
    uk: "Пароль",
    en: "Password",
    hy: "Գաղտնաբառ",
    ka: "პაროლი",
  },
  password_ph: {
    uk: "Залиште порожнім, щоб не змінювати",
    en: "Leave blank to keep the current one",
    hy: "Թողեք դատարկ՝ ընթացիկը պահելու համար",
    ka: "დატოვეთ ცარიელი მიმდინარის შესანარჩუნებლად",
  },
  password_hint: {
    uk: "Надсилається лише якщо заповнено.",
    en: "Only sent when filled in.",
    hy: "Ուղարկվում է միայն լրացնելու դեպքում։",
    ka: "იგზავნება მხოლოდ შევსების შემთხვევაში.",
  },
  sec_employment: {
    uk: "Працевлаштування",
    en: "Employment",
    hy: "Աշխատանք",
    ka: "დასაქმება",
  },
  visits_total: {
    uk: "Візити · всього",
    en: "Visits · total",
    hy: "Այցեր · ընդհանուր",
    ka: "ვიზიტები · სულ",
  },
  weekly_stops: {
    uk: "Точок на тиждень",
    en: "Weekly stops",
    hy: "Շաբաթական կետեր",
    ka: "კვირის წერტილები",
  },
  date_till_newbie: {
    uk: "Дата до новачка",
    en: "Date till newbie",
    hy: "Ամսաթիվ մինչև նորեկի կարգավիճակի ավարտը",
    ka: "თარიღი დამწყების სტატუსის დასრულებამდე",
  },
  f_is_active: {
    uk: "Активна",
    en: "Active",
    hy: "Ակտիվ",
    ka: "აქტიური",
  },
  date_deactivated: {
    uk: "Деактивовано",
    en: "Deactivated on",
    hy: "Ապաակտիվացվել է",
    ka: "დეაქტივირებულია",
  },
  newbie_hint: {
    uk: "До цієї дати мерчандайзер вважається новачком.",
    en: "Until this date the merchandiser counts as a newbie.",
    hy: "Մինչև այս ամսաթիվը մերչենդայզերը համարվում է նորեկ։",
    ka: "ამ თარიღამდე მერჩენდაიზერი ითვლება ახალბედად.",
  },
  yes_lc: {
    uk: "Так",
    en: "Yes",
    hy: "Այո",
    ka: "დიახ",
  },
  no_lc: {
    uk: "Ні",
    en: "No",
    hy: "Ոչ",
    ka: "არა",
  },
  next_absence: {
    uk: "Наступна відсутність",
    en: "Next absence",
    hy: "Հաջորդ բացակայությունը",
    ka: "შემდეგი არყოფნა",
  },
  summary: {
    uk: "Зведення",
    en: "Summary",
    hy: "Ամփոփում",
    ka: "შეჯამება",
  },
  status: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  routes: {
    uk: "Маршрути",
    en: "Routes",
    hy: "Երթուղիներ",
    ka: "მარშრუტები",
  },
  assignment: {
    uk: "Завдання",
    en: "Assignment",
    hy: "Առաջադրանք",
    ka: "დავალება",
  },
  visits: {
    uk: "Вiзити",
    en: "Visits",
    hy: "ԱՅՑԵՐ",
    ka: "ვიზიტები",
  },
  presence: {
    uk: "Відсутність",
    en: "Absence",
    hy: "ՆԵՐԿԱՅՈՒԹՅՈՒՆ",
    ka: "დასწრება",
  },
  routes_model_hint: {
    uk: "Точки — це три додаткові шари: тижнева основа, додатки на N-й день тижня місяця та одноразові додавання на конкретну дату.",
    en: "Stops are three additive layers: a weekly base, extras on the Nth weekday of a month, and one-off additions on a single date.",
    hy: "Կետերը երեք գումարվող շերտ են՝ շաբաթական հիմք, ամսվա N-րդ շաբաթօրյա հավելումներ և միանգամյա ավելացումներ որոշակի օրվա համար։",
    ka: "წერტილები სამი დამატებითი შრეა: კვირის ბაზა, თვის N-ე დღის დამატებები და ერთჯერადი დამატებები კონკრეტულ თარიღზე.",
  },
  wd_mon: {
    uk: "Пн",
    en: "Mon",
    hy: "Երկ",
    ka: "ორშ",
  },
  wd_tue: {
    uk: "Вт",
    en: "Tue",
    hy: "Երք",
    ka: "სამ",
  },
  wd_wed: {
    uk: "Ср",
    en: "Wed",
    hy: "Չրք",
    ka: "ოთხ",
  },
  wd_thu: {
    uk: "Чт",
    en: "Thu",
    hy: "Հնգ",
    ka: "ხუთ",
  },
  wd_fri: {
    uk: "Пт",
    en: "Fri",
    hy: "Ուրբ",
    ka: "პარ",
  },
  wd_sat: {
    uk: "Сб",
    en: "Sat",
    hy: "Շբթ",
    ka: "შაბ",
  },
  wd_sun: {
    uk: "Нд",
    en: "Sun",
    hy: "Կիր",
    ka: "კვ",
  },
  day_off: {
    uk: "Вихідний",
    en: "Day off",
    hy: "Հանգստյան օր",
    ka: "დასვენების დღე",
  },
  nth_add: {
    uk: "Тиждень {n}",
    en: "Week {n}",
    hy: "Շաբաթ {n}",
    ka: "კვირა {n}",
  },
  one_offs: {
    uk: "Одноразові додавання",
    en: "One-off additions",
    hy: "Միանգամյա ավելացումներ",
    ka: "ერთჯერადი დამატებები",
  },
  no_one_offs: {
    uk: "Одноразових додавань немає",
    en: "No one-off additions",
    hy: "Միանգամյա ավելացումներ չկան",
    ka: "ერთჯერადი დამატებები არ არის",
  },
  open_route_editor: {
    uk: "Відкрити редактор маршрутів",
    en: "Open route editor",
    hy: "Բացել երթուղու խմբագրիչը",
    ka: "მარშრუტის რედაქტორის გახსნა",
  },
  route_editor_toast: {
    uk: "Тут відкривається календар маршрутів",
    en: "The route calendar opens here",
    hy: "Այստեղ բացվում է երթուղիների օրացույցը",
    ka: "აქ იხსნება მარშრუტების კალენდარი",
  },
  duration: {
    uk: "Тривалість",
    en: "Duration",
    hy: "Տևողություն",
    ka: "ხანგრძლივობა",
  },
  min_short: {
    uk: "хв",
    en: "min",
    hy: "ր",
    ka: "წთ",
  },
  period: {
    uk: "Період",
    en: "Period",
    hy: "Ժամանակահատված",
    ka: "პერიოდი",
  },
  reason: {
    uk: "Причина",
    en: "Reason",
    hy: "Պատճառ",
    ka: "მიზეზი",
  },
  remove: {
    uk: "Видалити",
    en: "Remove",
    hy: "Հեռացնել",
    ka: "წაშლა",
  },
  no_absences: {
    uk: "Відсутностей не зафіксовано",
    en: "No absences recorded",
    hy: "Բացակայություններ գրանցված չեն",
    ka: "არყოფნა არ არის დაფიქსირებული",
  },
  abs_past: {
    uk: "Минула",
    en: "Past",
    hy: "Անցյալ",
    ka: "წარსული",
  },
  abs_now: {
    uk: "Поточна",
    en: "Current",
    hy: "Ընթացիկ",
    ka: "მიმდინარე",
  },
  abs_next: {
    uk: "Майбутня",
    en: "Upcoming",
    hy: "Առաջիկա",
    ka: "მომავალი",
  },
  date_from: {
    uk: "Дата з",
    en: "Date from",
    hy: "Ամսաթիվը սկսած",
    ka: "თარიღი დან",
  },
  date_to: {
    uk: "Дата до",
    en: "Date to",
    hy: "Ամսաթիվ մինչև",
    ka: "თარიღი მდე",
  },
  absence_reason: {
    uk: "Будь ласка, введіть причину відсутності",
    en: "Please enter the reason of absence",
    hy: "Խնդրում ենք նշել բացակայության պատճառը",
    ka: "გთხოვთ მიუთითოთ არყოფნის მიზეზი",
  },
  absence_saved: {
    uk: "Відсутність збережено",
    en: "Absence saved",
    hy: "Բացակայությունը պահպանված է",
    ka: "არყოფნა შენახულია",
  },
  absence_removed: {
    uk: "Відсутність видалено",
    en: "Absence removed",
    hy: "Բացակայությունը հեռացված է",
    ka: "არყოფნა წაშლილია",
  },
  confirm_remove_absence: {
    uk: "Видалити цю відсутність?",
    en: "Remove this absence?",
    hy: "Հեռացնե՞լ այս բացակայությունը",
    ka: "წაიშალოს ეს არყოფნა?",
  },
  absence_incomplete: {
    uk: "Вкажіть дати та причину",
    en: "Fill in dates and a reason",
    hy: "Լրացրեք ամսաթվերը և պատճառը",
    ka: "შეავსეთ თარიღები და მიზეზი",
  },
  v_to_after_from: {
    uk: "Дата завершення має бути після початку",
    en: "End date must be after the start date",
    hy: "Ավարտը պետք է մեկնարկից հետո լինի",
    ka: "დასრულება უნდა იყოს დაწყების შემდეგ",
  },
  v_fix_first: {
    uk: "Виправте позначені помилки перед збереженням",
    en: "Fix the highlighted issues before saving",
    hy: "Ուղղեք նշված սխալները նախքան պահպանելը",
    ka: "შენახვამდე გამოასწორეთ მონიშნული შეცდომები",
  },
  v_readiness: {
    uk: "Готовність",
    en: "Readiness",
    hy: "Պատրաստվածություն",
    ka: "მზადყოფნა",
  },
  v_first_required: {
    uk: "Ім'я обов'язкове",
    en: "First name is required",
    hy: "Անունը պարտադիր է",
    ka: "სახელი სავალდებულოა",
  },
  v_last_required: {
    uk: "Прізвище обов'язкове",
    en: "Last name is required",
    hy: "Ազգանունը պարտադիր է",
    ka: "გვარი სავალდებულოა",
  },
  v_phone_invalid: {
    uk: "Введіть коректний номер телефону",
    en: "Enter a valid phone number",
    hy: "Մուտքագրեք վավեր հեռախոսահամար",
    ka: "შეიყვანეთ სწორი ტელეფონის ნომერი",
  },
  discard_confirm: {
    uk: "Відхилити незбережені зміни?",
    en: "Discard unsaved changes?",
    hy: "Չեղարկե՞լ չպահպանված փոփոխությունները։",
    ka: "გავაუქმოთ შენახული ცვლილებები?",
  },
  data_saved: {
    uk: "Дані успішно збережені",
    en: "Data successfully saved",
    hy: "Տվյալները հաջողությամբ պահպանվեցին",
    ka: "მონაცემები წარმატებით შენახულია",
  },
  empty_tab: {
    uk: "Немає даних",
    en: "No data",
    hy: "Տվյալներ չկան",
    ka: "მონაცემები არ არის",
  },
  joined: {
    uk: "Прийнято",
    en: "Joined",
    hy: "Ընդունվել է",
    ka: "მიღებულია",
  },
  load_error: {
    uk: "Не вдалося завантажити дані",
    en: "Failed to load data",
    hy: "Չհաջողվեց բեռնել տվյալները",
    ka: "მონაცემების ჩატვირთვა ვერ მოხერხდა",
  },
  // Fallback only: a 400 shows what the server said (see `reportFailure`).
  save_error: {
    uk: "Помилка збереження",
    en: "Error while saving",
    hy: "Պահպանման սխալ",
    ka: "შენახვის შეცდომა",
  },
  new_merch: {
    uk: "Новий мерчандайзер",
    en: "New merchandiser",
    hy: "Նոր մերչենդայզեր",
    ka: "ახალი მერჩენდაიზერი",
  },
  not_found_desc: {
    uk: "Мерчандайзера не знайдено або він видалений.",
    en: "Merchandiser not found or deleted.",
    hy: "Մերչենդայզերը չի գտնվել կամ ջնջված է։",
    ka: "მერჩენდაიზერი ვერ მოიძებნა ან წაშლილია.",
  },
  not_found_title: {
    uk: "Не знайдено",
    en: "Not found",
    hy: "Չի գտնվել",
    ka: "არ მოიძებნა",
  },
  retry: {
    uk: "Повторити",
    en: "Retry",
    hy: "Կրկնել",
    ka: "ხელახლა",
  },
};

export const SUPERVISOR_LIST = {
  page_sub: { uk: "Хто що покриває", en: "Who covers what", hy: "Ով ինչ է ծածկում", ka: "ვინ რას ფარავს" },
  search_ph: { uk: "Пошук за іменем", en: "Search by name", hy: "Որոնել ըստ անվան", ka: "ძებნა სახელით" },
  seg_all: { uk: "Усі", en: "All", hy: "Բոլորը", ka: "ყველა" },
  seg_active: { uk: "Активні", en: "Active", hy: "Ակտիվ", ka: "აქტიური" },
  seg_inactive: { uk: "Неактивні", en: "Inactive", hy: "Ոչ ակտիվ", ka: "არააქტიური" },
  no_points: { uk: "Без точок", en: "No points", hy: "Առանց կետերի", ka: "წერტილების გარეშე" },
  no_points_hint: {
    uk: "Відповідає за нуль точок",
    en: "Responsible for zero points",
    hy: "Պատասխանատու չէ ոչ մի կետի համար",
    ka: "არ არის პასუხისმგებელი არცერთ წერტილზე",
  },
  no_region: { uk: "Без регіону", en: "No region", hy: "Առանց մարզի", ka: "რეგიონის გარეშე" },
  empty_title: { uk: "Супервайзерів не знайдено", en: "No supervisors", hy: "Սուպերվայզերներ չկան", ka: "სუპერვაიზერები არ არის" },
  empty_desc: {
    uk: "Жоден супервайзер не відповідає поточним фільтрам.",
    en: "No supervisors match the current filters.",
    hy: "Ոչ մի սուպերվայզեր չի համապատասխանում ընթացիկ զտիչներին։",
    ka: "არცერთი სუპერვაიზერი არ ემთხვევა მიმდინარე ფილტრებს.",
  },
  open: { uk: "Відкрити", en: "Open", hy: "Բաց", ka: "ღიაა" },
  activate: { uk: "Активувати", en: "Activate", hy: "Ակտիվացնել", ka: "გააქტიურება" },
  deactivate: { uk: "Деактивувати", en: "Deactivate", hy: "Դեակտիվացնել", ka: "დეაქტივაცია" },
  confirm_deactivate: { uk: "Деактивувати? ({n})", en: "Deactivate? ({n})", hy: "Դեակտիվացնե՞լ։ ({n})", ka: "დეაქტივაცია? ({n})" },
  activated_msg: { uk: "Активовано: {n}", en: "Activated: {n}", hy: "Ակտիվացված է: {n}", ka: "აქტივირებულია: {n}" },
  deactivated_msg: { uk: "Деактивовано: {n}", en: "Deactivated: {n}", hy: "Ապաակտիվացված է: {n}", ka: "დეაქტივირებულია: {n}" },
  change_failed_msg: { uk: "Не вдалося оновити: {n}", en: "Failed to update: {n}", hy: "Չհաջողվեց թարմացնել՝ {n}", ka: "განახლება ვერ მოხერხდა: {n}" },
};

export const SUPERVISOR_DETAIL = {
  account: { uk: "Акаунт", en: "Account", hy: "Հաշիվ", ka: "ანგარიში" },
  coverage: { uk: "Покриття", en: "Coverage", hy: "Ծածկույթ", ka: "დაფარვა" },
  f_telegram: { uk: "Telegram", en: "Telegram", hy: "Telegram", ka: "Telegram" },
  add_points: { uk: "Додати точки", en: "Add points", hy: "Ավելացնել կետեր", ka: "წერტილების დამატება" },
  add_merchandisers: { uk: "Додати мерчендайзерів", en: "Add merchandisers", hy: "Ավելացնել մերչենդայզերներ", ka: "მერჩენდაიზერების დამატება" },
  add: { uk: "Додати", en: "Add", hy: "Ավելացնել", ka: "დამატება" },
  remove: { uk: "Видалити", en: "Remove", hy: "Ջնջել", ka: "წაშლა" },
  empty_tab: { uk: "Немає записів", en: "No records", hy: "Գրառումներ չկան", ka: "ჩანაწერები არ არის" },
  picker_ph: { uk: "Пошук для додавання…", en: "Search to add…", hy: "Որոնեք ավելացնելու համար…", ka: "მოძებნეთ დასამატებლად…" },
  load_error: { uk: "Не вдалося завантажити дані", en: "Failed to load data", hy: "Չհաջողվեց բեռնել տվյալները", ka: "მონაცემების ჩატვირთვა ვერ მოხერხდა" },
  retry: { uk: "Спробувати знову", en: "Retry", hy: "Կրկնել", ka: "ხელახლა" },
  not_found_title: { uk: "Не знайдено", en: "Not found", hy: "Չի գտնվել", ka: "არ მოიძებნა" },
  not_found_desc: {
    uk: "Супервайзер не знайдений або видалений.",
    en: "Supervisor not found or deleted.",
    hy: "Սուպերվայզերը չի գտնվել կամ ջնջված է։",
    ka: "სუპერვაიზერი ვერ მოიძებნა ან წაშლილია.",
  },
  assign_error: { uk: "Не вдалося призначити", en: "Failed to assign", hy: "Չհաջողվեց նշանակել", ka: "მინიჭება ვერ მოხერხდა" },
  ignored_msg: { uk: "Проігноровано: {n}", en: "Ignored: {n}", hy: "Անտեսվել է՝ {n}", ka: "გამოტოვებულია: {n}" },
  no_coordinates: { uk: "Без координат", en: "No coordinates", hy: "Առանց կոորդինատների", ka: "კოორდინატები არ არის" },
  no_points_hint: { uk: "Без точок", en: "No points", hy: "Առանց կետերի", ka: "წერტილების გარეშე" },
  no_region: { uk: "Без регіону", en: "No region", hy: "Առանց մարզի", ka: "რეგიონის გარეშე" },
  removed_msg: { uk: "Видалено: {n}", en: "Removed: {n}", hy: "Հեռացվել է՝ {n}", ka: "ამოღებულია: {n}" },
  added_msg: { uk: "Додано: {n}", en: "Added: {n}", hy: "Ավելացվել է՝ {n}", ka: "დამატებულია: {n}" },
  confirm_remove_point: { uk: "Відкріпити «{name}»?", en: 'Unassign "{name}"?', hy: "Հեռացնե՞լ «{name}»-ը։", ka: "მოვაშოროთ „{name}“?" },
  confirm_remove_merchandiser: { uk: "Відкріпити «{name}»?", en: 'Unassign "{name}"?', hy: "Հեռացնե՞լ «{name}»-ը։", ka: "მოვაშოროთ „{name}“?" },
  telegram_linked: {
    uk: "Підключено",
    en: "Linked",
    hy: "Կապակցված է",
    ka: "დაკავშირებულია",
  },
  telegram_none: {
    uk: "Не підключено",
    en: "Not linked",
    hy: "Կապակցված չէ",
    ka: "არ არის დაკავშირებული",
  },
};

/* /task — the tasks list (spec/03 archetype A). Separate from the older `TAKS_*` groups (note the
   typo in those names): `photo-review` and `visit/tabs/*` still import them, so
   they stay put and the redesigned pages get their own. Filter labels come from
   ENTITY_DROPDOWN_SETTINGS rather than being translated a second time here.

   hy/ka are machine-authored and NEED NATIVE REVIEW (spec/04). */
export const TASK_LIST = {
  page_sub: {
    uk: "Що не зроблено і що ось-ось прострочиться",
    en: "What is not done, and what is about to be late",
    hy: "Ինչը կատարված չէ և ինչը շուտով կուշանա",
    ka: "რა არ არის შესრულებული და რა დაგვიანდება",
  },
  /* Status. Active/inactive is a plain column; the four-way verdict below is the API's `status`
     (newest answer's `is_supervised` — PICSELL-1615 #6/#9), also the segment's options. */
  col_status: { uk: "Статус", en: "Status", hy: "Կարգավիճակ", ka: "სტატუსი" },
  st_active: { uk: "Активна", en: "Active", hy: "Ակտիվ", ka: "აქტიური" },
  st_inactive: { uk: "Деактивовано", en: "Deactivated", hy: "Ապաակտիվացված", ka: "დეაქტივირებული" },
  st_all: { uk: "Усі", en: "All", hy: "Բոլորը", ka: "ყველა" },
  st_awaiting: { uk: "Без відповіді", en: "Awaiting answer", hy: "Սպասում է պատասխանի", ka: "პასუხის მოლოდინში" },
  st_on_review: { uk: "На перевірці", en: "On review", hy: "Ստուգման փուլում", ka: "გადამოწმებაში" },
  st_approved: { uk: "Схвалено", en: "Approved", hy: "Հաստատված", ka: "დამტკიცებული" },
  st_rejected: { uk: "Відхилено", en: "Rejected", hy: "Մերժված", ka: "უარყოფილი" },
  /* Derived chips. Each says what the state MEANS operationally, per spec/04. */
  chip_overdue: { uk: "Прострочені", en: "Overdue", hy: "Ժամկետանց", ka: "ვადაგადაცილებული" },
  chip_overdue_hint: {
    uk: "Дедлайн минув, а завдання ще не виконане",
    en: "Past its deadline and still not done",
    hy: "Ժամկետն անցել է, բայց դեռ կատարված չէ",
    ka: "ვადა გასულია და ჯერ არ არის შესრულებული",
  },
  chip_negative: { uk: "Негативні відповіді", en: "Negative answers", hy: "Բացասական պատասխաններ", ka: "უარყოფითი პასუხები" },
  chip_negative_hint: {
    uk: "Мерчендайзер відповів «ні»",
    en: "The merchandiser answered no",
    hy: "Մերչենդայզերը պատասխանել է «ոչ»",
    ka: "მერჩენდაიზერმა უპასუხა „არა“",
  },
  chip_inactive: { uk: "Деактивовані", en: "Deactivated", hy: "Ապաակտիվացված", ka: "დეაქტივირებული" },
  chip_inactive_hint: {
    uk: "Закрите завдання, відповіді вже надані",
    en: "Closed, with answers already given",
    hy: "Փակված է, պատասխաններն արդեն տրված են",
    ka: "დახურულია, პასუხები უკვე გაცემულია",
  },
  /* Columns */
  col_task: { uk: "Завдання", en: "Task", hy: "Առաջադրանք", ka: "დავალება" },
  col_type: { uk: "Тип", en: "Type", hy: "Տիպ", ka: "ტიპი" },
  col_point: { uk: "Точка", en: "Point", hy: "Կետ", ka: "წერტილი" },
  col_deadline: { uk: "Дедлайн", en: "Deadline", hy: "Վերջնաժամկետ", ka: "ბოლო ვადა" },
  col_author: { uk: "Автор", en: "Created by", hy: "Հեղինակ", ka: "ავტორი" },
  /* The list's own copy of this label. `translate()` returns null (not the key) for a miss, so
     borrowing TASK_DETAIL's `k_merchandiser` from here rendered the filter with NO label at all and
     the column with a BLANK header — visible only in the browser, never in the source. */
  k_merchandiser: { uk: "Мерчендайзер", en: "Merchandiser", hy: "Մերչենդայզեր", ka: "მერჩენდაიზერი" },
  cancel_btn: { uk: "Скасувати", en: "Cancel", hy: "Չեղարկել", ka: "გაუქმება" },
  /* The bulk bar says what the selection covers: there is no bulk endpoint, so "select all" is
     the LOADED page and claiming otherwise would be a lie about scope. */
  select_page_hint: {
    uk: "Вибір діє на завантажену сторінку",
    en: "Selection covers the loaded page",
    hy: "Ընտրությունը վերաբերում է բեռնված էջին",
    ka: "არჩევანი მოქმედებს ჩატვირთულ გვერდზე",
  },
  search_ph: {
    uk: "Пошук за назвою або описом",
    en: "Search by name or description",
    hy: "Որոնել ըստ անվան կամ նկարագրության",
    ka: "ძებნა სახელით ან აღწერით",
  },
  columns: { uk: "Стовпці", en: "Columns", hy: "Սյունակներ", ka: "სვეტები" },
  rows_per_page: { uk: "Рядків на сторінці", en: "Rows per page", hy: "Տողեր էջում", ka: "მწკრივი გვერდზე" },
  /* Next/prev, not `{from}–{to} of {n}`: `GET tasks/` reports no total, so `range_of` went
     with the numbered footer. The strings match VISIT_PAGE's, which the report section uses. */
  page_n: { uk: "Сторінка {n}", en: "Page {n}", hy: "Էջ {n}", ka: "გვერდი {n}" },
  page_prev: { uk: "Попередня", en: "Previous", hy: "Նախորդը", ka: "წინა" },
  page_next: { uk: "Наступна", en: "Next", hy: "Հաջորդը", ka: "შემდეგი" },
  row_actions: { uk: "Дії з рядком", en: "Row actions", hy: "Տողի գործողություններ", ka: "მწკრივის მოქმედებები" },
  open: { uk: "Відкрити", en: "Open", hy: "Բացել", ka: "გახსნა" },
  /* Create. Three targets, because the API takes three: one point, a whole network, or a group.
     The last two fan out server-side into one task per point. */
  new_task: { uk: "Нове завдання", en: "New task", hy: "Նոր առաջադրանք", ka: "ახალი დავალება" },
  new_for_point: { uk: "На точку", en: "For a point", hy: "Կետի համար", ka: "წერტილისთვის" },
  new_for_network: { uk: "На мережу", en: "For a network", hy: "Ցանցի համար", ka: "ქსელისთვის" },
  new_for_group: { uk: "На групу точок", en: "For a group of points", hy: "Կետերի խմբի համար", ka: "წერტილების ჯგუფისთვის" },
  /* Deactivate. PATCH is_active=false — never DELETE, which hard-deletes a task with no answers. */
  deactivate: { uk: "Деактивувати", en: "Deactivate", hy: "Ապաակտիվացնել", ka: "დეაქტივაცია" },
  confirm_deactivate: {
    uk: "Деактивувати завдання? ({n})",
    en: "Deactivate tasks? ({n})",
    hy: "Ապաակտիվացնե՞լ առաջադրանքները։ ({n})",
    ka: "დავალებების დეაქტივაცია? ({n})",
  },
  confirm_deactivate_desc: {
    uk: "Мерчендайзери більше не побачать їх у застосунку.",
    en: "Merchandisers will no longer see them in the app.",
    hy: "Մերչենդայզերները այլևս չեն տեսնի դրանք հավելվածում։",
    ka: "მერჩენდაიზერები მათ აპლიკაციაში ვეღარ დაინახავენ.",
  },
  deactivated_msg: { uk: "Деактивовано: {n}", en: "Deactivated: {n}", hy: "Ապաակտիվացված է՝ {n}", ka: "დეაქტივირებულია: {n}" },
  change_failed_msg: { uk: "Не вдалося оновити: {n}", en: "Failed to update: {n}", hy: "Չհաջողվեց թարմացնել՝ {n}", ka: "განახლება ვერ მოხერხდა: {n}" },
  /* Empty states differ by cause (spec/04): clear the filters vs create the first task. */
  empty_title: { uk: "Завдань не знайдено", en: "No tasks found", hy: "Առաջադրանքներ չեն գտնվել", ka: "დავალებები არ მოიძებნა" },
  empty_desc: {
    uk: "Жодне завдання не відповідає поточним фільтрам.",
    en: "No tasks match the current filters.",
    hy: "Ոչ մի առաջադրանք չի համապատասխանում ընթացիկ զտիչներին։",
    ka: "არცერთი დავალება არ ემთხვევა მიმდინარე ფილტრებს.",
  },
  empty_none_title: { uk: "Ще немає завдань", en: "No tasks yet", hy: "Դեռ առաջադրանքներ չկան", ka: "ჯერ არ არის დავალებები" },
  empty_none_desc: {
    uk: "Створіть перше завдання на точку або мережу.",
    en: "Create the first task for a point or a network.",
    hy: "Ստեղծեք առաջին առաջադրանքը կետի կամ ցանցի համար։",
    ka: "შექმენით პირველი დავალება წერტილისთვის ან ქსელისთვის.",
  },
};

/* /task/:id — the task detail page (spec/03 archetype B).
   hy/ka are machine-authored and NEED NATIVE REVIEW (spec/04). */
export const TASK_DETAIL = {
  crumb: { uk: "Завдання", en: "Tasks", hy: "Առաջադրանքներ", ka: "დავალებები" },
  new_title: { uk: "Нове завдання", en: "New task", hy: "Նոր առաջադրանք", ka: "ახალი დავალება" },
  /* Sections */
  sec_what: { uk: "Що зробити", en: "What to do", hy: "Ինչ պետք է անել", ka: "რა უნდა გაკეთდეს" },
  sec_what_desc: {
    uk: "Це те, що мерчендайзер побачить у застосунку.",
    en: "This is what the merchandiser sees in the app.",
    hy: "Սա այն է, ինչ մերչենդայզերը տեսնում է հավելվածում։",
    ka: "ეს არის ის, რასაც მერჩენდაიზერი ხედავს აპლიკაციაში.",
  },
  sec_where: { uk: "Де", en: "Where", hy: "Որտեղ", ka: "სად" },
  sec_where_desc: {
    uk: "Ціль не змінюється після створення.",
    en: "The target cannot be changed after creation.",
    hy: "Թիրախը ստեղծելուց հետո չի փոխվում։",
    ka: "მიზანი შექმნის შემდეგ არ იცვლება.",
  },
  sec_when: { uk: "Коли", en: "When", hy: "Երբ", ka: "როდის" },
  sec_form: { uk: "Форма відповіді", en: "Answer form", hy: "Պատասխանի ձև", ka: "პასუხის ფორმა" },
  sec_form_desc: {
    uk: "Шаблон визначає, що саме запитають у мерчендайзера.",
    en: "The template decides what the merchandiser is asked for.",
    hy: "Կաղապարը որոշում է, թե ինչ կհարցնեն մերչենդայզերին։",
    ka: "შაბლონი განსაზღვრავს, რას ეკითხებიან მერჩენდაიზერს.",
  },
  sec_answers: { uk: "Відповіді", en: "Answers", hy: "Պատասխաններ", ka: "პასუხები" },
  /* Fields */
  f_title: { uk: "Назва", en: "Name", hy: "Անվանում", ka: "სახელი" },
  f_description: { uk: "Опис", en: "Description", hy: "Նկարագրություն", ka: "აღწერა" },
  f_image: { uk: "Зображення-зразок", en: "Reference image", hy: "Նմուշային պատկեր", ka: "საორიენტაციო სურათი" },
  f_image_hint: {
    uk: "Показується мерчендайзеру як зразок викладки.",
    en: "Shown to the merchandiser as the shelf they should match.",
    hy: "Ցուցադրվում է մերչենդայզերին որպես օրինակ։",
    ka: "ეჩვენება მერჩენდაიზერს როგორც ნიმუში.",
  },
  img_add: { uk: "Додати зображення", en: "Add an image", hy: "Ավելացնել պատկեր", ka: "სურათის დამატება" },
  img_change: { uk: "Замінити зображення", en: "Replace the image", hy: "Փոխարինել պատկերը", ka: "სურათის შეცვლა" },
  img_remove: { uk: "Прибрати зображення", en: "Remove the image", hy: "Հեռացնել պատկերը", ka: "სურათის მოშორება" },
  img_too_big: {
    uk: "Файл завеликий — до {n} МБ",
    en: "File is too large — up to {n} MB",
    hy: "Ֆայլը շատ մեծ է — մինչև {n} ՄԲ",
    ka: "ფაილი ძალიან დიდია — {n} MB-მდე",
  },
  img_failed: {
    uk: "Не вдалося завантажити зображення",
    en: "Failed to upload the image",
    hy: "Չհաջողվեց վերբեռնել պատկերը",
    ka: "სურათის ატვირთვა ვერ მოხერხდა",
  },
  f_point: { uk: "Точка", en: "Point", hy: "Կետ", ka: "წერტილი" },
  f_network: { uk: "Мережа", en: "Network", hy: "Ցանց", ka: "ქსელი" },
  f_group: { uk: "Група точок", en: "Group of points", hy: "Կետերի խումբ", ka: "წერტილების ჯგუფი" },
  f_group_name: { uk: "Назва пакета завдань", en: "Batch name", hy: "Փաթեթի անվանում", ka: "პაკეტის სახელი" },
  f_start: { uk: "Початок", en: "Start", hy: "Սկիզբ", ka: "დაწყება" },
  f_end: { uk: "Дедлайн", en: "Deadline", hy: "Վերջնաժամկետ", ka: "ბოლო ვადა" },
  f_template: { uk: "Шаблон", en: "Template", hy: "Կաղապար", ka: "შაბლონი" },
  /* Priority and components come from the TEMPLATE and are read-only here — Task has no such
     columns, so the old form's editable priority was discarded by the API on every save. */
  f_priority: { uk: "Пріоритет", en: "Priority", hy: "Առաջնահերթություն", ka: "პრიორიტეტი" },
  f_components: { uk: "Мерчендайзер надсилає", en: "The merchandiser submits", hy: "Մերչենդայզերն ուղարկում է", ka: "მერჩენდაიზერი აგზავნის" },
  from_template: { uk: "Із шаблону", en: "From the template", hy: "Կաղապարից", ka: "შაბლონიდან" },
  cmp_photo: { uk: "Фото", en: "Photo", hy: "Լուսանկար", ka: "ფოტო" },
  cmp_text: { uk: "Текст", en: "Text", hy: "Տեքստ", ka: "ტექსტი" },
  cmp_boolean: { uk: "Так / ні", en: "Yes / no", hy: "Այո / ոչ", ka: "დიახ / არა" },
  cmp_numeric: { uk: "Число", en: "Number", hy: "Թիվ", ka: "რიცხვი" },
  cmp_tags: { uk: "Теги", en: "Tags", hy: "Պիտակներ", ka: "ტეგები" },
  prio_0: { uk: "Обов'язковий", en: "Required", hy: "Պարտադիր", ka: "სავალდებულო" },
  prio_1: { uk: "Високий", en: "High", hy: "Բարձր", ka: "მაღალი" },
  prio_2: { uk: "Середній", en: "Medium", hy: "Միջին", ka: "საშუალო" },
  prio_3: { uk: "Низький", en: "Low", hy: "Ցածր", ka: "დაბალი" },
  /* Rail */
  rail_summary: { uk: "Зведення", en: "Summary", hy: "Ամփոփում", ka: "შემოკლება" },
  rail_quality: { uk: "Що заповнити", en: "Still needed", hy: "Դեռ պետք է", ka: "ჯერ საჭიროა" },
  k_created: { uk: "Створено", en: "Created", hy: "Ստեղծված", ka: "შექმნილია" },
  k_created_by: { uk: "Автор", en: "Created by", hy: "Հեղինակ", ka: "ავტორი" },
  k_supervisor: { uk: "Супервайзер", en: "Supervisor", hy: "Սուպերվայզեր", ka: "სუპერვაიზერი" },
  k_merchandiser: { uk: "Мерчендайзер", en: "Merchandiser", hy: "Մերչենդայզեր", ka: "მერჩენდაიზერი" },
  k_locality: { uk: "Населений пункт", en: "Locality", hy: "Բնակավայր", ka: "დასახლება" },
  k_last_answer: { uk: "Остання відповідь", en: "Last answer", hy: "Վերջին պատասխանը", ka: "ბოლო პასუხი" },
  k_photos: { uk: "Фото", en: "Photos", hy: "Լուսանկարներ", ka: "ფოტოები" },
  no_merchandiser: { uk: "Нікого не призначено", en: "Nobody assigned", hy: "Ոչ ոք նշանակված չէ", ka: "არავინ არის დანიშნული" },
  /* Answers section */
  ans_empty: { uk: "Відповідей ще немає", en: "No answers yet", hy: "Դեռ պատասխաններ չկան", ka: "ჯერ არ არის პასუხები" },
  ans_show: { uk: "Показати", en: "Show", hy: "Ցուցադրել", ka: "ჩვენება" },
  ans_hide: { uk: "Згорнути", en: "Hide", hy: "Թաքցնել", ka: "დამალვა" },
  /* Column headers for the answers table. */
  col_status: { uk: "Статус", en: "Status", hy: "Կարգավիճակ", ka: "სტატუსი" },
  ans_text: { uk: "Відповідь", en: "Answer", hy: "Պատասխան", ka: "პასუხი" },
  ans_comment: { uk: "Коментар", en: "Comment", hy: "Մեկնաբանություն", ka: "კომენტარი" },
  ans_date: { uk: "Дата", en: "Date", hy: "Ամսաթիվ", ka: "თარიღი" },
  row_actions: { uk: "Дії з рядком", en: "Row actions", hy: "Տողի գործողություններ", ka: "მწკრივის მოქმედებები" },
  ans_by: { uk: "Відповів", en: "Answered by", hy: "Պատասխանել է", ka: "პასუხი გასცა" },
  ans_yes: { uk: "Так", en: "Yes", hy: "Այո", ka: "დიახ" },
  ans_no: { uk: "Ні", en: "No", hy: "Ոչ", ka: "არა" },
  approve: { uk: "Затвердити", en: "Approve", hy: "Հաստատել", ka: "დამტკიცება" },
  reject: { uk: "Відхилити", en: "Reject", hy: "Մերժել", ka: "უარყოფა" },
  approved_msg: { uk: "Відповідь затверджено", en: "Answer approved", hy: "Պատասխանը հաստատված է", ka: "პასუხი დამტკიცებულია" },
  rejected_msg: { uk: "Відповідь відхилено", en: "Answer rejected", hy: "Պատասխանը մերժված է", ka: "პასუხი უარყოფილია" },
  load_error: {
    uk: "Не вдалося завантажити відповіді",
    en: "Failed to load answers",
    hy: "Չհաջողվեց բեռնել պատասխանները",
    ka: "პასუხების ჩატვირთვა ვერ მოხერხდა",
  },
  retry: { uk: "Спробувати знову", en: "Retry", hy: "Կրկնել", ka: "ხელახლა" },
  /* Lifecycle */
  edit: { uk: "Редагувати", en: "Edit", hy: "Խմբագրել", ka: "რედაქტირება" },
  save: { uk: "Зберегти", en: "Save", hy: "Պահպանել", ka: "შენახვა" },
  cancel: { uk: "Скасувати", en: "Cancel", hy: "Չեղարկել", ka: "გაუქმება" },
  draft: { uk: "Чернетка — ще не збережено", en: "Draft — not saved yet", hy: "Սևագիր — դեռ պահպանված չէ", ka: "მონახაზი — ჯერ არ არის შენახული" },
  unsaved: { uk: "Незбережені зміни", en: "Unsaved changes", hy: "Չպահպանված փոփոխություններ", ka: "შეუნახავი ცვლილებები" },
  confirm_cancel: { uk: "Відхилити зміни?", en: "Discard changes?", hy: "Չեղարկե՞լ փոփոխությունները։", ka: "ცვლილებების გაუქმება?" },
  saved_msg: { uk: "Збережено", en: "Saved", hy: "Պահպանված է", ka: "შენახულია" },
  save_failed: { uk: "Не вдалося зберегти", en: "Failed to save", hy: "Չհաջողվեց պահպանել", ka: "შენახვა ვერ მოხერხდა" },
  required_field: { uk: "Заповніть це поле", en: "Fill this in", hy: "Լրացրեք սա", ka: "შეავსეთ ეს" },
  not_found_title: { uk: "Не знайдено", en: "Not found", hy: "Չի գտնվել", ka: "არ მოიძებნა" },
  not_found_desc: {
    uk: "Завдання не знайдене або видалене.",
    en: "Task not found or deleted.",
    hy: "Առաջադրանքը չի գտնվել կամ ջնջված է։",
    ka: "დავალება ვერ მოიძებნა ან წაშლილია.",
  },
  back_to_list: { uk: "До списку завдань", en: "Back to tasks", hy: "Վերադառնալ առաջադրանքներին", ka: "დავალებებში დაბრუნება" },
  /* Bulk create returns no single record, so it lands back on the list with a count. */
  bulk_created_msg: {
    uk: "Створення запущено — завдань: {n}",
    en: "Creation started — tasks: {n}",
    hy: "Ստեղծումը սկսվել է — առաջադրանքներ՝ {n}",
    ka: "შექმნა დაიწყო — დავალებები: {n}",
  },
  bulk_queued_msg: {
    uk: "Створення поставлено в чергу. Завдання з'являться у списку.",
    en: "Creation queued. The tasks will appear in the list.",
    hy: "Ստեղծումը հերթում է։ Առաջադրանքները կհայտնվեն ցանկում։",
    ka: "შექმნა რიგშია. დავალებები გამოჩნდება სიაში.",
  },
};

/* /answers — the answers list (spec/03 archetype A).
   Status words, the verdict buttons and the status pill come from VISIT_PAGE, which every
   moderation surface already shares; only what is this page's own lives here.
   hy/ka are machine-authored and NEED NATIVE REVIEW (spec/04). */
export const ANSWER_LIST = {
  page_sub: {
    uk: "Що мерчендайзери надіслали і що чекає на вашу оцінку",
    en: "What merchandisers sent, and what is waiting for your verdict",
    hy: "Ինչ են ուղարկել մերչենդայզերները և ինչն է սպասում ձեր գնահատականին",
    ka: "რა გამოაგზავნეს მერჩენდაიზერებმა და რა ელოდება თქვენს შეფასებას",
  },
  /* Derived chips. Each says what the state MEANS operationally, per spec/04. */
  chip_photo: { uk: "З фото", en: "With a photo", hy: "Լուսանկարով", ka: "ფოტოთი" },
  chip_photo_hint: {
    uk: "Є що подивитися — відповідь містить знімок",
    en: "There is something to look at — the answer carries a photo",
    hy: "Կա դիտելու բան — պատասխանը պարունակում է լուսանկար",
    ka: "არის სანახავი — პასუხს ფოტო ახლავს",
  },
  chip_negative: { uk: "Негативні", en: "Negative", hy: "Բացասական", ka: "უარყოფითი" },
  chip_negative_hint: {
    uk: "Мерчендайзер відповів «ні»",
    en: "The merchandiser answered no",
    hy: "Մերչենդայզերը պատասխանել է «ոչ»",
    ka: "მერჩენდაიზერმა უპასუხა „არა“",
  },
  /* Columns */
  col_point: { uk: "Точка і завдання", en: "Point and task", hy: "Կետ և առաջադրանք", ka: "წერტილი და დავალება" },
  col_answer: { uk: "Відповідь", en: "Answer", hy: "Պատասխան", ka: "პასუხი" },
  col_by: { uk: "Мерчендайзер", en: "Merchandiser", hy: "Մերչենդայզեր", ka: "მერჩენდაიზერი" },
  col_when: { uk: "Отримано", en: "Received", hy: "Ստացվել է", ka: "მიღებულია" },
  ans_yes: { uk: "Так", en: "Yes", hy: "Այո", ka: "დიახ" },
  ans_no: { uk: "Ні", en: "No", hy: "Ոչ", ka: "არა" },
  ans_photo_only: { uk: "Лише фото", en: "Photo only", hy: "Միայն լուսանկար", ka: "მხოლოდ ფოტო" },
  photos_count: { uk: "Фото: {n}", en: "Photos: {n}", hy: "Լուսանկարներ՝ {n}", ka: "ფოტოები: {n}" },
  search_ph: { uk: "Пошук за назвою точки", en: "Search by point name", hy: "Որոնել ըստ կետի անվան", ka: "ძებნა წერტილის სახელით" },
  rows_per_page: { uk: "Рядків на сторінці", en: "Rows per page", hy: "Տողեր էջում", ka: "მწკრივი გვერდზე" },
  range_of: { uk: "{from}–{to} з {n}", en: "{from}–{to} of {n}", hy: "{from}–{to} / {n}", ka: "{from}–{to} / {n}" },
  row_actions: { uk: "Дії з рядком", en: "Row actions", hy: "Տողի գործողություններ", ka: "მწკრივის მოქმედებები" },
  open: { uk: "Відкрити", en: "Open", hy: "Բացել", ka: "გახსნა" },
  /* Bulk. There is no bulk endpoint, so the selection is the LOADED page — saying otherwise
     would be a lie about scope. Reject is per-record: it needs a reason and a corrective task. */
  select_page_hint: {
    uk: "Вибір діє на завантажену сторінку",
    en: "Selection covers the loaded page",
    hy: "Ընտրությունը վերաբերում է բեռնված էջին",
    ka: "არჩევანი მოქმედებს ჩატვირთულ გვერდზე",
  },
  approved_msg: { uk: "Прийнято: {n}", en: "Approved: {n}", hy: "Ընդունված է՝ {n}", ka: "მიღებულია: {n}" },
  failed_msg: { uk: "Не вдалося оновити: {n}", en: "Failed to update: {n}", hy: "Չհաջողվեց թարմացնել՝ {n}", ka: "განახლება ვერ მოხერხდა: {n}" },
  empty_title: { uk: "Відповідей не знайдено", en: "No answers found", hy: "Պատասխաններ չեն գտնվել", ka: "პასუხები არ მოიძებნა" },
  empty_desc: {
    uk: "Жодна відповідь не відповідає поточним фільтрам.",
    en: "No answers match the current filters.",
    hy: "Ոչ մի պատասխան չի համապատասխանում ընթացիկ զտիչներին։",
    ka: "არცერთი პასუხი არ ემთხვევა მიმდინარე ფილტრებს.",
  },
};

/* /answers/:id — the answer review workspace (spec/03 archetype C).
   hy/ka are machine-authored and NEED NATIVE REVIEW (spec/04). */
export const ANSWER_PAGE = {
  crumb: { uk: "Відповіді", en: "Answers", hy: "Պատասխաններ", ka: "პასუხები" },
  back_to_list: { uk: "До списку відповідей", en: "Back to answers", hy: "Վերադառնալ պատասխաններին", ka: "პასუხებში დაბრუნება" },
  /* The queue position. One string per locale so the number never has to agree with a noun. */
  queue_of: { uk: "{i} з {n}", en: "{i} of {n}", hy: "{i} / {n}", ka: "{i} / {n}" },
  queue_prev: { uk: "Попередня", en: "Previous", hy: "Նախորդը", ka: "წინა" },
  queue_next: { uk: "Наступна", en: "Next", hy: "Հաջորդը", ka: "შემდეგი" },
  queue_end: { uk: "Це остання відповідь у черзі", en: "That is the last answer in the queue", hy: "Սա հերթի վերջին պատասխանն է", ka: "ეს რიგში ბოლო პასუხია" },
  photo_of: { uk: "{i} з {n}", en: "{i} of {n}", hy: "{i} / {n}", ka: "{i} / {n}" },
  photo_prev: { uk: "Попереднє фото", en: "Previous photo", hy: "Նախորդ լուսանկարը", ka: "წინა ფოტო" },
  photo_next: { uk: "Наступне фото", en: "Next photo", hy: "Հաջորդ լուսանկարը", ka: "შემდეგი ფოტო" },
  sec_photos: { uk: "Фото", en: "Photos", hy: "Լուսանկարներ", ka: "ფოტოები" },
  sec_task: { uk: "Завдання", en: "Task", hy: "Առաջադրանք", ka: "დავალება" },
  /* The answer is a response to a task; deciding it often needs what was actually asked for. */
  open_task: { uk: "Відкрити завдання", en: "Open task", hy: "Բացել առաջադրանքը", ka: "დავალების გახსნა" },
  sec_response: { uk: "Відповідь", en: "Answer", hy: "Պատասխան", ka: "პასუხი" },
  k_title: { uk: "Назва", en: "Title", hy: "Անվանում", ka: "სახელი" },
  k_point: { uk: "Точка", en: "Point", hy: "Կետ", ka: "წერტილი" },
  k_priority: { uk: "Пріоритет", en: "Priority", hy: "Առաջնահերթություն", ka: "პრიორიტეტი" },
  k_deadline: { uk: "Дедлайн", en: "Deadline", hy: "Վերջնաժամկետ", ka: "ბოლო ვადა" },
  k_description: { uk: "Опис", en: "Description", hy: "Նկարագրություն", ka: "აღწერა" },
  k_tags: { uk: "Теги", en: "Tags", hy: "Պիտակներ", ka: "ტეგები" },
  k_by: { uk: "Мерчендайзер", en: "Merchandiser", hy: "Մերչենդայզեր", ka: "მერჩენდაიზერი" },
  k_supervisor: { uk: "Супервайзер", en: "Supervisor", hy: "Սուպերվայզեր", ka: "სუპერვაიზერი" },
  k_when: { uk: "Отримано", en: "Received", hy: "Ստացվել է", ka: "მიღებულია" },
  k_text: { uk: "Текст відповіді", en: "Answer text", hy: "Պատասխանի տեքստ", ka: "პასუხის ტექსტი" },
  k_boolean: { uk: "Так / Ні", en: "Yes / No", hy: "Այո / Ոչ", ka: "დიახ / არა" },
  k_visit: { uk: "Візит", en: "Visit", hy: "Այց", ka: "ვიზიტი" },
  k_verdict_comment: { uk: "Причина відхилення", en: "Rejection reason", hy: "Մերժման պատճառ", ka: "უარყოფის მიზეზი" },
  yes: { uk: "Так", en: "Yes", hy: "Այո", ka: "დიახ" },
  no: { uk: "Ні", en: "No", hy: "Ոչ", ka: "არა" },
  no_photos: { uk: "Без фото", en: "No photos", hy: "Առանց լուսանկարի", ka: "ფოტოს გარეშე" },
  /* Keyboard help, shown once under the queue stepper. */
  keys_hint: {
    uk: "[ і ] — попередня та наступна",
    en: "[ and ] — previous and next",
    hy: "[ և ] — նախորդը և հաջորդը",
    ka: "[ და ] — წინა და შემდეგი",
  },
  not_found_title: { uk: "Не знайдено", en: "Not found", hy: "Չի գտնվել", ka: "არ მოიძებნა" },
  not_found_desc: {
    uk: "Відповідь не знайдена або видалена.",
    en: "Answer not found or deleted.",
    hy: "Պատասխանը չի գտնվել կամ ջնջված է։",
    ka: "პასუხი ვერ მოიძებნა ან წაშლილია.",
  },
  load_error: { uk: "Не вдалося завантажити", en: "Could not load", hy: "Չհաջողվեց բեռնել", ka: "ჩატვირთვა ვერ მოხერხდა" },
  retry: { uk: "Спробувати ще", en: "Try again", hy: "Կրկին փորձել", ka: "ხელახლა ცდა" },
};

/* Import and My uploads — `src/module/import/`.
 *
 * Replaces the ~41 live keys of `TAKS_IMPORT` that belonged to the four `tasks-import` tabs. That
 * group stays put because 23 of its keys are `points/ext/AddToGroup.js`'s and one is
 * `util.js`'s `fieldIsRequired` default.
 *
 * ⚠ `hy` and `ka` are machine-authored and NEED NATIVE REVIEW (spec/04). */
export const IMPORT = {
  /* ---------------------------------------------------------------- page */
  page_title: { uk: "Імпорт", en: "Import", hy: "Ներմուծում", ka: "იმპორტი" },
  page_sub: {
    uk: "Створення завдань і асортиментних матриць пакетом із файлу.",
    en: "Create tasks and assortment matrices in bulk from a file.",
    hy: "Ստեղծեք առաջադրանքներ և տեսականու մատրիցներ խմբաքանակով՝ ֆայլից։",
    ka: "შექმენით დავალებები და ასორტიმენტის მატრიცები ერთიანად ფაილიდან.",
  },
  to_uploads: { uk: "Мої завантаження", en: "My uploads", hy: "Իմ ներբեռնումները", ka: "ჩემი ატვირთვები" },

  /* ---------------------------------------------------------------- kinds */
  kind_label: { uk: "Що імпортуємо", en: "What are you importing", hy: "Ի՞նչ եք ներմուծում", ka: "რას აიმპორტებთ" },
  kind_tasks: { uk: "Завдання", en: "Tasks", hy: "Առաջադրանքներ", ka: "დავალებები" },
  kind_tasks_desc: {
    uk: "Усі завдання з файлу отримають одну точку або одну мережу, вибрану нижче.",
    en: "Every task in the file goes to the one point or network you pick below.",
    hy: "Ֆայլի բոլոր առաջադրանքները կստանան ներքևում ընտրված մեկ կետը կամ մեկ ցանցը։",
    ka: "ფაილის ყველა დავალება მიენიჭება ქვემოთ არჩეულ ერთ წერტილს ან ერთ ქსელს.",
  },
  kind_tasks_by_row: {
    uk: "Завдання з точкою в рядку",
    en: "Tasks with a point per row",
    hy: "Առաջադրանքներ՝ կետը տողում",
    ka: "დავალებები წერტილით თითო მწკრივში",
  },
  kind_tasks_by_row_desc: {
    uk: "Кожен рядок файлу несе власний код точки або мережі.",
    en: "Each row of the file carries its own point or network code.",
    hy: "Ֆայլի յուրաքանչյուր տող կրում է իր կետի կամ ցանցի կոդը։",
    ka: "ფაილის თითოეული მწკრივი შეიცავს საკუთარ წერტილის ან ქსელის კოდს.",
  },
  kind_matrix: { uk: "Асортиментна матриця", en: "Assortment matrix", hy: "Տեսականու մատրից", ka: "ასორტიმენტის მატრიცა" },
  kind_matrix_desc: {
    uk: "Сітка: коди точок у заголовку, коди товарів у першому стовпці, позначка на перетині.",
    en: "A grid: point codes across the top, product codes down the first column, a mark where they meet.",
    hy: "Ցանց՝ կետերի կոդերը վերևում, ապրանքների կոդերը առաջին սյունակում, նշան՝ հատման կետում։",
    ka: "ბადე: წერტილების კოდები ზემოთ, პროდუქტების კოდები პირველ სვეტში, ნიშანი გადაკვეთაზე.",
  },

  /* ------------------------------------------------------------- sections */
  sec_batch: { uk: "Пакет", en: "Batch", hy: "Խմբաքանակ", ka: "პაკეტი" },
  sec_batch_desc: {
    uk: "Назва, під якою цей імпорт з’явиться у «Моїх завантаженнях».",
    en: "The name this import will appear under in My uploads.",
    hy: "Անունը, որով այս ներմուծումը կհայտնվի «Իմ ներբեռնումներում»։",
    ka: "სახელი, რომლითაც ეს იმპორტი გამოჩნდება „ჩემს ატვირთვებში“.",
  },
  sec_scope: { uk: "Куди", en: "Where to", hy: "Ուր", ka: "სად" },
  sec_scope_desc: {
    uk: "Одна точка або одна мережа на весь пакет.",
    en: "One point or one network, for the whole batch.",
    hy: "Մեկ կետ կամ մեկ ցանց՝ ամբողջ խմբաքանակի համար։",
    ka: "ერთი წერტილი ან ერთი ქსელი მთელი პაკეტისთვის.",
  },
  sec_file: { uk: "Файл", en: "File", hy: "Ֆայլ", ka: "ფაილი" },
  sec_rows: { uk: "Рядки", en: "Rows", hy: "Տողեր", ka: "მწკრივები" },
  sec_rows_desc: {
    uk: "Перевірте перед імпортом. Надсилаються лише рядки без проблем.",
    en: "Check before importing. Only rows without problems are sent.",
    hy: "Ստուգեք նախքան ներմուծումը։ Ուղարկվում են միայն առանց խնդիրների տողերը։",
    ka: "შეამოწმეთ იმპორტამდე. იგზავნება მხოლოდ პრობლემების გარეშე მწკრივები.",
  },

  /* --------------------------------------------------------------- fields */
  f_name: { uk: "Назва пакета", en: "Batch name", hy: "Խմբաքանակի անուն", ka: "პაკეტის სახელი" },
  f_name_ph: {
    uk: "Наприклад, Вересень — мережа АТБ",
    en: "For example, September — ATB network",
    hy: "Օրինակ՝ Սեպտեմբեր — ATB ցանց",
    ka: "მაგალითად, სექტემბერი — ATB ქსელი",
  },
  f_scope_type: { uk: "Тип", en: "Type", hy: "Տեսակ", ka: "ტიპი" },
  scope_network: { uk: "Мережа", en: "Network", hy: "Ցանց", ka: "ქსელი" },
  scope_point: { uk: "Точка", en: "Point", hy: "Կետ", ka: "წერტილი" },

  /* --------------------------------------------------------------- upload */
  drop_hint: {
    uk: "Натисніть або перетягніть файл сюди",
    en: "Click or drag a file here",
    hy: "Սեղմեք կամ քաշեք ֆայլը այստեղ",
    ka: "დააჭირეთ ან გადმოიტანეთ ფაილი აქ",
  },
  drop_sub: { uk: "Один файл .csv або .xlsx", en: "One .csv or .xlsx file", hy: "Մեկ .csv կամ .xlsx ֆայլ", ka: "ერთი .csv ან .xlsx ფაილი" },
  file_remove: { uk: "Прибрати файл", en: "Remove file", hy: "Հեռացնել ֆայլը", ka: "ფაილის მოშორება" },
  download_template: { uk: "Завантажити шаблон", en: "Download template", hy: "Ներբեռնել ձևանմուշը", ka: "შაბლონის ჩამოტვირთვა" },
  expected_columns: { uk: "Очікувані стовпці", en: "Expected columns", hy: "Սպասվող սյունակներ", ka: "მოსალოდნელი სვეტები" },
  date_format_hint: { uk: "Дати у форматі {f}", en: "Dates in {f} format", hy: "Ամսաթվերը {f} ձևաչափով", ka: "თარიღები {f} ფორმატში" },
  reading: { uk: "Читаємо файл…", en: "Reading the file…", hy: "Կարդում ենք ֆայլը…", ka: "ფაილის წაკითხვა…" },
  read_error: {
    uk: "Не вдалося прочитати цей файл. Перевірте, що це .csv або .xlsx.",
    en: "Could not read this file. Check that it is a .csv or .xlsx.",
    hy: "Չհաջողվեց կարդալ այս ֆայլը։ Ստուգեք, որ այն .csv կամ .xlsx է։",
    ka: "ფაილის წაკითხვა ვერ მოხერხდა. შეამოწმეთ, რომ ის .csv ან .xlsx არის.",
  },
  empty_file: { uk: "У цьому файлі немає рядків", en: "That file has no rows", hy: "Այս ֆայլում տողեր չկան", ka: "ამ ფაილში მწკრივები არ არის" },

  /* -------------------------------------------------------------- columns */
  col_row: { uk: "Рядок", en: "Row", hy: "Տող", ka: "მწკრივი" },
  col_title: { uk: "Назва", en: "Title", hy: "Անվանում", ka: "დასახელება" },
  col_description: { uk: "Опис", en: "Description", hy: "Նկարագրություն", ka: "აღწერა" },
  col_start: { uk: "Початок", en: "Start", hy: "Սկիզբ", ka: "დაწყება" },
  col_end: { uk: "Кінець", en: "End", hy: "Ավարտ", ka: "დასრულება" },
  col_point: { uk: "Точка", en: "Point", hy: "Կետ", ka: "წერტილი" },
  col_network: { uk: "Мережа", en: "Network", hy: "Ցանց", ka: "ქსელი" },
  col_products: { uk: "Товари", en: "Products", hy: "Ապրանքներ", ka: "პროდუქტები" },
  col_reason: { uk: "Причина", en: "Reason", hy: "Պատճառ", ka: "მიზეზი" },
  sample_title: { uk: "Перевірити викладку", en: "Check the shelf", hy: "Ստուգել դարակը", ka: "შეამოწმეთ თარო" },

  /* ----------------------------------------------------------- row errors */
  e_required: { uk: "Обов’язкове", en: "Required", hy: "Պարտադիր", ka: "სავალდებულო" },
  e_date: { uk: "Не дата — потрібен формат {f}", en: "Not a date — use {f}", hy: "Ամսաթիվ չէ — օգտագործեք {f}", ka: "არ არის თარიღი — გამოიყენეთ {f}" },
  e_end_before_start: { uk: "Кінець раніше за початок", en: "Ends before it starts", hy: "Ավարտը սկզբից շուտ է", ka: "სრულდება დაწყებამდე" },
  e_point_or_network: {
    uk: "Потрібен код точки або мережі",
    en: "Needs a point or a network code",
    hy: "Անհրաժեշտ է կետի կամ ցանցի կոդ",
    ka: "საჭიროა წერტილის ან ქსელის კოდი",
  },
  e_no_assignments: { uk: "Жодного товару не позначено", en: "No products ticked", hy: "Ոչ մի ապրանք նշված չէ", ka: "პროდუქტები არ არის მონიშნული" },

  /* ----------------------------------------------------------------- rows */
  add_row: { uk: "Додати рядок", en: "Add row", hy: "Ավելացնել տող", ka: "მწკრივის დამატება" },
  remove_row: { uk: "Прибрати рядок", en: "Remove row", hy: "Հեռացնել տողը", ka: "მწკრივის მოშორება" },
  rows_empty_title: { uk: "Ще немає рядків", en: "No rows yet", hy: "Դեռ տողեր չկան", ka: "ჯერ არ არის მწკრივები" },
  rows_empty_desc: {
    uk: "Завантажте файл або додайте рядок вручну.",
    en: "Upload a file, or add a row by hand.",
    hy: "Վերբեռնեք ֆայլ կամ ավելացրեք տող ձեռքով։",
    ka: "ატვირთეთ ფაილი ან დაამატეთ მწკრივი ხელით.",
  },
  rows_empty_file_desc: {
    uk: "Завантажте файл, щоб побачити рядки.",
    en: "Upload a file to see its rows.",
    hy: "Վերբեռնեք ֆայլ՝ տողերը տեսնելու համար։",
    ka: "ატვირთეთ ფაილი მწკრივების სანახავად.",
  },

  /* ----------------------------------------------------------------- rail */
  n_parsed: { uk: "Прочитано", en: "Parsed", hy: "Կարդացված", ka: "წაკითხული" },
  n_ok: { uk: "Готові", en: "Ready", hy: "Պատրաստ", ka: "მზადაა" },
  n_problems: { uk: "З проблемами", en: "Problems", hy: "Խնդիրներով", ka: "პრობლემებით" },
  rail_summary: { uk: "Підсумок", en: "Summary", hy: "Ամփոփում", ka: "შეჯამება" },
  rail_target: { uk: "Куди піде", en: "Target", hy: "Ուր կգնա", ka: "სად წავა" },
  server_checks_hint: {
    uk: "Тут перевіряється лише форма рядків. Коди точок, мереж і товарів звіряються на сервері після імпорту.",
    en: "Only the shape of each row is checked here. Point, network and product codes are verified on the server after the import.",
    hy: "Այստեղ ստուգվում է միայն տողերի ձևը։ Կետերի, ցանցերի և ապրանքների կոդերը ստուգվում են սերվերում ներմուծումից հետո։",
    ka: "აქ მოწმდება მხოლოდ მწკრივების ფორმა. წერტილების, ქსელებისა და პროდუქტების კოდები მოწმდება სერვერზე იმპორტის შემდეგ.",
  },

  /* -------------------------------------------------------------- submit */
  submit: { uk: "Імпортувати", en: "Import", hy: "Ներմուծել", ka: "იმპორტი" },
  cancel: { uk: "Скасувати", en: "Cancel", hy: "Չեղարկել", ka: "გაუქმება" },
  discard_rows: { uk: "Відкинути рядки", en: "Discard rows", hy: "Հրաժարվել տողերից", ka: "მწკრივების გაუქმება" },
  change_kind_confirm: {
    uk: "Прочитані рядки не підходять до іншого типу імпорту, тож їх буде відкинуто. Продовжити?",
    en: "The rows you have read in do not fit another import kind, so they will be discarded. Continue?",
    hy: "Կարդացված տողերը այլ տեսակի ներմուծման չեն համապատասխանում, ուստի կհեռացվեն։ Շարունակե՞լ։",
    ka: "წაკითხული მწკრივები არ შეესაბამება სხვა ტიპის იმპორტს, ამიტომ გაუქმდება. გავაგრძელოთ?",
  },
  only_problems: { uk: "Лише з проблемами", en: "Problems only", hy: "Միայն խնդիրներով", ka: "მხოლოდ პრობლემებით" },
  v_name_required: { uk: "Вкажіть назву пакета", en: "Give the batch a name", hy: "Նշեք խմբաքանակի անունը", ka: "მიუთითეთ პაკეტის სახელი" },
  v_template_required: { uk: "Виберіть шаблон", en: "Pick a template", hy: "Ընտրեք ձևանմուշ", ka: "აირჩიეთ შაბლონი" },
  v_scope_required: { uk: "Виберіть точку або мережу", en: "Pick a point or a network", hy: "Ընտրեք կետ կամ ցանց", ka: "აირჩიეთ წერტილი ან ქსელი" },
  v_no_valid_rows: {
    uk: "Немає жодного рядка без проблем",
    en: "No row is free of problems",
    hy: "Չկա առանց խնդիրների ոչ մի տող",
    ka: "არცერთი მწკრივი არ არის პრობლემების გარეშე",
  },
  queued_msg: {
    uk: "Імпорт поставлено в чергу. Результат — у «Моїх завантаженнях».",
    en: "Import queued. The result appears in My uploads.",
    hy: "Ներմուծումը հերթում է։ Արդյունքը՝ «Իմ ներբեռնումներում»։",
    ka: "იმპორტი რიგშია. შედეგი გამოჩნდება „ჩემს ატვირთვებში“.",
  },
  submit_failed: { uk: "Імпорт не вдався", en: "The import was refused", hy: "Ներմուծումը մերժվեց", ka: "იმპორტი უარყოფილია" },
  leave_confirm: {
    uk: "Прочитані рядки буде втрачено. Залишити сторінку?",
    en: "The rows you have read in will be lost. Leave the page?",
    hy: "Կարդացված տողերը կկորչեն։ Լքե՞լ էջը։",
    ka: "წაკითხული მწკრივები დაიკარგება. დატოვებთ გვერდს?",
  },

  /* ------------------------------------------------------- My uploads */
  uploads_title: { uk: "Мої завантаження", en: "My uploads", hy: "Իմ ներբեռնումները", ka: "ჩემი ატვირთვები" },
  uploads_sub: {
    uk: "Кожен імпорт та його результат. Обробка триває на сервері після надсилання.",
    en: "Every import and how it went. Processing continues on the server after you submit.",
    hy: "Յուրաքանչյուր ներմուծում և դրա արդյունքը։ Մշակումը շարունակվում է սերվերում ուղարկելուց հետո։",
    ka: "თითოეული იმპორტი და მისი შედეგი. დამუშავება გრძელდება სერვერზე გაგზავნის შემდეგ.",
  },
  u_col_name: { uk: "Назва", en: "Name", hy: "Անվանում", ka: "დასახელება" },
  u_col_type: { uk: "Тип", en: "Type", hy: "Տեսակ", ka: "ტიპი" },
  u_col_created: { uk: "Коли", en: "When", hy: "Երբ", ka: "როდის" },
  u_col_errors: { uk: "Помилки", en: "Errors", hy: "Սխալներ", ka: "შეცდომები" },
  type_tasks: { uk: "Завдання", en: "Tasks", hy: "Առաջադրանքներ", ka: "დავალებები" },
  type_matrix: { uk: "Асортиментна матриця", en: "Assortment matrix", hy: "Տեսականու մատրից", ka: "ასორტიმენტის მატრიცა" },
  st_received: { uk: "Прийнято", en: "Received", hy: "Ստացված", ka: "მიღებული" },
  st_pending: { uk: "В обробці", en: "Processing", hy: "Մշակվում է", ka: "მუშავდება" },
  st_failed: { uk: "Не вдалося", en: "Failed", hy: "Ձախողվեց", ka: "ჩაიშალა" },
  st_done: { uk: "Готово", en: "Done", hy: "Պատրաստ", ka: "დასრულებული" },
  st_deleted: { uk: "Дані видалено", en: "Data removed", hy: "Տվյալները հեռացված են", ka: "მონაცემები წაშლილია" },
  f_status: { uk: "Статус", en: "Status", hy: "Կարգավիճակ", ka: "სტატუსი" },
  f_type: { uk: "Тип", en: "Type", hy: "Տեսակ", ka: "ტიპი" },
  f_search_ph: { uk: "Пошук за назвою", en: "Search by name", hy: "Որոնել ըստ անվան", ka: "ძებნა სახელით" },
  view_logs: { uk: "Переглянути помилки", en: "View errors", hy: "Դիտել սխալները", ka: "შეცდომების ნახვა" },
  download_logs: { uk: "Завантажити CSV", en: "Download CSV", hy: "Ներբեռնել CSV", ka: "CSV-ის ჩამოტვირთვა" },
  logs_title: { uk: "Помилки імпорту", en: "Import errors", hy: "Ներմուծման սխալներ", ka: "იმპორტის შეცდომები" },
  logs_opaque: {
    uk: "Сервер повідомив про помилку, але не зберіг, які саме рядки не пройшли.",
    en: "The server reported a failure but did not record which rows did not go through.",
    hy: "Սերվերը հաղորդել է սխալի մասին, բայց չի պահպանել, թե որ տողերն են ձախողվել։",
    ka: "სერვერმა შეცდომა დააფიქსირა, მაგრამ არ შეინახა, რომელი მწკრივები ჩაიშალა.",
  },
  delete_data: { uk: "Видалити створені дані", en: "Remove the created data", hy: "Ջնջել ստեղծված տվյալները", ka: "შექმნილი მონაცემების წაშლა" },
  delete_confirm_tasks: {
    uk: "Завдання, створені імпортом «{name}», буде видалено назавжди. Сам запис про завантаження залишиться.",
    en: "The tasks created by the import “{name}” will be deleted for good. The upload record itself stays.",
    hy: "«{name}» ներմուծմամբ ստեղծված առաջադրանքները ընդմիշտ կջնջվեն։ Ներբեռնման գրառումն ինքնին կմնա։",
    ka: "იმპორტით „{name}“ შექმნილი დავალებები სამუდამოდ წაიშლება. ატვირთვის ჩანაწერი დარჩება.",
  },
  delete_confirm_matrix: {
    uk: "Асортиментні матриці, створені імпортом «{name}», буде видалено назавжди. Сам запис про завантаження залишиться.",
    en: "The assortment matrices created by the import “{name}” will be deleted for good. The upload record itself stays.",
    hy: "«{name}» ներմուծմամբ ստեղծված տեսականու մատրիցները ընդմիշտ կջնջվեն։ Ներբեռնման գրառումն ինքնին կմնա։",
    ka: "იმპორტით „{name}“ შექმნილი ასორტიმენტის მატრიცები სამუდამოდ წაიშლება. ატვირთვის ჩანაწერი დარჩება.",
  },
  deleted_msg: { uk: "Створені дані видалено", en: "The created data was removed", hy: "Ստեղծված տվյալները հեռացվեցին", ka: "შექმნილი მონაცემები წაიშალა" },
  row_actions: { uk: "Дії з рядком", en: "Row actions", hy: "Տողի գործողություններ", ka: "მწკრივის მოქმედებები" },
  rows_per_page: { uk: "Рядків на сторінці", en: "Rows per page", hy: "Տողեր էջում", ka: "მწკრივი გვერდზე" },
  range_of: { uk: "{from}–{to} з {n}", en: "{from}–{to} of {n}", hy: "{from}–{to} / {n}", ka: "{from}–{to} / {n}" },
  empty_title: { uk: "Ще нічого не імпортовано", en: "Nothing imported yet", hy: "Դեռ ոչինչ ներմուծված չէ", ka: "ჯერ არაფერია იმპორტირებული" },
  empty_desc: {
    uk: "Завантаження з’являються тут одразу після надсилання.",
    en: "Uploads appear here as soon as you submit one.",
    hy: "Ներբեռնումները հայտնվում են այստեղ ուղարկելուց անմիջապես հետո։",
    ka: "ატვირთვები აქ გამოჩნდება გაგზავნისთანავე.",
  },
  empty_filtered_title: {
    uk: "Нічого не знайдено",
    en: "Nothing matches these filters",
    hy: "Այս զտիչներին ոչինչ չի համապատասխանում",
    ka: "ამ ფილტრებს არაფერი ემთხვევა",
  },
  empty_filtered_desc: {
    uk: "Спробуйте зняти частину фільтрів або розширити період.",
    en: "Try clearing some filters or widening the period.",
    hy: "Փորձեք հեռացնել որոշ զտիչներ կամ ընդլայնել ժամանակահատվածը։",
    ka: "სცადეთ ზოგიერთი ფილტრის მოხსნა ან პერიოდის გაფართოება.",
  },
  go_import: { uk: "Перейти до імпорту", en: "Go to import", hy: "Անցնել ներմուծմանը", ka: "იმპორტზე გადასვლა" },
  new_row: { uk: "Щойно надіслано", en: "Just submitted", hy: "Հենց նոր ուղարկված", ka: "ახლახან გაგზავნილი" },
  refresh: { uk: "Оновити", en: "Refresh", hy: "Թարմացնել", ka: "განახლება" },
};

/* /tracking — the online tracking page.
 *
 * ⚠ The copy must keep saying WHERE THE NUMBER COMES FROM. There is no live GPS in this system: a
 * position is the coordinate of the point of an OPEN visit, and "last" is the point of the last
 * closed one. So the states name the visit ("At X since 10:32", "Last · Y · 14:05") rather than
 * claiming a live fix, and `st_open_stale` reads as a forgotten close rather than a fault.
 *
 * Counts never inflect a noun (spec/04): "Points: {n}", "{n} h" — never "{n} points".
 */
export const TRACKING = {
  page_sub: {
    uk: "Позиції та маршрути за вибраний день",
    en: "Positions and routes for the selected day",
    hy: "Դիրքերը և երթուղիները ընտրված օրվա համար",
    ka: "პოზიციები და მარშრუტები არჩეული დღისთვის",
  },
  day: { uk: "День", en: "Day", hy: "Օր", ka: "დღე" },
  today: { uk: "Сьогодні", en: "Today", hy: "Այսօր", ka: "დღეს" },
  refresh: { uk: "Оновити", en: "Refresh", hy: "Թարմացնել", ka: "განახლება" },
  updated: { uk: "Оновлено {time}", en: "Updated {time}", hy: "Թարմացվել է {time}", ka: "განახლდა {time}" },

  st_in_visit: { uk: "У {point} · з {time}", en: "At {point} · since {time}", hy: "{point} · {time}-ից", ka: "{point} · {time}-დან" },
  st_open_stale: {
    uk: "Не закрито · {point} · з {time}",
    en: "Not closed · {point} · since {time}",
    hy: "Չփակված · {point} · {time}-ից",
    ka: "დაუხურავი · {point} · {time}-დან",
  },
  st_between: { uk: "Останній · {point} · {time}", en: "Last · {point} · {time}", hy: "Վերջին · {point} · {time}", ka: "ბოლო · {point} · {time}" },
  st_idle: { uk: "Немає візитів", en: "No visits", hy: "Այցեր չկան", ka: "ვიზიტები არ არის" },

  no_coords: { uk: "Немає координат", en: "No coordinates", hy: "Կոորդինատներ չկան", ka: "კოორდინატები არ არის" },
  seq_title: { uk: "Відвідані точки", en: "Visited points", hy: "Այցելված կետեր", ka: "მონახულებული წერტილები" },
  plan_title: { uk: "Запланований маршрут", en: "Planned route", hy: "Պլանավորված երթուղի", ka: "დაგეგმილი მარშრუტი" },
  plan_pending: { uk: "Заплановано, не відвідано", en: "Planned, not visited", hy: "Պլանավորված, չայցելված", ka: "დაგეგმილი, არ მონახულებული" },
  no_plan: {
    uk: "Немає запланованого маршруту на цей день",
    en: "No planned route for this day",
    hy: "Այս օրվա համար պլանավորված երթուղի չկա",
    ka: "ამ დღისთვის დაგეგმილი მარშრუტი არ არის",
  },
  here_now: { uk: "Зараз тут", en: "Here now", hy: "Հիմա այստեղ", ka: "ახლა აქ" },
  on_route: { uk: "За планом", en: "Planned", hy: "Ըստ պլանի", ka: "გეგმის მიხედვით" },
  off_route: { uk: "Поза маршрутом", en: "Off route", hy: "Երթուղուց դուրս", ka: "მარშრუტის გარეთ" },

  dur_h: { uk: "{n} год", en: "{n} h", hy: "{n} ժ", ka: "{n} სთ" },
  dur_m: { uk: "{n} хв", en: "{n} min", hy: "{n} ր", ka: "{n} წთ" },
  points_visited: { uk: "Точок: {n}", en: "Points: {n}", hy: "Կետեր՝ {n}", ka: "წერტილები: {n}" },

  show_team: { uk: "Показати всю команду", en: "Show whole team", hy: "Ցույց տալ ողջ թիմը", ka: "მთელი გუნდის ჩვენება" },
  call: { uk: "Подзвонити", en: "Call", hy: "Զանգահարել", ka: "დარეკვა" },
  open_visit: { uk: "Відкрити візит", en: "Open visit", hy: "Բացել այցը", ka: "ვიზიტის გახსნა" },

  empty_map_title: { uk: "Нікого на карті", en: "Nobody on the map", hy: "Քարտեզին ոչ ոք չկա", ka: "რუკაზე არავინაა" },
  empty_map_desc: {
    uk: "Немає візитів з координатами за цей день.",
    en: "No visits with coordinates for this day.",
    hy: "Այս օրվա համար կոորդինատներով այցեր չկան։",
    ka: "ამ დღისთვის კოორდინატებით ვიზიტები არ არის.",
  },
  empty_roster_title: { uk: "Немає мерчандайзерів", en: "No merchandisers", hy: "Մերչենդայզերներ չկան", ka: "მერჩენდაიზერები არ არის" },
  empty_roster_desc: {
    uk: "До вас не закріплено активних мерчандайзерів.",
    en: "There are no active merchandisers assigned to you.",
    hy: "Ձեզ ամրագրված ակտիվ մերչենդայզերներ չկան։",
    ka: "თქვენზე მიმაგრებული აქტიური მერჩენდაიზერები არ არის.",
  },

  truncated: {
    uk: "Показано візитів: {shown} з {total}",
    en: "Visits shown: {shown} of {total}",
    hy: "Ցուցադրված այցեր՝ {shown} / {total}",
    ka: "ნაჩვენები ვიზიტები: {shown} / {total}",
  },
  map_unavailable: { uk: "Карта недоступна", en: "Map unavailable", hy: "Քարտեզը հասանելի չէ", ka: "რუკა მიუწვდომელია" },
  load_error: { uk: "Не вдалося завантажити день", en: "Could not load the day", hy: "Չհաջողվեց բեռնել օրը", ka: "დღის ჩატვირთვა ვერ მოხერხდა" },
  retry: { uk: "Спробувати ще", en: "Retry", hy: "Կրկնել", ka: "ხელახლა" },
};

/* ------------------------------------------------------------------
   HELP_PAGE — the /help guide (src/module/help/). One section per screen plus the shell and the
   common list grammar; keys are `<section>_title`, `<section>_desc`, `<section>_b1..bN`, where N
   is declared per section in View.js's SECTIONS (a missing key renders an empty bullet).
   The illustrations' labels (fictional company, people, points) are NOT translated: the frame is
   aria-hidden and the copy here names what it shows.
   ⚠ hy / ka are machine drafts and NEED NATIVE REVIEW (spec/04).
   ------------------------------------------------------------------ */
export const HELP_PAGE = {
  title: { uk: "Як працює дашборд", en: "How the dashboard works", hy: "Ինչպես է աշխատում դաշբորդը", ka: "როგორ მუშაობს დეშბორდი" },
  subtitle: {
    uk: "Усі екрани в одному місці: для чого кожен, що на ньому можна робити, і коротка анімація. У прикладах — вигадана компанія.",
    en: "Every screen in one place: what it is for, what you can do there, and a short animation of it in use. The examples show a fictional company.",
    hy: "Բոլոր էկրանները մեկ տեղում. ինչի համար է յուրաքանչյուրը, ինչ կարելի է անել այնտեղ, և կարճ անիմացիա։ Օրինակներում պատկերված է հորինված ընկերություն։",
    ka: "ყველა ეკრანი ერთ ადგილას: რისთვის არის თითოეული, რა შეგიძლიათ გააკეთოთ და მოკლე ანიმაცია. მაგალითებში გამოგონილი კომპანიაა.",
  },
  rail_label: { uk: "На цій сторінці", en: "On this page", hy: "Այս էջում", ka: "ამ გვერდზე" },
  support_title: { uk: "Потрібна допомога?", en: "Still need help?", hy: "Դեռ օգնության կարիք ունե՞ք", ka: "კიდევ გჭირდებათ დახმარება?" },
  support_desc: {
    uk: "Надішліть запит — служба підтримки звʼяжеться з вами в Telegram.",
    en: "Send a request and the support team will contact you in Telegram.",
    hy: "Ուղարկեք հարցում, և աջակցության թիմը կապ կհաստատի ձեզ հետ Telegram-ում։",
    ka: "გაგზავნეთ მოთხოვნა და მხარდაჭერის გუნდი დაგიკავშირდებათ Telegram-ში.",
  },
  support_btn: { uk: "Звернутися в підтримку", en: "Contact support", hy: "Կապ աջակցության հետ", ka: "მხარდაჭერასთან დაკავშირება" },

  /* --- shell --- */
  search_title: { uk: "Глобальний пошук", en: "Global search", hy: "Ընդհանուր որոնում", ka: "გლობალური ძიება" },
  search_desc: {
    uk: "Поле пошуку у верхній панелі шукає одразу серед точок, мерчандайзерів, візитів, опитувань і документів і відкриває запис одним кліком.",
    en: "The search box in the top bar finds points, merchandisers, visits, surveys and documents at once, and opens the record in one click.",
    hy: "Վերևի վահանակի որոնման դաշտը միաժամանակ գտնում է կետեր, մերչենդայզերներ, այցեր, հարցումներ և փաստաթղթեր և բացում է գրառումը մեկ սեղմումով։",
    ka: "ზედა პანელის საძიებო ველი ერთდროულად პოულობს წერტილებს, მერჩენდაიზერებს, ვიზიტებს, გამოკითხვებსა და დოკუმენტებს და ერთი დაწკაპუნებით ხსნის ჩანაწერს.",
  },
  search_b1: {
    uk: "Натисніть / на будь-якій сторінці, щоб перейти в поле пошуку.",
    en: "Press / anywhere to focus the box.",
    hy: "Սեղմեք / ցանկացած էջում՝ որոնման դաշտին անցնելու համար։",
    ka: "დააჭირეთ / ნებისმიერ გვერდზე, რომ საძიებო ველზე გადახვიდეთ.",
  },
  search_b2: {
    uk: "Введіть щонайменше 3 символи. Кожне слово має збігатися, тож «Bluefinch Central» знайде точку за мережею і населеним пунктом разом.",
    en: "Type at least 3 characters. Every word must match, so «Bluefinch Central» finds a point by its network and its locality together.",
    hy: "Մուտքագրեք առնվազն 3 նիշ։ Յուրաքանչյուր բառը պետք է համընկնի, այնպես որ «Bluefinch Central»-ը գտնում է կետը ցանցով և բնակավայրով միասին։",
    ka: "შეიყვანეთ მინიმუმ 3 სიმბოლო. ყველა სიტყვა უნდა დაემთხვეს, ასე რომ «Bluefinch Central» პოულობს წერტილს ქსელითა და დასახლებით ერთად.",
  },
  search_b3: {
    uk: "↑ ↓ — рух між результатами, Enter відкриває, Esc закриває.",
    en: "↑ ↓ move between results, Enter opens, Esc closes.",
    hy: "↑ ↓՝ արդյունքների միջև անցում, Enter՝ բացել, Esc՝ փակել։",
    ka: "↑ ↓ — გადაადგილება შედეგებს შორის, Enter ხსნის, Esc ხურავს.",
  },
  search_b4: {
    uk: "Порожнє поле показує останні пошуки. «Показати все» звужує результати до одного типу.",
    en: "An empty box shows your recent searches. «See all» narrows the results to one type.",
    hy: "Դատարկ դաշտը ցույց է տալիս վերջին որոնումները։ «Տեսնել բոլորը» նեղացնում է արդյունքները մեկ տեսակի։",
    ka: "ცარიელი ველი აჩვენებს ბოლო ძიებებს. «ყველას ნახვა» შედეგებს ერთ ტიპამდე ავიწროებს.",
  },

  notifications_title: { uk: "Сповіщення", en: "Notifications", hy: "Ծանուցումներ", ka: "შეტყობინებები" },
  notifications_desc: {
    uk:
      "Дзвіночок показує, що потребує уваги саме зараз. Числа обчислюються з актуальних даних при кожному відкритті, тому нічого не треба закривати по одному.",
    en:
      "The bell shows what needs attention right now. The numbers are computed from live data each time you open it, so nothing has to be dismissed one by one.",
    hy:
      "Զանգակը ցույց է տալիս, թե ինչն է հիմա ուշադրության կարիք ունենում։ Թվերը հաշվարկվում են թարմ տվյալներից ամեն բացելիս, այնպես որ ոչինչ մեկ-մեկ փակելու կարիք չկա։",
    ka:
      "ზარი აჩვენებს, რას სჭირდება ყურადღება ახლა. რიცხვები ყოველი გახსნისას მიმდინარე მონაცემებიდან ითვლება, ამიტომ არაფრის სათითაოდ დახურვა არ არის საჭირო.",
  },
  notifications_b1: {
    uk: "Три сигнали: візити на перевірці, мерчандайзери без візитів кілька днів, опитування, що скоро закриваються.",
    en: "Three signals: visits awaiting verification, merchandisers with no visits for several days, surveys that close soon.",
    hy: "Երեք ազդանշան՝ ստուգման սպասող այցեր, մի քանի օր այց չունեցող մերչենդայզերներ, շուտով փակվող հարցումներ։",
    ka: "სამი სიგნალი: შემოწმების მოლოდინში მყოფი ვიზიტები, რამდენიმე დღე ვიზიტების გარეშე მერჩენდაიზერები, მალე დახურვადი გამოკითხვები.",
  },
  notifications_b2: {
    uk: "Крапка на дзвіночку зникає, щойно ви відкриєте список, і повертається, коли якесь число зміниться.",
    en: "The dot on the bell disappears once you open the list and comes back when a number changes.",
    hy: "Զանգակի կետը անհետանում է, երբ բացում եք ցուցակը, և վերադառնում է, երբ որևէ թիվ փոխվում է։",
    ka: "ზარზე წერტილი ქრება სიის გახსნისას და ბრუნდება, როცა რომელიმე რიცხვი იცვლება.",
  },
  notifications_b3: {
    uk: "Кожен рядок відкриває сторінку, де є ця робота.",
    en: "Each row opens the page where the work is.",
    hy: "Յուրաքանչյուր տող բացում է այն էջը, որտեղ աշխատանքն է։",
    ka: "თითოეული სტრიქონი ხსნის გვერდს, სადაც სამუშაოა.",
  },

  account_title: { uk: "Мова, профіль і вихід", en: "Language, profile and sign-out", hy: "Լեզու, պրոֆիլ և ելք", ka: "ენა, პროფილი და გასვლა" },
  account_desc: {
    uk: "Праворуч у верхній панелі — перемикач мови та меню облікового запису з вашим імʼям і роллю.",
    en: "The right side of the top bar holds the language switcher and your account menu with your name and role.",
    hy: "Վերևի վահանակի աջ կողմում են լեզվի փոխարկիչը և ձեր հաշվի ընտրացանկը՝ անունով և դերով։",
    ka: "ზედა პანელის მარჯვენა მხარეს არის ენის გადამრთველი და თქვენი ანგარიშის მენიუ სახელითა და როლით.",
  },
  account_b1: {
    uk: "Вибір мови зберігається у вашому обліковому записі, після чого сторінка перезавантажується.",
    en: "Picking a language saves it to your account and reloads the page.",
    hy: "Լեզվի ընտրությունը պահվում է ձեր հաշվում, որից հետո էջը վերաբեռնվում է։",
    ka: "ენის არჩევა ინახება თქვენს ანგარიშში და გვერდი თავიდან იტვირთება.",
  },
  account_b2: {
    uk: "Мій профайл: імʼя, посада, Telegram, регіон, фото. Телефон і роль змінити не можна.",
    en: "My profile: name, position, Telegram, county, photo. The phone number and role are read-only.",
    hy: "Իմ պրոֆիլը՝ անուն, պաշտոն, Telegram, մարզ, լուսանկար։ Հեռախոսը և դերը փոխել հնարավոր չէ։",
    ka: "ჩემი პროფილი: სახელი, თანამდებობა, Telegram, რეგიონი, ფოტო. ტელეფონი და როლი არ იცვლება.",
  },
  account_b3: {
    uk: "Кнопка збереження зʼявляється внизу лише тоді, коли щось змінено.",
    en: "Save appears at the bottom only when something has changed.",
    hy: "Պահպանելու կոճակը ներքևում հայտնվում է միայն այն ժամանակ, երբ ինչ-որ բան փոխվել է։",
    ka: "შენახვის ღილაკი ქვემოთ ჩნდება მხოლოდ მაშინ, როცა რამე შეიცვალა.",
  },
  account_b4: {
    uk: "«Допомога» відкриває цю сторінку, «Вийти» завершує сеанс.",
    en: "Help opens this page; Sign out ends the session.",
    hy: "«Օգնություն»-ը բացում է այս էջը, «Ելք»-ը ավարտում է նստաշրջանը։",
    ka: "«დახმარება» ხსნის ამ გვერდს, «გასვლა» ასრულებს სესიას.",
  },

  /* --- the common list grammar --- */
  lists_title: { uk: "Як працюють списки", en: "How lists work", hy: "Ինչպես են աշխատում ցուցակները", ka: "როგორ მუშაობს სიები" },
  lists_desc: {
    uk: "Візити, задачі, відповіді, мерчандайзери, точки та інші списки мають однакові елементи керування. Досить вивчити їх один раз.",
    en: "Visits, tasks, answers, merchandisers, points and the other lists share one set of controls. Learn them once.",
    hy: "Այցերը, առաջադրանքները, պատասխանները, մերչենդայզերները, կետերը և մյուս ցուցակները ունեն նույն կառավարման տարրերը։ Բավական է դրանք մեկ անգամ սովորել։",
    ka: "ვიზიტებს, დავალებებს, პასუხებს, მერჩენდაიზერებს, წერტილებსა და სხვა სიებს ერთი და იგივე მართვის ელემენტები აქვს. საკმარისია ერთხელ ისწავლოთ.",
  },
  lists_b1: {
    uk: "Фільтри застосовуються одразу, кнопки «Застосувати» немає. Застосовані фільтри показані як мітки, які можна прибрати.",
    en: "Filters apply as you change them; there is no Apply button. Applied filters show as chips you can remove.",
    hy: "Զտիչները կիրառվում են փոխելուն պես, «Կիրառել» կոճակ չկա։ Կիրառված զտիչները ցուցադրվում են պիտակների տեսքով, որոնք կարելի է հեռացնել։",
    ka: "ფილტრები მაშინვე მოქმედებს, «გამოყენება» ღილაკი არ არის. გამოყენებული ფილტრები ჩანს ჩიპებად, რომლებიც შეგიძლიათ მოხსნათ.",
  },
  lists_b2: {
    uk:
      "Період обмежений: 14 днів за замовчуванням, до 90 днів у більшості списків і 62 дні у фотозвіті. Задачі фільтруються за дедлайном, тому там доступні майбутні дати.",
    en:
      "The period is capped: 14 days by default, up to 90 days on most lists and 62 days on the photo report. Tasks filter by deadline, so future dates are allowed there.",
    hy:
      "Ժամանակահատվածը սահմանափակ է՝ լռելյայն 14 օր, ցուցակների մեծ մասում մինչև 90 օր, լուսանկարների հաշվետվությունում՝ 62 օր։ Առաջադրանքները զտվում են վերջնաժամկետով, այնպես որ այնտեղ ապագա ամսաթվերը հասանելի են։",
    ka:
      "პერიოდი შეზღუდულია: ნაგულისხმევად 14 დღე, სიების უმეტესობაში 90 დღემდე, ფოტოანგარიშში 62 დღე. დავალებები ვადის მიხედვით იფილტრება, ამიტომ იქ მომავალი თარიღებიც შეიძლება.",
  },
  lists_b3: {
    uk: "Адресний рядок містить фільтри, сторінку й сортування, тож скопійоване посилання відкриває той самий вигляд, а «Назад» повертає до нього.",
    en: "The address bar holds the filters, page and sort, so a copied link opens the same view and Back returns to it.",
    hy: "Հասցեի տողը պահում է զտիչները, էջը և դասավորումը, այնպես որ պատճենված հղումը բացում է նույն տեսքը, իսկ «Հետ»-ը վերադարձնում է դրան։",
    ka: "მისამართის ველი ინახავს ფილტრებს, გვერდსა და დალაგებას, ასე რომ კოპირებული ბმული იმავე ხედს ხსნის და «უკან» მასზე აბრუნებს.",
  },
  lists_b4: {
    uk: "Сортуються лише ті колонки, які може відсортувати сервер. «Записів: N» під таблицею — загальна кількість за поточними фільтрами.",
    en: "Only columns the server can sort are sortable. «Records: N» under the table is the total for the current filters.",
    hy: "Դասավորվում են միայն այն սյունակները, որոնք սերվերը կարող է դասավորել։ Աղյուսակի տակ գտնվող «Գրառումներ՝ N»-ը ընթացիկ զտիչներով ընդհանուր քանակն է։",
    ka: "დალაგება მხოლოდ იმ სვეტებით შეიძლება, რომლებსაც სერვერი ალაგებს. ცხრილის ქვეშ «ჩანაწერები: N» მიმდინარე ფილტრების ჯამური რაოდენობაა.",
  },
  lists_b5: {
    uk: "Виділіть рядки для масової дії. «Вибрати все» виділяє завантажену сторінку, а не всі відповідні записи.",
    en: "Select rows for a bulk action. «Select all» selects the loaded page, not every matching record.",
    hy: "Ընտրեք տողերը զանգվածային գործողության համար։ «Ընտրել բոլորը» ընտրում է բեռնված էջը, ոչ թե բոլոր համապատասխան գրառումները։",
    ka: "მონიშნეთ სტრიქონები ჯგუფური მოქმედებისთვის. «ყველას მონიშვნა» მონიშნავს ჩატვირთულ გვერდს და არა ყველა შესაბამის ჩანაწერს.",
  },
  lists_b6: {
    uk: "Архівувати й деактивувати — різні дії: архівований запис приховано, його можна відновити; деактивований лишається в списках як неактивний.",
    en: "Archive and Deactivate are different: an archived record is hidden and can be restored; a deactivated one stays in lists as inactive.",
    hy:
      "Արխիվացնելը և ապաակտիվացնելը տարբեր գործողություններ են՝ արխիվացված գրառումը թաքցված է և կարելի է վերականգնել, ապաակտիվացվածը մնում է ցուցակներում՝ ոչ ակտիվ։",
    ka: "დაარქივება და დეაქტივაცია სხვადასხვა მოქმედებაა: დაარქივებული ჩანაწერი დამალულია და შეიძლება აღდგეს, დეაქტივირებული სიებში რჩება არააქტიურად.",
  },

  /* --- pages, in nav order --- */
  overview_desc: {
    uk: "Один місяць компанії на одному екрані: люди, візити, звіти, відповіді й опитування зі зміною відносно попереднього місяця.",
    en: "One month of the company at a glance: people, visits, reports, answers and surveys, with the change against the previous month.",
    hy: "Ընկերության մեկ ամիսը մեկ էկրանին՝ մարդիկ, այցեր, հաշվետվություններ, պատասխաններ և հարցումներ նախորդ ամսվա համեմատ փոփոխությամբ։",
    ka: "კომპანიის ერთი თვე ერთ ეკრანზე: ადამიანები, ვიზიტები, ანგარიშები, პასუხები და გამოკითხვები წინა თვესთან ცვლილებით.",
  },
  overview_b1: {
    uk: "Перемикач місяця вгорі — єдиний елемент, що перезавантажує дані.",
    en: "The month stepper at the top is the only control that reloads the data.",
    hy: "Վերևի ամսվա փոխարկիչը միակ տարրն է, որը վերաբեռնում է տվյալները։",
    ka: "ზედა თვის გადამრთველი ერთადერთი ელემენტია, რომელიც მონაცემებს თავიდან ტვირთავს.",
  },
  overview_b2: {
    uk: "Картки KPI показують підсумок за місяць і різницю з попереднім місяцем.",
    en: "KPI cards show the month total and the delta against the previous month.",
    hy: "KPI քարտերը ցույց են տալիս ամսվա ընդհանուրը և նախորդ ամսվա հետ տարբերությունը։",
    ka: "KPI ბარათები აჩვენებს თვის ჯამს და წინა თვესთან სხვაობას.",
  },
  overview_b3: {
    uk:
      "Графіки: активність по днях, статуси візитів, потік фото, відповіді за типами, регіони, активність опитувань, найактивніші мерчандайзери, календар візитів.",
    en: "Charts: activity by day, visit statuses, the photo pipeline, answers by type, counties, survey activity, top merchandisers, a visit calendar.",
    hy:
      "Գծապատկերներ՝ ակտիվություն օրերով, այցերի կարգավիճակներ, լուսանկարների հոսք, պատասխաններ ըստ տեսակի, մարզեր, հարցումների ակտիվություն, լավագույն մերչենդայզերներ, այցերի օրացույց։",
    ka:
      "დიაგრამები: აქტივობა დღეების მიხედვით, ვიზიტების სტატუსები, ფოტოების ნაკადი, პასუხები ტიპების მიხედვით, რეგიონები, გამოკითხვების აქტივობა, საუკეთესო მერჩენდაიზერები, ვიზიტების კალენდარი.",
  },
  overview_b4: {
    uk: "Таблиця мерчандайзерів унизу шукає й перегортає сторінки миттєво, без нового запиту.",
    en: "The merchandiser table at the bottom searches and pages instantly, without a new request.",
    hy: "Ներքևի մերչենդայզերների աղյուսակը որոնում և թերթում է անմիջապես, առանց նոր հարցման։",
    ka: "ქვედა მერჩენდაიზერების ცხრილი ეძებს და გვერდებს მყისიერად ცვლის, ახალი მოთხოვნის გარეშე.",
  },

  photo_review_desc: {
    uk: "Фото, зроблені мерчандайзерами в точках, у вигляді сітки, готові до рішення. Тут відбувається більша частина щоденної перевірки.",
    en: "Photos merchandisers took at points, in a grid, ready for a verdict. This is where most of the daily review happens.",
    hy: "Մերչենդայզերների կետերում արված լուսանկարները ցանցի տեսքով, պատրաստ որոշման։ Այստեղ է կատարվում ամենօրյա ստուգման մեծ մասը։",
    ka: "მერჩენდაიზერების მიერ წერტილებზე გადაღებული ფოტოები ბადის სახით, გადაწყვეტილებისთვის მზად. ყოველდღიური შემოწმების უმეტესი ნაწილი აქ ხდება.",
  },
  photo_review_b1: {
    uk: "Фільтруйте за періодом (до 62 днів), регіоном, мережею, точками, мерчандайзерами, товарами й тегами. Набір фільтрів можна зберегти як шаблон.",
    en: "Filter by period (up to 62 days), county, network, points, merchandisers, products and tags. Save a filter set as a preset.",
    hy:
      "Զտեք ըստ ժամանակահատվածի (մինչև 62 օր), մարզի, ցանցի, կետերի, մերչենդայզերների, ապրանքների և պիտակների։ Զտիչների հավաքածուն կարելի է պահել որպես նախապատրաստ։",
    ka:
      "გაფილტრეთ პერიოდით (62 დღემდე), რეგიონით, ქსელით, წერტილებით, მერჩენდაიზერებით, პროდუქტებითა და ტეგებით. ფილტრების ნაკრები შეგიძლიათ შაბლონად შეინახოთ.",
  },
  photo_review_b2: {
    uk: "Перемикач статусу (на перевірці, схвалено, відхилено) звужує вже завантажені фото; загальна кількість на цій сторінці не показується.",
    en: "The status segment (pending, approved, rejected) narrows the photos already loaded; this page shows no total.",
    hy: "Կարգավիճակի փոխարկիչը (սպասում է, հաստատված, մերժված) նեղացնում է արդեն բեռնված լուսանկարները. այս էջում ընդհանուր քանակը չի ցուցադրվում։",
    ka: "სტატუსის გადამრთველი (მოლოდინში, დამტკიცებული, უარყოფილი) უკვე ჩატვირთულ ფოტოებს ავიწროებს; ამ გვერდზე ჯამური რაოდენობა არ ჩანს.",
  },
  photo_review_b3: {
    uk: "Схвалюйте прямо з картки або відхиляйте з причиною. Відхилення створює для мерчандайзера коригувальну задачу.",
    en: "Approve from the card, or reject with a reason. A rejection creates a corrective task for the merchandiser.",
    hy: "Հաստատեք անմիջապես քարտից կամ մերժեք պատճառով։ Մերժումը մերչենդայզերի համար ուղղիչ առաջադրանք է ստեղծում։",
    ka: "დაამტკიცეთ პირდაპირ ბარათიდან ან უარყავით მიზეზით. უარყოფა მერჩენდაიზერს მაკორექტირებელ დავალებას უქმნის.",
  },
  photo_review_b4: {
    uk: "У переглядачі: ← → перехід між фото, A — схвалити, R — відхилити, Esc — закрити.",
    en: "In the viewer: ← → move between photos, A approves, R rejects, Esc closes.",
    hy: "Դիտիչում՝ ← → անցում լուսանկարների միջև, A՝ հաստատել, R՝ մերժել, Esc՝ փակել։",
    ka: "მნახველში: ← → ფოტოებს შორის გადასვლა, A — დამტკიცება, R — უარყოფა, Esc — დახურვა.",
  },
  photo_review_b5: {
    uk: "Виділіть кілька фото, щоб схвалити, відхилити або завантажити їх разом. Друк і «Завантажити все» — у заголовку сторінки.",
    en: "Select several photos to approve, reject or download them together. Print and Download all are in the page head.",
    hy: "Ընտրեք մի քանի լուսանկար՝ միասին հաստատելու, մերժելու կամ ներբեռնելու համար։ Տպելը և «Ներբեռնել բոլորը» գտնվում են էջի վերնագրում։",
    ka: "მონიშნეთ რამდენიმე ფოტო ერთად დამტკიცების, უარყოფის ან ჩამოტვირთვისთვის. ბეჭდვა და «ყველას ჩამოტვირთვა» გვერდის სათაურშია.",
  },

  visits_desc: {
    uk: "Усі візити мерчандайзерів з рішенням по кожному. Відкрийте візит, щоб переглянути все зібране під час нього в одному робочому просторі.",
    en: "Every visit a merchandiser made, with its verdict. Open one to review everything collected during it in a single workspace.",
    hy: "Մերչենդայզերների բոլոր այցերը՝ յուրաքանչյուրի որոշմամբ։ Բացեք այցը՝ դրա ընթացքում հավաքված ամեն ինչ մեկ աշխատանքային տարածքում դիտելու համար։",
    ka: "მერჩენდაიზერების ყველა ვიზიტი თითოეულის გადაწყვეტილებით. გახსენით ვიზიტი, რომ მის დროს შეგროვებული ყველაფერი ერთ სამუშაო სივრცეში ნახოთ.",
  },
  visits_b1: {
    uk:
      "Фільтруйте за періодом (за початком візиту), регіоном, мережею, мерчандайзерами, супервайзерами й точками. Перемикач статусу розділяє «на перевірці», «схвалено» й «відхилено».",
    en:
      "Filter by period (matched on the visit start), county, network, merchandisers, supervisors and points. The status segment splits pending, approved and rejected.",
    hy:
      "Զտեք ըստ ժամանակահատվածի (այցի սկզբով), մարզի, ցանցի, մերչենդայզերների, սուպերվայզերների և կետերի։ Կարգավիճակի փոխարկիչը բաժանում է սպասող, հաստատված և մերժված այցերը։",
    ka:
      "გაფილტრეთ პერიოდით (ვიზიტის დაწყებით), რეგიონით, ქსელით, მერჩენდაიზერებით, სუპერვაიზერებითა და წერტილებით. სტატუსის გადამრთველი ყოფს მოლოდინში, დამტკიცებულ და უარყოფილ ვიზიტებს.",
  },
  visits_b2: {
    uk: "Схвалюйте чи відхиляйте з меню рядка або кілька одразу з панелі, що зʼявляється під виділенням.",
    en: "Approve or reject from the row menu, or several at once from the bar that appears under a selection.",
    hy: "Հաստատեք կամ մերժեք տողի ընտրացանկից, կամ մի քանիսը միասին՝ ընտրության տակ հայտնվող վահանակից։",
    ka: "დაამტკიცეთ ან უარყავით სტრიქონის მენიუდან, ან რამდენიმე ერთდროულად მონიშვნის ქვეშ გამოჩენილი პანელიდან.",
  },
  visits_b3: {
    uk:
      "Сторінка візиту відкривається чергою «Потребує вашої уваги» з усім ще не вирішеним, далі — по одному розділу: замовлення, повернення, оплати, фотозвіти, задачі, моніторинг цін, опитування, GPS-трек, журнал.",
    en:
      "The visit page opens with a «Needs your attention» queue of everything still undecided, then one section at a time: orders, returns, payments, photo reports, tasks, price monitoring, surveys, GPS track, log.",
    hy:
      "Այցի էջը բացվում է «Ձեր ուշադրության կարիքն ունի» հերթով՝ դեռ չորոշվածով, ապա մեկ բաժին միաժամանակ՝ պատվերներ, վերադարձներ, վճարումներ, լուսանկարների հաշվետվություններ, առաջադրանքներ, գների մոնիտորինգ, հարցումներ, GPS հետագիծ, մատյան։",
    ka:
      "ვიზიტის გვერდი იხსნება «თქვენს ყურადღებას საჭიროებს» რიგით, სადაც ყველა გადაუწყვეტელია, შემდეგ თითო სექცია: შეკვეთები, დაბრუნებები, გადახდები, ფოტოანგარიშები, დავალებები, ფასების მონიტორინგი, გამოკითხვები, GPS ტრეკი, ჟურნალი.",
  },
  visits_b4: {
    uk: "Клавіші [ і ] переходять до попереднього й наступного візиту у відфільтрованому списку без повернення назад.",
    en: "The [ and ] keys step to the previous and next visit in the filtered list without going back.",
    hy: "[ և ] ստեղները անցնում են զտված ցուցակի նախորդ և հաջորդ այցին՝ առանց հետ վերադառնալու։",
    ka: "[ და ] კლავიშები გაფილტრულ სიაში წინა და შემდეგ ვიზიტზე გადადის უკან დაბრუნების გარეშე.",
  },

  tracking_desc: {
    uk:
      "Де сьогодні команда — за даними візитів. Позиція — це точка відкритого візиту, а не GPS у реальному часі, тому вона така ж свіжа, як останнє відкриття чи закриття візиту.",
    en:
      "Where the team is today, from visit data. A position is the point of an open visit, not a live GPS fix, so it is as fresh as the last visit opened or closed.",
    hy:
      "Որտեղ է թիմն այսօր՝ ըստ այցերի տվյալների։ Դիրքը բաց այցի կետն է, ոչ թե իրական ժամանակի GPS, այնպես որ այն նույնքան թարմ է, որքան այցի վերջին բացումը կամ փակումը։",
    ka:
      "სად არის გუნდი დღეს — ვიზიტების მონაცემებით. პოზიცია ღია ვიზიტის წერტილია და არა რეალურ დროში GPS, ამიტომ ის იმდენად ახალია, რამდენადაც ვიზიტის ბოლო გახსნა ან დახურვა.",
  },
  tracking_b1: {
    uk: "Чотири стани, найважливіші вгорі: у візиті, візит відкритий занадто довго (забули закрити), між візитами, без візитів сьогодні.",
    en: "Four states, most urgent on top: in a visit, visit open too long (a forgotten close), between visits, no visits today.",
    hy: "Չորս կարգավիճակ, ամենակարևորը վերևում՝ այցի մեջ, այցը չափազանց երկար բաց է (մոռացել են փակել), այցերի միջև, այսօր այցեր չկան։",
    ka: "ოთხი მდგომარეობა, ყველაზე მნიშვნელოვანი ზემოთ: ვიზიტში, ვიზიტი ძალიან დიდხანს ღიაა (დახურვა დაავიწყდათ), ვიზიტებს შორის, დღეს ვიზიტების გარეშე.",
  },
  tracking_b2: {
    uk: "Зелені й жовті маркери — відкриті візити, сірі — точка останнього закритого візиту.",
    en: "Green and amber pins are open visits; grey pins are the point of the last closed visit.",
    hy: "Կանաչ և դեղին քորոցները բաց այցեր են, մոխրագույնները՝ վերջին փակված այցի կետը։",
    ka: "მწვანე და ყვითელი პინები ღია ვიზიტებია, ნაცრისფერი — ბოლო დახურული ვიზიტის წერტილი.",
  },
  tracking_b3: {
    uk: "Натисніть маркер або рядок, щоб побачити день людини: візити по порядку та запланований маршрут поруч із фактичним.",
    en: "Click a pin or a row to see that person's day: the visits in order and the planned route beside the actual one.",
    hy: "Սեղմեք քորոցի կամ տողի վրա՝ մարդու օրը տեսնելու համար. այցերը հերթականությամբ և պլանավորված երթուղին փաստացիի կողքին։",
    ka: "დააწკაპუნეთ პინზე ან სტრიქონზე, რომ ადამიანის დღე ნახოთ: ვიზიტები თანმიმდევრობით და დაგეგმილი მარშრუტი ფაქტობრივის გვერდით.",
  },
  tracking_b4: {
    uk: "Сьогоднішній день оновлюється щохвилини; ваш масштаб і положення карти зберігаються. Інший день обирайте в календарі.",
    en: "Today refreshes every minute; your pan and zoom are kept. Pick another day with the date picker.",
    hy: "Այսօրվա օրը թարմացվում է ամեն րոպե, ձեր մասշտաբը և քարտեզի դիրքը պահպանվում են։ Այլ օր ընտրեք օրացույցում։",
    ka: "დღევანდელი დღე ყოველ წუთს ახლდება; თქვენი მასშტაბი და რუკის პოზიცია ინახება. სხვა დღე კალენდარში აირჩიეთ.",
  },

  bi_reports_desc: {
    uk: "Дашборди Power BI, підготовлені для вашої компанії, вбудовані в застосунок.",
    en: "Power BI dashboards prepared for your company, embedded in the app.",
    hy: "Ձեր ընկերության համար պատրաստված Power BI դաշբորդներ՝ ներկառուցված հավելվածում։",
    ka: "თქვენი კომპანიისთვის მომზადებული Power BI დეშბორდები, აპლიკაციაში ჩაშენებული.",
  },
  bi_reports_b1: {
    uk: "Одночасно відкритий один звіт; відкриття іншого закриває перший.",
    en: "One report is open at a time; opening another closes the first.",
    hy: "Միաժամանակ բաց է մեկ հաշվետվություն, մյուսը բացելը փակում է առաջինը։",
    ka: "ერთდროულად ერთი ანგარიშია ღია; მეორის გახსნა პირველს ხურავს.",
  },
  bi_reports_b2: {
    uk: "«Відкрити в новій вкладці» показує звіт на весь екран.",
    en: "«Open in new tab» shows the report full-size.",
    hy: "«Բացել նոր ներդիրում» ցույց է տալիս հաշվետվությունը լիաէկրան։",
    ka: "«ახალ ჩანართში გახსნა» ანგარიშს სრულ ზომაში აჩვენებს.",
  },
  bi_reports_b3: {
    uk: "Відкритий звіт зберігається в адресному рядку, тож оновлення сторінки й «Назад» повертають до нього.",
    en: "The open report is kept in the address bar, so reload and Back return to it.",
    hy: "Բաց հաշվետվությունը պահվում է հասցեի տողում, այնպես որ վերաբեռնումը և «Հետ»-ը վերադարձնում են դրան։",
    ka: "ღია ანგარიში მისამართის ველში ინახება, ასე რომ განახლება და «უკან» მასზე აბრუნებს.",
  },

  tasks_desc: {
    uk:
      "Що мерчандайзери мають зробити в точках і чим завершилося кожне доручення. На задачу відповідають із мобільного застосунку, і статус визначає найновіша відповідь.",
    en:
      "What merchandisers are asked to do at points, and how each request ended. A task is answered from the mobile app, and the newest answer decides its status.",
    hy:
      "Ինչ պետք է անեն մերչենդայզերները կետերում և ինչպես ավարտվեց յուրաքանչյուր հանձնարարություն։ Առաջադրանքին պատասխանում են բջջային հավելվածից, և կարգավիճակը որոշում է ամենավերջին պատասխանը։",
    ka:
      "რა უნდა გააკეთონ მერჩენდაიზერებმა წერტილებზე და როგორ დასრულდა თითოეული დავალება. დავალებას მობილური აპლიკაციიდან პასუხობენ და სტატუსს უახლესი პასუხი განსაზღვრავს.",
  },
  tasks_b1: {
    uk: "Чотири статуси: очікує відповіді, на перевірці, схвалено, відхилено. Мітки додають «Просрочені», «З негативними відповідями» та «Неактивні».",
    en: "Four statuses: awaiting an answer, on review, approved, rejected. Chips add Overdue, With negative answers and Inactive.",
    hy: "Չորս կարգավիճակ՝ սպասում է պատասխանի, ստուգման մեջ, հաստատված, մերժված։ Պիտակները ավելացնում են «Ժամկետանց», «Բացասական պատասխաններով» և «Ոչ ակտիվ»։",
    ka: "ოთხი სტატუსი: პასუხის მოლოდინში, შემოწმებაზე, დამტკიცებული, უარყოფილი. ჩიპები ამატებს «ვადაგადაცილებულს», «უარყოფითი პასუხებით» და «არააქტიურს».",
  },
  tasks_b2: {
    uk: "Нова задача — для однієї точки, цілої мережі (по задачі на кожну її точку) або групи точок. Шаблон визначає, що саме запитують у мерчандайзера.",
    en: "New task targets one point, a whole network (one task per point in it) or a point group. The template decides what the merchandiser is asked for.",
    hy:
      "Նոր առաջադրանքը մեկ կետի, ամբողջ ցանցի (յուրաքանչյուր կետի համար մեկ առաջադրանք) կամ կետերի խմբի համար է։ Ձևանմուշը որոշում է, թե ինչ է պահանջվում մերչենդայզերից։",
    ka:
      "ახალი დავალება ერთი წერტილისთვის, მთელი ქსელისთვის (თითო დავალება მის ყოველ წერტილზე) ან წერტილების ჯგუფისთვის. შაბლონი განსაზღვრავს, რას სთხოვენ მერჩენდაიზერს.",
  },
  tasks_b3: {
    uk: "Період фільтрує за дедлайном, за замовчуванням — тиждень назад і тиждень уперед.",
    en: "The period filters by deadline and defaults to a week back and a week ahead.",
    hy: "Ժամանակահատվածը զտում է վերջնաժամկետով, լռելյայն՝ մեկ շաբաթ առաջ և մեկ շաբաթ հետո։",
    ka: "პერიოდი ვადის მიხედვით ფილტრავს, ნაგულისხმევად — კვირა უკან და კვირა წინ.",
  },
  tasks_b4: {
    uk: "Задачу деактивують, а не видаляють. На сторінці задачі можна схвалити чи відхилити останню відповідь і змінити опис, дати, шаблон і зображення.",
    en: "A task is deactivated, never deleted. On the task page you approve or reject its newest answer and edit the description, dates, template and images.",
    hy:
      "Առաջադրանքը ապաակտիվացվում է, ոչ թե ջնջվում։ Առաջադրանքի էջում կարելի է հաստատել կամ մերժել վերջին պատասխանը և փոխել նկարագրությունը, ամսաթվերը, ձևանմուշը և պատկերները։",
    ka:
      "დავალება დეაქტივირდება და არა იშლება. დავალების გვერდზე შეგიძლიათ დაამტკიცოთ ან უარყოთ უახლესი პასუხი და შეცვალოთ აღწერა, თარიღები, შაბლონი და სურათები.",
  },

  answers_desc: {
    uk: "Усі відповіді мерчандайзерів на задачі — як черга на ваше рішення.",
    en: "Every answer merchandisers gave to tasks, as a queue for your verdict.",
    hy: "Մերչենդայզերների բոլոր պատասխանները առաջադրանքներին՝ որպես հերթ ձեր որոշման համար։",
    ka: "მერჩენდაიზერების ყველა პასუხი დავალებებზე — რიგი თქვენი გადაწყვეტილებისთვის.",
  },
  answers_b1: {
    uk: "Фільтруйте за періодом, регіоном, мережею, шаблоном, мерчандайзером, супервайзером і точками; мітка «Негативні» залишає лише негативні відповіді.",
    en: "Filter by period, county, network, template, merchandiser, supervisor and points; the Negative chip keeps only negative answers.",
    hy: "Զտեք ըստ ժամանակահատվածի, մարզի, ցանցի, ձևանմուշի, մերչենդայզերի, սուպերվայզերի և կետերի. «Բացասական» պիտակը թողնում է միայն բացասական պատասխանները։",
    ka: "გაფილტრეთ პერიოდით, რეგიონით, ქსელით, შაბლონით, მერჩენდაიზერით, სუპერვაიზერითა და წერტილებით; «უარყოფითი» ჩიპი მხოლოდ უარყოფით პასუხებს ტოვებს.",
  },
  answers_b2: {
    uk: "Відкрийте відповідь, щоб побачити фото, що запитували і що надійшло, з посиланнями на задачу та візит.",
    en: "Open an answer to see the photos, what was asked and what came back, with links to the task and the visit.",
    hy: "Բացեք պատասխանը՝ լուսանկարները, հարցվածը և ստացվածը տեսնելու համար, առաջադրանքի և այցի հղումներով։",
    ka: "გახსენით პასუხი, რომ ნახოთ ფოტოები, რა იკითხეს და რა მოვიდა, დავალებისა და ვიზიტის ბმულებით.",
  },
  answers_b3: {
    uk: "Схвалюйте або відхиляйте з причиною; відхилення створює коригувальну задачу. Зі списку можна схвалити кілька відповідей одразу.",
    en: "Approve, or reject with a reason; a rejection creates a corrective task. From the list, several answers can be approved at once.",
    hy: "Հաստատեք կամ մերժեք պատճառով. մերժումը ուղղիչ առաջադրանք է ստեղծում։ Ցուցակից կարելի է մի քանի պատասխան միասին հաստատել։",
    ka: "დაამტკიცეთ ან უარყავით მიზეზით; უარყოფა მაკორექტირებელ დავალებას ქმნის. სიიდან რამდენიმე პასუხის ერთდროულად დამტკიცება შეიძლება.",
  },
  answers_b4: {
    uk: "[ і ] переходять по черзі; після рішення наступна відповідь відкривається сама.",
    en: "[ and ] step through the queue; after a verdict the next answer opens by itself.",
    hy: "[ և ] անցնում են հերթով, որոշումից հետո հաջորդ պատասխանն ինքն է բացվում։",
    ka: "[ და ] რიგში გადადის; გადაწყვეტილების შემდეგ შემდეგი პასუხი თავად იხსნება.",
  },

  import_title: { uk: "Імпорт і завантаження", en: "Import and uploads", hy: "Ներմուծում և բեռնումներ", ka: "იმპორტი და ატვირთვები" },
  import_desc: {
    uk:
      "Створюйте багато задач або асортиментну матрицю з файлу замість того, щоб робити це по одній. Результат кожного пакета — на сторінці «Мої завантаження».",
    en: "Create many tasks or an assortment matrix from a file instead of one by one. The result of each batch lives on My uploads.",
    hy: "Ստեղծեք բազմաթիվ առաջադրանքներ կամ տեսականու մատրիցա ֆայլից՝ մեկ-մեկ անելու փոխարեն։ Յուրաքանչյուր փաթեթի արդյունքը «Իմ բեռնումները» էջում է։",
    ka: "შექმენით ბევრი დავალება ან ასორტიმენტის მატრიცა ფაილიდან სათითაოს ნაცვლად. თითოეული პაკეტის შედეგი «ჩემი ატვირთვები» გვერდზეა.",
  },
  import_b1: {
    uk: "Три види: задачі зі спільною точкою чи мережею, задачі з точкою чи мережею в кожному рядку та асортиментна матриця.",
    en: "Three kinds: tasks with one shared point or network, tasks with the point or network in each row, and an assortment matrix.",
    hy: "Երեք տեսակ՝ առաջադրանքներ ընդհանուր կետով կամ ցանցով, առաջադրանքներ յուրաքանչյուր տողում կետով կամ ցանցով, և տեսականու մատրիցա։",
    ka: "სამი სახეობა: დავალებები საერთო წერტილით ან ქსელით, დავალებები ყოველ სტრიქონში წერტილით ან ქსელით, და ასორტიმენტის მატრიცა.",
  },
  import_b2: {
    uk: "CSV і XLSX читаються в браузері; кожен рядок перевіряється на форму, і надсилаються лише коректні. Коди точок, товарів і шаблонів перевіряє сервер.",
    en:
      "CSV and XLSX are read in the browser; each row is checked for shape and only valid rows are sent. Codes of points, products and templates are checked by the server.",
    hy:
      "CSV և XLSX ֆայլերը կարդացվում են բրաուզերում, յուրաքանչյուր տողը ստուգվում է ձևով, և ուղարկվում են միայն վավեր տողերը։ Կետերի, ապրանքների և ձևանմուշների կոդերը ստուգում է սերվերը։",
    ka:
      "CSV და XLSX ბრაუზერში იკითხება; ყოველი სტრიქონი ფორმით მოწმდება და მხოლოდ სწორი იგზავნება. წერტილების, პროდუქტებისა და შაბლონების კოდებს სერვერი ამოწმებს.",
  },
  import_b3: {
    uk:
      "Обробка асинхронна: після надсилання ви потрапляєте на «Мої завантаження», де сторінка оновлюється, поки пакет обробляється, а потім показує його журнал.",
    en: "Processing is asynchronous: after submitting you land on My uploads, which refreshes while the batch is pending and then shows its logs.",
    hy:
      "Մշակումը ասինխրոն է. ուղարկելուց հետո հայտնվում եք «Իմ բեռնումները» էջում, որը թարմացվում է, մինչ փաթեթը սպասման մեջ է, ապա ցույց է տալիս դրա մատյանը։",
    ka:
      "დამუშავება ასინქრონულია: გაგზავნის შემდეგ «ჩემი ატვირთვები» გვერდზე ხვდებით, რომელიც ახლდება, სანამ პაკეტი მოლოდინშია, შემდეგ კი მის ჟურნალს აჩვენებს.",
  },
  import_b4: {
    uk: "«Видалити дані» прибирає все, що створив пакет. «Завантажити шаблон» дає очікувані колонки з рядком-прикладом.",
    en: "Delete data removes everything a batch created. Download template gives the expected columns with an example row.",
    hy: "«Ջնջել տվյալները» հեռացնում է փաթեթի ստեղծած ամեն ինչ։ «Ներբեռնել ձևանմուշը» տալիս է սպասվող սյունակները օրինակ տողով։",
    ka: "«მონაცემების წაშლა» შლის ყველაფერს, რაც პაკეტმა შექმნა. «შაბლონის ჩამოტვირთვა» მოსალოდნელ სვეტებს მაგალითის სტრიქონით იძლევა.",
  },

  merchandisers_desc: {
    uk: "Ваша команда: хто доступний, хто новачок, у кого немає точок, а також маршрути, точки, візити й відсутності кожного.",
    en: "Your team: who is available, who is new, who has no points to visit, and each person's routes, points, visits and absences.",
    hy: "Ձեր թիմը՝ ով է հասանելի, ով է նորեկ, ով կետեր չունի, ինչպես նաև յուրաքանչյուրի երթուղիները, կետերը, այցերը և բացակայությունները։",
    ka: "თქვენი გუნდი: ვინ არის ხელმისაწვდომი, ვინ არის ახალი, ვის არ აქვს წერტილები, და თითოეულის მარშრუტები, წერტილები, ვიზიტები და გაცდენები.",
  },
  merchandisers_b1: {
    uk: "Мітки «Відсутні сьогодні», «Новачки» й «Без точок»; перемикач розділяє активних і неактивних.",
    en: "Chips for Absent today, Newbie and No points; the segment splits active and inactive.",
    hy: "«Այսօր բացակա», «Նորեկ» և «Կետեր չկան» պիտակներ. փոխարկիչը բաժանում է ակտիվ և ոչ ակտիվ։",
    ka: "ჩიპები «დღეს არ არის», «ახალბედა» და «წერტილების გარეშე»; გადამრთველი ყოფს აქტიურებსა და არააქტიურებს.",
  },
  merchandisers_b2: {
    uk: "У профілі чотири вкладки, що завантажуються по одній: «Маршрути», «Закріплення» (точки), «Візити» й «Присутність» (відсутності).",
    en: "The profile has four tabs, loaded one at a time: Routes, Assignment (points), Visits and Presence (absences).",
    hy: "Պրոֆիլն ունի չորս ներդիր, որոնք բեռնվում են մեկ-մեկ՝ Երթուղիներ, Ամրագրում (կետեր), Այցեր և Ներկայություն (բացակայություններ)։",
    ka: "პროფილს ოთხი ჩანართი აქვს, სათითაოდ ჩატვირთული: მარშრუტები, მიმაგრება (წერტილები), ვიზიტები და დასწრება (გაცდენები).",
  },
  merchandisers_b3: {
    uk: "Маршрути — три шари на календарі: тижнева основа, додаткові точки в N-й день тижня місяця та разові точки на конкретну дату.",
    en: "Routes are three layers on a calendar: a weekly base, extras on the Nth weekday of a month, and one-off stops on a single date.",
    hy: "Երթուղիները օրացույցի երեք շերտ են՝ շաբաթական հիմք, հավելյալ կետեր ամսվա N-րդ շաբաթվա օրը և միանգամյա կետեր կոնկրետ ամսաթվի։",
    ka: "მარშრუტები კალენდარზე სამი ფენაა: კვირეული საფუძველი, დამატებითი წერტილები თვის N-ე კვირის დღეს და ერთჯერადი წერტილები კონკრეტულ თარიღზე.",
  },
  merchandisers_b4: {
    uk: "Додайте відсутність із причиною, редагуйте профіль, деактивуйте чи активуйте. «Новий мерчандайзер» створює обліковий запис.",
    en: "Add an absence with a reason, edit the profile, deactivate or activate. New merchandiser creates an account.",
    hy: "Ավելացրեք բացակայություն պատճառով, խմբագրեք պրոֆիլը, ապաակտիվացրեք կամ ակտիվացրեք։ «Նոր մերչենդայզեր»-ը հաշիվ է ստեղծում։",
    ka: "დაამატეთ გაცდენა მიზეზით, დაარედაქტირეთ პროფილი, დეაქტივირეთ ან გააქტიურეთ. «ახალი მერჩენდაიზერი» ანგარიშს ქმნის.",
  },

  supervisors_desc: {
    uk: "Хто за що відповідає: регіон, точки й команда кожного супервайзера.",
    en: "Who covers what: each supervisor's county, points and team.",
    hy: "Ով ինչի համար է պատասխանատու՝ յուրաքանչյուր սուպերվայզերի մարզը, կետերը և թիմը։",
    ka: "ვინ რაზეა პასუხისმგებელი: თითოეული სუპერვაიზერის რეგიონი, წერტილები და გუნდი.",
  },
  supervisors_b1: {
    uk: "Фільтруйте за регіоном; мітка «Без точок» знаходить супервайзерів, які ні за що не відповідають.",
    en: "Filter by county; the No points chip finds supervisors responsible for nothing.",
    hy: "Զտեք ըստ մարզի. «Կետեր չկան» պիտակը գտնում է ոչնչի համար պատասխանատու չհանդիսացող սուպերվայզերներին։",
    ka: "გაფილტრეთ რეგიონით; «წერტილების გარეშე» ჩიპი პოულობს სუპერვაიზერებს, რომლებიც არაფერზე არიან პასუხისმგებელი.",
  },
  supervisors_b2: {
    uk: "У профілі вкладки «Точки» й «Команда» додають або прибирають точки й мерчандайзерів. Додавання ніколи не замінює вже закріплене.",
    en: "On the profile, the Points and Team tabs add or remove points and merchandisers. Adding never replaces what is already assigned.",
    hy: "Պրոֆիլում «Կետեր» և «Թիմ» ներդիրները ավելացնում կամ հեռացնում են կետեր և մերչենդայզերներ։ Ավելացումը երբեք չի փոխարինում արդեն ամրագրվածը։",
    ka: "პროფილში «წერტილები» და «გუნდი» ჩანართები ამატებს ან შლის წერტილებსა და მერჩენდაიზერებს. დამატება არასდროს ცვლის უკვე მიმაგრებულს.",
  },
  supervisors_b3: {
    uk: "Деактивуйте чи активуйте супервайзера зі списку або профілю. Облікові записи тут не створюються.",
    en: "Deactivate or activate a supervisor from the list or the profile. Accounts are not created here.",
    hy: "Ապաակտիվացրեք կամ ակտիվացրեք սուպերվայզերին ցուցակից կամ պրոֆիլից։ Հաշիվներ այստեղ չեն ստեղծվում։",
    ka: "დეაქტივირეთ ან გააქტიურეთ სუპერვაიზერი სიიდან ან პროფილიდან. ანგარიშები აქ არ იქმნება.",
  },

  documents_desc: {
    uk: "Спільні файли компанії: інструкції, планограми, прайси.",
    en: "Shared files for the company: instructions, planograms, price lists.",
    hy: "Ընկերության ընդհանուր ֆայլեր՝ հրահանգներ, պլանոգրամներ, գնացուցակներ։",
    ka: "კომპანიის საზიარო ფაილები: ინსტრუქციები, პლანოგრამები, ფასების სიები.",
  },
  documents_b1: {
    uk: "«Додати файл» завантажує один файл із назвою; шукайте й сортуйте за назвою або датою.",
    en: "Add file uploads one file with a name; search and sort by name or date.",
    hy: "«Ավելացնել ֆայլ»-ը բեռնում է մեկ ֆայլ անվանումով, որոնեք և դասավորեք ըստ անվան կամ ամսաթվի։",
    ka: "«ფაილის დამატება» ერთ ფაილს სახელით ტვირთავს; მოძებნეთ და დაალაგეთ სახელით ან თარიღით.",
  },
  documents_b2: {
    uk: "Кнопка відкриття в рядку відкриває файл у новій вкладці; сам рядок не є посиланням.",
    en: "The open button on a row opens the file in a new tab; the row itself is not a link.",
    hy: "Տողի բացելու կոճակը բացում է ֆայլը նոր ներդիրում, տողն ինքը հղում չէ։",
    ka: "სტრიქონის გახსნის ღილაკი ფაილს ახალ ჩანართში ხსნის; თავად სტრიქონი ბმული არ არის.",
  },
  documents_b3: {
    uk: "Документи також зʼявляються в глобальному пошуку.",
    en: "Documents also appear in global search.",
    hy: "Փաստաթղթերը հայտնվում են նաև ընդհանուր որոնման մեջ։",
    ka: "დოკუმენტები გლობალურ ძიებაშიც ჩანს.",
  },

  surveys_desc: {
    uk: "Анкети, які мерчандайзери заповнюють у точках під час візиту: що запитувати, у кого і коли.",
    en: "Questionnaires merchandisers fill in at points during a visit: what to ask, whom to ask, and when.",
    hy: "Հարցաթերթիկներ, որոնք մերչենդայզերները լրացնում են կետերում այցի ընթացքում՝ ինչ հարցնել, ում և երբ։",
    ka: "კითხვარები, რომლებსაც მერჩენდაიზერები ვიზიტის დროს წერტილებზე ავსებენ: რა ვკითხოთ, ვის და როდის.",
  },
  surveys_b1: {
    uk: "Опитування має назву, період дії та аудиторію: точки, групи точок або мережі.",
    en: "A survey has a title, an active period and an audience: points, point groups or networks.",
    hy: "Հարցումն ունի վերնագիր, գործողության ժամանակահատված և լսարան՝ կետեր, կետերի խմբեր կամ ցանցեր։",
    ka: "გამოკითხვას აქვს სათაური, მოქმედების პერიოდი და აუდიტორია: წერტილები, წერტილების ჯგუფები ან ქსელები.",
  },
  surveys_b2: {
    uk: "Запитання додаються в редакторі, кожне зі своїм типом, обовʼязковістю, пріоритетом і власним таргетингом.",
    en: "Questions are added in the editor, each with its type, required flag, priority and its own targeting.",
    hy: "Հարցերն ավելացվում են խմբագրիչում, յուրաքանչյուրը իր տեսակով, պարտադիր լինելով, առաջնահերթությամբ և սեփական թիրախավորմամբ։",
    ka: "კითხვები რედაქტორში ემატება, თითოეული თავისი ტიპით, სავალდებულოობით, პრიორიტეტითა და საკუთარი მიზნობრიობით.",
  },
  surveys_b3: {
    uk: "Архівуйте завершене опитування; «Відновити» повертає його.",
    en: "Archive a survey that is over; Restore brings it back.",
    hy: "Արխիվացրեք ավարտված հարցումը, «Վերականգնել»-ը վերադարձնում է այն։",
    ka: "დაარქივეთ დასრულებული გამოკითხვა; «აღდგენა» მას აბრუნებს.",
  },
  surveys_b4: {
    uk: "Відповіді зʼявляються в розділі «Опитування» візиту та в картці активності опитувань на Огляді.",
    en: "Answers appear in the visit's Surveys section and in the survey activity card on Overview.",
    hy: "Պատասխանները հայտնվում են այցի «Հարցումներ» բաժնում և Ակնարկի հարցումների ակտիվության քարտում։",
    ka: "პასუხები ჩანს ვიზიტის «გამოკითხვები» სექციაში და მიმოხილვის გამოკითხვების აქტივობის ბარათზე.",
  },

  reference_title: { uk: "Точки та довідники", en: "Points and reference data", hy: "Կետեր և տեղեկատու տվյալներ", ka: "წერტილები და საცნობარო მონაცემები" },
  reference_desc: {
    uk:
      "Точки, мережі, категорії, країни, регіони, населені пункти й групи точок мають спільний список і редактор. Для точок є додаткові інструменти якості даних.",
    en:
      "Points, networks, categories, countries, counties, localities and point groups share one list and one editor. Points get extra tools for data quality.",
    hy:
      "Կետերը, ցանցերը, կատեգորիաները, երկրները, մարզերը, բնակավայրերը և կետերի խմբերը ունեն ընդհանուր ցուցակ և խմբագրիչ։ Կետերի համար կան տվյալների որակի հավելյալ գործիքներ։",
    ka:
      "წერტილებს, ქსელებს, კატეგორიებს, ქვეყნებს, რეგიონებს, დასახლებებსა და წერტილების ჯგუფებს საერთო სია და რედაქტორი აქვს. წერტილებს მონაცემთა ხარისხის დამატებითი ხელსაწყოები აქვს.",
  },
  reference_b1: {
    uk: "Точки: мітки «Без координат» (візит туди неможливо перевірити) і «Не закріплені» (ніхто не їде); перемикач розділяє активні, неактивні й архівовані.",
    en:
      "Points: chips for No coordinates (a visit there can never be verified) and Unassigned (nobody is going); the segment splits active, inactive and archived.",
    hy:
      "Կետեր՝ «Առանց կոորդինատների» (այնտեղ այցը հնարավոր չէ ստուգել) և «Չամրագրված» (ոչ ոք չի գնում) պիտակներ. փոխարկիչը բաժանում է ակտիվ, ոչ ակտիվ և արխիվացված։",
    ka:
      "წერტილები: ჩიპები «კოორდინატების გარეშე» (იქ ვიზიტი ვერ შემოწმდება) და «მიუმაგრებელი» (არავინ მიდის); გადამრთველი ყოფს აქტიურს, არააქტიურსა და დაარქივებულს.",
  },
  reference_b2: {
    uk: "У редакторі точки перетягніть маркер або натисніть на карту, щоб задати координати; масштабуйте кнопками.",
    en: "In the point editor, drag the pin or click the map to set coordinates; zoom with the buttons.",
    hy: "Կետի խմբագրիչում քաշեք քորոցը կամ սեղմեք քարտեզի վրա՝ կոորդինատները սահմանելու համար, մասշտաբավորեք կոճակներով։",
    ka: "წერტილის რედაქტორში გადაათრიეთ პინი ან დააწკაპუნეთ რუკაზე კოორდინატების დასაყენებლად; მასშტაბი ღილაკებით შეცვალეთ.",
  },
  reference_b3: {
    uk: "Виділіть точки й натисніть «Додати в групу», щоб додати їх до наявної або нової групи. Склад групи доповнюється, а не замінюється.",
    en: "Select points and use Add to group to put them in an existing or new group. Membership is merged, never replaced.",
    hy: "Ընտրեք կետերը և օգտագործեք «Ավելացնել խմբում»՝ դրանք գոյություն ունեցող կամ նոր խմբում տեղադրելու համար։ Խմբի կազմը լրացվում է, ոչ թե փոխարինվում։",
    ka: "მონიშნეთ წერტილები და გამოიყენეთ «ჯგუფში დამატება» არსებულ ან ახალ ჯგუფში ჩასამატებლად. ჯგუფის შემადგენლობა ივსება და არა იცვლება.",
  },
  reference_b4: {
    uk:
      "Кожен редактор має картку «Якість даних» зі списком того, чого не вистачає; натискання переводить фокус на поле. Ці списки запамʼятовують фільтри окремо, а не в адресному рядку.",
    en:
      "Each editor shows a Data quality card listing what is missing; clicking an item focuses the field. These lists remember their filters per list rather than in the address bar.",
    hy:
      "Յուրաքանչյուր խմբագրիչ ունի «Տվյալների որակ» քարտ, որտեղ նշված է, թե ինչ է բացակայում. սեղմելը կենտրոնացնում է դաշտը։ Այս ցուցակները զտիչները հիշում են առանձին, ոչ թե հասցեի տողում։",
    ka:
      "თითოეულ რედაქტორს აქვს «მონაცემთა ხარისხი» ბარათი, სადაც ჩანს, რა აკლია; დაწკაპუნება ველზე ფოკუსს გადაიტანს. ეს სიები ფილტრებს ცალკე იმახსოვრებს და არა მისამართის ველში.",
  },
};

/* Orders — read-only Sales section: the /sales/orders list and the /sales/orders/:id detail page.

   Deliberately no cross-reference to VISIT_PAGE's `orders_popup_*` / `order_status_*` keys, even
   where the words match: those were written for the visit's collapsed, nested order section, not
   a standalone record page with its own full field set — the two are free to diverge in wording,
   so they get their own keys here rather than sharing one that would drag one page's copy change
   into the other. */
export const ORDERS_PAGE = {
  list_title: {
    uk: "Замовлення",
    en: "Orders",
    hy: "Պատվերներ",
    ka: "შეკვეთები",
  },
  retry: {
    uk: "Спробувати ще",
    en: "Try again",
    hy: "Կրկին փորձել",
    ka: "ხელახლა ცდა",
  },
  error_title: {
    uk: "Не вдалося завантажити замовлення.",
    en: "Couldn't load the order.",
    hy: "Չհաջողվեց բեռնել պատվերը։",
    ka: "შეკვეთის ჩატვირთვა ვერ მოხერხდა.",
  },
  not_found_title: {
    uk: "Замовлення не знайдено",
    en: "Order not found",
    hy: "Պատվերը չի գտնվել",
    ka: "შეკვეთა ვერ მოიძებნა",
  },
  not_found_desc: {
    uk: "Перевірте посилання або поверніться до списку замовлень.",
    en: "Check the link or go back to the orders list.",
    hy: "Ստուգեք հղումը կամ վերադարձեք պատվերների ցանկին։",
    ka: "შეამოწმეთ ბმული ან დაბრუნდით შეკვეთების სიაში.",
  },
  back_to_list: {
    uk: "До списку замовлень",
    en: "Back to orders",
    hy: "Վերադառնալ պատվերներին",
    ka: "შეკვეთებში დაბრუნება",
  },
  /* The order's groups under the items / in the page's rail. ⚠ hy / ka are machine-authored drafts. */
  sec_delivery: { uk: "Доставка", en: "Delivery", hy: "Առաքում", ka: "მიწოდება" },
  sec_details: { uk: "Деталі", en: "Details", hy: "Մանրամասներ", ka: "დეტალები" },
  sec_items: {
    uk: "Позиції",
    en: "Items",
    hy: "Ապրանքներ",
    ka: "პოზიციები",
  },
  /* The header KPI strip's compact combined label — "4 / 25" reads under it as
     items-count / units-count. */
  k_positions_units: {
    uk: "Позицій / одиниць",
    en: "Items / units",
    hy: "Ապրանքատեսակներ / միավոր",
    ka: "პოზიციები / ერთეული",
  },
  k_price_type: {
    uk: "Тип ціни",
    en: "Price type",
    hy: "Գնի տեսակ",
    ka: "ფასის ტიპი",
  },
  k_delivery_date: {
    uk: "Дата доставки",
    en: "Delivery date",
    hy: "Առաքման ամսաթիվ",
    ka: "მიწოდების თარიღი",
  },
  /* Two discounts, never one label: the order's own percentage (`discount`, a row of the general
     information) and the head tile's total — the items discount plus what a recalculation took off,
     in money and as a share. ⚠ hy / ka are machine-authored drafts. */
  k_order_discount: { uk: "Знижка на замовлення", en: "Order discount", hy: "Պատվերի զեղչ", ka: "შეკვეთის ფასდაკლება" },
  k_discount_total: { uk: "Знижка всього", en: "Total discount", hy: "Ընդհանուր զեղչ", ka: "სულ ფასდაკლება" },
  /* Deliberately names no system. `external_id` is the record's id in whatever system feeds this
     one; that it is 1C today is one deployment's detail, not a property of the field — an earlier
     "1С: …" badge both hard-coded that and shipped a Cyrillic "С" into the en/hy/ka UI. */
  k_external_id: {
    uk: "Зовнішній ID",
    en: "External ID",
    hy: "Արտաքին ID",
    ka: "გარე ID",
  },
  k_counterparty: {
    uk: "Контрагент",
    en: "Counterparty",
    hy: "Կոնտրագենտ",
    ka: "კონტრაგენტი",
  },
  k_created_by: {
    uk: "Автор",
    en: "Created by",
    hy: "Հեղինակ",
    ka: "ავტორი",
  },
  k_visit: {
    uk: "Візит",
    en: "Visit",
    hy: "Այց",
    ka: "ვიზიტი",
  },
  k_tracked_geolocation: {
    uk: "Відстежена геолокація",
    en: "Tracked geolocation",
    hy: "Հետագծված աշխարհագրական դիրք",
    ka: "თრექინგის გეოლოკაცია",
  },
  k_status_changed: {
    uk: "Статус змінено",
    en: "Status changed",
    hy: "Կարգավիճակը փոխվել է",
    ka: "სტატუსი შეიცვალა",
  },
  k_comment: {
    uk: "Коментар",
    en: "Comment",
    hy: "Մեկնաբանություն",
    ka: "კომენტარი",
  },
  k_line_no: { uk: "№", en: "No.", hy: "Հ/Հ", ka: "№" },
  k_product_name: {
    uk: "Назва",
    en: "Name",
    hy: "Անվանում",
    ka: "სახელი",
  },
  k_product_code: {
    uk: "Код",
    en: "Code",
    hy: "Կոդ",
    ka: "კოდი",
  },
  k_quantity: {
    uk: "Кількість",
    en: "Quantity",
    hy: "Քանակ",
    ka: "რაოდენობა",
  },
  k_amount: {
    uk: "Сума",
    en: "Amount",
    hy: "Գումար",
    ka: "თანხა",
  },
  /* The items table: `amount` is the UNIT price; "Сума" is amount × quantity. The note stands by the
     section title when the order was recalculated. ⚠ hy / ka are machine-authored drafts. */
  k_price: { uk: "Ціна", en: "Price", hy: "Գին", ka: "ფასი" },
  k_recalc_diff: { uk: "Перерахунок цін", en: "Price recalculation", hy: "Գների վերահաշվարկ", ka: "ფასების გადაანგარიშება" },
  k_total_due: { uk: "Всього до сплати", en: "Total due", hy: "Ընդամենը վճարման", ka: "სულ გადასახდელი" },
  k_due: { uk: "До сплати", en: "Amount due", hy: "Վճարման ենթակա", ka: "გადასახდელი" },
  k_recalc_note: { uk: "Ціни після перерахунку", en: "Prices after recalculation", hy: "Գները վերահաշվարկից հետո", ka: "ფასები გადაანგარიშების შემდეგ" },
  k_order_total: {
    uk: "Сума замовлення",
    en: "Order total",
    hy: "Պատվերի գումարը",
    ka: "შეკვეთის ჯამი",
  },
  k_items_discount: {
    uk: "Знижка на позиції",
    en: "Items discount",
    hy: "Ապրանքների զեղչ",
    ka: "პოზიციების ფასდაკლება",
  },
  k_shipping_cost: {
    uk: "Вартість доставки",
    en: "Shipping cost",
    hy: "Առաքման արժեքը",
    ka: "მიწოდების ღირებულება",
  },
  order_status_new: {
    uk: "Новий",
    en: "New",
    hy: "Նոր",
    ka: "ახალი",
  },
  order_status_processing: {
    uk: "В обробці",
    en: "Processing",
    hy: "Մշակվում է",
    ka: "მუშავდება",
  },
  order_status_sent_for_delivering: {
    uk: "Відправлено на доставку",
    en: "Sent for delivering",
    hy: "Ուղարկված է առաքման",
    ka: "გაგზავნილია მიწოდებაზე",
  },
  order_status_closed: {
    uk: "Закрито",
    en: "Closed",
    hy: "Փակված",
    ka: "დახურული",
  },
  order_status_canceled: {
    uk: "Скасовано",
    en: "Cancelled",
    hy: "Չեղարկված",
    ka: "გაუქმებული",
  },
  price_type_retail: {
    uk: "Роздрібна",
    en: "Retail",
    hy: "Մանրածախ",
    ka: "საცალო",
  },
  price_type_wholesale: {
    uk: "Оптова",
    en: "Wholesale",
    hy: "Մեծածախ",
    ka: "საბითუმო",
  },
  price_type_semi_wholesale: {
    uk: "Дрібнооптова",
    en: "Semi-wholesale",
    hy: "Կիսամեծածախ",
    ka: "წვრილბითუმი",
  },
  price_type_market_retail: {
    uk: "Ринкова роздрібна",
    en: "Market retail",
    hy: "Շուկայի մանրածախ",
    ka: "საბაზრო საცალო",
  },
  no_items: {
    uk: "Немає позицій",
    en: "No items",
    hy: "Դիրքեր չկան",
    ka: "პოზიციები არ არის",
  },
  page_sub: {
    uk: "Замовлення контрагентів, деталі та статуси",
    en: "Counterparty orders, details and statuses",
    hy: "Կոնտրագենտների պատվերները, մանրամասները և կարգավիճակները",
    ka: "კონტრაგენტების შეკვეთები, დეტალები და სტატუსები",
  },
  records_count: {
    uk: "Кількість записів",
    en: "Records",
    hy: "Գրառումների քանակ",
    ka: "ჩანაწერების რაოდენობა",
  },
  col_items_count: {
    uk: "Позицій",
    en: "Items",
    hy: "Դիրքեր",
    ka: "პოზიციები",
  },
  empty_title: {
    uk: "Замовлень немає",
    en: "No orders",
    hy: "Պատվերներ չկան",
    ka: "შეკვეთები არ არის",
  },
  empty_desc: {
    uk: "Тут ще немає жодного замовлення.",
    en: "There are no orders here yet.",
    hy: "Այստեղ դեռ պատվերներ չկան։",
    ka: "აქ ჯერ არცერთი შეკვეთა არ არის.",
  },
  rows_per_page: {
    uk: "Рядків на сторінці",
    en: "Rows per page",
    hy: "Տողեր մեկ էջում",
    ka: "სტრიქონები გვერდზე",
  },
  range_of: {
    uk: "{from}–{to} з {n}",
    en: "{from}–{to} of {n}",
    hy: "{from}–{to} {n}-ից",
    ka: "{from}–{to} {n}-დან",
  },
  copy_link_btn: {
    uk: "Копіювати посилання",
    en: "Copy link",
    hy: "Պատճենել հղումը",
    ka: "ბმულის კოპირება",
  },
  open_page_btn: {
    uk: "Відкрити сторінку",
    en: "Open page",
    hy: "Բացել էջը",
    ka: "გვერდის გახსნა",
  },
  link_copied: {
    uk: "Посилання скопійовано",
    en: "Link copied",
    hy: "Հղումը պատճենվեց",
    ka: "ბმული დაკოპირდა",
  },
  period: {
    uk: "Період",
    en: "Period",
    hy: "Ժամանակահատված",
    ka: "პერიოდი",
  },
  filter_reset: {
    uk: "Скинути фільтри",
    en: "Reset the filters",
    hy: "Զրոյացնել ֆիլտրերը",
    ka: "ფილტრების გადატვირთვა",
  },
  seg_all: {
    uk: "Усі",
    en: "All",
    hy: "Բոլորը",
    ka: "ყველა",
  },
  search_placeholder: {
    uk: "№ або контрагент",
    en: "Order No. or counterparty",
    hy: "№ կամ կոնտրագենտ",
    ka: "№ ან კონტრაგენტი",
  },
  row_actions: { uk: "Дії з рядком", en: "Row actions", hy: "Տողի գործողություններ", ka: "მწკრივის მოქმედებები" },
  geo_no_data: {
    uk: "Немає даних",
    en: "No data",
    hy: "Տվյալներ չկան",
    ka: "მონაცემები არ არის",
  },
  geo_points_count_label: {
    uk: "Точок",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  geo_fake_count_label: {
    uk: "Підроблених точок",
    en: "Fake points",
    hy: "Կեղծ կետեր",
    ka: "ყალბი წერტილები",
  },
  geo_fake_label: {
    uk: "Підроблена геолокація",
    en: "Fake geolocation",
    hy: "Կեղծ աշխարհագրական դիրք",
    ka: "ყალბი გეოლოკაცია",
  },
  geo_sending_label: {
    uk: "Надіслано",
    en: "Sent",
    hy: "Ուղարկված է",
    ka: "გაგზავნილია",
  },
  /* Describes the NUMBER, and deliberately neither the shape nor the size. Two earlier wordings
     failed on exactly that: one promised a "large marker" that measured the same 28px as its
     neighbours, the next named a rounded square that `.lf-pin--point` no longer is (it went back
     to the base circle, one step larger — see `leaflet.scss`). Of the three signals left on THIS
     map — the stops are numbered and the point is not, the fills differ, and 32px against 28px —
     the number is the strongest and the only one a silhouette or a token change cannot quietly
     invalidate. Colour is named as support, never as the only signal (spec/01).
     The subject is the PERSON, not the order: `tracked_geolocation` is what the mobile app
     recorded from the device while the order was being created, so the pins are where its holder
     was, not where the order "is". "GPS-трек" is the term `VISIT_PAGE.gps_track` already uses for
     the same thing, and "автор" is what this very page calls `created_by` — the role cannot be
     named instead, since an order can be created by a merchandiser, a sales representative or an
     order manager alike (all three appear in the data). */
  geo_map_legend: {
    uk: "Синій маркер без номера — торгова точка, пронумеровані — GPS-трек автора",
    en: "The unnumbered blue marker is the retail point; the numbered ones are the author's GPS track",
    hy: "Առանց համարի կապույտ նշիչը՝ առևտրի կետն է, համարակալվածները՝ հեղինակի GPS երթուղին",
    ka: "უნომრო ლურჯი მარკერი — სავაჭრო წერტილია, დანომრილები — ავტორის GPS ტრეკი",
  },
  /* Wording matched to `VISIT_PAGE`'s `gps_mock_warning` for consistency — same underlying signal
     (mock/fake GPS), own key per CLAUDE.md's page-scoped-copy rule. */
  geo_fake_gps_warning: {
    uk: "Виявлено ознаки підробленого GPS: позначок — {n}. Перевірте замовлення.",
    en: "Possible fake GPS detected: {n} flagged points. Review this order.",
    hy: "Հնարավոր կեղծ GPS՝ {n} նշված կետ։ Ստուգեք պատվերը։",
    ka: "შესაძლო ყალბი GPS: {n} მონიშნული წერტილი. გადაამოწმეთ შეკვეთა.",
  },
  geo_fake_badge: {
    uk: "Підроблений GPS",
    en: "Fake GPS",
    hy: "Կեղծ GPS",
    ka: "ყალბი GPS",
  },
  geo_distance_km: {
    uk: "{n} км",
    en: "{n} km",
    hy: "{n} կմ",
    ka: "{n} კმ",
  },
  geo_distance_m: {
    uk: "{n} м",
    en: "{n} m",
    hy: "{n} մ",
    ka: "{n} მ",
  },
  k_name: {
    uk: "Назва",
    en: "Name",
    hy: "Անվանում",
    ka: "სახელი",
  },
  k_address: {
    uk: "Адреса",
    en: "Address",
    hy: "Հասցե",
    ka: "მისამართი",
  },
  k_phone: {
    uk: "Телефон",
    en: "Phone",
    hy: "Հեռախոս",
    ka: "ტელეფონი",
  },
  k_remaining_funds: {
    uk: "Залишок коштів",
    en: "Remaining funds",
    hy: "Մնացորդ միջոցներ",
    ka: "დარჩენილი სახსრები",
  },
  counterparty_all_orders_btn: {
    uk: "Усі замовлення контрагента",
    en: "All orders from this counterparty",
    hy: "Կոնտրագենտի բոլոր պատվերները",
    ka: "კონტრაგენტის ყველა შეკვეთა",
  },
  columns: { uk: "Стовпці", en: "Columns", hy: "Սյունակներ", ka: "სვეტები" },
  k_point: {
    uk: "Торгова точка",
    en: "Retail point",
    hy: "Առևտրի կետ",
    ka: "სავაჭრო წერტილი",
  },
  k_supervisor: { uk: "Супервайзер", en: "Supervisor", hy: "Սուպերվայզեր", ka: "სუპერვაიზერი" },
};

/* Returns — read-only Sales section, same gate as ORDERS_PAGE ("orders" in Company.features).
   Only the two stub screens' text lives here for now; the real list/detail copy gets added
   alongside those screens, as it did for orders. */
export const RETURNS_PAGE = {
  list_title: {
    uk: "Повернення",
    en: "Returns",
    hy: "Վերադարձներ",
    ka: "დაბრუნებები",
  },
  page_sub: {
    uk: "Повернення контрагентів, деталі та статуси",
    en: "Counterparty returns, details and statuses",
    hy: "Կոնտրագենտների վերադարձները, մանրամասները և կարգավիճակները",
    ka: "კონტრაგენტების დაბრუნებები, დეტალები და სტატუსები",
  },
  records_count: {
    uk: "Кількість записів",
    en: "Records",
    hy: "Գրառումների քանակ",
    ka: "ჩანაწერების რაოდენობა",
  },
  empty_title: {
    uk: "Повернень немає",
    en: "No returns",
    hy: "Վերադարձներ չկան",
    ka: "დაბრუნებები არ არის",
  },
  empty_desc: {
    uk: "Тут ще немає жодного повернення.",
    en: "There are no returns here yet.",
    hy: "Այստեղ դեռ վերադարձներ չկան։",
    ka: "აქ ჯერ არცერთი დაბრუნება არ არის.",
  },
  rows_per_page: {
    uk: "Рядків на сторінці",
    en: "Rows per page",
    hy: "Տողեր մեկ էջում",
    ka: "სტრიქონები გვერდზე",
  },
  range_of: {
    uk: "{from}–{to} з {n}",
    en: "{from}–{to} of {n}",
    hy: "{from}–{to} {n}-ից",
    ka: "{from}–{to} {n}-დან",
  },
  period: {
    uk: "Період",
    en: "Period",
    hy: "Ժամանակահատված",
    ka: "პერიოდი",
  },
  filter_reset: {
    uk: "Скинути фільтри",
    en: "Reset the filters",
    hy: "Զրոյացնել ֆիլտրերը",
    ka: "ფილტრების გადატვირთვა",
  },
  seg_all: {
    uk: "Усі",
    en: "All",
    hy: "Բոլորը",
    ka: "ყველა",
  },
  search_placeholder: {
    uk: "№ або контрагент",
    en: "Return No. or counterparty",
    hy: "№ կամ կոնտրագենտ",
    ka: "№ ან კონტრაგენტი",
  },
  columns: { uk: "Стовпці", en: "Columns", hy: "Սյունակներ", ka: "სვეტები" },
  retry: {
    uk: "Спробувати ще",
    en: "Try again",
    hy: "Կրկին փորձել",
    ka: "ხელახლა ცდა",
  },
  error_title: {
    uk: "Не вдалося завантажити повернення.",
    en: "Couldn't load the return.",
    hy: "Չհաջողվեց բեռնել վերադարձը։",
    ka: "დაბრუნების ჩატვირთვა ვერ მოხერხდა.",
  },
  not_found_title: {
    uk: "Повернення не знайдено",
    en: "Return not found",
    hy: "Վերադարձը չի գտնվել",
    ka: "დაბრუნება ვერ მოიძებნა",
  },
  not_found_desc: {
    uk: "Перевірте посилання або поверніться до списку повернень.",
    en: "Check the link or go back to the returns list.",
    hy: "Ստուգեք հղումը կամ վերադարձեք վերադարձների ցանկին։",
    ka: "შეამოწმეთ ბმული ან დაბრუნდით დაბრუნებების სიაში.",
  },
  back_to_list: {
    uk: "До списку повернень",
    en: "Back to returns",
    hy: "Վերադառնալ վերադարձներին",
    ka: "დაბრუნებებში დაბრუნება",
  },
  /* The return's "Деталі" group under the items / in the page's rail ("Контрагент" is
     `k_counterparty`). ⚠ hy / ka are machine-authored drafts. */
  sec_details: { uk: "Деталі", en: "Details", hy: "Մանրամասներ", ka: "დეტალები" },
  k_status_changed: { uk: "Статус змінено", en: "Status changed", hy: "Կարգավիճակը փոխվել է", ka: "სტატუსი შეიცვალა" },

  sec_items: {
    uk: "Позиції",
    en: "Items",
    hy: "Ապրանքներ",
    ka: "პოზიციები",
  },
  /* Same key, same wording and same reason as `ORDERS_PAGE.k_external_id` — see the note there.
     Duplicated rather than imported: a page never reads another page's lang group (spec/04). */
  k_external_id: {
    uk: "Зовнішній ID",
    en: "External ID",
    hy: "Արտաքին ID",
    ka: "გარე ID",
  },
  k_counterparty: {
    uk: "Контрагент",
    en: "Counterparty",
    hy: "Կոնտրագենտ",
    ka: "კონტრაგენტი",
  },
  k_point: {
    uk: "Торгова точка",
    en: "Retail point",
    hy: "Առևտրի կետ",
    ka: "სავაჭრო წერტილი",
  },
  k_visit: {
    uk: "Візит",
    en: "Visit",
    hy: "Այց",
    ka: "ვიზიტი",
  },
  k_created_by: {
    uk: "Автор",
    en: "Created by",
    hy: "Հեղինակ",
    ka: "ავტორი",
  },
  k_supervisor: { uk: "Супервайзер", en: "Supervisor", hy: "Սուպերվայզեր", ka: "სუპერვაიზერი" },

  k_return_date: {
    uk: "Дата повернення",
    en: "Return date",
    hy: "Վերադարձի ամսաթիվ",
    ka: "დაბრუნების თარიღი",
  },
  k_physical_return_date: {
    uk: "Дата фактичного повернення",
    en: "Physical return date",
    hy: "Ֆիզիկական վերադարձի ամսաթիվ",
    ka: "ფაქტობრივი დაბრუნების თარიღი",
  },
  k_created: {
    uk: "Створено",
    en: "Created",
    hy: "Ստեղծված է",
    ka: "შექმნილია",
  },
  k_modified: {
    uk: "Оновлено",
    en: "Modified",
    hy: "Թարմացված է",
    ka: "განახლებულია",
  },
  k_comment: {
    uk: "Коментар",
    en: "Comment",
    hy: "Մեկնաբանություն",
    ka: "კომენტარი",
  },
  k_line_no: { uk: "№", en: "No.", hy: "Հ/Հ", ka: "№" },
  k_product_name: {
    uk: "Назва",
    en: "Name",
    hy: "Անվանում",
    ka: "სახელი",
  },
  k_product_code: {
    uk: "Код",
    en: "Code",
    hy: "Կոդ",
    ka: "კოდი",
  },
  k_quantity: {
    uk: "Кількість",
    en: "Quantity",
    hy: "Քանակ",
    ka: "რაოდენობა",
  },
  no_items: {
    uk: "Немає позицій",
    en: "No items",
    hy: "Ապրանքներ չկան",
    ka: "პოზიციები არ არის",
  },
  k_items_count: {
    uk: "Позицій",
    en: "Items",
    hy: "Ապրանքատեսակներ",
    ka: "პოზიციები",
  },
  k_units_count: {
    uk: "Одиниць",
    en: "Units",
    hy: "Միավոր",
    ka: "ერთეული",
  },
  /* The emphasized total in the items card's footer — more specific than `k_units_count`, which
     stays as the short column header on the list. Wording matches `docs/design/return-page.html`'s
     own `.totbox` exactly ("Одиниць до повернення"). */

  /* The header KPI strip's compact combined label — "4 / 11" reads under it as
     items-count / units-count. Distinct from `k_items_count` (a column header) and
     `k_units_to_return` (an emphasized total): this one names the PAIR, not either half. */
  k_positions_units: {
    uk: "Позицій / одиниць",
    en: "Items / units",
    hy: "Ապրանքատեսակներ / միավոր",
    ka: "პოზიციები / ერთეული",
  },
  k_name: {
    uk: "Назва",
    en: "Name",
    hy: "Անվանում",
    ka: "სახელი",
  },
  k_address: {
    uk: "Адреса",
    en: "Address",
    hy: "Հասցե",
    ka: "მისამართი",
  },
  /* The counterparty rail card is one shared component across both sales detail pages
     (`component/CounterpartySection.js`), but each page keeps its own copy of the strings — a page
     never reads another page's lang group, even for identical copy. Wording is therefore
     deliberately identical to `ORDERS_PAGE`'s, so the same card reads the same on both screens. */
  k_phone: {
    uk: "Телефон",
    en: "Phone",
    hy: "Հեռախոս",
    ka: "ტელეფონი",
  },
  k_remaining_funds: {
    uk: "Залишок коштів",
    en: "Remaining funds",
    hy: "Մնացորդ միջոցներ",
    ka: "დარჩენილი სახსრები",
  },
  counterparty_all_returns_btn: {
    uk: "Усі повернення контрагента",
    en: "All returns from this counterparty",
    hy: "Կոնտրագենտի բոլոր վերադարձները",
    ka: "კონტრაგენტის ყველა დაბრუნება",
  },
  copy_link_btn: {
    uk: "Копіювати посилання",
    en: "Copy link",
    hy: "Պատճենել հղումը",
    ka: "ბმულის კოპირება",
  },
  open_page_btn: {
    uk: "Відкрити сторінку",
    en: "Open page",
    hy: "Բացել էջը",
    ka: "გვერდის გახსნა",
  },
  row_actions: { uk: "Дії з рядком", en: "Row actions", hy: "Տողի գործողություններ", ka: "მწკრივის მოქმედებები" },
  link_copied: {
    uk: "Посилання скопійовано",
    en: "Link copied",
    hy: "Հղումը պատճենվեց",
    ka: "ბმული დაკოპირდა",
  },
  return_status_new: {
    uk: "Нове",
    en: "New",
    hy: "Նոր",
    ka: "ახალი",
  },
  return_status_processing: {
    uk: "В обробці",
    en: "Processing",
    hy: "Մշակվում է",
    ka: "მუშავდება",
  },
  /* Wording matched to `VISIT_PAGE`'s `order_status_sent_to_logistics` for consistency — same
     status concept, own key, per CLAUDE.md's rule for page-scoped copy (each page's strings are
     free to diverge and never cross-reference another page's group). */
  return_status_sent_to_logistics: {
    uk: "Передано в логістику",
    en: "Sent to logistics",
    hy: "Փոխանցված է լոգիստիկային",
    ka: "გადაცემულია ლოგისტიკაში",
  },
  return_status_closed: {
    uk: "Закрито",
    en: "Closed",
    hy: "Փակված",
    ka: "დახურული",
  },
  return_status_canceled: {
    uk: "Скасовано",
    en: "Cancelled",
    hy: "Չեղարկված",
    ka: "გაუქმებული",
  },
};

/* Counterparties — the read-only Excalibur counterparty list (/sales/counterparties), same gate as
   ORDERS_PAGE ("orders" in Company.features). Its own copy of the shared list strings, as every
   page keeps (see the CounterpartySection note in RETURNS_PAGE). The filter labels match
   POINTS_ADMIN's, per spec/04's terminology — County / Locality, never "region" / "city". */
export const COUNTERPARTIES_PAGE = {
  list_title: {
    uk: "Контрагенти",
    en: "Counterparties",
    hy: "Կոնտրագենտներ",
    ka: "კონტრაგენტები",
  },
  /* ⚠ hy / ka "lifecycle" reuse `k_lifecycle`'s words; the rest is the earlier reviewed copy. */
  page_sub: {
    uk: "Контрагенти: тип клієнта, життєвий цикл, супервайзер, департамент, мерчендайзери та залишок коштів",
    en: "Counterparties: client type, lifecycle, supervisor, department, merchandisers and remaining funds",
    hy: "Կոնտրագենտներ՝ հաճախորդի տեսակ, կենսացիկլ, սուպերվայզեր, դեպարտամենտ, մերչենդայզերներ և մնացորդ միջոցներ",
    ka: "კონტრაგენტები: კლიენტის ტიპი, სასიცოცხლო ციკლი, სუპერვაიზერი, დეპარტამენტი, მერჩენდაიზერები და დარჩენილი სახსრები",
  },
  /* --- Detail card (/sales/counterparties/:id). uk + en authored; hy + ka machine-generated,
     pending a native review. --- */
  tab_overview: { uk: "Огляд", en: "Overview", hy: "Ընդհանուր", ka: "მიმოხილვა" },
  tab_orders: { uk: "Замовлення", en: "Orders", hy: "Պատվերներ", ka: "შეკვეთები" },
  tab_returns: { uk: "Повернення", en: "Returns", hy: "Վերադարձեր", ka: "დაბრუნებები" },
  tab_payments: { uk: "Оплати", en: "Payments", hy: "Վճարումներ", ka: "გადახდები" },
  tab_debts: { uk: "Борги", en: "Debts", hy: "Պարտքեր", ka: "დავალიანებები" },
  tab_addresses: { uk: "Адреси", en: "Addresses", hy: "Հասցեներ", ka: "მისამართები" },
  tab_contacts: { uk: "Контакти", en: "Contacts", hy: "Կոնտակտներ", ka: "კონტაქტები" },
  tab_comments: { uk: "Коментарі", en: "Comments", hy: "Մեկնաբանություններ", ka: "კომენტარები" },
  card_back: { uk: "До списку", en: "Back to list", hy: "Վերադառնալ ցուցակ", ka: "სიაში დაბრუნება" },
  card_not_found_title: {
    uk: "Контрагента не знайдено",
    en: "Counterparty not found",
    hy: "Կոնտրագենտը չի գտնվել",
    ka: "კონტრაგენტი ვერ მოიძებნა",
  },
  card_not_found_desc: {
    uk: "Можливо, його видалено або у вас немає доступу.",
    en: "It may have been removed, or you don't have access.",
    hy: "Հնարավոր է՝ այն ջնջվել է կամ դուք մուտք չունեք։",
    ka: "შესაძლოა, ის წაშლილია ან თქვენ არ გაქვთ წვდომა.",
  },
  k_phone: { uk: "Телефон", en: "Phone", hy: "Հեռախոս", ka: "ტელეფონი" },
  /* Head actions + metrics strip. hy + ka machine-generated, pending native review (as above). */
  card_copy_link: { uk: "Копіювати посилання", en: "Copy link", hy: "Պատճենել հղումը", ka: "ბმულის კოპირება" },
  card_copied: { uk: "Посилання скопійовано", en: "Link copied", hy: "Հղումը պատճենվեց", ka: "ბმული დაკოპირდა" },
  card_copy_error: {
    uk: "Не вдалося скопіювати посилання",
    en: "Couldn't copy the link",
    hy: "Չհաջողվեց պատճենել հղումը",
    ka: "ბმულის კოპირება ვერ მოხერხდა",
  },
  m_orders_90d: { uk: "Замовлень за 90 днів", en: "Orders in 90 days", hy: "Պատվերներ 90 օրում", ka: "შეკვეთები 90 დღეში" },
  m_orders_no_cancelled: { uk: "без скасованих", en: "excluding cancelled", hy: "առանց չեղարկվածների", ka: "გაუქმებულების გარეშე" },
  m_points: { uk: "Торгових точок", en: "Retail points", hy: "Առևտրի կետեր", ka: "სავაჭრო წერტილები" },
  m_cooperation_since: { uk: "Співпраця з", en: "Customer since", hy: "Համագործակցության սկիզբ", ka: "თანამშრომლობის დაწყება" },
  m_remaining: { uk: "Залишок коштів", en: "Remaining funds", hy: "Մնացորդ միջոցներ", ka: "დარჩენილი სახსრები" },
  /* Whole-card edit mode. */
  edit_btn: { uk: "Редагувати", en: "Edit", hy: "Խմբագրել", ka: "რედაქტირება" },
  edit_save: { uk: "Зберегти", en: "Save", hy: "Պահպանել", ka: "შენახვა" },
  edit_cancel: { uk: "Скасувати", en: "Cancel", hy: "Չեղարկել", ka: "გაუქმება" },
  edit_replace_photo: { uk: "Замінити фото", en: "Replace photo", hy: "Փոխարինել լուսանկարը", ka: "ფოტოს შეცვლა" },
  edit_discard_confirm: {
    uk: "Відкинути незбережені зміни?",
    en: "Discard unsaved changes?",
    hy: "Հե՞տ գցել չպահպանված փոփոխությունները։",
    ka: "გაუქმდეს შენახვის გარეშე ცვლილებები?",
  },
  edit_discard_ok: { uk: "Відкинути", en: "Discard", hy: "Հետ գցել", ka: "უარყოფა" },
  edit_saved_msg: { uk: "Зміни збережено", en: "Changes saved", hy: "Փոփոխությունները պահպանվեցին", ka: "ცვლილებები შენახულია" },
  edit_error_msg: {
    uk: "Не вдалося зберегти зміни",
    en: "Couldn't save the changes",
    hy: "Չհաջողվեց պահպանել փոփոխությունները",
    ka: "ცვლილებების შენახვა ვერ მოხერხდა",
  },
  /* Orders / returns tab columns. */
  o_number_date: { uk: "№ / дата", en: "No. / date", hy: "№ / ամսաթիվ", ka: "№ / თარიღი" },
  o_point: { uk: "Торгова точка", en: "Outlet", hy: "Առևտրի կետ", ka: "სავაჭრო წერტილი" },
  /* The words `ORDERS_PAGE.k_created_by` uses, so the tab and the orders list name the same field alike. */
  o_author: { uk: "Автор", en: "Created by", hy: "Հեղինակ", ka: "ავტორი" },
  o_visit: { uk: "Візит", en: "Visit", hy: "Այց", ka: "ვიზიტი" },
  /* `{date}` is DD.MM — the year is in the link's tooltip. */
  o_visit_on: { uk: "Візит {date}", en: "Visit {date}", hy: "Այց {date}", ka: "ვიზიტი {date}" },
  o_no_visit: { uk: "— без візиту", en: "— no visit", hy: "— առանց այցի", ka: "— ვიზიტის გარეშე" },
  o_sum: { uk: "Сума", en: "Amount", hy: "Գումար", ka: "თანხა" },
  /* The Orders / Returns tab heads (`tabParts.js`) — the window they show, that the data is
     read-only here, and the way to the rest. */
  docs_window: { uk: "за останні 90 днів", en: "last 90 days", hy: "վերջին 90 օրում", ka: "ბოლო 90 დღე" },
  docs_readonly: { uk: "Тільки читання", en: "Read-only", hy: "Միայն ընթերցում", ka: "მხოლოდ წაკითხვა" },
  orders_all: { uk: "Усі замовлення", en: "All orders", hy: "Բոլոր պատվերները", ka: "ყველა შეკვეთა" },
  orders_empty: {
    uk: "Немає замовлень за останні 90 днів",
    en: "No orders in the last 90 days",
    hy: "Վերջին 90 օրում պատվերներ չկան",
    ka: "ბოლო 90 დღეში შეკვეთები არ არის",
  },
  returns_all: { uk: "Усі повернення", en: "All returns", hy: "Բոլոր վերադարձները", ka: "ყველა დაბრუნება" },
  returns_empty: {
    uk: "Немає повернень за останні 90 днів",
    en: "No returns in the last 90 days",
    hy: "Վերջին 90 օրում վերադարձներ չկան",
    ka: "ბოლო 90 დღეში დაბრუნებები არ არის",
  },
  r_items: { uk: "Позицій", en: "Items", hy: "Դիրքեր", ka: "პოზიციები" },
  /* Columns the Payments and Debts tabs share. */
  doc_amount: { uk: "Сума", en: "Amount", hy: "Գումար", ka: "თანხა" },
  doc_comment: { uk: "Коментар", en: "Comment", hy: "Մեկնաբանություն", ka: "კომენტარი" },
  /* The Payments tab (`PaymentsTab.js`): its own columns, the "no debt" cell, the empty window and the
     summary under the table. The number stands apart from its label (`Оплат: 3`), never inflected. */
  p_date: { uk: "Дата", en: "Date", hy: "Ամսաթիվ", ka: "თარიღი" },
  p_debt: { uk: "Погашає борг", en: "Pays off debt", hy: "Մարում է պարտքը", ka: "ფარავს დავალიანებას" },
  p_accepted_by: { uk: "Прийняв", en: "Received by", hy: "Ընդունել է", ka: "მიიღო" },
  p_no_debt: { uk: "— без боргу", en: "— no debt", hy: "— առանց պարտքի", ka: "— დავალიანების გარეშე" },
  payments_empty: {
    uk: "Немає оплат за останні 90 днів",
    en: "No payments in the last 90 days",
    hy: "Վերջին 90 օրում վճարումներ չկան",
    ka: "ბოლო 90 დღეში გადახდები არ არის",
  },
  p_sum_count: { uk: "Оплат:", en: "Payments:", hy: "Վճարումներ՝", ka: "გადახდები:" },
  p_sum_total: { uk: "Сума за 90 днів:", en: "Total for 90 days:", hy: "Գումարը 90 օրում՝", ka: "ჯამი 90 დღეში:" },
  /* The Debts tab (`DebtsTab.js`): what its heading says in place of the 90-day window, its
     columns and its empty state. `{n}` is an abbreviated unit, so it is never inflected. */
  debts_window: { uk: "відкриті борги", en: "open debts", hy: "բաց պարտքեր", ka: "ღია დავალიანებები" },
  d_document: { uk: "Документ", en: "Document", hy: "Փաստաթուղթ", ka: "დოკუმენტი" },
  d_due: { uk: "Термін оплати", en: "Due date", hy: "Վճարման ժամկետ", ka: "გადახდის ვადა" },
  d_overdue: { uk: "Прострочено", en: "Overdue", hy: "Ժամկետանց", ka: "ვადაგადაცილება" },
  d_days: { uk: "{n} дн.", en: "{n} d", hy: "{n} օր", ka: "{n} დღე" },
  debts_empty: {
    uk: "Відкритих боргів немає",
    en: "No open debts",
    hy: "Բաց պարտքեր չկան",
    ka: "ღია დავალიანებები არ არის",
  },
  /* The Addresses tab (`AddressesTab.js`, `AddressModal.js`) and the "no points" notice (AD-4).
     Counts stand apart from their nouns (`Записів: 3`), never inflected (spec/04). ⚠ hy / ka are
     machine-authored drafts. */
  ad_nopoints_title: {
    uk: "У контрагента немає торгових точок",
    en: "This counterparty has no retail points",
    hy: "Կոնտրագենտը առևտրի կետեր չունի",
    ka: "კონტრაგენტს სავაჭრო წერტილები არ აქვს",
  },
  ad_nopoints_body: {
    uk: "Без торгової точки з контрагентом неможливо працювати в полі: візити, замовлення, фотозвіти.",
    en: "Without a retail point there is no field work with this counterparty: no visits, orders or photo reports.",
    hy: "Առանց առևտրի կետի հնարավոր չէ աշխատել կոնտրագենտի հետ դաշտում՝ այցեր, պատվերներ, ֆոտոհաշվետվություններ։",
    ka: "სავაჭრო წერტილის გარეშე კონტრაგენტთან საველე მუშაობა შეუძლებელია: ვიზიტები, შეკვეთები, ფოტოანგარიშები.",
  },
  ad_create_point: { uk: "Створити точку", en: "Create point", hy: "Ստեղծել կետ", ka: "წერტილის შექმნა" },
  ad_points_title: { uk: "Торгові точки", en: "Retail points", hy: "Առևտրի կետեր", ka: "სავაჭრო წერტილები" },
  ad_col_point: { uk: "Точка", en: "Point", hy: "Կետ", ka: "წერტილი" },
  ad_col_locality: { uk: "Населений пункт", en: "Locality", hy: "Բնակավայր", ka: "დასახლებული პუნქტი" },
  ad_col_network: { uk: "Мережа", en: "Network", hy: "Ցանց", ka: "ქსელი" },
  ad_col_responsible: { uk: "Відповідальний", en: "Responsible", hy: "Պատասխանատու", ka: "პასუხისმგებელი" },
  ad_no_network: { uk: "— без мережі", en: "— no network", hy: "— առանց ցանցի", ka: "— ქსელის გარეშე" },
  ad_no_responsible: { uk: "— не призначено", en: "— not assigned", hy: "— նշանակված չէ", ka: "— არ არის დანიშნული" },
  ad_inactive: { uk: "неактивна", en: "inactive", hy: "ոչ ակտիվ", ka: "არააქტიური" },
  ad_no_location: { uk: "без координат", en: "no coordinates", hy: "առանց կոորդինատների", ka: "კოორდინატების გარეშე" },
  ad_points_empty: { uk: "Торгових точок немає", en: "No retail points", hy: "Առևտրի կետեր չկան", ka: "სავაჭრო წერტილები არ არის" },
  ad_open_point: { uk: "Відкрити точку", en: "Open point", hy: "Բացել կետը", ka: "წერტილის გახსნა" },
  ad_unlink: { uk: "Від'єднати", en: "Unlink", hy: "Անջատել", ka: "გათიშვა" },
  ad_unlink_title: {
    uk: "Від'єднати точку «{name}»?",
    en: "Unlink the point «{name}»?",
    hy: "Անջատե՞լ «{name}» կետը",
    ka: "გაითიშოს წერტილი «{name}»?",
  },
  ad_unlink_body: {
    uk: "Точка лишається, від контрагента прибирається лише зв'язок.",
    en: "The point stays; only its link to this counterparty is removed.",
    hy: "Կետը մնում է, հեռացվում է միայն նրա կապը կոնտրագենտի հետ։",
    ka: "წერტილი რჩება, კონტრაგენტისგან მხოლოდ კავშირი იშლება.",
  },
  ad_unlinked_msg: { uk: "Точку від'єднано", en: "Point unlinked", hy: "Կետն անջատված է", ka: "წერტილი გაითიშა" },
  ad_unlink_gone_msg: {
    uk: "Ця точка вже не пов'язана з контрагентом. Список оновлено.",
    en: "This point is no longer linked to the counterparty. The list has been refreshed.",
    hy: "Այս կետն այլևս կապված չէ կոնտրագենտի հետ։ Ցանկը թարմացվել է։",
    ka: "ეს წერტილი აღარ არის დაკავშირებული კონტრაგენტთან. სია განახლდა.",
  },
  ad_title: { uk: "Адреси", en: "Addresses", hy: "Հասցեներ", ka: "მისამართები" },
  ad_summary: {
    uk: "Записів: {n} · з точкою: {m}",
    en: "Records: {n} · with a point: {m}",
    hy: "Գրառումներ՝ {n} · կետով՝ {m}",
    ka: "ჩანაწერები: {n} · წერტილით: {m}",
  },
  /* Shared by the Addresses and Contacts blocks: data kept in PICSELL, not taken from 1C. */
  picsell_data_tag: { uk: "Дані PICSELL", en: "PICSELL data", hy: "PICSELL տվյալներ", ka: "PICSELL მონაცემები" },
  ad_add: { uk: "Додати", en: "Add", hy: "Ավելացնել", ka: "დამატება" },
  ad_col_address: { uk: "Адреса", en: "Address", hy: "Հասցե", ka: "მისამართი" },
  ad_col_type: { uk: "Тип", en: "Type", hy: "Տեսակ", ka: "ტიპი" },
  ad_primary: { uk: "головна", en: "primary", hy: "հիմնական", ka: "მთავარი" },
  ad_empty: { uk: "Адрес ще немає", en: "No addresses yet", hy: "Հասցեներ դեռ չկան", ka: "მისამართები ჯერ არ არის" },
  ad_delete: { uk: "Видалити", en: "Delete", hy: "Ջնջել", ka: "წაშლა" },
  ad_delete_title: {
    uk: "Видалити адресу «{street}»?",
    en: "Delete the address «{street}»?",
    hy: "Ջնջե՞լ «{street}» հասցեն",
    ka: "წაიშალოს მისამართი «{street}»?",
  },
  ad_delete_body: {
    uk: "Торгова точка, створена з цієї адреси, лишиться як є.",
    en: "A retail point made from this address stays as it is.",
    hy: "Այս հասցեից ստեղծված առևտրի կետը կմնա անփոփոխ։",
    ka: "ამ მისამართიდან შექმნილი სავაჭრო წერტილი უცვლელი დარჩება.",
  },
  ad_deleted_msg: { uk: "Адресу видалено", en: "Address deleted", hy: "Հասցեն ջնջված է", ka: "მისამართი წაიშალა" },
  ad_saved_msg: { uk: "Адресу збережено", en: "Address saved", hy: "Հասցեն պահպանված է", ka: "მისამართი შენახულია" },
  ad_modal_new: { uk: "Нова адреса", en: "New address", hy: "Նոր հասցե", ka: "ახალი მისამართი" },
  ad_modal_edit: { uk: "Редагувати адресу", en: "Edit address", hy: "Խմբագրել հասցեն", ka: "მისამართის რედაქტირება" },
  ad_f_type: { uk: "Тип адреси", en: "Address type", hy: "Հասցեի տեսակ", ka: "მისამართის ტიპი" },
  ad_f_county: { uk: "Область", en: "Region", hy: "Մարզ", ka: "რეგიონი" },
  ad_f_locality: { uk: "Населений пункт", en: "Locality", hy: "Բնակավայր", ka: "დასახლებული პუნქტი" },
  ad_f_street: { uk: "Вулиця й будинок", en: "Street and building", hy: "Փողոց և շենք", ka: "ქუჩა და შენობა" },
  ad_f_building: { uk: "Тип будівлі", en: "Building type", hy: "Շենքի տեսակ", ka: "შენობის ტიპი" },
  ad_f_location: { uk: "Координати", en: "Coordinates", hy: "Կոորդինատներ", ka: "კოორდინატები" },
  ad_map_hint: {
    uk: "Клацніть на карті, щоб поставити позначку, або перетягніть її.",
    en: "Click the map to place the pin, or drag it.",
    hy: "Սեղմեք քարտեզին՝ նշիչը դնելու համար, կամ քաշեք այն։",
    ka: "დააწკაპუნეთ რუკაზე ნიშნულის დასასმელად ან გადაათრიეთ იგი.",
  },
  ad_clear_location: { uk: "Очистити", en: "Clear", hy: "Մաքրել", ka: "გასუფთავება" },
  ad_f_primary: { uk: "Головна адреса", en: "Primary address", hy: "Հիմնական հասցե", ka: "მთავარი მისამართი" },
  ad_required: { uk: "Заповніть це поле.", en: "Fill in this field.", hy: "Լրացրեք այս դաշտը։", ka: "შეავსეთ ეს ველი." },
  ad_field_invalid: {
    uk: "Значення не прийнято. Перевірте його.",
    en: "This value wasn't accepted. Check it.",
    hy: "Արժեքը չի ընդունվել։ Ստուգեք այն։",
    ka: "მნიშვნელობა არ იქნა მიღებული. შეამოწმეთ.",
  },
  /* AD-3: a retail point made from an address (`PointFromAddressModal.js`). ⚠ hy / ka are
     machine-authored drafts. */
  ad_ptmodal_title: {
    uk: "Нова торгова точка з адреси",
    en: "New retail point from the address",
    hy: "Նոր առևտրի կետ հասցեից",
    ka: "ახალი სავაჭრო წერტილი მისამართიდან",
  },
  ad_cand_title: {
    uk: "Можливо, точка вже є",
    en: "The point may already exist",
    hy: "Հնարավոր է՝ կետն արդեն կա",
    ka: "შესაძლოა, წერტილი უკვე არსებობს",
  },
  ad_cand_link: { uk: "Прив'язати цю", en: "Link this one", hy: "Կապել այս մեկը", ka: "ამის მიბმა" },
  ad_cand_linked: { uk: "вже прив'язана", en: "already linked", hy: "արդեն կապված է", ka: "უკვე მიბმულია" },
  ad_unit_m: { uk: "м", en: "m", hy: "մ", ka: "მ" },
  ad_unit_km: { uk: "км", en: "km", hy: "կմ", ka: "კმ" },
  ad_pt_name: { uk: "Назва точки", en: "Point name", hy: "Կետի անվանում", ka: "წერტილის სახელი" },
  ad_pt_address: { uk: "Адреса", en: "Address", hy: "Հասցե", ka: "მისამართი" },
  ad_pt_network: { uk: "Мережа", en: "Network", hy: "Ցանց", ka: "ქსელი" },
  ad_pt_category: { uk: "Категорія", en: "Category", hy: "Կատեգորիա", ka: "კატეგორია" },
  ad_pt_merch: { uk: "Відповідальний мерчендайзер", en: "Responsible merchandiser", hy: "Պատասխանատու մերչենդայզեր", ka: "პასუხისმგებელი მერჩენდაიზერი" },
  ad_pt_supervisors: {
    uk: "Відповідальні супервайзери",
    en: "Responsible supervisors",
    hy: "Պատասխանատու սուպերվայզերներ",
    ka: "პასუხისმგებელი სუპერვაიზერები",
  },
  ad_pt_pin_required: {
    uk: "Поставте позначку на карті.",
    en: "Place the pin on the map.",
    hy: "Դրեք նշիչը քարտեզի վրա։",
    ka: "დასვით ნიშნული რუკაზე.",
  },
  ad_pt_note: {
    uk: "Точку одразу буде прив'язано до контрагента — саме це дає змогу працювати з ним у полі: візити, замовлення, фотозвіти.",
    en: "The point is linked to the counterparty right away — that is what makes field work with it possible: visits, orders, photo reports.",
    hy: "Կետն անմիջապես կկապվի կոնտրագենտի հետ — հենց դա է հնարավոր դարձնում դաշտային աշխատանքը՝ այցեր, պատվերներ, ֆոտոհաշվետվություններ։",
    ka: "წერტილი მაშინვე მიებმება კონტრაგენტს — სწორედ ეს იძლევა საველე მუშაობის საშუალებას: ვიზიტები, შეკვეთები, ფოტოანგარიშები.",
  },
  ad_pt_created_msg: {
    uk: "Точку створено й прив'язано",
    en: "Point created and linked",
    hy: "Կետը ստեղծվել և կապվել է",
    ka: "წერტილი შეიქმნა და მიება",
  },
  ad_pt_linked_msg: {
    uk: "Точку прив'язано до адреси",
    en: "Point linked to the address",
    hy: "Կետը կապվել է հասցեին",
    ka: "წერტილი მიება მისამართს",
  },
  ad_pt_has_point_msg: {
    uk: "У цієї адреси вже є точка. Список оновлено.",
    en: "This address already has a point. The list has been refreshed.",
    hy: "Այս հասցեն արդեն կետ ունի։ Ցանկը թարմացվել է։",
    ka: "ამ მისამართს უკვე აქვს წერტილი. სია განახლდა.",
  },
  /* CT-2: the Contacts tab (`ContactsTab.js`, `ContactModal.js`). The count stands apart from its
     noun (spec/04). ⚠ hy / ka are machine-authored drafts. */
  ct_records: { uk: "Записів: {n}", en: "Records: {n}", hy: "Գրառումներ՝ {n}", ka: "ჩანაწერები: {n}" },
  ct_add: { uk: "Додати", en: "Add", hy: "Ավելացնել", ka: "დამატება" },
  ct_empty: { uk: "Контактів ще немає", en: "No contacts yet", hy: "Կոնտակտներ դեռ չկան", ka: "კონტაქტები ჯერ არ არის" },
  ct_col_contact: { uk: "Контакт", en: "Contact", hy: "Կոնտակտ", ka: "კონტაქტი" },
  ct_col_role: { uk: "Роль", en: "Role", hy: "Դեր", ka: "როლი" },
  ct_col_channels: { uk: "Канали", en: "Channels", hy: "Կապուղիներ", ka: "არხები" },
  ct_col_status: { uk: "Статус", en: "Status", hy: "Կարգավիճակ", ka: "სტატუსი" },
  ct_primary: { uk: "Головний", en: "Primary", hy: "Հիմնական", ka: "მთავარი" },
  ct_active: { uk: "Активний", en: "Active", hy: "Ակտիվ", ka: "აქტიური" },
  ct_deactivated: { uk: "Деактивований", en: "Deactivated", hy: "Ապաակտիվացված", ka: "დეაქტივირებული" },
  ct_make_primary: { uk: "Зробити головним", en: "Make primary", hy: "Դարձնել հիմնական", ka: "მთავრად გახდომა" },
  ct_more: { uk: "+{n}", en: "+{n}", hy: "+{n}", ka: "+{n}" },
  ct_collapse: { uk: "Згорнути", en: "Collapse", hy: "Ծալել", ka: "ჩაკეცვა" },
  ct_deactivate: { uk: "Деактивувати", en: "Deactivate", hy: "Ապաակտիվացնել", ka: "დეაქტივაცია" },
  ct_deactivate_title: {
    uk: "Деактивувати контакт «{name}»?",
    en: "Deactivate the contact «{name}»?",
    hy: "Ապաակտիվացնե՞լ «{name}» կոնտակտը",
    ka: "დეაქტივირდეს კონტაქტი «{name}»?",
  },
  ct_deactivated_msg: { uk: "Контакт деактивовано", en: "Contact deactivated", hy: "Կոնտակտն ապաակտիվացված է", ka: "კონტაქტი დეაქტივირებულია" },
  ct_type_phone: { uk: "Телефон", en: "Phone", hy: "Հեռախոս", ka: "ტელეფონი" },
  ct_type_email: { uk: "Email", en: "Email", hy: "Էլ. փոստ", ka: "ელფოსტა" },
  ct_type_instagram: { uk: "Instagram", en: "Instagram", hy: "Instagram", ka: "Instagram" },
  ct_type_telegram: { uk: "Telegram", en: "Telegram", hy: "Telegram", ka: "Telegram" },
  ct_type_viber: { uk: "Viber", en: "Viber", hy: "Viber", ka: "Viber" },
  ct_type_website: { uk: "Сайт", en: "Website", hy: "Կայք", ka: "ვებსაიტი" },
  ct_type_other: { uk: "Інше", en: "Other", hy: "Այլ", ka: "სხვა" },
  ct_modal_new: { uk: "Новий контакт", en: "New contact", hy: "Նոր կոնտակտ", ka: "ახალი კონტაქტი" },
  ct_modal_edit: { uk: "Редагувати контакт", en: "Edit contact", hy: "Խմբագրել կոնտակտը", ka: "კონტაქტის რედაქტირება" },
  ct_f_first_name: { uk: "Ім'я", en: "First name", hy: "Անուն", ka: "სახელი" },
  ct_f_last_name: { uk: "Прізвище", en: "Last name", hy: "Ազգանուն", ka: "გვარი" },
  ct_f_role: { uk: "Роль", en: "Role", hy: "Դեր", ka: "როლი" },
  ct_f_role_hint: { uk: "Довідник компанії", en: "Company dictionary", hy: "Ընկերության տեղեկատու", ka: "კომპანიის ცნობარი" },
  ct_f_position: { uk: "Посада", en: "Position", hy: "Պաշտոն", ka: "თანამდებობა" },
  ct_f_channels: { uk: "Канали зв'язку", en: "Contact channels", hy: "Կապի ուղիներ", ka: "კავშირის არხები" },
  ct_add_channel: { uk: "Додати канал", en: "Add channel", hy: "Ավելացնել կապուղի", ka: "არხის დამატება" },
  ct_remove_channel: { uk: "Прибрати канал", en: "Remove channel", hy: "Հեռացնել կապուղին", ka: "არხის მოშორება" },
  ct_channel_value: { uk: "Значення", en: "Value", hy: "Արժեք", ka: "მნიშვნელობა" },
  ct_channels_hint: {
    uk: "Канали необов'язкові — контакт можна зберегти лише з іменем.",
    en: "Channels are optional — a contact can be saved with a name alone.",
    hy: "Կապուղիները պարտադիր չեն — կոնտակտը կարելի է պահպանել միայն անունով։",
    ka: "არხები სავალდებულო არ არის — კონტაქტი შეიძლება შეინახოს მხოლოდ სახელით.",
  },
  ct_f_primary: { uk: "Головний контакт", en: "Primary contact", hy: "Հիմնական կոնտակտ", ka: "მთავარი კონტაქტი" },
  ct_primary_takes: {
    uk: "Зараз головний — {name}, він втратить позначку.",
    en: "The primary now is {name}; they will lose the mark.",
    hy: "Այժմ հիմնականը {name}-ն է, նա կկորցնի նշումը։",
    ka: "ახლა მთავარია {name}, ის დაკარგავს ნიშანს.",
  },
  ct_f_active: { uk: "Активний", en: "Active", hy: "Ակտիվ", ka: "აქტიური" },
  ct_active_hint: {
    uk: "Деактивований контакт лишається в історії, але не пропонується для зв'язку.",
    en: "A deactivated contact stays in the history but is not offered for contact.",
    hy: "Ապաակտիվացված կոնտակտը մնում է պատմության մեջ, բայց չի առաջարկվում կապի համար։",
    ka: "დეაქტივირებული კონტაქტი ისტორიაში რჩება, მაგრამ კავშირისთვის არ შემოთავაზდება.",
  },
  ct_deactivated_not_primary: {
    uk: "Деактивований контакт не може бути головним.",
    en: "A deactivated contact cannot be primary.",
    hy: "Ապաակտիվացված կոնտակտը չի կարող հիմնական լինել։",
    ka: "დეაქტივირებული კონტაქტი ვერ იქნება მთავარი.",
  },
  ct_primary_not_deactivated: {
    uk: "Головний контакт не можна деактивувати. Спершу зробіть головним інший контакт.",
    en: "The primary contact can't be deactivated. Make another contact primary first.",
    hy: "Հիմնական կոնտակտը հնարավոր չէ ապաակտիվացնել։ Նախ հիմնական դարձրեք մեկ այլ կոնտակտ։",
    ka: "მთავარი კონტაქტის დეაქტივაცია შეუძლებელია. ჯერ სხვა კონტაქტი გახადეთ მთავარი.",
  },
  /* ⚠ hy / ka are machine-authored drafts. */
  ct_channel_invalid: {
    uk: "Значення не може бути порожнім або довшим за 256 символів",
    en: "The value can't be empty or longer than 256 characters",
    hy: "Արժեքը չի կարող լինել դատարկ կամ 256 նիշից երկար",
    ka: "მნიშვნელობა არ შეიძლება იყოს ცარიელი ან 256 სიმბოლოზე გრძელი",
  },
  ct_channel_duplicate: {
    uk: "Цей канал уже вказано в контакті",
    en: "This channel is already listed for this contact",
    hy: "Այս կապուղին արդեն նշված է կոնտակտում",
    ka: "ეს არხი კონტაქტში უკვე მითითებულია",
  },
  ct_channel_taken: {
    uk: "Цей канал уже є в контакті {name}",
    en: "This channel already belongs to {name}",
    hy: "Այս կապուղին արդեն կա {name} կոնտակտում",
    ka: "ეს არხი უკვე აქვს კონტაქტს {name}",
  },
  ct_saved_msg: { uk: "Контакт збережено", en: "Contact saved", hy: "Կոնտակտը պահպանված է", ka: "კონტაქტი შენახულია" },
  ct_primary_msg: { uk: "Головний контакт змінено", en: "Primary contact changed", hy: "Հիմնական կոնտակտը փոխվել է", ka: "მთავარი კონტაქტი შეიცვალა" },
  /* The Comments tab, stage 1 (`CommentsTab.js`): the team's notes. ⚠ hy / ka are machine-authored
     drafts. */
  cm_placeholder: { uk: "Напишіть коментар…", en: "Write a comment…", hy: "Գրեք մեկնաբանություն…", ka: "დაწერეთ კომენტარი…" },
  cm_hint: {
    uk: "Коментар бачить уся команда з доступом до контрагента.",
    en: "The whole team with access to this counterparty sees the comment.",
    hy: "Մեկնաբանությունը տեսնում է կոնտրագենտին հասանելիություն ունեցող ամբողջ թիմը։",
    ka: "კომენტარს ხედავს მთელი გუნდი, რომელსაც კონტრაგენტზე წვდომა აქვს.",
  },
  cm_save: { uk: "Зберегти", en: "Save", hy: "Պահպանել", ka: "შენახვა" },
  cm_shortcut: { uk: "{key}+Enter — зберегти", en: "{key}+Enter to save", hy: "{key}+Enter՝ պահպանելու համար", ka: "{key}+Enter — შენახვა" },
  /* The composer's images (`CommentsTab.js`, `util/image-jpeg.js`). ⚠ hy / ka are machine-authored
     drafts. */
  cm_attach: { uk: "Прикріпити", en: "Attach", hy: "Կցել", ka: "მიმაგრება" },
  cm_drop: { uk: "Відпустіть, щоб прикріпити", en: "Drop to attach", hy: "Թողեք՝ կցելու համար", ka: "გაუშვით მისამაგრებლად" },
  cm_images_hint: {
    uk: "До 5 зображень PNG, JPEG, WEBP або GIF, до 10 МБ кожне. Можна перетягнути або вставити з буфера.",
    en: "Up to 5 PNG, JPEG, WEBP or GIF images, up to 10 MB each. You can also drag them in or paste.",
    hy: "Մինչև 5 PNG, JPEG, WEBP կամ GIF պատկեր, յուրաքանչյուրը մինչև 10 ՄԲ։ Կարելի է նաև քաշել կամ տեղադրել։",
    ka: "5-მდე PNG, JPEG, WEBP ან GIF სურათი, თითოეული 10 მბ-მდე. შეგიძლიათ ჩააგდოთ ან ჩასვათ.",
  },
  cm_image_type: {
    uk: "«{name}»: такий тип файлу не підтримується — лише PNG, JPEG, WEBP, GIF",
    en: "“{name}”: this file type isn't supported — PNG, JPEG, WEBP or GIF only",
    hy: "«{name}»՝ ֆայլի այս տեսակը չի աջակցվում — միայն PNG, JPEG, WEBP, GIF",
    ka: "„{name}“: ფაილის ეს ტიპი არ არის მხარდაჭერილი — მხოლოდ PNG, JPEG, WEBP, GIF",
  },
  cm_image_size: {
    uk: "«{name}»: файл більший за 10 МБ",
    en: "“{name}”: the file is larger than 10 MB",
    hy: "«{name}»՝ ֆայլը 10 ՄԲ-ից մեծ է",
    ka: "„{name}“: ფაილი 10 მბ-ზე დიდია",
  },
  cm_image_count: {
    uk: "«{name}»: не додано — у коментарі вже 5 зображень",
    en: "“{name}”: not added — the comment already has 5 images",
    hy: "«{name}»՝ չի ավելացվել — մեկնաբանությունն արդեն ունի 5 պատկեր",
    ka: "„{name}“: არ დაემატა — კომენტარს უკვე აქვს 5 სურათი",
  },
  cm_image_read: {
    uk: "«{name}»: не вдалося прочитати зображення",
    en: "“{name}”: the image couldn't be read",
    hy: "«{name}»՝ պատկերը չհաջողվեց կարդալ",
    ka: "„{name}“: სურათის წაკითხვა ვერ მოხერხდა",
  },
  cm_image_pasted: { uk: "Зображення з буфера обміну", en: "Pasted image", hy: "Պատկեր փոխանակման բուֆերից", ka: "სურათი ბუფერიდან" },
  cm_image_remove: { uk: "Прибрати зображення", en: "Remove image", hy: "Հեռացնել պատկերը", ka: "სურათის მოშორება" },
  cm_image_alt: { uk: "Зображення до коментаря", en: "Image attached to the comment", hy: "Մեկնաբանության պատկեր", ka: "კომენტარის სურათი" },
  cm_images_invalid: {
    uk: "Зображення не прийнято. Спробуйте інше або приберіть його.",
    en: "The images weren't accepted. Try another one or remove it.",
    hy: "Պատկերները չեն ընդունվել։ Փորձեք այլ պատկեր կամ հեռացրեք այն։",
    ka: "სურათები არ იქნა მიღებული. სცადეთ სხვა ან მოაშორეთ.",
  },
  cm_today: { uk: "Сьогодні", en: "Today", hy: "Այսօր", ka: "დღეს" },
  cm_yesterday: { uk: "Вчора", en: "Yesterday", hy: "Երեկ", ka: "გუშინ" },
  cm_edited: { uk: "змінено", en: "edited", hy: "խմբագրված", ka: "შეცვლილია" },
  cm_unknown_author: { uk: "Невідомий автор", en: "Unknown author", hy: "Անհայտ հեղինակ", ka: "უცნობი ავტორი" },
  /* The words of the card's own "Edit" (`edit_btn`), so the note's menu reads like the Contacts and
     Addresses row menus. */
  cm_edit: { uk: "Редагувати", en: "Edit", hy: "Խմբագրել", ka: "რედაქტირება" },
  cm_actions: { uk: "Дії з коментарем", en: "Comment actions", hy: "Մեկնաբանության գործողություններ", ka: "კომენტარის მოქმედებები" },
  cm_delete: { uk: "Видалити", en: "Delete", hy: "Ջնջել", ka: "წაშლა" },
  cm_cancel: { uk: "Скасувати", en: "Cancel", hy: "Չեղարկել", ka: "გაუქმება" },
  cm_delete_title: { uk: "Видалити коментар?", en: "Delete the comment?", hy: "Ջնջե՞լ մեկնաբանությունը", ka: "წაიშალოს კომენტარი?" },
  cm_deleted_msg: { uk: "Коментар видалено", en: "Comment deleted", hy: "Մեկնաբանությունը ջնջված է", ka: "კომენტარი წაიშალა" },
  cm_saved_msg: { uk: "Коментар збережено", en: "Comment saved", hy: "Մեկնաբանությունը պահպանված է", ka: "კომენტარი შენახულია" },
  cm_updated_msg: { uk: "Коментар змінено", en: "Comment updated", hy: "Մեկնաբանությունը փոխված է", ka: "კომენტარი შეიცვალა" },
  cm_forbidden_msg: {
    uk: "Цей коментар уже не можна змінити.",
    en: "This comment can no longer be changed.",
    hy: "Այս մեկնաբանությունն այլևս հնարավոր չէ փոխել։",
    ka: "ამ კომენტარის შეცვლა აღარ შეიძლება.",
  },
  cm_empty: { uk: "Коментарів ще немає", en: "No comments yet", hy: "Մեկնաբանություններ դեռ չկան", ka: "კომენტარები ჯერ არ არის" },
  cm_more: { uk: "Завантажити ще", en: "Load more", hy: "Բեռնել ավելին", ka: "მეტის ჩატვირთვა" },
  cm_more_error: {
    uk: "Не вдалося завантажити наступні коментарі",
    en: "Couldn't load more comments",
    hy: "Չհաջողվեց բեռնել հաջորդ մեկնաբանությունները",
    ka: "შემდეგი კომენტარების ჩატვირთვა ვერ მოხერხდა",
  },
  tab_load_error: {
    uk: "Не вдалося завантажити список",
    en: "Couldn't load the list",
    hy: "Չհաջողվեց բեռնել ցուցակը",
    ka: "სიის ჩატვირთვა ვერ მოხერხდა",
  },
  k_name: {
    uk: "Назва",
    en: "Name",
    hy: "Անվանում",
    ka: "სახელი",
  },
  k_address: {
    uk: "Адреса",
    en: "Address",
    hy: "Հասցե",
    ka: "მისამართი",
  },
  k_department: {
    uk: "Департамент",
    en: "Department",
    hy: "Դեպարտամենտ",
    ka: "დეპარტამენტი",
  },
  /* "Responsible", not "Merchandisers": the column names the RELATION (who is responsible for this
     counterparty), not the role. The list no longer filters by it, so the singular `f_responsible`
     is gone. */
  k_responsible: {
    uk: "Відповідальні",
    en: "Responsible",
    hy: "Պատասխանատուներ",
    ka: "პასუხისმგებლები",
  },
  k_remaining_funds: {
    uk: "Залишок коштів",
    en: "Remaining funds",
    hy: "Մնացորդ միջոցներ",
    ka: "დარჩენილი სახსრები",
  },
  f_network: {
    uk: "Мережа",
    en: "Network",
    hy: "Ցանց",
    ka: "ქსელი",
  },
  f_county: {
    uk: "Регіон",
    en: "County",
    hy: "Մարզ",
    ka: "რეგიონი",
  },
  f_locality: {
    uk: "Населений пункт",
    en: "Locality",
    hy: "Բնակավայր",
    ka: "დასახლებული პუნქტი",
  },
  f_point: {
    uk: "Точка",
    en: "Point",
    hy: "Կետ",
    ka: "წერტილი",
  },
  f_point_group: {
    uk: "Група точок",
    en: "Point group",
    hy: "Կետերի խումբ",
    ka: "წერტილების ჯგუფი",
  },
  /* The endpoint's `search` matches the name AND `external_id`. The placeholder is short because
     the field is ~126px of text at 1366px — "Name or external ID" was cut off there; the full
     statement is `search_hint`, shown under the field. */
  search_placeholder: { uk: "Назва або код", en: "Name or code", hy: "Անվանում կամ կոդ", ka: "სახელი ან კოდი" },
  search_hint: {
    uk: "Шукає за назвою і зовнішнім кодом",
    en: "Searches by name and external ID",
    hy: "Որոնում է ըստ անվանման և արտաքին կոդի",
    ka: "ეძებს სახელისა და გარე კოდის მიხედვით",
  },
  /* The lifecycle `<Segmented>`'s first option — no lifecycle filter. The four stages reuse `lc_*`. */
  seg_all: { uk: "Усі", en: "All", hy: "Բոլորը", ka: "ყველა" },
  filter_reset: {
    uk: "Скинути фільтри",
    en: "Reset the filters",
    hy: "Զրոյացնել ֆիլտրերը",
    ka: "ფილტრების გადატვირთვა",
  },
  records_count: {
    uk: "Кількість записів",
    en: "Records",
    hy: "Գրառումների քանակ",
    ka: "ჩანაწერების რაოდენობა",
  },
  rows_per_page: {
    uk: "Рядків на сторінці",
    en: "Rows per page",
    hy: "Տողեր մեկ էջում",
    ka: "სტრიქონები გვერდზე",
  },
  range_of: {
    uk: "{from}–{to} з {n}",
    en: "{from}–{to} of {n}",
    hy: "{from}–{to} {n}-ից",
    ka: "{from}–{to} {n}-დან",
  },
  empty_title: {
    uk: "Контрагентів немає",
    en: "No counterparties",
    hy: "Կոնտրագենտներ չկան",
    ka: "კონტრაგენტები არ არის",
  },
  empty_desc: {
    uk: "Тут ще немає жодного контрагента.",
    en: "There are no counterparties here yet.",
    hy: "Այստեղ դեռ կոնտրագենտներ չկան։",
    ka: "აქ ჯერ არცერთი კონტრაგენტი არ არის.",
  },
  empty_filtered_title: {
    uk: "Нічого не знайдено",
    en: "Nothing found",
    hy: "Ոչինչ չի գտնվել",
    ka: "ვერაფერი მოიძებნა",
  },
  empty_filtered_desc: {
    uk: "Жоден контрагент не відповідає цим фільтрам. Змініть або скиньте їх.",
    en: "No counterparty matches these filters. Change or reset them.",
    hy: "Ոչ մի կոնտրագենտ չի համապատասխանում այս ֆիլտրերին։ Փոխեք կամ զրոյացրեք դրանք։",
    ka: "არცერთი კონტრაგენტი არ შეესაბამება ამ ფილტრებს. შეცვალეთ ან გადატვირთეთ ისინი.",
  },
  error_title: {
    uk: "Не вдалося завантажити контрагентів.",
    en: "Couldn't load the counterparties.",
    hy: "Չհաջողվեց բեռնել կոնտրագենտներին։",
    ka: "კონტრაგენტების ჩატვირთვა ვერ მოხერხდა.",
  },
  retry: {
    uk: "Спробувати ще",
    en: "Try again",
    hy: "Կրկին փորձել",
    ka: "ხელახლა ცდა",
  },
  row_actions: { uk: "Дії з рядком", en: "Row actions", hy: "Տողի գործողություններ", ka: "მწკრივის მოქმედებები" },
  columns: {
    uk: "Стовпці",
    en: "Columns",
    hy: "Սյունակներ",
    ka: "სვეტები",
  },
  /* The point block of the filter card. Its five filters describe ONE point together — the hint
     says so, because five independent-looking selects would otherwise read as five separate
     conditions. */
  point_filters_title: {
    uk: "Фільтри за торговими точками",
    en: "Point filters",
    hy: "Ֆիլտրեր ըստ կետերի",
    ka: "ფილტრები წერტილების მიხედვით",
  },
  point_filters_hint: {
    uk: "Одна з точок контрагента має відповідати всім цим умовам одночасно.",
    en: "One of the counterparty's points has to match all of these at once.",
    hy: "Կոնտրագենտի կետերից մեկը պետք է միաժամանակ համապատասխանի այս բոլոր պայմաններին։",
    ka: "კონტრაგენტის ერთ-ერთი წერტილი ერთდროულად უნდა აკმაყოფილებდეს ყველა ამ პირობას.",
  },
  /* The short note in the point block's HEADER, after the list of its fields — lowercase, it
     continues that line. `point_filters_hint` above stays in the block's body: it says the stricter
     thing (ONE point must satisfy all of them). */
  point_filters_note: {
    uk: "фільтрують контрагентів через прив'язані точки",
    en: "filter counterparties through their linked points",
    hy: "ֆիլտրում են կոնտրագենտներին կցված կետերի միջոցով",
    ka: "ფილტრავს კონტრაგენტებს მიბმული წერტილების მიხედვით",
  },
  point_chip_prefix: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  all_orders_btn: {
    uk: "Усі замовлення контрагента",
    en: "All orders from this counterparty",
    hy: "Այս կոնտրագենտի բոլոր պատվերները",
    ka: "ამ კონტრაგენტის ყველა შეკვეთა",
  },
  /* Same words as RETURNS_PAGE.counterparty_all_returns_btn — the counterparty card's button on a
     return's page goes to the same place. */
  all_returns_btn: {
    uk: "Усі повернення контрагента",
    en: "All returns from this counterparty",
    hy: "Կոնտրագենտի բոլոր վերադարձները",
    ka: "კონტრაგენტის ყველა დაბრუნება",
  },
  /* The card's seven editable fields and its sync line (`excalibur/counterparties/:id/`).
     ⚠ hy / ka below are machine-authored drafts, not reviewed by a native speaker (spec/04). */
  /* The list's column heads. Short on purpose: the columns are 100–158px, and `k_supervisor`'s
     "Assigned supervisor" is a form label, not a head. The lifecycle column is headed by
     `k_lifecycle`. */
  /* Type and category each get a column. The category head is the whole word — «Кат.» read as a
     puzzle — and its `title` is the full `k_client_category` ("Client category"), which is also the
     filter's label and the Columns panel's. */
  col_type: { uk: "Тип", en: "Type", hy: "Տեսակ", ka: "ტიპი" },
  col_category: { uk: "Категорія", en: "Category", hy: "Կատեգորիա", ka: "კატეგორია" },
  col_supervisor: { uk: "Супервайзер", en: "Supervisor", hy: "Սուպերվայզեր", ka: "სუპერვაიზერი" },
  /* The balance column's HEAD only: `k_remaining_funds` ("Remaining funds") wraps to two lines in a
     150px column at 1366px, in every locale. The card's metric and the Columns panel keep the full
     phrase. Still a signed balance — never "debt". */
  col_remaining: { uk: "Залишок", en: "Balance", hy: "Մնացորդ", ka: "ნაშთი" },
  k_supervisor: { uk: "Закріплений супервайзер", en: "Assigned supervisor", hy: "Կցված սուպերվայզեր", ka: "მიმაგრებული სუპერვაიზერი" },
  k_supervisor_hint: {
    uk: "Відповідає за роботу з контрагентом. У списку лише активні супервайзери.",
    en: "Accountable for this counterparty. Only active supervisors are listed.",
    hy: "Պատասխանատու է կոնտրագենտի հետ աշխատանքի համար։ Ցուցակում միայն ակտիվ սուպերվայզերներն են։",
    ka: "პასუხისმგებელია კონტრაგენტთან მუშაობაზე. სიაში მხოლოდ აქტიური სუპერვაიზერებია.",
  },
  k_client_type: { uk: "Тип клієнта", en: "Client type", hy: "Հաճախորդի տեսակ", ka: "კლიენტის ტიპი" },
  k_client_category: { uk: "Категорія клієнта", en: "Client category", hy: "Հաճախորդի կատեգորիա", ka: "კლიენტის კატეგორია" },
  k_sales_channel: { uk: "Канал збуту", en: "Sales channel", hy: "Վաճառքի ալիք", ka: "გაყიდვების არხი" },
  k_start_cooperation: { uk: "Початок співпраці", en: "Cooperation start", hy: "Համագործակցության սկիզբ", ka: "თანამშრომლობის დაწყება" },
  k_lifecycle: { uk: "Життєвий цикл", en: "Lifecycle", hy: "Կենսացիկլ", ka: "სასიცოცხლო ციკლი" },
  /* Lifecycle / sync are TextChoices KEYS on the API; these are their labels, under
     their own `lc_` / `sync_` prefixes. */
  lc_new_client: { uk: "Новий клієнт", en: "New client", hy: "Նոր հաճախորդ", ka: "ახალი კლიენტი" },
  /* ⚠ hy «Ներգրավում» reads closer to "engagement" than to "adaptation" — flagged for a native
     speaker; ka already says "adaptation", which is what uk now says too. */
  lc_onboarding: { uk: "Адаптація", en: "Onboarding", hy: "Ներգրավում", ka: "ადაპტაცია" },
  lc_regular: { uk: "Постійний", en: "Regular", hy: "Մշտական", ka: "მუდმივი" },
  lc_churned: { uk: "Втрачений", en: "Churned", hy: "Կորցրած", ka: "დაკარგული" },
  /* `lifecycle_is_manual` — the stage was set by a person, not by automation. The title names the
     icon beside the pill (its `aria-label` and the tooltip's heading); the hint is the tooltip's
     body and says how to return to automatic. ⚠ hy / ka of the hint's last sentence and of every
     `lc_manual_*` key below it are machine-authored drafts. */
  lc_manual_title: { uk: "Встановлено вручну", en: "Set manually", hy: "Սահմանված է ձեռքով", ka: "დაყენებულია ხელით" },
  lc_manual_hint: {
    uk:
      "Життєвий цикл встановила людина. Автоматичний перерахунок його не змінює. Щоб повернути автоматичний режим, вимкніть «Ручне керування життєвим циклом» у формі або натисніть «Повернути автоматичний режим» в огляді картки.",
    en:
      "The lifecycle was set by a person. Automatic recalculation does not change it. To return to automatic mode, turn off “Manual lifecycle control” in the form or click “Return to automatic mode” on the card's overview.",
    hy:
      "Կենսացիկլը սահմանել է մարդը։ Ավտոմատ վերահաշվարկը այն չի փոխում։ Ավտոմատ ռեժիմը վերադարձնելու համար անջատեք «Կենսացիկլի ձեռքով կառավարում»-ը ձևում կամ սեղմեք «Վերադարձնել ավտոմատ ռեժիմը» քարտի ակնարկում։",
    ka:
      "სასიცოცხლო ციკლი ადამიანმა დააყენა. ავტომატური გადაანგარიშება მას არ ცვლის. ავტომატურ რეჟიმზე დასაბრუნებლად გამორთეთ „სასიცოცხლო ციკლის ხელით მართვა“ ფორმაში ან დააჭირეთ „ავტომატურ რეჟიმზე დაბრუნება“ ბარათის მიმოხილვაში.",
  },
  lc_manual_switch: {
    uk: "Ручне керування життєвим циклом",
    en: "Manual lifecycle control",
    hy: "Կենսացիկլի ձեռքով կառավարում",
    ka: "სასიცოცხლო ციკლის ხელით მართვა",
  },
  lc_manual_switch_hint: {
    uk: "Поки ввімкнено, автоматичний перерахунок не змінює життєвий цикл",
    en: "While on, automatic recalculation does not change the lifecycle",
    hy: "Քանի դեռ միացված է, ավտոմատ վերահաշվարկը չի փոխում կենսացիկլը",
    ka: "სანამ ჩართულია, ავტომატური გადაანგარიშება სასიცოცხლო ციკლს არ ცვლის",
  },
  lc_manual_needs_stage: {
    uk: "Спершу виберіть життєвий цикл",
    en: "Choose the lifecycle first",
    hy: "Նախ ընտրեք կենսացիկլը",
    ka: "ჯერ აირჩიეთ სასიცოცხლო ციკლი",
  },
  lc_manual_banner: {
    uk: "Життєвий цикл «{stage}» встановлено вручну. Автоматичний перерахунок його не змінює.",
    en: "The lifecycle “{stage}” was set manually. Automatic recalculation does not change it.",
    hy: "«{stage}» կենսացիկլը սահմանված է ձեռքով։ Ավտոմատ վերահաշվարկը այն չի փոխում։",
    ka: "სასიცოცხლო ციკლი „{stage}“ დაყენებულია ხელით. ავტომატური გადაანგარიშება მას არ ცვლის.",
  },
  lc_manual_revert: { uk: "Повернути автоматичний режим", en: "Return to automatic mode", hy: "Վերադարձնել ավտոմատ ռեժիմը", ka: "ავტომატურ რეჟიმზე დაბრუნება" },
  lc_manual_revert_title: {
    uk: "Повернути автоматичний режим?",
    en: "Return to automatic mode?",
    hy: "Վերադարձնե՞լ ավտոմատ ռեժիմը",
    ka: "დავუბრუნდეთ ავტომატურ რეჟიმს?",
  },
  lc_manual_revert_body: {
    uk: "Життєвий цикл «{stage}» лишиться як є. Автоматичний перерахунок зможе змінити його під час наступного запуску.",
    en: "The lifecycle “{stage}” stays as it is. Automatic recalculation may change it on its next run.",
    hy: "«{stage}» կենսացիկլը կմնա անփոփոխ։ Ավտոմատ վերահաշվարկը կարող է այն փոխել հաջորդ գործարկման ժամանակ։",
    ka: "სასიცოცხლო ციკლი „{stage}“ უცვლელი დარჩება. ავტომატურმა გადაანგარიშებამ შეიძლება ის შეცვალოს შემდეგი გაშვებისას.",
  },
  lc_manual_revert_ok: { uk: "Повернути", en: "Return", hy: "Վերադարձնել", ka: "დაბრუნება" },
  lc_manual_reverted_msg: {
    uk: "Автоматичний режим повернуто",
    en: "Automatic mode restored",
    hy: "Ավտոմատ ռեժիմը վերադարձված է",
    ka: "ავტომატური რეჟიმი აღდგენილია",
  },
  lc_manual_refused: {
    uk: "Сервер не прийняв зміну режиму",
    en: "The server did not accept the mode change",
    hy: "Սերվերը չընդունեց ռեժիմի փոփոխությունը",
    ka: "სერვერმა რეჟიმის ცვლილება არ მიიღო",
  },
  sync_synced: { uk: "Синхронізовано", en: "Synced", hy: "Համաժամացված է", ka: "სინქრონიზებულია" },
  sync_pending: { uk: "Очікує синхронізації", en: "Sync pending", hy: "Սպասում է համաժամացման", ka: "ელოდება სინქრონიზაციას" },
  sync_failed: { uk: "Помилка синхронізації", en: "Sync failed", hy: "Համաժամացման սխալ", ka: "სინქრონიზაციის შეცდომა" },
  /* `{time}` is a whole relative phrase from `Intl.RelativeTimeFormat` ("5 хвилин тому"), so no noun
     here is inflected against a number. */
  sync_synced_at: { uk: "Синхронізовано {time}", en: "Synced {time}", hy: "Համաժամացվել է {time}", ka: "სინქრონიზებულია {time}" },
  /* One phrase for every field the API refuses on save; the API's own message is English and is
     never shown. */
  field_error: {
    uk: "Значення не прийнято. Виберіть інше.",
    en: "This value wasn't accepted. Choose another one.",
    hy: "Արժեքը չի ընդունվել։ Ընտրեք մեկ այլ արժեք։",
    ka: "მნიშვნელობა არ იქნა მიღებული. აირჩიეთ სხვა.",
  },
  /* A Save whose field request landed and whose photo request did not. */
  edit_partial_msg: {
    uk: "Поля збережено, але фото не збережено",
    en: "The fields were saved, but the photo was not",
    hy: "Դաշտերը պահպանվել են, բայց լուսանկարը չի պահպանվել",
    ka: "ველები შენახულია, მაგრამ ფოტო არ შეინახა",
  },
  photo_error: {
    uk: "Фото не збережено. Виберіть інший файл зображення і збережіть ще раз.",
    en: "The photo wasn't saved. Choose another image file and save again.",
    hy: "Լուսանկարը չի պահպանվել։ Ընտրեք մեկ այլ պատկերի ֆայլ և կրկին պահպանեք։",
    ka: "ფოტო არ შეინახა. აირჩიეთ სხვა სურათის ფაილი და ხელახლა შეინახეთ.",
  },
  /* The card's "Linked counterparties" block (`LinksSection.js`). `{name}` is the other
     counterparty's name. ⚠ hy / ka are machine-authored drafts (spec/04). */
  links_title: { uk: "Пов'язані контрагенти", en: "Linked counterparties", hy: "Կապակցված կոնտրագենտներ", ka: "დაკავშირებული კონტრაგენტები" },
  links_add: { uk: "Прив'язати", en: "Link", hy: "Կապակցել", ka: "დაკავშირება" },
  links_empty: {
    uk: "Пов'язаних контрагентів немає",
    en: "No linked counterparties",
    hy: "Կապակցված կոնտրագենտներ չկան",
    ka: "დაკავშირებული კონტრაგენტები არ არის",
  },
  links_modal_title: { uk: "Прив'язати контрагента", en: "Link a counterparty", hy: "Կապակցել կոնտրագենտ", ka: "კონტრაგენტის დაკავშირება" },
  links_field_counterparty: { uk: "Контрагент", en: "Counterparty", hy: "Կոնտրագենտ", ka: "კონტრაგენტი" },
  links_field_type: { uk: "Тип зв'язку", en: "Link type", hy: "Կապի տեսակ", ka: "კავშირის ტიპი" },
  links_type_placeholder: { uk: "Без типу", en: "No type", hy: "Առանց տեսակի", ka: "ტიპის გარეშე" },
  links_unlink: { uk: "Від'єднати", en: "Unlink", hy: "Անջատել", ka: "გათიშვა" },
  links_unlink_confirm: { uk: "Від'єднати «{name}»?", en: "Unlink «{name}»?", hy: "Անջատե՞լ «{name}»-ը", ka: "გაითიშოს «{name}»?" },
  links_added_msg: { uk: "Контрагента прив'язано", en: "Counterparty linked", hy: "Կոնտրագենտը կապակցված է", ka: "კონტრაგენტი დაკავშირებულია" },
  links_removed_msg: { uk: "Зв'язок прибрано", en: "Link removed", hy: "Կապը հեռացված է", ka: "კავშირი წაიშალა" },
  links_gone_msg: {
    uk: "Цього зв'язку вже немає. Список оновлено.",
    en: "This link no longer exists. The list has been refreshed.",
    hy: "Այս կապն այլևս գոյություն չունի։ Ցանկը թարմացվել է։",
    ka: "ეს კავშირი აღარ არსებობს. სია განახლდა.",
  },
  /* The Overview's groups (`overviewSection` in `Page.js`). The contacts group's note names no
     system on purpose — which books feed `external_id` belongs to the deployment. ⚠ hy / ka are
     machine-authored drafts (spec/04). */
  ov_sec_client: { uk: "Клієнт", en: "Client", hy: "Հաճախորդ", ka: "კლიენტი" },
  ov_sec_status: { uk: "Стан і супровід", en: "Status and support", hy: "Կարգավիճակ և ուղեկցում", ka: "სტატუსი და მხარდაჭერა" },
  /* The Overview's "Additional fields" (`customFields.js`): the company's own fields, set up in the
     admin. ⚠ hy / ka are machine-authored drafts. */
  ov_sec_custom: { uk: "Додаткові поля", en: "Additional fields", hy: "Լրացուցիչ դաշտեր", ka: "დამატებითი ველები" },
  cf_empty: { uk: "не заповнено", en: "not filled in", hy: "լրացված չէ", ka: "შევსებული არ არის" },
  cf_yes: { uk: "Так", en: "Yes", hy: "Այո", ka: "დიახ" },
  cf_no: { uk: "Ні", en: "No", hy: "Ոչ", ka: "არა" },
  cf_clear_hint: {
    uk: "Очистіть, щоб лишити незаповненим.",
    en: "Clear it to leave the field empty.",
    hy: "Մաքրեք՝ դաշտը չլրացված թողնելու համար։",
    ka: "გაასუფთავეთ, რომ ველი შეუვსებელი დარჩეს.",
  },
  /* The list's "Additional fields" filter block (`customFieldFilters.js`). Field and option names
     come from the API as they are. ⚠ hy / ka are machine-authored drafts. */
  cf_filters_title: { uk: "Додаткові поля", en: "Additional fields", hy: "Լրացուցիչ դաշտեր", ka: "დამატებითი ველები" },
  cf_filters_hint: {
    uk: "Відбирає контрагентів за полями, які веде компанія. Кілька полів поєднуються через «і».",
    en: "Narrows by the fields your company keeps. Several fields combine with “and”.",
    hy: "Ընտրում է կոնտրագենտներին ընկերության վարած դաշտերով։ Մի քանի դաշտ միավորվում են «և»-ով։",
    ka: "ირჩევს კონტრაგენტებს კომპანიის მიერ წარმოებული ველებით. რამდენიმე ველი ერთიანდება „და“-თი.",
  },
  cf_chip_prefix: { uk: "Дод. поля", en: "Extra fields", hy: "Լրաց. դաշտեր", ka: "დამ. ველები" },
  cf_any: { uk: "Будь-яке", en: "Any", hy: "Ցանկացած", ka: "ნებისმიერი" },
  cf_from: { uk: "від", en: "from", hy: "սկսած", ka: "დან" },
  cf_to: { uk: "до", en: "to", hy: "մինչև", ka: "მდე" },
  cf_chip_from: { uk: "від {n}", en: "from {n}", hy: "{n}-ից", ka: "{n}-დან" },
  cf_chip_to: { uk: "до {n}", en: "up to {n}", hy: "մինչև {n}", ka: "{n}-მდე" },
  cf_range_invalid: {
    uk: "«Від» більше за «до» — фільтр не застосовано.",
    en: "“From” is above “to” — the filter is not applied.",
    hy: "«Սկսած»-ը մեծ է «մինչև»-ից — զտիչը չի կիրառվել։",
    ka: "„დან“ მეტია „მდე“-ზე — ფილტრი არ გამოიყენება.",
  },
  ov_sec_contacts: {
    uk: "Контакти й обслуговування",
    en: "Contacts and service",
    hy: "Կոնտակտներ և սպասարկում",
    ka: "კონტაქტები და მომსახურება",
  },
  ov_sec_account_desc: {
    uk: "Надходять з облікової системи й тут не редагуються.",
    en: "These come from the accounting system and are not edited here.",
    hy: "Ստացվում են հաշվառման համակարգից և այստեղ չեն խմբագրվում։",
    ka: "მოდის აღრიცხვის სისტემიდან და აქ არ რედაქტირდება.",
  },
};
